  import React, { createContext, useState, useContext, useMemo } from "react";

  const JobContext = createContext();

  export const useJobs = () => {
    const context = useContext(JobContext);
    if (!context) throw new Error("useJobs must be used within a JobProvider");
    return context;
  };  
  export const JobProvider = ({ children }) => {
    const [jobs] = useState([

{
  id: 'DELPHI2026001',
  title: 'Data & AI Intern',
  company: 'Delphi Consulting Middle East',
  location: 'Remote',
  jobType: 'Internship',
  description: 'Work on data analysis, AI-related tasks, Excel reporting, and problem-solving projects in a remote internship program.',
  role: 'Data & AI Intern',
  qualification: ['Any Degree'],
  experience: 'Freshers',
  batch: '2019-2025',
  salary: '₹5-7 LPA',
  stipend: '₹20K-30K Per Month',
  requirements: [
    'Excel',
    'Data Analysis',
    'Communication Skills',
    'Problem Solving',
    'Aptitude'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://placement.acciojob.com/job-drive-details/?jobDriveId=50c30050-8cde-475c-924e-a007774d2aa6'
},
{
  id: 'ZOHO2026002',
  title: 'Zoho Developer',
  company: 'Confidential',
  location: 'Gurugram / Hyderabad',
  jobType: 'Full-Time',
  description: 'Develop and maintain Zoho CRM, Creator, Books solutions with Deluge scripting and API integrations.',
  role: 'Zoho Developer',
  qualification: ['Bachelor Degree'],
  experience: '2-4 Years',
  batch: '',
  salary: '₹3-5 LPA',
  requirements: [
    'Zoho CRM',
    'Zoho Creator',
    'Deluge Scripting',
    'REST APIs',
    'Workflow Automation',
    'Zoho Books'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:manyataneja@hotmal.com'
},
{
  id: 'BULWARK2026003',
  title: 'Senior Databricks Administrator',
  company: 'Bulwark Management Consultants',
  location: 'Bangalore / Pune',
  jobType: 'Full-Time',
  description: 'Manage Databricks environments and AWS infrastructure with governance, automation, and cloud optimization.',
  role: 'Senior Databricks Administrator',
  qualification: ['Bachelor Degree'],
  experience: '9-13 Years',
  batch: '',
  salary: '₹26 LPA',
  requirements: [
    'Databricks',
    'AWS EC2',
    'AWS Glue',
    'AWS Lambda',
    'AWS S3',
    'Terraform',
    'IAM',
    'CI/CD'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://abekus.ai/public-job-search/senior-databricks-administrator?referral_hash=IIHT.VIMANNAGAR0138'
},
{
  id: 'SRITECH2026004',
  title: 'Software Developer – Embedded Networking',
  company: 'SriTech Solutions',
  location: 'Bangalore / Hyderabad / Chennai',
  jobType: 'Full-Time',
  description: 'Develop embedded networking software using C/C++, Linux, and Layer 2 networking protocols.',
  role: 'Embedded Software Developer',
  qualification: ['Bachelor Degree'],
  experience: '5-15 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'C',
    'C++',
    'Embedded Linux',
    'Ethernet',
    'VLAN',
    'QoS',
    'DHCP',
    'PPPoE',
    'Networking'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:ravinder.k@sritechsolutions.com'
},
{
  id: 'ECOLAB2026005',
  title: 'Senior Software Engineering Manager',
  company: 'Ecolab',
  location: 'Pune',
  jobType: 'Full-Time',
  description: 'Lead embedded Linux and firmware teams building secure IoT solutions and cloud-connected devices.',
  role: 'Software Engineering Manager',
  qualification: ['Bachelor Degree'],
  experience: '10+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Embedded Linux',
    'Firmware Development',
    'C++',
    'Python',
    'Yocto',
    'Buildroot',
    'CI/CD',
    'Cyber Security'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://jobs.ecolab.com/global/en/job/R00287888/Senior-Software-Engineering-Manager'
},
{
  id: 'PEGA2026006',
  title: 'Pega Business Analyst',
  company: 'AadhyaRaj Tech',
  location: 'Bangalore / Pune / Gurgaon',
  jobType: 'Full-Time',
  description: 'Gather business requirements and translate them into Pega functional specifications.',
  role: 'Business Analyst',
  qualification: ['Bachelor Degree'],
  experience: '7-9 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Pega',
    'BRD',
    'FRD',
    'Agile',
    'Scrum',
    'Stakeholder Management'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:tag@aadhyarajtech.com'
},
{
  id: 'DELL2026007',
  title: 'Software Engineer',
  company: 'Dell Technologies',
  location: 'Bengaluru',
  jobType: 'Full-Time',
  description: 'Design, develop, test, and maintain enterprise software applications and platforms.',
  role: 'Software Engineer',
  qualification: ['Bachelor Degree'],
  experience: '8+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Java',
    'Python',
    'Databases',
    'Full Stack Development',
    'CI/CD',
    'Cloud'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://iawmqy.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/careers/jobs/preview/R289959/'
},
{
  id: 'DEVOPS2026008',
  title: 'Senior DevOps Engineer',
  company: '91HR',
  location: 'Goa',
  jobType: 'Full-Time',
  description: 'Build and manage cloud infrastructure, containerization, and DevSecOps practices.',
  role: 'Senior DevOps Engineer',
  qualification: ['Bachelor Degree'],
  experience: '7-8 Years',
  batch: '',
  salary: '₹11-15 LPA',
  requirements: [
    'AWS',
    'Azure',
    'GCP',
    'Docker',
    'Kubernetes',
    'Jenkins',
    'GitHub Actions',
    'Helm'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:suzanne@91hr.in'
},{
  id: 'CGI2026009',
  title: 'Mainframe Developer - COBOL DB2 JCL',
  company: 'CGI',
  location: 'Hyderabad / Bangalore',
  jobType: 'Full-Time',
  description: 'Develop and maintain mainframe applications using COBOL, JCL, DB2, IMS DB/DC and related utilities.',
  role: 'Mainframe Developer',
  qualification: ['Engineering Graduate', 'MCA'],
  experience: '3-5 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'COBOL',
    'JCL',
    'DB2',
    'IMS DB/DC',
    'VSAM',
    'Mainframe Utilities',
    'Agile',
    'Xpediter'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://cgi.njoyn.com/CORP/xweb/xweb.asp?NTKN=c&clid=21001&Page=JobDetails&Jobid=J0426-1524'
},
{
  id: 'ACUVATE2026010',
  title: 'Senior Project Manager',
  company: 'Acuvate',
  location: 'Hyderabad',
  jobType: 'Full-Time',
  description: 'Lead end-to-end project management initiatives, stakeholder coordination, and delivery execution.',
  role: 'Senior Project Manager',
  qualification: ['Bachelor Degree'],
  experience: '8+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Project Management',
    'Agile',
    'Scrum',
    'JIRA',
    'MS Project',
    'Stakeholder Management',
    'Risk Management'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:anil.reddy@acuvate.com'
},
{
  id: 'ACCENTURE2026011',
  title: 'Custom Software Engineer',
  company: 'Accenture',
  location: 'Bengaluru',
  jobType: 'Full-Time',
  description: 'Develop custom software solutions using SAP ABAP Development for HANA and agile methodologies.',
  role: 'Software Engineer',
  qualification: ['Any Graduate'],
  experience: '0-2 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'SAP ABAP',
    'HANA',
    'Git',
    'Database Management',
    'Agile',
    'Problem Solving'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://www.accenture.com/in-en/careers/jobdetails?id=ATCI-5483614-S2020888_en'
},
{
  id: 'ACCUDATA2026012',
  title: 'QA Engineer / Software Tester',
  company: 'AccuData Analytics',
  location: 'New Delhi',
  jobType: 'Full-Time',
  description: 'Perform manual and API testing for healthcare technology products and client-facing applications.',
  role: 'QA Engineer',
  qualification: ['Bachelor Degree'],
  experience: '4-5 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Manual Testing',
    'API Testing',
    'Postman',
    'SQL',
    'JIRA',
    'Regression Testing',
    'UAT'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:hr@accudataanalytics.com'
},
{
  id: 'HUMANCLOUD2026013',
  title: 'MERN Stack Developer',
  company: 'HumanCloud',
  location: 'India',
  jobType: 'Full-Time',
  description: 'Build modern web applications using MongoDB, Express.js, React.js and Node.js.',
  role: 'MERN Stack Developer',
  qualification: ['Bachelor Degree', 'Master Degree'],
  experience: '0-4 Years',
  batch: '2022 & Earlier',
  salary: 'Up to ₹8 LPA',
  requirements: [
    'MongoDB',
    'Express.js',
    'React.js',
    'Node.js',
    'JavaScript',
    'TypeScript',
    'REST APIs'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://forms.gle/GQRcFFNhKQHbyeh96'
},
{
  id: 'HUMANCLOUD2026014',
  title: 'Full Stack Developer (Java)',
  company: 'HumanCloud',
  location: 'India',
  jobType: 'Full-Time',
  description: 'Develop enterprise applications using Java, Spring Boot, React or Angular frameworks.',
  role: 'Full Stack Developer',
  qualification: ['Bachelor Degree', 'Master Degree'],
  experience: '0-4 Years',
  batch: '2022 & Earlier',
  salary: 'Up to ₹8 LPA',
  requirements: [
    'Java',
    'Spring Boot',
    'React',
    'Angular',
    'MySQL',
    'OOPs',
    'DSA'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://forms.gle/GQRcFFNhKQHbyeh96'
},
{
  id: 'SAP2026015',
  title: 'SAP ABAP HANA + RAP + BTP Consultant',
  company: 'Confidential',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Work on SAP ABAP HANA, RAP and BTP implementation projects in a remote environment.',
  role: 'SAP Consultant',
  qualification: ['Bachelor Degree'],
  experience: '8+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'SAP ABAP',
    'SAP HANA',
    'RAP',
    'BTP',
    'SAP Development'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://wa.me/918401026899'
},
{
  id: 'MERCOR2026016',
  title: 'Software Engineer Expert',
  company: 'Mercor',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Build MCP servers, integrate applications, and develop production-ready software solutions.',
  role: 'Software Engineer',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: '$40-$50 Per Hour',
  requirements: [
    'Python',
    'APIs',
    'Docker',
    'Linux',
    'Backend Development',
    'FastMCP',
    'Debugging'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://t.mercor.com/Hrjce'
},
{
  id: 'POWER2026017',
  title: 'Power Platform Developer',
  company: 'Microsoft Ecosystem Migration Project',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Develop and migrate enterprise applications using Microsoft Power Platform and Dynamics ecosystem.',
  role: 'Power Platform Developer',
  qualification: ['Bachelor Degree'],
  experience: '5+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Power Apps',
    'Power Automate',
    'Dataverse',
    'Dynamics CRM',
    'SQL',
    'Data Migration',
    'Workflow Automation'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:jobspinakin@gmail.com'
},
{
  id: 'NEET2026018',
  title: 'Full Stack Developer',
  company: 'NeetSupport',
  location: 'Noida',
  jobType: 'Full-Time',
  description: 'Develop MERN stack applications with AI integrations, WebSockets, SQL and vector databases.',
  role: 'Full Stack Developer',
  qualification: ['Bachelor Degree'],
  experience: 'Fresher / Experienced',
  batch: '',
  salary: '₹30K-40K Per Month',
  requirements: [
    'MongoDB',
    'Express.js',
    'React.js',
    'Node.js',
    'SQL',
    'WebSockets',
    'LangChain',
    'LangGraph',
    'Agentic AI',
    'Vector Databases'
  ],
  postedDate: '2026-06-24',
  applyLink: 'https://unstop.com/o/TGmfciP?lb=Bnie7Jo'
},


{
  id: 'HSSC2026019',
  title: 'Warder',
  company: 'Haryana Staff Selection Commission (HSSC)',
  location: 'Haryana',
  jobType: 'Government',
  description: 'Recruitment for Warder posts in Haryana prisons department.',
  role: 'Warder',
  qualification: ['12th Pass'],
  experience: 'Freshers',
  batch: '',
  salary: 'Pay Level FPL-2',
  vacancies: '1205',
  requirements: [
    '12th Pass',
    'Haryana CET Group-C'
  ],
  postedDate: '2026-06-24',
  lastDate: '2026-06-30',
  applyLink: 'https://govtjobsalert.in/hssc-warder-recruitment-2026/'
},
{
  id: 'KSP2026020',
  title: 'Armed Police Constable',
  company: 'Karnataka State Police',
  location: 'Karnataka',
  jobType: 'Government',
  description: 'Recruitment for Armed Police Constable posts across Karnataka.',
  role: 'Police Constable',
  qualification: ['PUC', '12th Pass'],
  experience: 'Freshers',
  batch: '',
  salary: '₹37,500 - ₹76,100',
  vacancies: '1600',
  requirements: [
    '12th Pass',
    'Physical Fitness'
  ],
  postedDate: '2026-06-24',
  lastDate: '2026-07-22',
  applyLink: 'https://govtjobsalert.in/ksp-armed-police-constable-recruitment-2026/'
},
{
  id: 'IAF2026021',
  title: 'Agniveer Vayu Intake 02/2027',
  company: 'Indian Air Force',
  location: 'India',
  jobType: 'Government',
  description: 'Join the Indian Air Force as Agniveer Vayu under Agnipath Scheme.',
  role: 'Agniveer Vayu',
  qualification: ['10+2 Pass'],
  experience: 'Freshers',
  batch: '',
  salary: '₹30,000 - ₹40,000 Per Month',
  vacancies: 'Various',
  requirements: [
    '10+2 Pass',
    'Medical Fitness',
    'Physical Fitness'
  ],
  postedDate: '2026-06-24',
  lastDate: '2026-07-26',
  applyLink: 'https://govtjobsalert.in/iaf-agniveer-vayu-intake-02-2027/'
},
{
  id: 'SSC2026022',
  title: 'Combined Graduate Level (CGL)',
  company: 'Staff Selection Commission',
  location: 'India',
  jobType: 'Government',
  description: 'SSC CGL Recruitment for various Group B and Group C Central Government posts.',
  role: 'SSC CGL',
  qualification: ['Bachelor Degree'],
  experience: 'Freshers',
  batch: '',
  salary: '₹25,500 - ₹1,51,100 Per Month',
  vacancies: '12256',
  requirements: [
    'Graduate',
    'Competitive Exam'
  ],
  postedDate: '2026-06-24',
  lastDate: '2026-06-25',
  applyLink: 'https://govtjobsalert.in/ssc-cgl-recruitment-2026/'
},
{
  id: 'NAVY2026023',
  title: 'SSC Officer June 2027 Entry',
  company: 'Indian Navy',
  location: 'India',
  jobType: 'Government',
  description: 'Recruitment of SSC Officers in various branches of the Indian Navy.',
  role: 'SSC Officer',
  qualification: [
    'BE',
    'BTech',
    'Graduation',
    'Post Graduation'
  ],
  experience: 'Freshers',
  batch: '',
  salary: '₹1,20,000 Per Month',
  vacancies: '275',
  requirements: [
    'Engineering Degree',
    'Branch-wise Eligibility'
  ],
  postedDate: '2026-06-24',
  lastDate: '2026-07-27',
  applyLink: 'https://govtjobsalert.in/indian-navy-ssc-officer-june-2027-entry/'
},
{
  id: 'GAOTEK2026024',
  title: 'Digital Marketing Staff',
  company: 'GAOTek Inc.',
  location: 'Remote',
  jobType: 'Full-Time',
  description: 'Manage social media, SEO, content creation, email marketing and analytics.',
  role: 'Digital Marketing Executive',
  qualification: [
    'Marketing Degree',
    'Business Administration',
    'Communications'
  ],
  experience: '2+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'SEO',
    'Social Media Marketing',
    'Google Analytics',
    'Email Marketing',
    'Content Writing'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:Hire-India-C@thegaogroup.com'
},
{
  id: 'LEGRAND2026025',
  title: 'Analyst - Demand Planning',
  company: 'Legrand India',
  location: 'Mumbai',
  jobType: 'Full-Time',
  description: 'Demand forecasting, planning and analytics for supply chain operations.',
  role: 'Demand Planning Analyst',
  qualification: ['Bachelor Degree'],
  experience: '3-6 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Demand Forecasting',
    'Power BI',
    'Supply Chain',
    'Anaplan'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:maya.hasabe@legrand.com'
},
{
  id: 'DELOITTE2026026',
  title: 'Senior Audit Assistant',
  company: 'Deloitte USI',
  location: 'Gurgaon / Hyderabad / Bengaluru',
  jobType: 'Full-Time',
  description: 'Audit and Assurance role for recently qualified Chartered Accountants.',
  role: 'Senior Audit Assistant',
  qualification: ['Chartered Accountant'],
  experience: 'Freshers',
  batch: 'CA Jan 2026 / May 2026',
  salary: 'Not Disclosed',
  requirements: [
    'Qualified CA',
    'Audit Knowledge'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:prachaturvedi@deloitte.com'
},
{
  id: 'NEXUS2026027',
  title: 'Executive Assistant cum HR Executive',
  company: 'Nexus HR Solutions',
  location: 'Pune',
  jobType: 'Full-Time',
  description: 'Executive support, HR operations, recruitment coordination and administration.',
  role: 'EA cum HR Executive',
  qualification: [
    'Graduate',
    'MBA HR',
    'MPM',
    'MSW'
  ],
  experience: '2-5 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'MS Office',
    'HR Operations',
    'Recruitment',
    'Communication Skills'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:resume@nexushrsolutions.com'
},
{
  id: 'CAPGEMINI2026028',
  title: 'SAP Professionals',
  company: 'Capgemini',
  location: 'India',
  jobType: 'Full-Time',
  description: 'Multiple SAP opportunities across DTS practice and transformation programs.',
  role: 'SAP Consultant',
  qualification: ['Bachelor Degree'],
  experience: '5+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'SAP APO PP/DS',
    'SAP ePP/DS',
    'SAP IBP',
    'SAP PPQM',
    'SAP EAM',
    'SAP PLM'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:neesha.rawat@capgemini.com'
},
{
  id: 'BHARATCX2026029',
  title: 'Founders Office Associate',
  company: 'BharatCX',
  location: 'Nashik',
  jobType: 'Full-Time',
  description: 'Work directly with founders to drive business initiatives and strategic projects.',
  role: 'Founders Office Associate',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Business Operations',
    'Problem Solving',
    'Leadership',
    'Communication Skills'
  ],
  postedDate: '2026-06-24',
  applyLink: 'mailto:people@transactix.in'
},
{
  id: 'OCROLUS2026030',
  title: 'Data Verifier',
  company: 'Ocrolus East',
  location: 'Noida',
  jobType: 'Walk-In',
  description: 'Data verification, data entry and document validation role.',
  role: 'Data Verifier',
  qualification: ['Any Graduate'],
  experience: '0-4 Years',
  batch: '',
  salary: '₹1-2 LPA',
  vacancies: '100',
  requirements: [
    'Typing Speed',
    'Data Entry',
    'English Typing',
    'Data Verification'
  ],
  postedDate: '2026-06-24',
  walkInDate: '2026-06-26',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-data-verifier-26th-june-26-noida-ocrolus-east-noida-0-to-4-years-230626020855'
},






{
  id: 'MERCOR2026001',
  title: 'Backend Engineer (Coding Agent Experience)',
  company: 'Mercor',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Evaluate and improve frontier AI coding models through backend engineering assessments.',
  role: 'Backend Engineer',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: '$85 Per Hour',
  requirements: [
    'Backend Development',
    'APIs',
    'Distributed Systems',
    'Microservices',
    'Databases',
    'AI Coding Agents'
  ],
  postedDate: '2026-06-22',
  applyLink: 'https://t.mercor.com/5hBj3'
},

{
  id: 'EUTECH2026001',
  title: 'Network Engineer',
  company: 'EU Tech',
  location: 'Remote',
  jobType: 'Full-Time',
  description: 'Remote network engineering role for immediate joiners.',
  role: 'Network Engineer',
  qualification: ['Bachelor Degree'],
  experience: 'Experienced',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Routing & Switching',
    'LAN/WAN',
    'VPN',
    'Firewall Management',
    'Network Security',
    'Network Monitoring'
  ],
  postedDate: '2026-06-22',
  applyLink: 'mailto:swati.nigam@eutech.org'
},

{
  id: 'OPTM2026001',
  title: 'Lead Dot Net FullStack Developer',
  company: 'OptimHire',
  location: 'Remote',
  jobType: 'Full-Time',
  description: 'Develop enterprise applications using .NET, Angular, Cloud and AI technologies.',
  role: 'Lead Dot Net FullStack Developer',
  qualification: ['BCA', 'MCA', 'BE', 'BTech'],
  experience: '2-4 Years',
  batch: '',
  salary: '₹10-30 LPA',
  requirements: [
    '.NET',
    'Angular',
    'MSSQL',
    'MongoDB',
    'CI/CD',
    'Docker',
    'Azure',
    'AWS',
    'API Security'
  ],
  postedDate: '2026-06-22',
  applyLink: 'https://optimhire.com/developers/jv/309727?ref_code=mukesh-agrawal'
},

{
  id: 'TVGS2026001',
  title: 'Snowflake Data Warehouse Engineer',
  company: 'TechVest Global Solutions',
  location: 'Remote',
  jobType: 'Full-Time',
  description: 'Build scalable Snowflake data warehouse and analytics solutions.',
  role: 'Data Warehouse Engineer',
  qualification: ['Bachelor Degree'],
  experience: '7+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Snowflake',
    'SQL',
    'dbt',
    'Azure',
    'GitLab CI/CD',
    'Data Modeling'
  ],
  postedDate: '2026-06-22',
  applyLink: 'mailto:sirishae@techvestglobal.com'
},

{
  id: 'KEVNIT2026001',
  title: 'Web Developer Intern',
  company: 'Kevnit Digital Solutions',
  location: 'Bangalore',
  jobType: 'Internship',
  description: 'Internship opportunity for aspiring web developers with MERN skills.',
  role: 'Web Developer Intern',
  qualification: ['Any Degree'],
  experience: 'Freshers',
  batch: '2021, 2022, 2023, 2024, 2025',
  salary: '₹4 LPA',
  requirements: [
    'HTML',
    'CSS',
    'JavaScript',
    'MERN Stack'
  ],
  postedDate: '2026-06-22',
  applyLink: 'https://placement.acciojob.com/job-drive-details/?jobDriveId=9f47dd6e-9ce2-4f43-b73d-d4c3f36b0753'
},

{
  id: 'PROGAI2026001',
  title: 'Business Analyst',
  company: 'Programmers.io',
  location: 'Remote',
  jobType: 'Full-Time',
  description: 'Bridge business requirements and technology teams in Agile environments.',
  role: 'Business Analyst',
  qualification: ['Bachelor Degree'],
  experience: '7+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Business Analysis',
    'Wireframing',
    'Agile',
    'Scrum',
    'SDLC'
  ],
  postedDate: '2026-06-22',
  applyLink: 'mailto:meghana.bodhimisetty@programmers.ai'
},

{
  id: 'APPADV2026001',
  title: 'Flutter Developer',
  company: 'Appadvent Technologies',
  location: 'Noida',
  jobType: 'Full-Time',
  description: 'Develop E-commerce and FinTech mobile applications using Flutter.',
  role: 'Flutter Developer',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: '₹3-4.2 LPA',
  requirements: [
    'Flutter',
    'Dart',
    'Firebase',
    'REST APIs',
    'Payment Gateway Integration'
  ],
  postedDate: '2026-06-22',
  applyLink: 'https://unstop.com/o/SbmlzuR?lb=Bnie7Jo'
},

{
  id: 'SSC2026001',
  title: 'SSC CGL Recruitment 2026',
  company: 'Staff Selection Commission',
  location: 'India',
  jobType: 'Government Job',
  description: 'Combined Graduate Level Examination for various central government posts.',
  role: 'Various Government Posts',
  qualification: ['Any Graduate'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹25,500 - ₹1,51,100',
  requirements: ['Graduation'],
  postedDate: '2026-06-22',
  applyLink: 'https://govtjobsalert.in/ssc-cgl-recruitment-2026/'
},

{
  id: 'RANCHI2026001',
  title: 'Civil Court Ranchi Peon Recruitment 2026',
  company: 'Civil Court Ranchi',
  location: 'Jharkhand',
  jobType: 'Government Job',
  description: 'Recruitment for Peon posts in Civil Court Ranchi.',
  role: 'Peon',
  qualification: ['10th Pass'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹18,000 - ₹56,900',
  requirements: ['10th Pass'],
  postedDate: '2026-06-22',
  applyLink: 'https://govtjobsalert.in/ranchi-civil-court-peon-recruitment-2026/'
},

{
  id: 'COINDCX2026001',
  title: 'Mobile Development Intern',
  company: 'CoinDCX',
  location: 'Bangalore',
  jobType: 'Internship',
  description: 'Mobile application development internship for fresh graduates.',
  role: 'Mobile Development Intern',
  qualification: ['Computer Science', 'Engineering'],
  experience: 'Freshers',
  batch: '2024, 2025, 2026',
  salary: 'Not Disclosed',
  requirements: [
    'Mobile Development',
    'Android',
    'iOS'
  ],
  postedDate: '2026-06-20',
  applyLink: 'https://careers.coindcx.com/opportunities/jd'
},

{
  id: 'HACKERRANK2026001',
  title: 'Customer Experience Engineer Intern',
  company: 'HackerRank',
  location: 'Bangalore',
  jobType: 'Internship',
  description: 'Customer Experience Engineer Internship for fresh graduates.',
  role: 'Customer Experience Engineer Intern',
  qualification: ['Bachelor Degree', 'Master Degree'],
  experience: 'Freshers',
  batch: '2024, 2025, 2026',
  salary: '₹15K - ₹30K Per Month',
  requirements: [
    'Communication Skills',
    'Problem Solving',
    'Technical Support'
  ],
  postedDate: '2026-06-21',
  applyLink: 'https://job-boards.greenhouse.io/hackerrank/jobs/8015586'
},


{
  id: 'JOB047',
  title: 'L3 Support Engineer',
  company: 'Jyotirgamay',
  location: 'Baner, Pune',
  jobType: 'Contract',
  description: 'Manage enterprise infrastructure, cloud operations, Microsoft 365, virtualization, networking and incident management.',
  role: 'L3 Support Engineer',
  qualification: [
    'BCA',
    'MCA',
    'BE',
    'B.Tech',
    'Relevant IT Degree'
  ],
  experience: '5+ Years',
  batch: '',
  salary: '₹25,000 - ₹28,000 Per Month',
  requirements: [
    'Windows Server',
    'Linux Administration',
    'Active Directory',
    'Microsoft 365',
    'Azure AD',
    'VMware ESXi',
    'VMware vCenter',
    'Hyper-V',
    'TCP/IP',
    'DNS',
    'DHCP',
    'VLAN',
    'VPN',
    'Microsoft Azure',
    'Veeam Backup',
    'PowerShell',
    'SQL Server',
    'ServiceNow',
    'PRTG',
    'SolarWinds',
    'Incident Management',
    'Infrastructure Administration'
  ],
  postedDate: '2026-06-18',
  applyLink: 'mailto:masa@jyotirgamay.com'
},

{
  id: 'JOB041',
  title: 'Frontend Engineer (Coding Agent Experience)',
  company: 'Mercor',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Evaluate and improve frontier AI coding models through frontend engineering assessments.',
  role: 'Frontend Engineer',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: '$85 Per Hour / $400 Per Accepted Task',
  requirements: [
    'React',
    'TypeScript',
    'JavaScript',
    'Frontend Development',
    'AI Coding Agents',
    'Cursor',
    'Claude Code',
    'Codex',
    'UI Architecture',
    'Performance Optimization'
  ],
  postedDate: '2026-06-18',
  applyLink: 'https://t.mercor.com/4dSZz'
},

{
  id: 'JOB042',
  title: 'Scrum Master',
  company: 'Assertive Business Solutions',
  location: 'Bangalore',
  jobType: 'Full-Time',
  description: 'Scrum Master role focused on Agile coaching and Health Insurance projects.',
  role: 'Scrum Master',
  qualification: ['Graduate'],
  experience: '4-12 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Scrum',
    'Agile Coaching',
    'Jira',
    'Confluence',
    'CSM',
    'PSM',
    'SSM',
    'SAFe Scrum Master',
    'Health Insurance Domain'
  ],
  postedDate: '2026-06-18',
  applyLink: 'mailto:santoshi@assertivebs.com'
},

{
  id: 'JOB043',
  title: 'Zoho Developer',
  company: 'OptimHire',
  location: 'Gurugram / Hyderabad',
  jobType: 'Full-Time',
  description: 'Design, develop and maintain custom solutions using Zoho CRM, Creator and Books.',
  role: 'Zoho Developer',
  qualification: [
    'BCA',
    'MCA',
    'BE',
    'B.Tech'
  ],
  experience: '2-4 Years',
  batch: '',
  salary: '₹4-6 LPA',
  requirements: [
    'Zoho CRM',
    'Zoho Creator',
    'Zoho Books',
    'Deluge',
    'REST API',
    'Workflows',
    'Automation',
    'Webhooks',
    'Integrations'
  ],
  postedDate: '2026-06-18',
  applyLink: 'https://optimhire.com/developers/jv/309886?ref_code=mukesh-agrawal'
},
{
  id: 'JOB044',
  title: 'Apprentice Recruitment 2026',
  company: 'Ordnance Factory Chanda (OFCH)',
  location: 'India',
  jobType: 'Apprenticeship',
  description: 'Graduate and Diploma Apprentice recruitment for engineering and general stream candidates.',
  role: 'Graduate / Diploma Apprentice',
  qualification: [
    'Engineering Degree',
    'General Degree',
    'Diploma'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹10,900 - ₹12,300 Per Month',
  requirements: [
    'Degree or Diploma',
    'Apprenticeship Eligibility'
  ],
  postedDate: '2026-06-18',
  applyLink: 'https://govtjobsalert.in/ofch-apprentice-recruitment-2026/'
},

{
  id: 'JOB045',
  title: 'Agniveer Vayu Intake 02/2027',
  company: 'Indian Air Force',
  location: 'India',
  jobType: 'Government Job',
  description: 'Join the Indian Air Force as Agniveer Vayu under Intake 02/2027.',
  role: 'Agniveer Vayu',
  qualification: [
    '10+2 Pass'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹30,000 - ₹40,000',
  requirements: [
    '10+2 Qualification',
    'Medical Fitness',
    'Physical Fitness',
    'Air Force Eligibility Criteria'
  ],
  postedDate: '2026-06-18',
  applyLink: 'https://govtjobsalert.in/iaf-agniveer-vayu-intake-02-2027/'
},
{
  id: 'JOB046',
  title: 'Semiconductor Engineering Apprentice',
  company: 'Synopsys',
  location: 'Pune / Bengaluru / Hyderabad / Noida',
  jobType: 'Apprenticeship',
  description: '12-month Semiconductor Engineering Apprenticeship program with hands-on experience in semiconductor technologies.',
  role: 'Semiconductor Engineering Apprentice',
  qualification: [
    'B.E.',
    'B.Tech',
    'ECE',
    'EEE',
    'E&I',
    'CSE',
    'VLSI',
    'Related Engineering Fields'
  ],
  experience: 'Freshers',
  batch: '2025, 2026',
  salary: '₹45,000 Per Month Stipend',
  requirements: [
    'Semiconductor Fundamentals',
    'Electronics Engineering',
    'VLSI Concepts',
    'Problem Solving',
    'Technical Aptitude'
  ],
  postedDate: '2026-06-18',
  applyLink: 'https://synopsys.avature.net/Indiaapprenticeprogram'
},



{
  id: 'JOB024',
  title: 'iOS Engineer (Coding Agent Experience)',
  company: 'Mercor',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Evaluate and improve frontier AI coding models through structured technical assessments focused on iOS development.',
  role: 'iOS Engineer',
  qualification: ['Bachelor Degree'],
  experience: '2+ Years',
  batch: '',
  salary: '$85 Per Hour / $400 Per Accepted Task',
  requirements: [
    'Swift',
    'iOS Development',
    'AI Coding Agents',
    'Cursor',
    'Claude Code',
    'Codex',
    'Mobile Architecture',
    'Code Review'
  ],
  postedDate: '2026-06-16',
  applyLink: 'https://t.mercor.com/3bgjn'
},

{
  id: 'JOB025',
  title: 'Business Analyst',
  company: 'Blue Yonder',
  location: 'Gurgaon / Hyderabad / Noida / Bangalore',
  jobType: 'Full-Time',
  description: 'Business Analyst role focused on Blue Yonder solutions and retail supply chain domain.',
  role: 'Business Analyst',
  qualification: ['Graduate'],
  experience: '8+ Years',
  batch: '',
  salary: '23 LPA',
  requirements: [
    'Blue Yonder',
    'Supply Chain',
    'Retail Domain',
    'Agile',
    'Stakeholder Management',
    'Business Analysis',
    'BY Commits',
    'BY DSS'
  ],
  postedDate: '2026-06-16',
  applyLink: 'mailto:Vyshnavi.Venigallav@hankersystems.in'
},

{
  id: 'JOB026',
  title: 'Lead Dot Net FullStack Developer',
  company: 'OptimHire',
  location: 'Bengaluru',
  jobType: 'Full-Time',
  description: 'Lead Full Stack Developer role with .NET, Angular, AI integrations and cloud technologies.',
  role: 'Lead Dot Net FullStack Developer',
  qualification: [
    'BCA',
    'MCA',
    'BE',
    'B.Tech'
  ],
  experience: '6-9 Years',
  batch: '',
  salary: '₹6-23 LPA',
  requirements: [
    '.NET',
    'Angular',
    'SQL Server',
    'MongoDB',
    'Git',
    'Docker',
    'Azure',
    'AWS',
    'GCP',
    'OpenAI APIs',
    'RAG',
    'Prompt Engineering',
    'CI/CD',
    'API Security'
  ],
  postedDate: '2026-06-16',
  applyLink: 'https://optimhire.com/developers/jv/309727?ref_code=mukesh-agrawal'
},{
  id: 'JOB027',
  title: 'Apprentice Recruitment 2026',
  company: 'State Bank of India (SBI)',
  location: 'India',
  jobType: 'Apprenticeship',
  description: 'SBI Apprentice Recruitment 2026.',
  role: 'Apprentice',
  qualification: ['Any Graduate'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹15,000 Per Month',
  requirements: [
    'Graduation'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/sbi-apprentice-recruitment-2026/'
},

{
  id: 'JOB028',
  title: 'Apprentice Recruitment 2026',
  company: 'Bank of Baroda',
  location: 'India',
  jobType: 'Apprenticeship',
  description: 'Bank of Baroda Apprentice Recruitment 2026.',
  role: 'Apprentice',
  qualification: ['Any Graduate'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹15,000 Per Month',
  requirements: [
    'Graduation'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/bob-apprentice-recruitment-2026/'
},

{
  id: 'JOB029',
  title: 'Agniveer Apprentice Recruitment 2026',
  company: 'Indian Navy',
  location: 'India',
  jobType: 'Government Job',
  description: 'Indian Navy Agniveer Apprentice Recruitment 2026.',
  role: 'Agniveer Apprentice',
  qualification: [
    '10th Pass',
    '3-Year Engineering Diploma'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹30,000 - ₹40,000',
  requirements: [
    'Engineering Diploma',
    'Physical Fitness'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/indian-navy-agniveer-apprentice-recruitment-2026/'
},

{
  id: 'JOB030',
  title: 'Latest 12th Pass Government Jobs 2026',
  company: 'Government of India',
  location: 'India',
  jobType: 'Government Job',
  description: 'Collection of active government jobs for 12th pass candidates.',
  role: 'Various Posts',
  qualification: ['12th Pass'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹18,000 - ₹1,51,100',
  requirements: [
    '12th Pass',
    'Post-wise Eligibility'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/12th-pass-govt-jobs/'
},

{
  id: 'JOB031',
  title: 'SSC GD Constable 2026 Answer Key',
  company: 'Staff Selection Commission',
  location: 'India',
  jobType: 'Government Job',
  description: 'SSC GD Constable 2026 Answer Key Released.',
  role: 'Constable GD',
  qualification: ['10th Pass'],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹21,700 - ₹69,100',
  requirements: [
    'SSC GD Eligibility'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/ssc-constable-gd-exam-2026/'
},

{
  id: 'JOB032',
  title: 'Civil Services Examination 2026 Result',
  company: 'UPSC',
  location: 'India',
  jobType: 'Result Notification',
  description: 'UPSC Civil Services Preliminary Examination 2026 Result.',
  role: 'Civil Services Candidate',
  qualification: ['Graduate'],
  experience: '',
  batch: '',
  salary: '',
  requirements: [],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/upsc-civil-services-2026/'
},

{
  id: 'JOB033',
  title: 'Forest Services Examination 2026 Result',
  company: 'UPSC',
  location: 'India',
  jobType: 'Result Notification',
  description: 'UPSC Forest Services Preliminary Examination 2026 Result.',
  role: 'Forest Services Candidate',
  qualification: ['Graduate'],
  experience: '',
  batch: '',
  salary: '',
  requirements: [],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/upsc-forest-service-exam-2026/'
},{
  id: 'JOB034',
  title: 'Payroll / HR Operations',
  company: 'Mphasis',
  location: 'Pune',
  jobType: 'Walk-In',
  description: 'Walk-in drive for Payroll and HR Operations professionals.',
  role: 'Payroll / HR Operations Executive',
  qualification: ['Any Graduate'],
  experience: '1-4 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Canada Payroll',
    'US Payroll',
    'Global Payroll',
    'HR Operations',
    'Payroll Processing'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-hiring-payroll-hr-operations-18th-june-26-mphasis-pune-1-to-4-years-150626038740'
},

{
  id: 'JOB035',
  title: 'CS Executive - Portfolio Management',
  company: 'AXA Global Business Services',
  location: 'Pune',
  jobType: 'Walk-In',
  description: 'Contractual role in Portfolio Management.',
  role: 'CS Executive',
  qualification: ['Graduate'],
  experience: '2-4 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Accounting',
    'Reconciliation',
    'Debit',
    'Credit',
    'Ledger Management'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-cs-executive-portfolio-management-contractual-role-pune-axa-global-business-services-pune-2-to-4-years-150626020809'
},

{
  id: 'JOB036',
  title: 'US Health & Welfare Associate',
  company: 'Conduent',
  location: 'Noida',
  jobType: 'Walk-In',
  description: 'US Health & Welfare process hiring.',
  role: 'Health & Welfare Associate',
  qualification: ['Any Graduate'],
  experience: '0-4 Years',
  batch: '',
  salary: '₹2-7 LPA',
  requirements: [
    'Health And Welfare',
    'HIPAA',
    'Annual Enrollment',
    'COBRA Processing',
    'Life Events'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-us-health-welfare-noida-conduent-noida-0-to-4-years-190126014878'
},

{
  id: 'JOB037',
  title: 'Biomedical Engineer',
  company: 'Access Healthcare',
  location: 'Chennai',
  jobType: 'Walk-In',
  description: 'Walk-in drive for Biomedical Engineers.',
  role: 'Biomedical Engineer',
  qualification: [
    'Biomedical Engineering'
  ],
  experience: '0-3 Years',
  batch: '',
  salary: '₹2.25-2.5 LPA',
  requirements: [
    'Biomedical Engineering',
    'Medical Coding',
    'Bioinformatics'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-for-bio-medical-engineers-freshers-access-healthcare-chennai-0-to-3-years-150626027105'
},

{
  id: 'JOB038',
  title: 'QA/QC Engineer',
  company: 'Negolice India',
  location: 'Gurugram',
  jobType: 'Walk-In',
  description: 'QA/QC Engineer hiring for real estate projects.',
  role: 'QA/QC Engineer',
  qualification: ['Civil Engineering or Related Degree'],
  experience: '3-8 Years',
  batch: '',
  salary: '₹4-6 LPA',
  requirements: [
    'QA/QC',
    'Quality Assurance',
    'Quality Control',
    'Residential Projects',
    'Real Estate'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-qa-qc-engineer-gurugram-20th-21st-june-negolice-india-gurugram-3-to-8-years-120626013716'
},

{
  id: 'JOB039',
  title: 'Java Microservices Developer',
  company: 'Tata Consultancy Services',
  location: 'Pune',
  jobType: 'Walk-In',
  description: 'Walk-in drive for Java Microservices professionals.',
  role: 'Java Microservices Developer',
  qualification: ['Bachelor Degree'],
  experience: '6-11 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Java',
    'Spring Boot',
    'Microservices'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-tcs-pune-walk-in-for-java-microservices-tata-consultancy-services-pune-6-to-11-years-120626013346'
},

{
  id: 'JOB040',
  title: 'Creative Quality Role',
  company: 'Accenture',
  location: 'Mumbai',
  jobType: 'Walk-In',
  description: 'Creative Quality role for design professionals.',
  role: 'Creative Quality Associate',
  qualification: ['Graduate'],
  experience: '3-7 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Creative Designing',
    'Visual Design',
    'UI/UX',
    'Graphic Design'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://www.naukri.com/job-listings-walk-in-drive-in-accenture-for-creative-quality-role-accenture-mumbai-all-areas-3-to-7-years-150626020577'
},
{
  id: 'JOB014',
  title: 'AI Native Engineer',
  company: 'HeyHomie',
  location: 'Bangalore',
  jobType: 'Full-Time',
  description: 'Founding-engineer grade role with trajectory to AI Lead in 12-18 months.',
  role: 'AI Native Engineer',
  qualification: ['Bachelor Degree'],
  experience: 'Production AI Experience',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'AI Engineering',
    'LLMs',
    'Production AI Systems',
    'Machine Learning'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://heyhomie.me/careers/ai-native-engineer'
},

{
  id: 'JOB015',
  title: 'Software Developer Intern',
  company: 'Anethix Labs',
  location: 'Remote / Guwahati Hybrid',
  jobType: 'Internship',
  description: 'Work on real products with real users and real business problems.',
  role: 'Software Developer Intern',
  qualification: ['Any Degree'],
  experience: 'Freshers',
  batch: '2024, 2025, 2026',
  salary: 'Unpaid Internship',
  requirements: [
    'Web Development',
    'App Development',
    'Portfolio Projects',
    'Problem Solving'
  ],
  postedDate: '2026-06-15',
  applyLink: 'mailto:team@anethixlabs.com'
},

{
  id: 'JOB016',
  title: 'System Administrator',
  company: 'PeepalCo',
  location: 'Bengaluru',
  jobType: 'Full-Time',
  description: 'IT Asset Management, User Onboarding, L1 Support and System Administration.',
  role: 'System Administrator',
  qualification: [
    'Bachelor Degree in IT',
    'Computer Science'
  ],
  experience: '3-4 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Windows',
    'MacOS',
    'Active Directory',
    'Google Workspace',
    'Jamf',
    'JumpCloud',
    'VPN',
    'DNS',
    'WiFi'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://recruiterflow.com/coinswitch/jobs/632'
},

{
  id: 'JOB017',
  title: 'Software Developer',
  company: 'Hafman Consulting',
  location: 'Remote India',
  jobType: 'Full-Time',
  description: 'Work remotely with Japanese clients and team.',
  role: 'Software Developer',
  qualification: ['Bachelor Degree'],
  experience: '3+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'JavaScript',
    'Java',
    'C#',
    'React',
    'Vue',
    'REST API'
  ],
  postedDate: '2026-06-15',
  applyLink: 'mailto:shilpa@hafman.ca'
},

{
  id: 'JOB018',
  title: 'Incident Management / Reliability / SRE Evaluator',
  company: 'Mercor',
  location: 'Remote',
  jobType: 'Contract',
  description: 'Evaluate AI-generated work products for quality, accuracy and reliability.',
  role: 'SRE Evaluator',
  qualification: [
    'Bachelor Degree',
    'Masters Preferred'
  ],
  experience: '5+ Years',
  batch: '',
  salary: '$80-$120 Per Hour',
  requirements: [
    'Incident Management',
    'SRE',
    'Reliability Engineering',
    'Microsoft Office',
    'Google Workspace',
    'English Fluency'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://t.mercor.com/k1LNL'
},

{
  id: 'JOB019',
  title: 'Group B & C Recruitment 2026',
  company: 'AIIMS',
  location: 'India',
  jobType: 'Government',
  description: 'AIIMS CRE-5 Group B & C Recruitment for various posts.',
  role: 'Group B & C Staff',
  qualification: [
    '10th Pass',
    '12th Pass',
    'Diploma',
    'Graduate',
    'Post Graduate'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹18,000 - ₹1,51,100',
  requirements: [
    'Post-wise Eligibility'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/aiims-cre-5-recruitment-2026/'
},

{
  id: 'JOB020',
  title: 'Assistant (Airport Security)',
  company: 'AAICLAS',
  location: 'India',
  jobType: 'Government',
  description: 'Airport Security Assistant recruitment.',
  role: 'Assistant (Airport Security)',
  qualification: [
    '12th Pass'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹21,500 - ₹22,500 Per Month',
  requirements: [
    'Communication Skills',
    'Security Operations'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/aaiclas-security-assistant-recruitment-2026/'
},

{
  id: 'JOB021',
  title: 'AFCAT 02/2026 Officer Recruitment',
  company: 'Indian Air Force',
  location: 'India',
  jobType: 'Government',
  description: 'Commissioned Officer recruitment through AFCAT 02/2026.',
  role: 'Air Force Officer',
  qualification: [
    'Any Graduate',
    'Engineering Graduate'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹56,100 - ₹1,77,500',
  requirements: [
    'AFCAT Eligibility Criteria',
    'Medical Fitness'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/afcat-2-2026/'
},

{
  id: 'JOB022',
  title: '10+2 B.Tech Cadet Entry 2026',
  company: 'Indian Navy',
  location: 'India',
  jobType: 'Government',
  description: 'Join Indian Navy through 10+2 B.Tech Cadet Entry Scheme.',
  role: 'Cadet Entry Officer',
  qualification: [
    '10+2 PCM'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: 'Sub Lieutenant Level-10 + Fully Paid B.Tech',
  requirements: [
    'Physics',
    'Chemistry',
    'Mathematics',
    'JEE Main Eligibility'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/indian-navy-10-2-btech-cadet-entry-2026/'
},

{
  id: 'JOB023',
  title: 'Latest Graduate Government Jobs 2026',
  company: 'Government of India',
  location: 'India',
  jobType: 'Government',
  description: 'Multiple graduate-level government job opportunities across departments.',
  role: 'Various Graduate Posts',
  qualification: [
    'Any Graduate'
  ],
  experience: 'Freshers Eligible',
  batch: '',
  salary: '₹25,500 - ₹1,77,500',
  requirements: [
    'Graduation',
    'Post-wise Eligibility'
  ],
  postedDate: '2026-06-15',
  applyLink: 'https://govtjobsalert.in/graduate-govt-jobs/'
},



  {
    id: 'JOB001',
    title: 'AWS Engineer',
    company: 'QubitV',
    location: 'Bangalore, Karnataka, India',
    jobType: 'Contract',
    description: 'AWS Engineer with FSx, FSxN and DataSync experience.',
    role: 'AWS Engineer',
    qualification: ['Bachelor Degree'],
    experience: '6-8 Years',
    batch: '',
    salary: 'Not Disclosed',
    requirements: [
      'AWS FSx',
      'AWS FSxN',
      'AWS DataSync',
      'EC2',
      'CloudWatch',
      'IAM',
      'S3',
      'Lambda',
      'VPC',
      'EBS',
      'KMS'
    ],
    postedDate: '2026-06-13',
    applyLink: 'mailto:swayzeestibeiro@qubitv.in'
  },

  {
    id: 'JOB002',
    title: 'Product Manager',
    company: 'Blinkit',
    location: 'India',
    jobType: 'Full-Time',
    description: 'Direct test opportunity for Product Manager role.',
    role: 'Product Manager',
    qualification: ['Any Qualification'],
    experience: 'Freshers',
    batch: '2024, 2025, 2026',
    salary: 'Not Disclosed',
    requirements: ['Python', 'SQL', 'Problem Solving'],
    postedDate: '2026-06-13',
    applyLink: 'https://www.hackerrank.com/test-v2/d7qptgerlc5/9a2bd46615676423ef4f2c9f8eaea386'
  },

  {
    id: 'JOB003',
    title: 'Intern',
    company: 'Wipro',
    location: 'Bengaluru',
    jobType: 'Internship',
    description: 'Internship opportunity for fresh graduates.',
    role: 'Intern',
    qualification: ['Bachelor Degree', 'Master Degree'],
    experience: 'Freshers',
    batch: '2024, 2025, 2026',
    salary: 'Not Disclosed',
    requirements: ['Programming', 'Communication Skills'],
    postedDate: '2026-06-13',
    applyLink: 'https://careers.wipro.com/job/Intern-New/166370-en_US'
  },

  {
    id: 'JOB004',
    title: 'Software Engineer I',
    company: 'Nike',
    location: 'Karnataka, India',
    jobType: 'Full-Time',
    description: 'Software Engineer role for freshers and experienced candidates.',
    role: 'Software Engineer I',
    qualification: ['Bachelor Degree', 'Master Degree'],
    experience: '0+ Years',
    batch: '2024, 2025, 2026',
    salary: 'Not Disclosed',
    requirements: ['Software Development', 'Programming'],
    postedDate: '2026-06-13',
    applyLink: 'https://careers.nike.com/software-engineer-i-itc/job/R-85669'
  },

  {
    id: 'JOB005',
    title: 'Measurement & Reporting Associate',
    company: 'Accenture',
    location: 'Bengaluru',
    jobType: 'Full-Time',
    description: 'Entry-level reporting and analytics role.',
    role: 'Measurement & Reporting Associate',
    qualification: ['Any Graduation'],
    experience: '0-1 Year',
    batch: '2024, 2025, 2026',
    salary: 'Not Disclosed',
    requirements: ['Reporting', 'MS Excel', 'Communication'],
    postedDate: '2026-06-13',
    applyLink: 'https://www.accenture.com/in-en/careers/jobdetails?id=AIOC-S01647826_en'
  },{
  id: 'JOB006',
  title: 'Technical Project Manager',
  company: 'MedWynk',
  location: 'Pune',
  jobType: 'Full-Time',
  description: 'Lead end-to-end development of medical devices across hardware, firmware and mechanical teams.',
  role: 'Technical Project Manager',
  qualification: ['B.E', 'B.Tech', 'Related Engineering Degree'],
  experience: '10-15 Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Project Management',
    'Stakeholder Management',
    'Vendor Management',
    'Medical Devices',
    'Hardware Development',
    'Firmware Development'
  ],
  postedDate: '2026-06-13',
  applyLink: 'mailto:urza.saini@medwynk.com'
},

{
  id: 'JOB007',
  title: 'Principal Engineer - Dev Platform',
  company: 'Rubrik',
  location: 'Bangalore',
  jobType: 'Full-Time',
  description: 'Drive technical strategy for Developer Platform, Infrastructure and AI-powered productivity.',
  role: 'Principal Engineer',
  qualification: ['B.E', 'B.Tech', 'MCA', 'Computer Science Degree'],
  experience: '18+ Years',
  batch: '',
  salary: 'Not Disclosed',
  requirements: [
    'Go',
    'Java',
    'Python',
    'C++',
    'Cloud Infrastructure',
    'CI/CD',
    'Observability',
    'AI/ML',
    'Platform Engineering'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://www.rubrik.com/company/careers/departments/job.7270376.1929?reqId=INSW9693'
},

{
  id: 'JOB008',
  title: 'Program / Project Manager',
  company: 'Era Manpower',
  location: 'Gurgaon',
  jobType: 'Full-Time',
  description: 'IT Project Management in Logistics and 3PL domain.',
  role: 'Program Manager',
  qualification: ['B.Tech', 'MCA'],
  experience: '15-20 Years',
  batch: '',
  salary: '25-35 LPA',
  requirements: [
    'ERP',
    'WMS',
    'TMS',
    'PMP',
    'PRINCE2',
    'Process Automation',
    'IT Transformation'
  ],
  postedDate: '2026-06-13',
  applyLink: 'mailto:hr@eramanpower.com'
},

{
  id: 'JOB009',
  title: 'Paid Internship 2026',
  company: 'DRDO ARDE',
  location: 'Pune',
  jobType: 'Internship',
  description: 'Paid internship opportunity for engineering students.',
  role: 'Engineering Intern',
  qualification: ['B.E', 'B.Tech', 'M.Tech'],
  experience: 'Freshers',
  batch: '2026',
  salary: '₹30,000 Stipend',
  requirements: [
    'Engineering Background',
    'Research Interest'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://govtjobsalert.in/drdo-arde-pune-paid-internship-2026/'
},

{
  id: 'JOB010',
  title: 'Non-Teaching Staff',
  company: 'University of Jammu',
  location: 'Jammu',
  jobType: 'Government Job',
  description: 'Various non-teaching positions available.',
  role: 'Non-Teaching Staff',
  qualification: [
    'Matric',
    'Diploma',
    'B.E',
    'B.Tech'
  ],
  experience: 'As Per Post',
  batch: '',
  salary: '₹14,800 - ₹1,13,500',
  requirements: [
    'Post Specific Eligibility'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://govtjobsalert.in/jammu-university-non-teaching-recruitment-2026/'
},

{
  id: 'JOB011',
  title: 'Trade Apprentice',
  company: 'Mazagon Dock Shipbuilders Limited',
  location: 'Mumbai',
  jobType: 'Apprenticeship',
  description: 'Trade Apprentice recruitment under Apprentices Act 1961.',
  role: 'Trade Apprentice',
  qualification: [
    '8th Pass',
    '10th Pass',
    'ITI'
  ],
  experience: 'Freshers',
  batch: '',
  salary: 'Stipend As Per Rules',
  requirements: [
    'Relevant Trade Skills'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://govtjobsalert.in/mdl-trade-apprentice-recruitment-2026/'
},

{
  id: 'JOB012',
  title: 'Assistant Loco Pilot',
  company: 'Railway Recruitment Board',
  location: 'India',
  jobType: 'Government Job',
  description: 'Assistant Loco Pilot recruitment.',
  role: 'Assistant Loco Pilot',
  qualification: [
    'Diploma',
    'ITI',
    'Engineering Degree'
  ],
  experience: 'Freshers',
  batch: '',
  salary: '₹19,900 + Allowances',
  requirements: [
    'RRB Eligibility Criteria'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://govtjobsalert.in/rrb-assistant-loco-pilot-recruitment-2025/'
},

{
  id: 'JOB013',
  title: 'RRB NTPC Graduate Level',
  company: 'Railway Recruitment Board',
  location: 'India',
  jobType: 'Government Job',
  description: 'Graduate level NTPC recruitment.',
  role: 'NTPC Graduate',
  qualification: [
    'Any Graduation'
  ],
  experience: 'Freshers',
  batch: '',
  salary: 'As Per RRB Norms',
  requirements: [
    'RRB Eligibility Criteria'
  ],
  postedDate: '2026-06-13',
  applyLink: 'https://govtjobsalert.in/rrb-ntpc-graduate-exam-2025/'
},


  {
    id: "gov-20260524-edcil-879",
    title: "EdCIL Staff Recruitment 2026",
    company: "EdCIL",
    category: "Government",
    jobType: "Full-time",
    location: "India",
    experience: "Freshers & Experienced",
    qualification: "Relevant Degree / Diploma",
    salary: "₹25,000 - ₹55,000 per month",
    skills: [
      "Communication Skills",
      "Administrative Skills",
      "Technical Knowledge"
    ],
    responsibilities: [
      "Perform assigned contractual duties",
      "Maintain departmental workflow",
      "Support project and operational activities"
    ],
    requirements: [
      "Relevant Degree or Diploma required",
      "Candidates must meet official eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "Government Job Opportunity",
      "Monthly Consolidated Salary"
    ],
    applyLink: "https://govtjobsalert.in/edcil-staff-recruitment-2026/",
    postedDate: "2026-05-24"
  },

  {
    id: "gov-20260524-drdo-10",
    title: "DRDO MTRDC Paid Internship 2026",
    company: "DRDO MTRDC Bengaluru",
    category: "Government",
    jobType: "Internship",
    location: "Bengaluru, Karnataka",
    experience: "Students",
    qualification: "B.Tech (VII/VIII Sem) or M.Tech/M.Sc 2nd Year",
    salary: "₹30,000 Total Stipend",
    skills: [
      "Research Skills",
      "Engineering Knowledge",
      "Technical Analysis"
    ],
    responsibilities: [
      "Assist in DRDO research projects",
      "Support technical and laboratory activities",
      "Work with research teams on defense technologies"
    ],
    requirements: [
      "Eligible B.Tech, M.Tech or M.Sc students only",
      "Candidates must satisfy DRDO internship criteria"
    ],
    certifications: [],
    benefits: [
      "Paid Internship",
      "Research Experience at DRDO"
    ],
    applyLink: "https://govtjobsalert.in/drdo-mtrdc-paid-internship-2026/",
    postedDate: "2026-05-24"
  },

  {
    id: "gov-20260524-tnpsc-461",
    title: "TNPSC CTSE 2026",
    company: "TNPSC",
    category: "Government",
    jobType: "Full-time",
    location: "Tamil Nadu",
    experience: "Freshers & Experienced",
    qualification: "B.E. / B.Tech / M.Sc. / B.Pharm / LLB / MBA / Others",
    salary: "₹28,480 - ₹2,18,200 per month",
    skills: [
      "Technical Knowledge",
      "Problem Solving",
      "Administrative Skills"
    ],
    responsibilities: [
      "Handle departmental technical tasks",
      "Perform government administrative duties",
      "Support project implementation and operations"
    ],
    requirements: [
      "Candidates must possess required educational qualifications",
      "Must meet TNPSC eligibility conditions"
    ],
    certifications: [],
    benefits: [
      "Government Salary Package",
      "Career Growth Opportunities"
    ],
    applyLink: "https://govtjobsalert.in/tnpsc-ctse-recruitment-2026/",
    postedDate: "2026-05-24"
  },

  {
    id: "gov-20260524-rssb-3951",
    title: "RSSB Computer Instructor Recruitment 2026",
    company: "RSSB Rajasthan",
    category: "Government",
    jobType: "Full-time",
    location: "Rajasthan",
    experience: "Freshers & Experienced",
    qualification: "PG (CS/IT) / MCA / Graduate + A Level / PGDCA / B.Tech (CS/IT) / BCA",
    salary: "₹35,400 - ₹1,77,500 per month",
    skills: [
      "Computer Science",
      "Programming",
      "Teaching Skills",
      "IT Knowledge"
    ],
    responsibilities: [
      "Teach computer-related subjects",
      "Prepare training materials",
      "Conduct classroom and practical sessions"
    ],
    requirements: [
      "Relevant CS/IT qualifications required",
      "Candidates must fulfill RSSB eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "Government Teaching Job",
      "High Salary Package"
    ],
    applyLink: "https://govtjobsalert.in/rssb-computer-instructor-recruitment-2026/",
    postedDate: "2026-05-24"
  },
  {
    id: "nonit-20260524-datamatics-misexecutive-001",
    title: "MIS Executive",
    company: "Datamatics Global Services Ltd.",
    category: "Non-IT",
    jobType: "Walk-in",
    location: "Nashik, Maharashtra",
    experience: "2 - 3 Years",
    qualification: "B.Com / M.Com / MBA (Finance)",
    salary: "Not Disclosed",
    skills: [
      "MIS Reporting",
      "Data Analysis",
      "Excel",
      "Reporting Operations",
      "Analytical Skills"
    ],
    responsibilities: [
      "Prepare MIS reports",
      "Handle reporting operations",
      "Analyze business data",
      "Maintain reporting accuracy"
    ],
    requirements: [
      "2-3 years experience required",
      "Finance background preferred",
      "Detail-oriented candidates preferred"
    ],
    certifications: [],
    benefits: [
      "Career Growth Opportunity",
      "Walk-in Interview"
    ],
    applyLink: "mailto:durga.gaikwad@datamatics.com",
    postedDate: "2026-05-24"
  },

  {
    id: "nonit-20260524-ltts-talentacquisition-002",
    title: "Talent Acquisition Professional",
    company: "L&T Technology Services",
    category: "Non-IT",
    jobType: "Full-time",
    location: "Pune, Maharashtra",
    experience: "2 - 5 Years",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "Talent Acquisition",
      "Recruitment",
      "HR Operations",
      "Communication Skills"
    ],
    responsibilities: [
      "Handle end-to-end recruitment",
      "Source and screen candidates",
      "Coordinate hiring processes",
      "Support talent acquisition operations"
    ],
    requirements: [
      "2-5 years recruitment experience required",
      "Immediate joiners preferred",
      "Work From Office mandatory"
    ],
    certifications: [],
    benefits: [
      "Corporate Work Environment",
      "Career Growth"
    ],
    applyLink: "mailto:india.careers@ltts.com",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-pletratech-assoftwareengineer-003",
    title: "Associate Software Engineer",
    company: "Pletratech",
    category: "IT",
    jobType: "Walk-in",
    location: "Pune, Maharashtra",
    experience: "0 - 1 Year",
    qualification: "2023/2024 Passout or Earlier",
    salary: "Not Disclosed",
    skills: [
      "Salesforce",
      "Apex",
      "LWC",
      "Triggers",
      "REST API",
      "SOAP API",
      "Sales Cloud",
      "Service Cloud"
    ],
    responsibilities: [
      "Develop Salesforce applications",
      "Work on Apex and LWC components",
      "Integrate REST/SOAP APIs",
      "Support cloud-based solutions"
    ],
    requirements: [
      "Salesforce internship or training required",
      "Immediate joiners preferred",
      "Basic Salesforce knowledge mandatory"
    ],
    certifications: [],
    benefits: [
      "IT Career Opportunity",
      "Walk-in Drive"
    ],
    applyLink: "mailto:careers@pletratech.com",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-paygent-fullstackintern-004",
    title: "Full Stack Developer Intern",
    company: "Paygent",
    category: "IT",
    jobType: "Internship",
    location: "Remote / Bengaluru",
    experience: "Freshers",
    qualification: "Currently pursuing a college/university degree",
    salary: "Unpaid with Performance Bonus",
    skills: [
      "Python",
      "JavaScript",
      "Go",
      "Next.js",
      "MERN Stack",
      "MongoDB",
      "Express.js",
      "React",
      "Node.js"
    ],
    responsibilities: [
      "Build full-stack features from scratch",
      "Develop AI monetization infrastructure",
      "Handle frontend and backend development",
      "Work on deployment and database design"
    ],
    requirements: [
      "Must be currently enrolled in college",
      "Portfolio or GitHub projects required",
      "Strong frontend and backend skills",
      "Self-starter mindset required"
    ],
    certifications: [],
    benefits: [
      "Performance Bonus",
      "Internship Certificate",
      "Letter of Recommendation",
      "Real-world AI startup experience"
    ],
    applyLink: "https://wellfound.com/jobs/4219924-full-stack-software-engineer",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-transitionprojectmanager-005",
    title: "IT Project Manager / Transition Project Manager / Transition Project Coordinator",
    company: "Confidential",
    category: "IT",
    jobType: "Full-time",
    location: "India",
    experience: "Experienced",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "IT Project Management",
      "ITSM",
      "ServiceNow",
      "Jira",
      "ITAD",
      "IMACD",
      "Vendor Management",
      "Infrastructure Deployment"
    ],
    responsibilities: [
      "Manage end-to-end IT transition projects",
      "Coordinate infrastructure deployments",
      "Track project risks and escalations",
      "Handle stakeholder communication"
    ],
    requirements: [
      "Experience in IT Project Management required",
      "Knowledge of ITSM and PMO governance",
      "Experience with ServiceNow and Jira preferred"
    ],
    certifications: [
      "ITIL"
    ],
    benefits: [
      "Career Growth",
      "Enterprise Project Exposure"
    ],
    applyLink: "mailto:raghumadav1432@gmail.com,kumarisravani1998@gmail.com",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-akamai-softwareengineer-006",
    title: "Software Engineer",
    company: "Akamai Technologies",
    category: "IT",
    jobType: "Full-time",
    location: "India",
    experience: "0 - 2 Years",
    qualification: "Bachelor's or Master's Degree in Computer Science",
    salary: "Not Disclosed",
    skills: [
      "C",
      "C++",
      "Python",
      "Linux",
      "Networking",
      "TCP/IP",
      "HTTP",
      "DNS"
    ],
    responsibilities: [
      "Develop and maintain scalable systems",
      "Work on internet technologies",
      "Debug distributed systems",
      "Support automation frameworks"
    ],
    requirements: [
      "Computer Science degree required",
      "Knowledge of operating systems and networks",
      "Programming and scripting skills required"
    ],
    certifications: [],
    benefits: [
      "Global Tech Company",
      "Career Growth Opportunities"
    ],
    applyLink: "https://fa-extu-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/job/3000",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-csiglobal-incidentmanager-007",
    title: "Senior Incident Manager",
    company: "CSI Global",
    category: "IT",
    jobType: "Full-time",
    location: "India",
    experience: "8 - 12 Years",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "Incident Management",
      "ITIL",
      "ServiceNow",
      "SLA Management",
      "Risk Management"
    ],
    responsibilities: [
      "Lead P1/P2 incident management",
      "Coordinate cross-functional teams",
      "Track MTTA and MTTR metrics",
      "Provide executive updates"
    ],
    requirements: [
      "3-5 years in Major Incident Management required",
      "Experience with ServiceNow preferred",
      "Strong stakeholder management skills"
    ],
    certifications: [
      "ITIL"
    ],
    benefits: [
      "Leadership Role",
      "Enterprise IT Exposure"
    ],
    applyLink: "mailto:Ramya.Gangula@CSIGlobal.co.uk",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-visa-seniorsoftwareengineer-008",
    title: "Senior Software Engineer – Open Banking",
    company: "Visa",
    category: "IT",
    jobType: "Full-time",
    location: "Bengaluru, Karnataka",
    experience: "2 - 8 Years",
    qualification: "Bachelor Degree in Computer Science or Related Field",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Node.js",
      "JavaScript",
      "AWS",
      "Kubernetes",
      "Docker",
      "CI/CD",
      "Generative AI",
      "Datadog"
    ],
    responsibilities: [
      "Build scalable banking APIs",
      "Develop AI-powered engineering solutions",
      "Manage cloud-native deployments",
      "Maintain DevOps workflows"
    ],
    requirements: [
      "Experience in Java and Node.js required",
      "Cloud-native DevOps experience preferred",
      "Knowledge of Generative AI concepts preferred"
    ],
    certifications: [],
    benefits: [
      "Global Fintech Opportunity",
      "AI-First Engineering Environment",
      "Hybrid Work Model"
    ],
    applyLink: "https://visa.wd5.myworkdayjobs.com/en-US/Visa/details/Senior-Software-Engineer---Open-Banking_REF082360W-1",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-cognizant-servicedesk-009",
    title: "Digital Workplace Practice (Service Desk)",
    company: "Cognizant",
    category: "IT",
    jobType: "Full-time",
    location: "PAN India",
    experience: "Freshers",
    qualification: "BCA, BSc, BCom, BA, BBA & other 3-year UG courses",
    salary: "Not Disclosed",
    skills: [
      "Service Desk",
      "Technical Support",
      "Communication Skills",
      "Problem Solving",
      "Customer Support"
    ],
    responsibilities: [
      "Provide IT support to users",
      "Handle service desk operations",
      "Resolve technical issues",
      "Maintain customer satisfaction"
    ],
    requirements: [
      "Eligible 3-year UG degree required",
      "Good communication skills required",
      "Freshers can apply"
    ],
    certifications: [],
    benefits: [
      "PAN India Opportunity",
      "Career Growth in IT Support"
    ],
    applyLink: "https://app.joinsuperset.com/join/#/signup/student/jobprofiles/a8af19f3-444e-43bd-8828-e8656f637a17",
    postedDate: "2026-05-24"
  },

  {
    id: "it-20260524-visa-devopsengineer-010",
    title: "Software Engineer - DevOps",
    company: "Visa",
    category: "IT",
    jobType: "Full-time",
    location: "Bengaluru, Karnataka",
    experience: "Freshers / Experienced",
    qualification: "Bachelor's Degree",
    salary: "Not Disclosed",
    skills: [
      "DevOps",
      "Cloud",
      "CI/CD",
      "Automation",
      "Infrastructure Management"
    ],
    responsibilities: [
      "Develop and maintain DevOps pipelines",
      "Support infrastructure automation",
      "Monitor deployment systems",
      "Collaborate with engineering teams"
    ],
    requirements: [
      "Bachelor's degree required",
      "Knowledge of DevOps concepts preferred",
      "Freshers and experienced candidates can apply"
    ],
    certifications: [],
    benefits: [
      "Global Fintech Company",
      "Career Growth Opportunities"
    ],
    applyLink: "https://visa.wd5.myworkdayjobs.com/en-US/Visa/job/SW-Engineer_REF080404W",
    postedDate: "2026-05-22"
  },

  {
    id: "it-20260524-jpmorgan-operationsanalyst-011",
    title: "Credit Risk - Operations Analyst",
    company: "JPMorgan",
    category: "IT",
    jobType: "Full-time",
    location: "Bengaluru / Mumbai",
    experience: "Freshers / Experienced",
    qualification: "Bachelor's / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Operations Analysis",
      "Credit Risk",
      "Data Analysis",
      "Financial Operations",
      "Communication Skills"
    ],
    responsibilities: [
      "Handle credit risk operations",
      "Analyze operational data",
      "Support financial processes",
      "Maintain operational accuracy"
    ],
    requirements: [
      "Bachelor's or Master’s degree required",
      "Analytical skills preferred",
      "Freshers and experienced candidates can apply"
    ],
    certifications: [],
    benefits: [
      "Global Banking Opportunity",
      "Career Development"
    ],
    applyLink: "https://jpmc.fa.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1001/jobs/preview/210660683/",
    postedDate: "2026-05-22"
  },

  {
    id: "it-20260524-harman-awsdevops-012",
    title: "Associate Engineer - AWS DevOps",
    company: "Harman",
    category: "IT",
    jobType: "Full-time",
    location: "Bangalore, Karnataka",
    experience: "0 - 1 Year",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "AWS",
      "DevOps",
      "Cloud Computing",
      "CI/CD",
      "Linux"
    ],
    responsibilities: [
      "Support AWS cloud infrastructure",
      "Maintain DevOps pipelines",
      "Assist deployment processes",
      "Collaborate with engineering teams"
    ],
    requirements: [
      "Bachelor’s degree required",
      "Freshers can apply",
      "Basic AWS and DevOps knowledge preferred"
    ],
    certifications: [],
    benefits: [
      "Global Product Company",
      "Cloud Technology Exposure"
    ],
    applyLink: "https://jobsearch.harman.com/en_US/careers/JobDetail/Associate-Engineer-AWS-Devops/31598",
    postedDate: "2026-05-23"
  },

  {
    id: "it-20260524-virtusa-javaawsdeveloper-013",
    title: "Java AWS Developer",
    company: "Virtusa",
    category: "IT",
    jobType: "Full-time",
    location: "Bangalore, Karnataka",
    experience: "Experienced",
    qualification: "Bachelor's / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "AWS",
      "Spring Boot",
      "Cloud Computing",
      "Backend Development"
    ],
    responsibilities: [
      "Develop Java-based applications",
      "Work on AWS cloud services",
      "Build scalable backend systems",
      "Collaborate with development teams"
    ],
    requirements: [
      "Experience in Java development required",
      "AWS knowledge required",
      "Bachelor’s or Master’s degree required"
    ],
    certifications: [],
    benefits: [
      "Enterprise IT Projects",
      "Career Growth Opportunities"
    ],
    applyLink: "https://www.virtusa.com/careers/in/gurgaon/core-tech-java/java-aws-developer/creq250605",
    postedDate: "2026-05-23"
  },

  {
    id: "scaler-problem-setter-intern-001",
    title: "Problem Setter and Content Intern",
    company: "Scaler",
    category: "Internship",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "College Students (2026/2027 Batch)",
    salary: "₹35,000/month",
    skills: [
      "Java",
      "Spring",
      "Python",
      "Django",
      "DSA",
      "GitHub",
      "GenAI",
      "LLMs"
    ],
    responsibilities: [
      "Create coding problems",
      "Work on technical content",
      "Collaborate with engineering teams",
      "Build programming-related content"
    ],
    requirements: [
      "Strong programming skills",
      "1600+ Codeforces or 5 Star CodeChef preferred",
      "Strong GitHub profile"
    ],
    certifications: [],
    benefits: [
      "High Stipend",
      "Remote Learning",
      "Career Growth"
    ],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSeD97G1Jwi6bpEMn7kqIVM21SQYV21372Boyim07z6zapAHsw/viewform",
    postedDate: "2026-05-22"
  },
  {
    id: "associate-principal-engineer-servicenow-002",
    title: "Associate Principal Engineer",
    company: "NCS",
    category: "IT Jobs",
    jobType: "Full Time",
    location: "PAN India",
    experience: "7-10+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹30 LPA",
    skills: [
      "ServiceNow",
      "ITSM",
      "ITOM",
      "CMDB",
      "PowerShell",
      "AngularJS",
      "Integrations"
    ],
    responsibilities: [
      "Implement ServiceNow modules",
      "Develop technical solutions",
      "Handle integrations",
      "Perform configuration changes"
    ],
    requirements: [
      "ServiceNow certification required",
      "Strong ServiceNow implementation experience",
      "Immediate joiners preferred"
    ],
    certifications: [
      "ServiceNow Certification"
    ],
    benefits: [
      "PAN India Opportunities",
      "Enterprise Projects",
      "High Salary"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-22"
  },
  {
    id: "upsc-cds-2-2026-003",
    title: "UPSC CDS-II 2026",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Graduate / Engineering",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Communication",
      "General Knowledge"
    ],
    responsibilities: [
      "Serve in defence services",
      "Complete officer training",
      "Handle operational duties"
    ],
    requirements: [
      "Graduate or Engineering qualification",
      "Eligibility as per UPSC norms"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "Defence Career",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/upsc-cds-2-2026-recruitment/",
    postedDate: "2026-05-22"
  },
  {
    id: "upsc-nda-2-2026-004",
    title: "UPSC NDA-II 2026",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "12th Pass",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Discipline",
      "Communication"
    ],
    responsibilities: [
      "Serve in defence services",
      "Complete military training",
      "Handle operational tasks"
    ],
    requirements: [
      "12th pass qualification",
      "Eligibility as per UPSC notification"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "Defence Opportunities",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/upsc-nda-2-2026-recruitment/",
    postedDate: "2026-05-22"
  },
  {
    id: "drdo-dg-aero-internship-005",
    title: "DRDO DG Aero Internship 2026",
    company: "DRDO",
    category: "Internship",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "Engineering / Graduate / Post Graduate",
    salary: "As Per Rules",
    skills: [
      "Research",
      "Engineering",
      "Aerospace",
      "Technology"
    ],
    responsibilities: [
      "Assist DRDO projects",
      "Support aerospace research",
      "Work with technical teams"
    ],
    requirements: [
      "Engineering or Graduate qualification",
      "Technical knowledge"
    ],
    certifications: [],
    benefits: [
      "Government Internship",
      "Research Exposure",
      "Skill Development"
    ],
    applyLink: "https://govtjobsalert.in/drdo-dg-aero-paid-internship-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "afcat-2-2026-006",
    title: "AFCAT 02/2026 Officer Posts",
    company: "Indian Air Force",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate / Engineering",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Communication",
      "Discipline"
    ],
    responsibilities: [
      "Serve as IAF Officer",
      "Handle defence operations",
      "Complete officer training"
    ],
    requirements: [
      "Graduate qualification",
      "Eligibility as per AFCAT norms"
    ],
    certifications: [],
    benefits: [
      "Air Force Career",
      "Government Benefits",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/afcat-2-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "punjab-sind-bank-apprentice-007",
    title: "Apprentice",
    company: "Punjab & Sind Bank",
    category: "Government Jobs",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹12,300/month",
    skills: [
      "Banking",
      "Communication",
      "Customer Service"
    ],
    responsibilities: [
      "Assist bank operations",
      "Support branch activities",
      "Handle customer interaction"
    ],
    requirements: [
      "Graduate qualification",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Banking Experience",
      "Government Opportunity",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/punjab-sind-bank-apprentice-recruitment-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "ssc-cgl-2026-008",
    title: "SSC CGL 2026",
    company: "SSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹25,500 – ₹1,51,100/month",
    skills: [
      "Reasoning",
      "Quantitative Aptitude",
      "General Awareness"
    ],
    responsibilities: [
      "Work in government departments",
      "Handle administrative tasks",
      "Support official operations"
    ],
    requirements: [
      "Graduate qualification",
      "Eligibility as per SSC norms"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "High Salary",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/ssc-cgl-recruitment-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "ibm-associate-system-engineer-009",
    title: "Associate System Engineer",
    company: "IBM",
    category: "Software Jobs",
    jobType: "Full Time",
    location: "Multiple Locations Across India",
    experience: "Freshers",
    qualification: "CSE / IT / AIML / DS / Cyber Security",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Engineering",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on enterprise software solutions",
      "Collaborate with technical teams",
      "Support development projects"
    ],
    requirements: [
      "2024 & 2025 batch eligible",
      "CS related branches preferred"
    ],
    certifications: [],
    benefits: [
      "IBM Career Opportunity",
      "Freshers Hiring",
      "Tech Industry Exposure"
    ],
    applyLink: "https://careers.ibm.com/en_US/careers/JobDetail/Associate-System-Engineer/103807?utm_source=commonjobs&utm_medium=referral&utm_campaign=job_listing",
    postedDate: "2026-05-22"
  },
  {
    id: "trident-hr-recruiter-010",
    title: "HR Recruiter",
    company: "Trident Group",
    category: "HR Jobs",
    jobType: "Full Time",
    location: "Electronic City, Bangalore",
    experience: "1-3 Years",
    qualification: "MBA in HR",
    salary: "Not Disclosed",
    skills: [
      "Recruitment",
      "Communication",
      "HR Operations"
    ],
    responsibilities: [
      "Handle recruitment process",
      "Coordinate interviews",
      "Manage hiring activities"
    ],
    requirements: [
      "MBA in HR",
      "1-3 years experience"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Corporate Exposure"
    ],
    applyLink: "mailto:Shobhams@tridentautomobiles.com",
    postedDate: "2026-05-22"
  },
  {
    id: "arisecapital-hr-operations-011",
    title: "Executive / Sr. Executive - HR Operation",
    company: "Arise Capital",
    category: "HR Jobs",
    jobType: "Full Time",
    location: "Coimbatore",
    experience: "3-5 Years",
    qualification: "Bachelor’s Degree in HR / Business Administration",
    salary: "Not Disclosed",
    skills: [
      "HR Operations",
      "Payroll",
      "Labour Law",
      "HRMS"
    ],
    responsibilities: [
      "Handle HR operations",
      "Manage payroll and compliance",
      "Maintain HR records"
    ],
    requirements: [
      "3-5 years HR experience",
      "Knowledge of payroll and HRMS"
    ],
    certifications: [],
    benefits: [
      "HR Career Growth",
      "Professional Environment"
    ],
    applyLink: "mailto:hr@arisecapital.in",
    postedDate: "2026-05-22"
  },
  {
    id: "bombay-play-data-analyst-012",
    title: "Data Analyst",
    company: "Bombay Play",
    category: "Data Analyst Jobs",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "1+ Year",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "SQL",
      "Analytics"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports",
      "Support business decisions"
    ],
    requirements: [
      "1+ year experience",
      "Analytical skills"
    ],
    certifications: [],
    benefits: [
      "Tech Company Exposure",
      "Career Development"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4417443856/",
    postedDate: "2026-05-22"
  },
  {
    id: "playo-data-analyst-013",
    title: "Data Analyst",
    company: "Playo",
    category: "Data Analyst Jobs",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers & Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Analytics",
      "SQL",
      "Data Visualization"
    ],
    responsibilities: [
      "Analyze datasets",
      "Support reporting",
      "Generate insights"
    ],
    requirements: [
      "Analytical mindset",
      "Data analysis skills"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Learning Opportunities"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4416172020/",
    postedDate: "2026-05-22"
  },

  {
    id: "vqcodes-php-developer-001",
    title: "PHP Developer",
    company: "VQCodes Software Solutions",
    category: "Software Development",
    jobType: "Full Time",
    location: "Mohali, Phase 8B",
    experience: "6 Months - 1 Year",
    qualification: "Any Degree",
    salary: "Not Disclosed",
    skills: [
      "PHP",
      "Web Development",
      "MySQL",
      "Backend Development"
    ],
    responsibilities: [
      "Develop PHP applications",
      "Work on live projects",
      "Maintain backend systems",
      "Collaborate with development teams"
    ],
    requirements: [
      "Strong understanding of PHP",
      "Good problem-solving skills",
      "Ability to work in-office"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Collaborative Environment",
      "Learning Opportunities"
    ],
    applyLink: "https://vqcodes.com",
    postedDate: "2026-05-21"
  },
  {
    id: "senior-it-support-microsoft-security-specialist-002",
    title: "Senior IT Support and Microsoft Security Specialist",
    company: "OptimHire",
    category: "IT Support",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "4+ Years",
    qualification: "BCA / MCA / BE / B.Tech",
    salary: "₹13-23 LPA",
    skills: [
      "Azure",
      "Microsoft Intune",
      "MFA",
      "Cloud Security",
      "Network Security",
      "Microsoft Defender",
      "SC-200",
      "SC-300",
      "AZ-104"
    ],
    responsibilities: [
      "Provide Level 2/3 IT support",
      "Handle cloud security operations",
      "Manage Microsoft security tools",
      "Support onboarding and offboarding",
      "Investigate security incidents"
    ],
    requirements: [
      "4+ years experience",
      "Experience with Microsoft 365 environment",
      "Strong troubleshooting skills",
      "Knowledge of cloud security"
    ],
    certifications: [
      "SC-200",
      "SC-300",
      "MS-102",
      "AZ-104"
    ],
    benefits: [
      "Hybrid Work",
      "Global Exposure",
      "Career Growth"
    ],
    applyLink: "https://optimhire.com/developers/jv/309771?ref_code=mukesh-agrawal",
    postedDate: "2026-05-21"
  },
  {
    id: "python-aws-fullstack-developer-003",
    title: "Python AWS Fullstack Developer",
    company: "NCS",
    category: "Full Stack Development",
    jobType: "Full Time",
    location: "Gurugram / Noida / Delhi",
    experience: "10-12 Years",
    qualification: "BE / B.Tech / MCA",
    salary: "₹2.5 LPM",
    skills: [
      "Python",
      "AWS",
      "Full Stack Development",
      "Cloud Computing"
    ],
    responsibilities: [
      "Develop cloud applications",
      "Build scalable backend systems",
      "Work with AWS infrastructure",
      "Collaborate with teams"
    ],
    requirements: [
      "10+ years experience",
      "Strong AWS knowledge",
      "Python expertise"
    ],
    certifications: [],
    benefits: [
      "High Salary",
      "Enterprise Projects",
      "Career Growth"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-21"
  },
  {
    id: "atenas-testing-associate-004",
    title: "Testing Associate",
    company: "Atenas Code Private Limited",
    category: "Cyber Security",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree in Computer Science or IT",
    salary: "₹10 LPA",
    skills: [
      "VAPT",
      "Penetration Testing",
      "Network Security",
      "API Security",
      "Cloud Security"
    ],
    responsibilities: [
      "Conduct VAPT assessments",
      "Perform penetration testing",
      "Handle vulnerability scanning",
      "Review security configurations"
    ],
    requirements: [
      "2-5 years cybersecurity experience",
      "Experience in VAPT projects",
      "Knowledge of enterprise security"
    ],
    certifications: [],
    benefits: [
      "Cybersecurity Exposure",
      "Career Development",
      "Enterprise Security Projects"
    ],
    applyLink: "https://unstop.com/o/rtv1CRp?lb=Bnie7Jo",
    postedDate: "2026-05-21"
  },
  {
    id: "upsc-exam-calendar-2027-001",
    title: "UPSC Exam Calendar 2027",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Graduate / Post Graduate / Engineering",
    salary: "As Per UPSC Norms",
    skills: [
      "General Knowledge",
      "Reasoning",
      "Analytical Skills",
      "Communication"
    ],
    responsibilities: [
      "Prepare for UPSC examinations",
      "Follow exam schedule",
      "Attend competitive exams"
    ],
    requirements: [
      "Graduate or equivalent qualification",
      "Eligibility as per UPSC notification"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "Job Stability",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/upsc-exam-calendar-2027/",
    postedDate: "2026-05-21"
  },
  {
    id: "ge-healthcare-get-002",
    title: "Graduate Engineer Trainee",
    company: "GE HealthCare",
    category: "Engineering Jobs",
    jobType: "Full Time",
    location: "Bengaluru",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Engineering",
      "Problem Solving",
      "Communication",
      "Technical Skills"
    ],
    responsibilities: [
      "Assist engineering teams",
      "Support product development",
      "Work on healthcare technologies"
    ],
    requirements: [
      "Bachelor’s Degree",
      "Freshers can apply"
    ],
    certifications: [],
    benefits: [
      "Healthcare Industry Exposure",
      "Career Growth",
      "Learning Opportunities"
    ],
    applyLink: "https://careers.gehealthcare.com/global/en/job/R4040589/Graduate-Engineering-Trainee",
    postedDate: "2026-05-21"
  },
  {
    id: "revolut-data-analyst-003",
    title: "Data Analyst",
    company: "Revolut",
    category: "Data Analytics",
    jobType: "Full Time",
    location: "Remote",
    experience: "Not Disclosed",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "SQL",
      "Excel",
      "Analytics"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports",
      "Support business decisions"
    ],
    requirements: [
      "Strong analytical skills",
      "Knowledge of data tools"
    ],
    certifications: [],
    benefits: [
      "Remote Work",
      "Global Exposure",
      "Career Growth"
    ],
    applyLink: "https://www.revolut.com/careers/position/a24a3d9b-1534-4e97-9d46-228b5aafbf78/",
    postedDate: "2026-05-21"
  },
  {
    id: "blucognition-analyst-004",
    title: "Analyst",
    company: "bluCognition",
    category: "Analytics",
    jobType: "Full Time",
    location: "Remote",
    experience: "1-2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Communication",
      "Reporting",
      "Problem Solving"
    ],
    responsibilities: [
      "Analyze data trends",
      "Prepare business reports",
      "Support operational teams"
    ],
    requirements: [
      "1-2 years experience",
      "Strong analytical skills"
    ],
    certifications: [],
    benefits: [
      "Remote Work",
      "Learning Opportunities",
      "Career Growth"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4404030872/",
    postedDate: "2026-05-21"
  },
  {
    id: "netapp-software-engineer-005",
    title: "Software Engineer",
    company: "NetApp",
    category: "Software Development",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers",
    qualification: "BE / B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Computer Science"
    ],
    responsibilities: [
      "Develop software applications",
      "Work with engineering teams",
      "Maintain software quality"
    ],
    requirements: [
      "2024 / 2025 graduates",
      "Strong coding knowledge"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Tech Exposure",
      "Learning Opportunities"
    ],
    applyLink: "https://careers.netapp.com/job/bengaluru/software-engineer/27600/94472561760",
    postedDate: "2026-05-21"
  },






      {
  id: "assistant-hr-manager-sarovarhotels-524",
  title: "Assistant HR Manager",
  company: "Sarovar Hotels",
  category: "Non-IT",
  jobType: "Full-time",
  location: "India",
  experience: "Hotel/Hospitality Industry Experience Required",
  qualification: "Graduate in HR or related field",
  salary: "₹40,000 Gross",
  skills: [
    "Human Resource Management",
    "Recruitment",
    "Employee Relations",
    "Communication Skills",
    "Hospitality Industry Experience"
  ],
  responsibilities: [
    "Manage HR operations and recruitment activities",
    "Handle employee relations and HR documentation",
    "Coordinate with hotel staff and management",
    "Support onboarding and employee engagement",
    "Maintain HR policies and compliance"
  ],
  requirements: [
    "Only female candidates can apply",
    "Immediate joiner preferred",
    "Must be able to join within 7 days",
    "Prior hotel or hospitality industry experience required",
    "Good communication and interpersonal skills"
  ],
  certifications: [],
  benefits: [
    "On-duty meals provided",
    "Off-duty meals provided"
  ],
  applyLink: "tel:+919382551601",
  postedDate: "2026-05-24"
},
  {
    id: "scaler-problem-setter-intern-001",
    title: "Problem Setter and Content Intern",
    company: "Scaler",
    category: "NON-IT",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "College Students (2026/2027 Batch)",
    salary: "₹35,000/month",
    skills: [
      "Java",
      "Spring",
      "Python",
      "Django",
      "DSA",
      "GitHub",
      "GenAI",
      "LLMs"
    ],
    responsibilities: [
      "Create coding problems",
      "Work on technical content",
      "Collaborate with engineering teams",
      "Build programming-related content"
    ],
    requirements: [
      "Strong programming skills",
      "1600+ Codeforces or 5 Star CodeChef preferred",
      "Strong GitHub profile"
    ],
    certifications: [],
    benefits: [
      "High Stipend",
      "Remote Learning",
      "Career Growth"
    ],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSeD97G1Jwi6bpEMn7kqIVM21SQYV21372Boyim07z6zapAHsw/viewform",
    postedDate: "2026-05-22"
  },
  {
    id: "associate-principal-engineer-servicenow-002",
    title: "Associate Principal Engineer",
    company: "NCS",
    category: "IT Jobs",
    jobType: "Full Time",
    location: "PAN India",
    experience: "7-10+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹30 LPA",
    skills: [
      "ServiceNow",
      "ITSM",
      "ITOM",
      "CMDB",
      "PowerShell",
      "AngularJS",
      "Integrations"
    ],
    responsibilities: [
      "Implement ServiceNow modules",
      "Develop technical solutions",
      "Handle integrations",
      "Perform configuration changes"
    ],
    requirements: [
      "ServiceNow certification required",
      "Strong ServiceNow implementation experience",
      "Immediate joiners preferred"
    ],
    certifications: [
      "ServiceNow Certification"
    ],
    benefits: [
      "PAN India Opportunities",
      "Enterprise Projects",
      "High Salary"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-22"
  },
  {
    id: "upsc-cds-2-2026-003",
    title: "UPSC CDS-II 2026",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Graduate / Engineering",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Communication",
      "General Knowledge"
    ],
    responsibilities: [
      "Serve in defence services",
      "Complete officer training",
      "Handle operational duties"
    ],
    requirements: [
      "Graduate or Engineering qualification",
      "Eligibility as per UPSC norms"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "Defence Career",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/upsc-cds-2-2026-recruitment/",
    postedDate: "2026-05-22"
  },
  {
    id: "upsc-nda-2-2026-004",
    title: "UPSC NDA-II 2026",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "12th Pass",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Discipline",
      "Communication"
    ],
    responsibilities: [
      "Serve in defence services",
      "Complete military training",
      "Handle operational tasks"
    ],
    requirements: [
      "12th pass qualification",
      "Eligibility as per UPSC notification"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "Defence Opportunities",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/upsc-nda-2-2026-recruitment/",
    postedDate: "2026-05-22"
  },
  {
    id: "drdo-dg-aero-internship-005",
    title: "DRDO DG Aero Internship 2026",
    company: "DRDO",
    category: "Internship",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "Engineering / Graduate / Post Graduate",
    salary: "As Per Rules",
    skills: [
      "Research",
      "Engineering",
      "Aerospace",
      "Technology"
    ],
    responsibilities: [
      "Assist DRDO projects",
      "Support aerospace research",
      "Work with technical teams"
    ],
    requirements: [
      "Engineering or Graduate qualification",
      "Technical knowledge"
    ],
    certifications: [],
    benefits: [
      "Government Internship",
      "Research Exposure",
      "Skill Development"
    ],
    applyLink: "https://govtjobsalert.in/drdo-dg-aero-paid-internship-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "afcat-2-2026-006",
    title: "AFCAT 02/2026 Officer Posts",
    company: "Indian Air Force",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate / Engineering",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Leadership",
      "Communication",
      "Discipline"
    ],
    responsibilities: [
      "Serve as IAF Officer",
      "Handle defence operations",
      "Complete officer training"
    ],
    requirements: [
      "Graduate qualification",
      "Eligibility as per AFCAT norms"
    ],
    certifications: [],
    benefits: [
      "Air Force Career",
      "Government Benefits",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/afcat-2-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "punjab-sind-bank-apprentice-007",
    title: "Apprentice",
    company: "Punjab & Sind Bank",
    category: "Government Jobs",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹12,300/month",
    skills: [
      "Banking",
      "Communication",
      "Customer Service"
    ],
    responsibilities: [
      "Assist bank operations",
      "Support branch activities",
      "Handle customer interaction"
    ],
    requirements: [
      "Graduate qualification",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Banking Experience",
      "Government Opportunity",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/punjab-sind-bank-apprentice-recruitment-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "ssc-cgl-2026-008",
    title: "SSC CGL 2026",
    company: "SSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹25,500 – ₹1,51,100/month",
    skills: [
      "Reasoning",
      "Quantitative Aptitude",
      "General Awareness"
    ],
    responsibilities: [
      "Work in government departments",
      "Handle administrative tasks",
      "Support official operations"
    ],
    requirements: [
      "Graduate qualification",
      "Eligibility as per SSC norms"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "High Salary",
      "Job Security"
    ],
    applyLink: "https://govtjobsalert.in/ssc-cgl-recruitment-2026/",
    postedDate: "2026-05-22"
  },
  {
    id: "ibm-associate-system-engineer-009",
    title: "Associate System Engineer",
    company: "IBM",
    category: "Software Jobs",
    jobType: "Full Time",
    location: "Multiple Locations Across India",
    experience: "Freshers",
    qualification: "CSE / IT / AIML / DS / Cyber Security",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Engineering",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on enterprise software solutions",
      "Collaborate with technical teams",
      "Support development projects"
    ],
    requirements: [
      "2024 & 2025 batch eligible",
      "CS related branches preferred"
    ],
    certifications: [],
    benefits: [
      "IBM Career Opportunity",
      "Freshers Hiring",
      "Tech Industry Exposure"
    ],
    applyLink: "https://careers.ibm.com/en_US/careers/JobDetail/Associate-System-Engineer/103807?utm_source=commonjobs&utm_medium=referral&utm_campaign=job_listing",
    postedDate: "2026-05-22"
  },
  {
    id: "trident-hr-recruiter-010",
    title: "HR Recruiter",
    company: "Trident Group",
    category: "HR Jobs",
    jobType: "Full Time",
    location: "Electronic City, Bangalore",
    experience: "1-3 Years",
    qualification: "MBA in HR",
    salary: "Not Disclosed",
    skills: [
      "Recruitment",
      "Communication",
      "HR Operations"
    ],
    responsibilities: [
      "Handle recruitment process",
      "Coordinate interviews",
      "Manage hiring activities"
    ],
    requirements: [
      "MBA in HR",
      "1-3 years experience"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Corporate Exposure"
    ],
    applyLink: "mailto:Shobhams@tridentautomobiles.com",
    postedDate: "2026-05-22"
  },
  {
    id: "arisecapital-hr-operations-011",
    title: "Executive / Sr. Executive - HR Operation",
    company: "Arise Capital",
    category: "HR Jobs",
    jobType: "Full Time",
    location: "Coimbatore",
    experience: "3-5 Years",
    qualification: "Bachelor’s Degree in HR / Business Administration",
    salary: "Not Disclosed",
    skills: [
      "HR Operations",
      "Payroll",
      "Labour Law",
      "HRMS"
    ],
    responsibilities: [
      "Handle HR operations",
      "Manage payroll and compliance",
      "Maintain HR records"
    ],
    requirements: [
      "3-5 years HR experience",
      "Knowledge of payroll and HRMS"
    ],
    certifications: [],
    benefits: [
      "HR Career Growth",
      "Professional Environment"
    ],
    applyLink: "mailto:hr@arisecapital.in",
    postedDate: "2026-05-22"
  },
  {
    id: "bombay-play-data-analyst-012",
    title: "Data Analyst",
    company: "Bombay Play",
    category: "Data Analyst Jobs",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "1+ Year",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "SQL",
      "Analytics"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports",
      "Support business decisions"
    ],
    requirements: [
      "1+ year experience",
      "Analytical skills"
    ],
    certifications: [],
    benefits: [
      "Tech Company Exposure",
      "Career Development"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4417443856/",
    postedDate: "2026-05-22"
  },
  {
    id: "playo-data-analyst-013",
    title: "Data Analyst",
    company: "Playo",
    category: "Data Analyst Jobs",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers & Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Analytics",
      "SQL",
      "Data Visualization"
    ],
    responsibilities: [
      "Analyze datasets",
      "Support reporting",
      "Generate insights"
    ],
    requirements: [
      "Analytical mindset",
      "Data analysis skills"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Learning Opportunities"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4416172020/",
    postedDate: "2026-05-22"
  },

  {
    id: "vqcodes-php-developer-001",
    title: "PHP Developer",
    company: "VQCodes Software Solutions",
    category: "Software Development",
    jobType: "Full Time",
    location: "Mohali, Phase 8B",
    experience: "6 Months - 1 Year",
    qualification: "Any Degree",
    salary: "Not Disclosed",
    skills: [
      "PHP",
      "Web Development",
      "MySQL",
      "Backend Development"
    ],
    responsibilities: [
      "Develop PHP applications",
      "Work on live projects",
      "Maintain backend systems",
      "Collaborate with development teams"
    ],
    requirements: [
      "Strong understanding of PHP",
      "Good problem-solving skills",
      "Ability to work in-office"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Collaborative Environment",
      "Learning Opportunities"
    ],
    applyLink: "https://vqcodes.com",
    postedDate: "2026-05-21"
  },
  {
    id: "senior-it-support-microsoft-security-specialist-002",
    title: "Senior IT Support and Microsoft Security Specialist",
    company: "OptimHire",
    category: "IT Support",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "4+ Years",
    qualification: "BCA / MCA / BE / B.Tech",
    salary: "₹13-23 LPA",
    skills: [
      "Azure",
      "Microsoft Intune",
      "MFA",
      "Cloud Security",
      "Network Security",
      "Microsoft Defender",
      "SC-200",
      "SC-300",
      "AZ-104"
    ],
    responsibilities: [
      "Provide Level 2/3 IT support",
      "Handle cloud security operations",
      "Manage Microsoft security tools",
      "Support onboarding and offboarding",
      "Investigate security incidents"
    ],
    requirements: [
      "4+ years experience",
      "Experience with Microsoft 365 environment",
      "Strong troubleshooting skills",
      "Knowledge of cloud security"
    ],
    certifications: [
      "SC-200",
      "SC-300",
      "MS-102",
      "AZ-104"
    ],
    benefits: [
      "Hybrid Work",
      "Global Exposure",
      "Career Growth"
    ],
    applyLink: "https://optimhire.com/developers/jv/309771?ref_code=mukesh-agrawal",
    postedDate: "2026-05-21"
  },
  {
    id: "python-aws-fullstack-developer-003",
    title: "Python AWS Fullstack Developer",
    company: "NCS",
    category: "Full Stack Development",
    jobType: "Full Time",
    location: "Gurugram / Noida / Delhi",
    experience: "10-12 Years",
    qualification: "BE / B.Tech / MCA",
    salary: "₹2.5 LPM",
    skills: [
      "Python",
      "AWS",
      "Full Stack Development",
      "Cloud Computing"
    ],
    responsibilities: [
      "Develop cloud applications",
      "Build scalable backend systems",
      "Work with AWS infrastructure",
      "Collaborate with teams"
    ],
    requirements: [
      "10+ years experience",
      "Strong AWS knowledge",
      "Python expertise"
    ],
    certifications: [],
    benefits: [
      "High Salary",
      "Enterprise Projects",
      "Career Growth"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-21"
  },
  {
    id: "atenas-testing-associate-004",
    title: "Testing Associate",
    company: "Atenas Code Private Limited",
    category: "Cyber Security",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree in Computer Science or IT",
    salary: "₹10 LPA",
    skills: [
      "VAPT",
      "Penetration Testing",
      "Network Security",
      "API Security",
      "Cloud Security"
    ],
    responsibilities: [
      "Conduct VAPT assessments",
      "Perform penetration testing",
      "Handle vulnerability scanning",
      "Review security configurations"
    ],
    requirements: [
      "2-5 years cybersecurity experience",
      "Experience in VAPT projects",
      "Knowledge of enterprise security"
    ],
    certifications: [],
    benefits: [
      "Cybersecurity Exposure",
      "Career Development",
      "Enterprise Security Projects"
    ],
    applyLink: "https://unstop.com/o/rtv1CRp?lb=Bnie7Jo",
    postedDate: "2026-05-21"
  },
  {
    id: "upsc-exam-calendar-2027-001",
    title: "UPSC Exam Calendar 2027",
    company: "UPSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Graduate / Post Graduate / Engineering",
    salary: "As Per UPSC Norms",
    skills: [
      "General Knowledge",
      "Reasoning",
      "Analytical Skills",
      "Communication"
    ],
    responsibilities: [
      "Prepare for UPSC examinations",
      "Follow exam schedule",
      "Attend competitive exams"
    ],
    requirements: [
      "Graduate or equivalent qualification",
      "Eligibility as per UPSC notification"
    ],
    certifications: [],
    benefits: [
      "Government Career",
      "Job Stability",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/upsc-exam-calendar-2027/",
    postedDate: "2026-05-21"
  },
  {
    id: "ge-healthcare-get-002",
    title: "Graduate Engineer Trainee",
    company: "GE HealthCare",
    category: "Engineering Jobs",
    jobType: "Full Time",
    location: "Bengaluru",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Engineering",
      "Problem Solving",
      "Communication",
      "Technical Skills"
    ],
    responsibilities: [
      "Assist engineering teams",
      "Support product development",
      "Work on healthcare technologies"
    ],
    requirements: [
      "Bachelor’s Degree",
      "Freshers can apply"
    ],
    certifications: [],
    benefits: [
      "Healthcare Industry Exposure",
      "Career Growth",
      "Learning Opportunities"
    ],
    applyLink: "https://careers.gehealthcare.com/global/en/job/R4040589/Graduate-Engineering-Trainee",
    postedDate: "2026-05-21"
  },
  {
    id: "revolut-data-analyst-003",
    title: "Data Analyst",
    company: "Revolut",
    category: "Data Analytics",
    jobType: "Full Time",
    location: "Remote",
    experience: "Not Disclosed",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "SQL",
      "Excel",
      "Analytics"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports",
      "Support business decisions"
    ],
    requirements: [
      "Strong analytical skills",
      "Knowledge of data tools"
    ],
    certifications: [],
    benefits: [
      "Remote Work",
      "Global Exposure",
      "Career Growth"
    ],
    applyLink: "https://www.revolut.com/careers/position/a24a3d9b-1534-4e97-9d46-228b5aafbf78/",
    postedDate: "2026-05-21"
  },
  {
    id: "blucognition-analyst-004",
    title: "Analyst",
    company: "bluCognition",
    category: "Analytics",
    jobType: "Full Time",
    location: "Remote",
    experience: "1-2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Communication",
      "Reporting",
      "Problem Solving"
    ],
    responsibilities: [
      "Analyze data trends",
      "Prepare business reports",
      "Support operational teams"
    ],
    requirements: [
      "1-2 years experience",
      "Strong analytical skills"
    ],
    certifications: [],
    benefits: [
      "Remote Work",
      "Learning Opportunities",
      "Career Growth"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4404030872/",
    postedDate: "2026-05-21"
  },
  {
    id: "netapp-software-engineer-005",
    title: "Software Engineer",
    company: "NetApp",
    category: "Software Development",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers",
    qualification: "BE / B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Computer Science"
    ],
    responsibilities: [
      "Develop software applications",
      "Work with engineering teams",
      "Maintain software quality"
    ],
    requirements: [
      "2024 / 2025 graduates",
      "Strong coding knowledge"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Tech Exposure",
      "Learning Opportunities"
    ],
    applyLink: "https://careers.netapp.com/job/bengaluru/software-engineer/27600/94472561760",
    postedDate: "2026-05-21"
  },


  {
    id: "emerson-business-systems-analyst-scm-001",
    title: "Business Systems Analyst SCM",
    company: "Emerson",
    category: "IT Jobs",
    jobType: "Full Time",
    location: "Chandigarh",
    experience: "8+ Years",
    qualification: "Bachelor’s Degree in Computer Science, IT or Related Field",
    salary: "Not Disclosed",
    skills: [
      "Oracle SCM",
      "PL/SQL",
      "Oracle Reports",
      "XML Publisher",
      "Workflow",
      "OAF",
      "REST APIs",
      "Python",
      "JSON",
      "XML"
    ],
    responsibilities: [
      "Work on Oracle SCM systems",
      "Develop REST APIs",
      "Handle system analysis and requirement gathering",
      "Collaborate with global teams",
      "Support implementation and deployment"
    ],
    requirements: [
      "8+ years experience in SCM projects",
      "Strong Oracle development skills",
      "Experience in APIs and scripting",
      "Analytical and communication skills"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Global Team Exposure",
      "Enterprise Project Experience"
    ],
    applyLink: "https://hdjq.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/jobs/preview/25030516/?location=India&locationId=300000000228786&locationLevel=country&mode=location",
    postedDate: "2026-05-20"
  },
  {
    id: "balmer-lawrie-executive-trainee-002",
    title: "Executive Trainee",
    company: "Balmer Lawrie",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "B.E./B.Tech / MBA",
    salary: "₹40,000 – ₹1,40,000",
    skills: [
      "Engineering",
      "Management",
      "Communication",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on assigned projects",
      "Support operations and management",
      "Coordinate with teams"
    ],
    requirements: [
      "BE/B.Tech/MBA qualification",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "High Salary",
      "Career Stability"
    ],
    applyLink: "https://govtjobsalert.in/balmer-lawrie-executive-trainee-recruitment-2026/",
    postedDate: "2026-05-20"
  },
  {
    id: "american-express-software-engineer-003",
    title: "Software Engineer I",
    company: "American Express",
    category: "Software Development",
    jobType: "Full Time",
    location: "Chennai",
    experience: "Freshers",
    qualification: "BE/B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Programming",
      "Software Development",
      "Problem Solving"
    ],
    responsibilities: [
      "Develop software solutions",
      "Collaborate with engineering teams",
      "Debug and maintain applications"
    ],
    requirements: [
      "2023/2024/2025 graduates",
      "Strong coding skills"
    ],
    certifications: [],
    benefits: [
      "Corporate Exposure",
      "Learning Opportunities"
    ],
    applyLink: "https://egug.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/job/26007663",
    postedDate: "2026-05-20"
  },
  {
    id: "licious-sde-frontend-004",
    title: "SDE I Frontend",
    company: "Licious",
    category: "Frontend Developer",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers",
    qualification: "BE/B.Tech",
    salary: "Not Disclosed",
    skills: [
      "React",
      "JavaScript",
      "HTML",
      "CSS",
      "Frontend Development"
    ],
    responsibilities: [
      "Build frontend applications",
      "Optimize UI performance",
      "Work with design teams"
    ],
    requirements: [
      "2022-2025 graduates",
      "Frontend development knowledge"
    ],
    certifications: [],
    benefits: [
      "Tech Career Growth",
      "Learning Environment"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4413509644/",
    postedDate: "2026-05-20"
  },
  {
    id: "bcg-frontend-engineer-005",
    title: "Software Engineer Frontend",
    company: "BCG",
    category: "Software Development",
    jobType: "Full Time",
    location: "Multiple Locations",
    experience: "Freshers",
    qualification: "BE/B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Frontend Development",
      "React",
      "JavaScript",
      "UI Development"
    ],
    responsibilities: [
      "Develop frontend systems",
      "Collaborate with product teams",
      "Enhance user experience"
    ],
    requirements: [
      "2021-2024 graduates",
      "Strong frontend skills"
    ],
    certifications: [],
    benefits: [
      "Global Exposure",
      "Career Development"
    ],
    applyLink: "https://careers.bcg.com/global/en/job/55285/Software-Engineer-Front-End-X-Delivery",
    postedDate: "2026-05-20"
  },
  {
    id: "ge-healthcare-get-006",
    title: "Graduate Engineer Trainee",
    company: "GE HealthCare",
    category: "Engineering Jobs",
    jobType: "Full Time",
    location: "Bengaluru",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Engineering",
      "Problem Solving",
      "Communication"
    ],
    responsibilities: [
      "Assist engineering teams",
      "Support product development",
      "Learn healthcare technologies"
    ],
    requirements: [
      "Bachelor’s Degree",
      "Freshers can apply"
    ],
    certifications: [],
    benefits: [
      "Healthcare Industry Exposure",
      "Career Growth"
    ],
    applyLink: "https://careers.gehealthcare.com/global/en/job/R4040589/Graduate-Engineering-Trainee",
    postedDate: "2026-05-20"
  },
  {
    id: "sbi-apprentice-recruitment-2026-001",
    title: "Apprentice",
    company: "State Bank of India",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduation",
    salary: "₹15,000/month",
    skills: [
      "Banking",
      "Communication",
      "Customer Service"
    ],
    responsibilities: [
      "Assist banking operations",
      "Support branch activities",
      "Handle customer interactions"
    ],
    requirements: [
      "Graduate degree",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Government Opportunity",
      "Banking Experience",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/sbi-apprentice-recruitment-2026/",
    postedDate: "2026-05-20"
  },
  {
    id: "drdo-cair-bengaluru-internship-2026-002",
    title: "Paid Internship",
    company: "DRDO CAIR",
    category: "Internship",
    jobType: "Internship",
    location: "Bengaluru",
    experience: "Freshers",
    qualification: "B.E./B.Tech Final Year",
    salary: "₹30,000/month",
    skills: [
      "Engineering",
      "Research",
      "AI",
      "Technology"
    ],
    responsibilities: [
      "Work on DRDO research projects",
      "Assist technical teams",
      "Learn advanced technologies"
    ],
    requirements: [
      "Final year BE/B.Tech students",
      "Strong technical knowledge"
    ],
    certifications: [],
    benefits: [
      "Research Exposure",
      "Government Internship",
      "Skill Development"
    ],
    applyLink: "https://govtjobsalert.in/drdo-cair-bengaluru-paid-internship-2026/",
    postedDate: "2026-05-20"
  },
  {
    id: "ncb-recruitment-2026-003",
    title: "Multiple Posts Recruitment",
    company: "NCB",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers & Experienced",
    qualification: "B.E./B.Tech / M.Sc / Ph.D / PG / Graduation",
    salary: "₹21,700 – ₹2,09,200",
    skills: [
      "Administration",
      "Technical Skills",
      "Communication"
    ],
    responsibilities: [
      "Handle departmental operations",
      "Support assigned projects",
      "Maintain official documentation"
    ],
    requirements: [
      "Relevant educational qualification",
      "Good analytical skills"
    ],
    certifications: [],
    benefits: [
      "Government Benefits",
      "Job Stability",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/ncb-recruitment-2026/",
    postedDate: "2026-05-20"
  },
  {
    id: "midhani-apprentice-recruitment-2026-004",
    title: "Apprentice",
    company: "MIDHANI",
    category: "Government Jobs",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Freshers",
    qualification: "B.E./B.Tech / Diploma",
    salary: "₹10,900 – ₹12,300/month",
    skills: [
      "Engineering",
      "Manufacturing",
      "Technical Knowledge"
    ],
    responsibilities: [
      "Assist technical departments",
      "Learn industrial processes",
      "Support project execution"
    ],
    requirements: [
      "Diploma or BE/B.Tech qualification",
      "Technical understanding"
    ],
    certifications: [],
    benefits: [
      "Industrial Experience",
      "Government Training",
      "Skill Enhancement"
    ],
    applyLink: "https://govtjobsalert.in/midhani-apprentice-recruitment-2026/",
    postedDate: "2026-05-20"
  },
  {
    id: "night-shift-paid-internship-005",
    title: "Night Shift Paid Internship",
    company: "Confidential",
    category: "Internship",
    jobType: "Internship",
    location: "Ahmedabad",
    experience: "Freshers",
    qualification: "Students / Graduates",
    salary: "Paid Internship",
    skills: [
      "Python",
      "Machine Learning",
      "AI",
      "Communication"
    ],
    responsibilities: [
      "Work on AI and ML projects",
      "Support development teams",
      "Learn industry technologies"
    ],
    requirements: [
      "Interest in AI/ML",
      "Basic programming knowledge"
    ],
    certifications: [],
    benefits: [
      "Hands-on Experience",
      "Career Growth",
      "Paid Internship"
    ],
    applyLink: "https://www.linkedin.com/posts/arfin-kazi-28a246238_hiring-internship-paidinternship-share-7462378648067534848-fVwP",
    postedDate: "2026-05-20"
  },
  {
    id: "revit-family-creation-intern-006",
    title: "Revit Family Creation Intern",
    company: "Confidential",
    category: "Internship",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "Any Degree",
    salary: "Not Disclosed",
    skills: [
      "Revit",
      "Design",
      "Architecture",
      "BIM"
    ],
    responsibilities: [
      "Create and update Revit families",
      "Support project teams",
      "Maintain family libraries"
    ],
    requirements: [
      "Knowledge of Revit",
      "Attention to detail"
    ],
    certifications: [],
    benefits: [
      "Practical Experience",
      "Industry Exposure"
    ],
    applyLink: "https://www.linkedin.com/posts/advaitc11_immediatejoiner-revit-familycreation-share-7462454305023864832-wO_2",
    postedDate: "2026-05-20"
  },
  {
    id: "ametek-software-engineer-007",
    title: "Software Engineer",
    company: "Ametek",
    category: "Software Development",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers",
    qualification: "BE/B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving"
    ],
    responsibilities: [
      "Develop software applications",
      "Collaborate with teams",
      "Maintain software quality"
    ],
    requirements: [
      "2023-2025 graduates",
      "Technical knowledge"
    ],
    certifications: [],
    benefits: [
      "Career Growth",
      "Learning Opportunities"
    ],
    applyLink: "https://jobs.ametek.com/job/Bangalore-Software-Developer-KA-560048/1385605500/",
    postedDate: "2026-05-20"
  },
  {
    id: "snapmint-sde-backend-008",
    title: "SDE I Backend",
    company: "Snapmint",
    category: "Backend Developer",
    jobType: "Full Time",
    location: "Gurugram",
    experience: "Freshers & Experienced",
    qualification: "BE/B.Tech",
    salary: "Not Disclosed",
    skills: [
      "Backend Development",
      "Node.js",
      "APIs",
      "Database Management"
    ],
    responsibilities: [
      "Develop backend services",
      "Optimize APIs",
      "Maintain server-side systems"
    ],
    requirements: [
      "2021-2025 graduates",
      "Backend development skills"
    ],
    certifications: [],
    benefits: [
      "Startup Exposure",
      "Career Development"
    ],
    applyLink: "https://www.instahyre.com/job-371492-sde-i-backend-at-snapmint-gurgaon/",
    postedDate: "2026-05-20"
  },


  {
    id: "python-developer-linkedin-801",
    title: "Python Developer",
    company: "Confidential Company",
    category: "Software Development",
    jobType: "Full Time",
    location: "Hyderabad / Remote",
    experience: "1-4 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Django",
      "Flask",
      "FastAPI",
      "REST APIs",
      "PostgreSQL",
      "Git"
    ],
    responsibilities: [
      "Develop backend applications",
      "Build REST APIs",
      "Optimize application performance",
      "Collaborate with development teams"
    ],
    requirements: [
      "Strong Python knowledge",
      "API development experience",
      "Database handling skills"
    ],
    certifications: [],
    benefits: [
      "Remote opportunities",
      "Modern tech stack",
      "Career growth"
    ],
    applyLink: "https://www.linkedin.com/posts/shruthi-reddy-sudugu-2b88542a0_hiring-pythondeveloper-pythonjobs-share-7461129879346921473-QwWI",
    postedDate: "2026-05-17"
  },

  {
    id: "qa-engineer-automation-linkedin-802",
    title: "QA Engineer - Automation Testing",
    company: "Confidential Company",
    category: "Quality Assurance",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Automation Testing",
      "Selenium",
      "API Testing",
      "Bug Tracking",
      "Agile"
    ],
    responsibilities: [
      "Perform automation testing",
      "Create and execute test cases",
      "Report bugs and issues",
      "Work with development teams"
    ],
    requirements: [
      "Knowledge of QA methodologies",
      "Testing and debugging skills",
      "Attention to detail"
    ],
    certifications: [],
    benefits: [
      "Learning opportunities",
      "Career growth",
      "Tech exposure"
    ],
    applyLink: "https://www.linkedin.com/posts/kadheeja-mol-ba8bb615b_hiring-qaengineer-automationtesting-share-7460924236325576704-Dz8_",
    postedDate: "2026-05-17"
  },

  {
    id: "dotnet-developer-freshers-linkedin-803",
    title: ".NET Developer",
    company: "Confidential Company",
    category: "Software Development",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "C#",
      "ASP.NET",
      "SQL Server",
      "JavaScript",
      "HTML",
      "CSS"
    ],
    responsibilities: [
      "Develop .NET applications",
      "Maintain backend systems",
      "Collaborate with development teams",
      "Debug and optimize code"
    ],
    requirements: [
      "Basic .NET knowledge",
      "Strong coding fundamentals",
      "Problem-solving skills"
    ],
    certifications: [],
    benefits: [
      "Freshers hiring",
      "Career growth",
      "Software development exposure"
    ],
    applyLink: "https://www.linkedin.com/posts/simran-bhinda-a4808b209_hiring-dotnetdeveloper-freshershiring-share-7451938309750296576-ZZQi",
    postedDate: "2026-05-17"
  },

  {
    id: "sales-executive-cyberhospitality-vadodara-701",
    title: "Sales Executive",
    company: "Cyber Hospitality Private Limited",
    category: "Sales",
    jobType: "Full Time",
    location: "Vadodara",
    experience: "6 Months - 1 Year",
    qualification: "Graduate",
    salary: "₹15,000 - ₹25,000 per month",
    skills: [
      "Sales",
      "Client Communication",
      "Negotiation",
      "MS Excel",
      "Email Handling"
    ],
    responsibilities: [
      "Communicate with US clients",
      "Handle calls and emails",
      "Share pricing and product details",
      "Maintain client records",
      "Achieve sales targets"
    ],
    requirements: [
      "Strong English communication",
      "Sales experience preferred",
      "Comfortable with night shifts",
      "Target-driven mindset"
    ],
    certifications: [],
    benefits: [
      "International sales exposure",
      "Career growth opportunity",
      "Corporate work environment"
    ],
    applyLink: "mailto:hr@cyberhospitalities.com",
    postedDate: "2026-05-17"
  },

  {
    id: "seo-specialist-vadodara-702",
    title: "SEO Specialist",
    company: "Cyber Hospitality",
    category: "Digital Marketing",
    jobType: "Full Time",
    location: "Vadodara",
    experience: "2+ Years",
    qualification: "Graduate",
    salary: "₹25,000 - ₹30,000 per month",
    skills: [
      "SEO",
      "Google Analytics",
      "Technical SEO",
      "Keyword Research",
      "Google Search Console"
    ],
    responsibilities: [
      "Develop SEO strategies",
      "Perform keyword research",
      "Handle on-page and off-page SEO",
      "Monitor website traffic",
      "Coordinate with content teams"
    ],
    requirements: [
      "2+ years SEO experience",
      "Knowledge of technical SEO",
      "Strong analytical skills"
    ],
    certifications: [],
    benefits: [
      "Marketing growth opportunity",
      "Hands-on SEO projects",
      "Professional work environment"
    ],
    applyLink: "mailto:hr@cyberhsospitalities.com",
    postedDate: "2026-05-17"
  },

  {
    id: "network-engineer-vadodara-703",
    title: "Network Engineer",
    company: "Cyber Hospitality",
    category: "Networking",
    jobType: "Full Time",
    location: "Vadodara",
    experience: "Fresher - 1 Year",
    qualification: "Graduate / Diploma",
    salary: "Not Disclosed",
    skills: [
      "TCP/IP",
      "LAN/WAN",
      "DNS",
      "DHCP",
      "VPN",
      "Firewalls"
    ],
    responsibilities: [
      "Manage network infrastructure",
      "Configure routers and switches",
      "Troubleshoot networking issues",
      "Maintain system connectivity"
    ],
    requirements: [
      "Basic networking knowledge",
      "Good communication skills",
      "Comfortable with rotational shifts"
    ],
    certifications: [
      "CCNA Preferred"
    ],
    benefits: [
      "Freshers can apply",
      "Networking career opportunity",
      "Technical learning exposure"
    ],
    applyLink: "mailto:hr@cyberhospitalities.com",
    postedDate: "2026-05-17"
  },


  {
    id: "isolved-software-engineer-hyderabad-601",
    title: "Software Engineer",
    company: "Isolved",
    category: "Software Development",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "Freshers / Experienced",
    qualification: "2021 / 2022 / 2023 / 2024 / 2025 Graduates",
    salary: "Not Disclosed",
    skills: [
      "Software Development",
      "Programming",
      "Problem Solving",
      "Debugging"
    ],
    responsibilities: [
      "Develop software applications",
      "Collaborate with engineering teams",
      "Debug and optimize applications",
      "Maintain code quality"
    ],
    requirements: [
      "Eligible graduating batches 2021-2025",
      "Strong coding fundamentals",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Career growth opportunities",
      "Work with engineering teams",
      "Tech industry exposure"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4413997494/",
    postedDate: "2026-05-16"
  },

  {
    id: "bureau-sde1-india-602",
    title: "Software Development Engineer I",
    company: "Bureau",
    category: "Software Development",
    jobType: "Full Time",
    location: "India",
    experience: "1-2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Software Engineering",
      "Backend Development",
      "Problem Solving",
      "Data Structures"
    ],
    responsibilities: [
      "Develop scalable applications",
      "Write clean and maintainable code",
      "Collaborate with product teams",
      "Participate in code reviews"
    ],
    requirements: [
      "1-2 years development experience",
      "Strong coding skills",
      "Good understanding of software engineering principles"
    ],
    certifications: [],
    benefits: [
      "Startup environment",
      "Learning opportunities",
      "Engineering growth"
    ],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSeIYEp35XCxCNBujVQTZX8s15COZtwP_Xa6LDf-fCFwG1vCcQ/viewform",
    postedDate: "2026-05-16"
  },
  {
    id: "senior-aws-python-developer-gurgaon-501",
    title: "Senior AWS Python Developer / AWS Solutions Engineer",
    company: "Archelos Tech",
    category: "Cloud Computing",
    jobType: "Full Time",
    location: "Gurgaon",
    experience: "10+ Years",
    qualification: "Bachelor’s Degree in Computer Science or Related Field",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "AWS",
      "Microservices",
      "REST APIs",
      "CI/CD",
      "Docker",
      "Jenkins",
      "GitHub Actions"
    ],
    responsibilities: [
      "Develop scalable backend applications",
      "Build cloud-native AWS applications",
      "Develop APIs and microservices",
      "Optimize cloud performance and costs",
      "Lead technical discussions"
    ],
    requirements: [
      "Strong AWS expertise",
      "Experience with Lambda, EC2, S3, RDS",
      "Hands-on DevOps experience",
      "Production troubleshooting skills"
    ],
    certifications: [
      "AWS Certification Preferred"
    ],
    benefits: [
      "Leadership role",
      "Cloud architecture exposure",
      "High-impact projects"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-16"
  },

  {
    id: "hr-recruiter-moderninfra-jaipur-502",
    title: "HR Recruiter",
    company: "Modern Infra Projects",
    category: "Human Resources",
    jobType: "Full Time",
    location: "Jaipur",
    experience: "Freshers / Experienced",
    qualification: "Graduate",
    salary: "₹15,000 - ₹20,000 per month",
    skills: [
      "Recruitment",
      "Communication",
      "Interview Coordination",
      "Candidate Screening"
    ],
    responsibilities: [
      "Handle end-to-end recruitment",
      "Schedule interviews",
      "Maintain recruitment records",
      "Coordinate with hiring managers"
    ],
    requirements: [
      "Female candidates only",
      "Good communication skills",
      "Passion for HR"
    ],
    certifications: [],
    benefits: [
      "Career growth opportunity",
      "Freshers can apply",
      "Supportive work environment"
    ],
    applyLink: "mailto:Hr@moderninfra.co.in",
    postedDate: "2026-05-16"
  },

  {
    id: "wii-project-posts-india-503",
    title: "Various Project Posts",
    company: "Wildlife Institute of India",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "Graduate / Master’s / Ph.D.",
    salary: "₹24,000 - ₹77,000 + HRA",
    skills: [
      "Research",
      "Project Management",
      "Wildlife Studies",
      "Data Analysis"
    ],
    responsibilities: [
      "Work on wildlife projects",
      "Research and field activities",
      "Project documentation"
    ],
    requirements: [
      "Relevant educational qualification",
      "Project-specific eligibility"
    ],
    certifications: [],
    benefits: [
      "Government opportunity",
      "Research exposure",
      "HRA benefits"
    ],
    applyLink: "https://govtjobsalert.in/wii-project-posts-recruitment-2026/",
    postedDate: "2026-05-16"
  },

  {
    id: "apple-junior-sdet-hyderabad-504",
    title: "Junior Software Developer in Test",
    company: "Apple",
    category: "Software Testing",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "Freshers",
    qualification: "2023 / 2024 / 2025 Graduates",
    salary: "Not Disclosed",
    skills: [
      "Software Testing",
      "Automation",
      "Programming",
      "Debugging"
    ],
    responsibilities: [
      "Develop test automation solutions",
      "Validate software quality",
      "Work with engineering teams"
    ],
    requirements: [
      "Strong programming skills",
      "Recent graduates eligible"
    ],
    certifications: [],
    benefits: [
      "Work at Apple",
      "Career growth",
      "Tech exposure"
    ],
    applyLink: "https://jobs.apple.com/en-us/details/200638113-1052/junior-software-developer-in-test-is-t",
    postedDate: "2026-05-16"
  },

  {
    id: "engineering-intern-remote-505",
    title: "Engineering Intern",
    company: "Remote Tech Team",
    category: "Internship",
    jobType: "Internship",
    location: "Remote",
    experience: "Freshers",
    qualification: "Student / Graduate",
    salary: "Paid Internship",
    skills: [
      "React",
      "Python",
      "Frontend Development",
      "Backend Development"
    ],
    responsibilities: [
      "Work on real-world projects",
      "Develop React/Python applications",
      "Collaborate with remote team"
    ],
    requirements: [
      "Passion for development",
      "Good problem-solving skills"
    ],
    certifications: [],
    benefits: [
      "Remote work",
      "Paid internship",
      "Learning opportunity"
    ],
    applyLink: "https://www.linkedin.com/posts/nawaljavaid_were-hiring-join-our-remote-team-role-share-7461123754014699520-ISbd",
    postedDate: "2026-05-16"
  },

  {
    id: "drdo-cfees-paid-internship-506",
    title: "DRDO CFEES Paid Internship 2026",
    company: "DRDO",
    category: "Government Internship",
    jobType: "Internship",
    location: "Delhi",
    experience: "Freshers",
    qualification: "Final Year B.E./B.Tech / M.Sc / M.Tech",
    salary: "₹30,000 Total Stipend",
    skills: [
      "Research",
      "Engineering",
      "Technical Analysis"
    ],
    responsibilities: [
      "Assist in DRDO research projects",
      "Technical documentation",
      "Lab and project support"
    ],
    requirements: [
      "Final year students only",
      "Relevant engineering background"
    ],
    certifications: [],
    benefits: [
      "DRDO internship experience",
      "Government research exposure"
    ],
    applyLink: "https://govtjobsalert.in/drdo-cfees-paid-internship-2026/",
    postedDate: "2026-05-16"
  },

  {
    id: "wapcos-multiple-posts-507",
    title: "Multiple Posts Recruitment 2026",
    company: "WAPCOS",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "India",
    experience: "Experienced",
    qualification: "B.E./B.Tech/Diploma",
    salary: "Based on Candidate Profile",
    skills: [
      "Engineering",
      "Project Execution",
      "Technical Operations"
    ],
    responsibilities: [
      "Handle engineering projects",
      "Technical execution",
      "Site coordination"
    ],
    requirements: [
      "Relevant experience required",
      "Engineering qualification"
    ],
    certifications: [],
    benefits: [
      "Government PSU opportunity",
      "Large-scale projects"
    ],
    applyLink: "https://govtjobsalert.in/wapcos-multiple-posts-recruitment-2026/",
    postedDate: "2026-05-16"
  },

  {
    id: "bpssc-asi-technical-508",
    title: "BPSSC ASI Technical Recruitment 2026",
    company: "BPSSC",
    category: "Government Jobs",
    jobType: "Full Time",
    location: "Bihar",
    experience: "Freshers",
    qualification: "Diploma in EC / ETC / IT / EE",
    salary: "₹29,200 – ₹92,300",
    skills: [
      "Electronics",
      "Technical Support",
      "IT Systems"
    ],
    responsibilities: [
      "Technical support operations",
      "Departmental technical tasks"
    ],
    requirements: [
      "Relevant diploma qualification"
    ],
    certifications: [],
    benefits: [
      "Government salary",
      "Job security"
    ],
    applyLink: "https://govtjobsalert.in/bpssc-asi-technical-recruitment-2026/",
    postedDate: "2026-05-16"
  },


  {
    id: "zoho-developer-pune-mumbai-301",
    title: "Zoho Developer",
    company: "OptimHire",
    category: "Software Development",
    jobType: "Full Time",
    location: "Pune / Mumbai",
    experience: "1-5 Years",
    qualification: "BCA / MCA / BE / B.Tech",
    salary: "₹9-22 LPA",
    skills: [
      "Zoho CRM",
      "Zoho Creator",
      "Deluge Scripting",
      "API Integration",
      "PHP",
      "SQL",
      "JavaScript"
    ],
    responsibilities: [
      "Develop Zoho applications",
      "Handle API integrations",
      "Create dashboards and reports",
      "Configure Zoho CRM and Desk"
    ],
    requirements: [
      "Strong Zoho CRM knowledge",
      "Experience with Deluge scripting",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "High salary package",
      "Enterprise implementation projects",
      "Career growth"
    ],
    applyLink: "https://optimhire.com/developers/jv/309644?ref_code=mukesh-agrawal",
    postedDate: "2026-05-14"
  },

  {
    id: "technical-project-manager-coforge-302",
    title: "Technical Project Manager / Delivery Manager",
    company: "Coforge",
    category: "Project Management",
    jobType: "Full Time",
    location: "Greater Noida",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Project Management",
      "Stakeholder Management",
      "Application Development",
      "Delivery Management",
      "Risk Management"
    ],
    responsibilities: [
      "Manage delivery outcomes",
      "Handle global client engagements",
      "Manage scope and risks",
      "Coordinate cross-functional teams"
    ],
    requirements: [
      "Experience in fixed-price delivery models",
      "Strong technical background",
      "Global client handling experience"
    ],
    certifications: [],
    benefits: [
      "Global projects",
      "Leadership opportunity",
      "Enterprise exposure"
    ],
    applyLink: "mailto:Achin.kumar@coforge.com",
    postedDate: "2026-05-14"
  },


  {
    id: "zoho-developer-pune-mumbai-301",
    title: "Zoho Developer",
    company: "OptimHire",
    category: "Software Development",
    jobType: "Full Time",
    location: "Pune / Mumbai",
    experience: "1-5 Years",
    qualification: "BCA / MCA / BE / B.Tech",
    salary: "₹9-22 LPA",
    skills: [
      "Zoho CRM",
      "Zoho Creator",
      "Deluge Scripting",
      "API Integration",
      "PHP",
      "SQL",
      "JavaScript"
    ],
    responsibilities: [
      "Develop Zoho applications",
      "Handle API integrations",
      "Create dashboards and reports",
      "Configure Zoho CRM and Desk"
    ],
    requirements: [
      "Strong Zoho CRM knowledge",
      "Experience with Deluge scripting",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "High salary package",
      "Enterprise implementation projects",
      "Career growth"
    ],
    applyLink: "https://optimhire.com/developers/jv/309644?ref_code=mukesh-agrawal",
    postedDate: "2026-05-14"
  },

  {
    id: "technical-project-manager-coforge-302",
    title: "Technical Project Manager / Delivery Manager",
    company: "Coforge",
    category: "Project Management",
    jobType: "Full Time",
    location: "Greater Noida",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Project Management",
      "Stakeholder Management",
      "Application Development",
      "Delivery Management",
      "Risk Management"
    ],
    responsibilities: [
      "Manage delivery outcomes",
      "Handle global client engagements",
      "Manage scope and risks",
      "Coordinate cross-functional teams"
    ],
    requirements: [
      "Experience in fixed-price delivery models",
      "Strong technical background",
      "Global client handling experience"
    ],
    certifications: [],
    benefits: [
      "Global projects",
      "Leadership opportunity",
      "Enterprise exposure"
    ],
    applyLink: "mailto:Achin.kumar@coforge.com",
    postedDate: "2026-05-14"
  },



  {
    id: "servicenow-associate-principal-engineer-ncs-101",
    title: "Associate Principal Engineer – ServiceNow",
    company: "NCS",
    category: "IT",
    jobType: "Full Time",
    location: "Gurgaon / Pune / Noida / Delhi / Chennai / Mumbai",
    experience: "9-15 Years",
    qualification: "Bachelor’s Degree",
    salary: "Up to ₹30 LPA",
    skills: [
      "ServiceNow",
      "ITSM",
      "ITOM",
      "CMDB",
      "PowerShell",
      "AngularJS",
      "Jelly Scripting"
    ],
    responsibilities: [
      "Implement ServiceNow modules",
      "Handle integrations",
      "Develop technical solutions",
      "Perform testing"
    ],
    requirements: [
      "Strong ServiceNow implementation experience",
      "ServiceNow certification mandatory",
      "Immediate joiners preferred"
    ],
    certifications: [
      "ServiceNow Certification"
    ],
    benefits: [
      "Pan India opportunity",
      "High salary package",
      "Enterprise projects"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-12"
  },

  {
    id: "divum-business-analyst-bengaluru-102",
    title: "Business Analyst",
    company: "Divum Corporate Services",
    category: "Business Analysis",
    jobType: "Full Time",
    location: "Bengaluru",
    experience: "2-5 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹5L - ₹15L /year",
    skills: [
      "Business Analysis",
      "Requirement Gathering",
      "Product Management",
      "SDLC"
    ],
    responsibilities: [
      "Gather requirements",
      "Create user stories",
      "Collaborate with engineering teams",
      "Support UAT"
    ],
    requirements: [
      "Strong BA fundamentals",
      "Experience in SDLC",
      "Stakeholder management skills"
    ],
    certifications: [],
    benefits: [
      "Onsite opportunity",
      "Product collaboration",
      "Career growth"
    ],
    applyLink: "https://abekus.ai/public-job-search/senior-full-stack-developer-2?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-12"
  },

  {
    id: "ble-application-developer-quest-global-103",
    title: "BLE Application Developer",
    company: "Quest Global",
    category: "Embedded Systems",
    jobType: "Full Time",
    location: "Bangalore / Trivandrum",
    experience: "4-12 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Bluetooth BLE",
      "Embedded Systems",
      "RTOS",
      "SPI",
      "I2C",
      "GPIO",
      "CAN"
    ],
    responsibilities: [
      "Develop BLE systems",
      "Maintain firmware",
      "Troubleshoot BLE issues",
      "Integrate BLE solutions"
    ],
    requirements: [
      "Bluetooth domain expertise",
      "Embedded development experience",
      "RTOS knowledge"
    ],
    certifications: [],
    benefits: [
      "Work on cutting-edge BLE tech",
      "Enterprise engineering projects"
    ],
    applyLink: "mailto:Nagamani.Peddireddy@quest-global.com",
    postedDate: "2026-05-12"
  },

  {
    id: "full-stack-developer-intern-global-engineering-104",
    title: "Full Stack Developer Intern",
    company: "Global Engineering Company",
    category: "Internship",
    jobType: "Internship",
    location: "Pune",
    experience: "Freshers",
    qualification: "Any Degree",
    salary: "₹25K Stipend",
    skills: [
      "MERN Stack",
      "HTML",
      "CSS",
      "Git",
      "Communication"
    ],
    responsibilities: [
      "Develop web applications",
      "Work on frontend and backend",
      "Collaborate with team"
    ],
    requirements: [
      "2023-2026 graduates",
      "Basic MERN stack knowledge"
    ],
    certifications: [],
    benefits: [
      "6 LPA opportunity",
      "Internship with stipend",
      "Career growth"
    ],
    applyLink: "https://placement.acciojob.com/job-drive-details/?utm_source=referral&utm_medium=share&jobDriveId=4631bda6-7e02-429d-9bad-e58faec8dd91&utm_content=4631bda6-7e02-429d-9bad-e58faec8dd91&utm_campaign=copy_link&referralId=bf41b401-93f9-45be-b563-5b6bcbd123a7",
    postedDate: "2026-05-12"
  },

  {
    id: "change-management-manager-enterprise-105",
    title: "Change Management Manager",
    company: "Enterprise Hiring",
    category: "Management",
    jobType: "Full Time",
    location: "Gurugram / Bangalore / Mumbai / Pune / Hyderabad / Kolkata / Chennai",
    experience: "8-12 Years",
    qualification: "MBA",
    salary: "Not Disclosed",
    skills: [
      "OCM",
      "Transformation Strategy",
      "Stakeholder Management",
      "SAP S/4HANA",
      "Oracle",
      "O365"
    ],
    responsibilities: [
      "Lead change management initiatives",
      "Drive adoption strategies",
      "Manage enterprise transformation"
    ],
    requirements: [
      "Post MBA experience",
      "Client-facing experience",
      "OCM expertise"
    ],
    certifications: [
      "PROSCI Preferred"
    ],
    benefits: [
      "Enterprise transformation projects",
      "Leadership exposure"
    ],
    applyLink: "mailto:purnima@firstcalli.com",
    postedDate: "2026-05-12"
  },

  {
    id: "cognizant-manual-qa-bangalore-106",
    title: "Manual QA Engineer",
    company: "Cognizant",
    category: "QA",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Manual Testing",
      "QA",
      "Agile",
      "REST APIs",
      "Defect Management"
    ],
    responsibilities: [
      "Perform manual testing",
      "Create test cases",
      "Support customers",
      "Track defects"
    ],
    requirements: [
      "Excellent communication skills",
      "Agile QA experience",
      "Attention to detail"
    ],
    certifications: [],
    benefits: [
      "Remote-first setup",
      "AI-powered automation projects",
      "Global team"
    ],
    applyLink: "https://careers.cognizant.com/global-en/jobs/00067661142/manual-qa/",
    postedDate: "2026-05-12"
  },

  {
    id: "laravel-developer-referral-107",
    title: "Laravel Developer",
    company: "Referral Opportunity",
    category: "Software Development",
    jobType: "Full Time",
    location: "India",
    experience: "1 Year",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Laravel",
      "PHP",
      "Backend Development"
    ],
    responsibilities: [
      "Develop Laravel applications",
      "Maintain backend systems"
    ],
    requirements: [
      "1 year Laravel experience"
    ],
    certifications: [],
    benefits: [
      "Referral opportunity"
    ],
    applyLink: "tel:+918299514900",
    postedDate: "2026-05-12"
  },

  {
    id: "fiserv-systems-security-analysis-108",
    title: "Advisor, Systems Security Analysis (IBM DataPower)",
    company: "Fiserv",
    category: "Cloud & Security",
    jobType: "Full Time",
    location: "Pune",
    experience: "6+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "IBM DataPower",
      "Apigee",
      "Python",
      "JavaScript",
      "Microservices",
      "API Management"
    ],
    responsibilities: [
      "Manage API solutions",
      "Develop DataPower services",
      "Handle production support",
      "Automate operational tasks"
    ],
    requirements: [
      "IBM DataPower expertise",
      "Apigee experience",
      "Microservices experience"
    ],
    certifications: [
      "Cloud Certification Preferred"
    ],
    benefits: [
      "Fintech projects",
      "Global enterprise systems"
    ],
    applyLink: "https://careers.fiserv.com/us/en/job/R-10363759/Advisor-Systems-Security-Analysis-IBM-DataPower",
    postedDate: "2026-05-12"
  },

  {
    id: "senior-software-developer-python-109",
    title: "Senior Software Developer – Python",
    company: "Elyx Digital",
    category: "Software Development",
    jobType: "Full Time",
    location: "Mumbai / Hybrid",
    experience: "8+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "FastAPI",
      "Django",
      "Flask",
      "Docker",
      "Kubernetes",
      "AWS"
    ],
    responsibilities: [
      "Build scalable backend systems",
      "Design microservices",
      "Develop REST APIs",
      "Maintain CI/CD pipelines"
    ],
    requirements: [
      "Strong architecture knowledge",
      "Cloud expertise",
      "Microservices experience"
    ],
    certifications: [],
    benefits: [
      "Hybrid work",
      "Scalable product engineering"
    ],
    applyLink: "mailto:neeta.w@elyxdigital.com",
    postedDate: "2026-05-12"
  },

  {
    id: "cgi-senior-azure-kubernetes-engineer-110",
    title: "Senior Azure Kubernetes Engineer",
    company: "CGI",
    category: "Cloud Computing",
    jobType: "Full Time",
    location: "Bangalore / Chennai / Pune / Mumbai",
    experience: "9+ Years",
    qualification: "Bachelor’s Degree in Computer Science",
    salary: "Not Disclosed",
    skills: [
      "Azure",
      "AKS",
      "Kubernetes",
      "IaC",
      "DevOps",
      "Cloud Computing"
    ],
    responsibilities: [
      "Manage Azure Kubernetes platforms",
      "Automate cloud infrastructure",
      "Maintain secure cloud systems"
    ],
    requirements: [
      "Azure expertise",
      "Kubernetes experience",
      "DevOps automation knowledge"
    ],
    certifications: [],
    benefits: [
      "Enterprise cloud projects",
      "Multi-city opportunities"
    ],
    applyLink: "https://www.cgi.com/",
    postedDate: "2026-05-12"
  },

  {
    id: "drdo-dlrl-internship-2026-048",
    title: "DRDO DLRL Internship 2026",
    company: "DRDO DLRL",
    category: "Internship",
    jobType: "Internship",
    location: "Hyderabad",
    experience: "Freshers",
    qualification: "Pre-final Year B.E./B.Tech",
    salary: "₹30,000 Stipend",
    skills: [
      "Engineering Basics",
      "Research",
      "Technical Analysis"
    ],
    responsibilities: [
      "Assist research projects",
      "Support DRDO technical teams",
      "Work on engineering tasks"
    ],
    requirements: [
      "Pre-final year students only",
      "Relevant engineering background"
    ],
    certifications: [],
    benefits: [
      "DRDO Exposure",
      "Research Experience"
    ],
    applyLink: "https://govtjobsalert.in/drdo-dlrl-hyderabad-internship-2026/",
    postedDate: "2026-05-12",
    lastDate: "2026-05-15"
  },

  {
    id: "union-bank-apprentice-2026-049",
    title: "Apprentice Recruitment 2026",
    company: "Union Bank of India",
    category: "Banking",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹15,000 – ₹20,000",
    skills: [
      "Banking Operations",
      "Communication",
      "Customer Service"
    ],
    responsibilities: [
      "Assist banking operations",
      "Support branch activities",
      "Handle customer interactions"
    ],
    requirements: [
      "Graduate qualification",
      "Basic banking knowledge"
    ],
    certifications: [],
    benefits: [
      "Banking Experience",
      "Government Opportunity"
    ],
    applyLink: "https://govtjobsalert.in/union-bank-of-india-apprentice-recruitment-2026/",
    postedDate: "2026-05-12",
    lastDate: "2026-05-19"
  },

  {
    id: "territorial-army-officer-2026-050",
    title: "Territorial Army Officer Recruitment 2026",
    company: "Territorial Army",
    category: "Defense",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "Graduate",
    salary: "₹56,100 + MSP ₹15,500",
    skills: [
      "Leadership",
      "Discipline",
      "Communication"
    ],
    responsibilities: [
      "Lead army operations",
      "Maintain discipline",
      "Support defense services"
    ],
    requirements: [
      "Graduate qualification",
      "Physical fitness"
    ],
    certifications: [],
    benefits: [
      "Defense Career",
      "Government Benefits"
    ],
    applyLink: "https://govtjobsalert.in/territorial-army-officer-recruitment-2026/",
    postedDate: "2026-05-12",
    lastDate: "2026-05-19"
  },

  {
    id: "engineering-govt-jobs-2026-053",
    title: "Latest Engineering Govt Jobs 2026",
    company: "Multiple Government Departments",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "B.E / B.Tech / Diploma",
    salary: "₹30,000 – ₹2,00,000+",
    skills: [
      "Engineering",
      "Technical Knowledge",
      "Problem Solving"
    ],
    responsibilities: [
      "Department-specific engineering tasks",
      "Technical project execution",
      "Government operations support"
    ],
    requirements: [
      "Engineering qualification",
      "Relevant eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "19,000+ Vacancies",
      "Government Salary"
    ],
    applyLink: "https://govtjobsalert.in/engineering-govt-jobs/",
    postedDate: "2026-05-12"
  },

  {
    id: "indian-army-csbo-grade-ii-2026-051",
    title: "Indian Army CSBO Grade II Recruitment 2026",
    company: "Indian Army",
    category: "Defense",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "10th Pass",
    salary: "₹21,700 – ₹69,100",
    skills: [
      "Communication",
      "Technical Support",
      "Discipline"
    ],
    responsibilities: [
      "Support army communication systems",
      "Maintain operational duties",
      "Assist defense operations"
    ],
    requirements: [
      "10th pass qualification",
      "Relevant experience preferred"
    ],
    certifications: [],
    benefits: [
      "Defense Career",
      "Government Benefits"
    ],
    applyLink: "https://govtjobsalert.in/indian-army-csbo-recruitment-2026/",
    postedDate: "2026-05-12",
    lastDate: "2026-05-31"
  },

  {
    id: "india-post-gds-2026-052",
    title: "India Post GDS Recruitment 2026",
    company: "India Post",
    category: "Postal Services",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass",
    salary: "As Per India Post Rules",
    skills: [
      "Communication",
      "Delivery Operations",
      "Basic Computer Knowledge"
    ],
    responsibilities: [
      "Handle postal delivery services",
      "Support branch operations",
      "Maintain customer service"
    ],
    requirements: [
      "10th pass eligible",
      "Document verification required"
    ],
    certifications: [],
    benefits: [
      "28,636 Vacancies",
      "Government Job"
    ],
    applyLink: "https://govtjobsalert.in/indian-post-gds-recruitment-2026/",
    postedDate: "2026-05-12"
  },

  {
    id: "hr-manager-cable-wire-coimbatore-201",
    title: "HR Manager",
    company: "Leading Cable & Wire Industry",
    category: "Human Resources",
    jobType: "Full Time",
    location: "Coimbatore",
    experience: "Experienced",
    qualification: "MBA / MSW / Any Relevant Degree",
    salary: "Best in Industry",
    skills: [
      "HR Operations",
      "Recruitment",
      "Employee Management",
      "HR Policy Implementation",
      "Leadership"
    ],
    responsibilities: [
      "Handle HR operations",
      "Implement HR policies",
      "Manage recruitment activities",
      "Support manufacturing HR setup"
    ],
    requirements: [
      "Manufacturing background preferred",
      "Strong communication skills",
      "Immediate joiners preferred",
      "Female candidates only"
    ],
    certifications: [],
    benefits: [
      "Leadership role",
      "Manufacturing industry exposure"
    ],
    applyLink: "mailto:sweety.diwakar@sonaligroup.com",
    postedDate: "2026-05-12"
  },

  {
    id: "jr-hr-executive-hosur-202",
    title: "Jr. HR Executive",
    company: "Hertz Electricals",
    category: "Human Resources",
    jobType: "Full Time",
    location: "Hosur",
    experience: "1 Year",
    qualification: "MSW / MBA",
    salary: "Best in Industry",
    skills: [
      "Recruitment",
      "HR Coordination",
      "Employee Support",
      "Communication"
    ],
    responsibilities: [
      "Support HR operations",
      "Coordinate hiring process",
      "Manage employee records"
    ],
    requirements: [
      "Immediate joiner preferred",
      "1 year HR experience"
    ],
    certifications: [],
    benefits: [
      "Career growth",
      "Industrial HR exposure"
    ],
    applyLink: "mailto:hrd@hertzelectricals.in",
    contact: "tel:+919566492885",
    postedDate: "2026-05-12"
  },

  {
    id: "hr-recruiter-surya-hr-bangalore-203",
    title: "HR Recruiter",
    company: "Surya HR & IR Consultant",
    category: "Human Resources",
    jobType: "Full Time",
    location: "Bangalore",
    experience: "Freshers / 0-2 Years",
    qualification: "Degree / MBA / MSW",
    salary: "₹15K - ₹20K + Incentives",
    skills: [
      "Recruitment",
      "Candidate Sourcing",
      "Screening",
      "Interview Coordination",
      "Database Management"
    ],
    responsibilities: [
      "Source candidates",
      "Screen resumes",
      "Coordinate interviews",
      "Maintain recruitment database"
    ],
    requirements: [
      "HR specialization preferred",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Incentives",
      "Freshers opportunity",
      "HR career growth"
    ],
    applyLink: "mailto:bindu@suryahrir.com",
    contact: "tel:+919611148915",
    postedDate: "2026-05-12"
  },







  {
    id: "mercor-performance-engineer-2026-014",
    title: "Performance Engineer (C++, Python, Rust) — W2",
    company: "Mercor",
    category: "AI / Systems Engineering",
    jobType: "Contract",
    location: "Remote, India",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "$35-$45 per hour",
    skills: [
      "C++",
      "Python",
      "Rust",
      "Systems Programming",
      "Performance Optimization",
      "Compiler Engineering"
    ],
    responsibilities: [
      "Improve AI model performance",
      "Design systems-level optimization tasks",
      "Evaluate engineering solutions"
    ],
    requirements: [
      "Low-level optimization expertise",
      "Strong written communication"
    ],
    certifications: [],
    benefits: [
      "Remote Work",
      "AI Lab Exposure"
    ],
    applyLink: "https://t.mercor.com/POBdz",
    postedDate: "2026-05-11"
  },

  {
    id: "decisivedge-senior-dotnet-developer-2026-015",
    title: "Senior .NET Developer",
    company: "Decisive Edge",
    category: "Software Development",
    jobType: "Full Time",
    location: "Pune – Magarpatta City",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "C#",
      "ASP.NET",
      ".NET Core",
      "Angular",
      "SQL Server",
      "MongoDB"
    ],
    responsibilities: [
      "Develop scalable applications",
      "Participate in code reviews",
      "Mentor developers"
    ],
    requirements: [
      "Strong .NET experience",
      "Agile/Scrum knowledge"
    ],
    certifications: [],
    benefits: [
      "5 Days Onsite",
      "Collaborative Team"
    ],
    applyLink: "mailto:pranjali.kohinkar@decisivedge.com",
    postedDate: "2026-05-11"
  },

  {
    id: "powerapps-agentic-ai-developer-2026-016",
    title: "Power Apps Developer with Agentic AI",
    company: "OptimHire",
    category: "AI Automation",
    jobType: "Full Time",
    location: "Remote",
    experience: "5-8 Years",
    qualification: "BE / BTech in Computer Science",
    salary: "₹11-20 LPA",
    skills: [
      "Power Apps",
      "Power Automate",
      "Agentic AI",
      "Copilot Studio",
      "Azure AI",
      "REST APIs"
    ],
    responsibilities: [
      "Build AI automation workflows",
      "Develop Power Apps solutions",
      "Create conversational AI agents"
    ],
    requirements: [
      "Power Platform expertise",
      "Generative AI understanding"
    ],
    certifications: [
      "Microsoft Power Platform Certifications"
    ],
    benefits: [
      "Fully Remote",
      "High Growth Opportunity"
    ],
    applyLink: "https://optimhire.com/developers/jv/309767?ref_code=mukesh-agrawal",
    postedDate: "2026-05-11"
  },

  {
    id: "sonata-software-developer-2026-017",
    title: "Developer / Sr. Developer",
    company: "Sonata Software",
    category: "Software Development",
    jobType: "Full Time",
    location: "Bangalore / Hyderabad / Chennai",
    experience: "3-5 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "C#",
      ".NET Core",
      "ASP.NET Core",
      "Angular",
      "React",
      "Vue"
    ],
    responsibilities: [
      "Develop enterprise applications",
      "Work on ERP development",
      "Build scalable APIs"
    ],
    requirements: [
      "Experience in .NET technologies",
      "Frontend framework knowledge"
    ],
    certifications: [],
    benefits: [
      "Multiple Locations",
      "Enterprise Projects"
    ],
    applyLink: "mailto:Udayashree.Pb@sonata-software.com",
    postedDate: "2026-05-11"
  },

  {
    id: "nabu-sde-fullstack-2026-018",
    title: "Software Development Engineer",
    company: "Nabu Technologies Private Limited",
    category: "Full Stack Development",
    jobType: "Full Time",
    location: "Faridabad",
    experience: "3-5 Years",
    qualification: "Bachelor’s Degree in Computer Science",
    salary: "₹2.4 LPA - ₹4 LPA",
    skills: [
      "Laravel",
      "React.js",
      "TypeScript",
      "MySQL",
      "REST APIs",
      "Tailwind CSS"
    ],
    responsibilities: [
      "Develop scalable web applications",
      "Build frontend and backend services",
      "Optimize application performance"
    ],
    requirements: [
      "Full stack development experience",
      "Strong debugging skills"
    ],
    certifications: [],
    benefits: [
      "Fast-paced Product Environment",
      "Growth Opportunity"
    ],
    applyLink: "https://unstop.com/o/MphcBnv?lb=Bnie7Jo",
    postedDate: "2026-05-11"
  },

  {
    id: "mumbai-datacenter-engineer-2026-019",
    title: "L2 and L3 Data Center Engineer",
    company: "CES",
    category: "Infrastructure",
    jobType: "Full Time",
    location: "Mumbai",
    experience: "5-8 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Cisco ACI",
      "Nexus",
      "SDN",
      "Routing & Switching",
      "Firewall",
      "Cloud Integration"
    ],
    responsibilities: [
      "Manage data center infrastructure",
      "Handle L2/L3 escalations",
      "Ensure high availability"
    ],
    requirements: [
      "Strong networking knowledge",
      "Incident management expertise"
    ],
    certifications: [],
    benefits: [
      "Enterprise Projects",
      "Growth-driven Culture"
    ],
    applyLink: "mailto:Piyushis@ces-pl.com",
    postedDate: "2026-05-11"
  },

  {
    id: "4basecare-senior-fullstack-2026-020",
    title: "Senior Full Stack Developer",
    company: "4basecare",
    category: "Full Stack Development",
    jobType: "Full Time",
    location: "Bengaluru (Hybrid)",
    experience: "4-14 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹14L - ₹26L /year",
    skills: [
      "Java",
      "Node.js",
      "React.js",
      "MS SQL",
      "REST APIs"
    ],
    responsibilities: [
      "Develop modern web applications",
      "Build scalable backend services",
      "Optimize database performance"
    ],
    requirements: [
      "Production-grade application experience",
      "Scalable architecture understanding"
    ],
    certifications: [],
    benefits: [
      "Hybrid Work",
      "High Salary"
    ],
    applyLink: "https://abekus.ai/public-job-search/senior-full-stack-developer-2?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-11"
  },

  {
    id: "progresinnotech-techlead-pm-2026-021",
    title: "Tech Lead / Project Manager",
    company: "Progres Innotech",
    category: "Management",
    jobType: "Full Time",
    location: "Vadodara",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Project Management",
      "Leadership",
      "Team Coordination"
    ],
    responsibilities: [
      "Lead technical teams",
      "Manage projects",
      "Coordinate deliverables"
    ],
    requirements: [
      "Leadership experience",
      "Strong communication"
    ],
    certifications: [],
    benefits: [
      "Leadership Role",
      "Career Growth"
    ],
    applyLink: "mailto:juhi@progresinnotech.com",
    postedDate: "2026-05-11"
  },

  {
    id: "global-fullstack-intern-2026-022",
    title: "Full Stack Developer Intern",
    company: "Global Engineering Company",
    category: "Internship",
    jobType: "Internship",
    location: "Pune",
    experience: "Freshers",
    qualification: "All Degrees",
    salary: "₹25k Internship Stipend",
    skills: [
      "MERN Stack",
      "HTML",
      "CSS",
      "Git",
      "Communication"
    ],
    responsibilities: [
      "Develop web applications",
      "Assist engineering team",
      "Work on frontend and backend"
    ],
    requirements: [
      "2023-2026 Graduates",
      "Basic MERN knowledge"
    ],
    certifications: [],
    benefits: [
      "6 LPA CTC",
      "Internship Opportunity"
    ],
    applyLink: "https://placement.acciojob.com/job-drive-details/?utm_source=referral&utm_medium=share&jobDriveId=4631bda6-7e02-429d-9bad-e58faec8dd91&utm_content=4631bda6-7e02-429d-9bad-e58faec8dd91&utm_campaign=copy_link&referralId=bf41b401-93f9-45be-b563-5b6bcbd123a7",
    postedDate: "2026-05-11"
  },

  {
    id: "incident-manager-delhi-2026-023",
    title: "Incident Manager",
    company: "Stride4E",
    category: "IT Operations",
    jobType: "Full Time",
    location: "Delhi",
    experience: "8-12 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "ITIL",
      "ITSM",
      "Incident Management",
      "Core Banking",
      "SLA Governance"
    ],
    responsibilities: [
      "Lead war rooms",
      "Manage incidents",
      "Drive RCA and preventive actions"
    ],
    requirements: [
      "Banking operations experience",
      "Stakeholder management"
    ],
    certifications: [],
    benefits: [
      "Leadership Exposure",
      "Enterprise Operations"
    ],
    applyLink: "mailto:ta1@stride4e.com",
    postedDate: "2026-05-11"
  },

  {
    id: "arohitha-app-dev-intern-2026-024",
    title: "App Development Intern",
    company: "Arohitha Global Services",
    category: "Internship",
    jobType: "Internship",
    location: "Mysore",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: [
      "Flutter",
      "React Native",
      "Node.js",
      "Firebase",
      "MongoDB"
    ],
    responsibilities: [
      "Assist app development",
      "Improve UI/UX",
      "Support backend integrations"
    ],
    requirements: [
      "Basic app development knowledge",
      "Good collaboration skills"
    ],
    certifications: [],
    benefits: [
      "Hands-on Experience",
      "Startup Exposure"
    ],
    applyLink: "mailto:arohithaofficial@gmail.com",
    postedDate: "2026-05-11"
  },

  {
    id: "indian-navy-agniveer-musician-2026-025",
    title: "Agniveer MR (Musician) 02/2026",
    company: "Indian Navy",
    category: "Defense",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass",
    salary: "As Per Navy Rules",
    skills: [
      "Music",
      "Discipline",
      "Physical Fitness"
    ],
    responsibilities: [
      "Perform musical duties",
      "Participate in Navy training",
      "Follow official instructions"
    ],
    requirements: [
      "Already applied candidates only",
      "Download call-up letter from portal"
    ],
    certifications: [],
    benefits: [
      "Defense Career",
      "Government Benefits"
    ],
    applyLink: "https://govtjobsalert.in/indian-navy-agniveer-mr-musician-recruitment-2026/",
    postedDate: "2026-05-11"
  },

  {
    id: "ssb-constable-sports-quota-2026-026",
    title: "Constable Sports Quota",
    company: "SSB",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass + Sports",
    salary: "₹21,700 – ₹69,100",
    skills: [
      "Sports",
      "Physical Fitness",
      "Discipline"
    ],
    responsibilities: [
      "Perform constable duties",
      "Represent sports quota activities",
      "Maintain physical standards"
    ],
    requirements: [
      "Sports qualification required",
      "10th pass eligible"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "Pay Level-3"
    ],
    applyLink: "https://govtjobsalert.in/ssb-constable-sports-quota-recruitment-2026/",
    postedDate: "2026-05-11",
    lastDate: "2026-06-07"
  },

  {
    id: "cescom-apprentice-2026-027",
    title: "Apprentice Recruitment",
    company: "CESCOM",
    category: "Apprenticeship",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "BE / B.Tech / Diploma / Graduate",
    salary: "₹10,900 – ₹12,300/month",
    skills: [
      "Technical Knowledge",
      "Electrical Basics",
      "Communication"
    ],
    responsibilities: [
      "Assist technical teams",
      "Support engineering operations",
      "Learn industry practices"
    ],
    requirements: [
      "Relevant qualification",
      "Freshers eligible"
    ],
    certifications: [],
    benefits: [
      "Monthly Stipend",
      "Industry Exposure"
    ],
    applyLink: "https://govtjobsalert.in/cescom-apprentice-recruitment-2026/",
    postedDate: "2026-05-11",
    lastDate: "2026-05-29"
  },

  {
    id: "csir-serc-project-associate-2026-028",
    title: "Project Associate Recruitment",
    company: "CSIR-SERC",
    category: "Research",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "BE / B.Tech / M.E. / M.Tech / Diploma",
    salary: "₹20,000 – ₹35,000 + HRA",
    skills: [
      "Research",
      "Engineering",
      "Technical Analysis"
    ],
    responsibilities: [
      "Assist research projects",
      "Support technical operations",
      "Prepare reports"
    ],
    requirements: [
      "Engineering qualification",
      "Walk-in interview participation"
    ],
    certifications: [],
    benefits: [
      "Research Exposure",
      "HRA Benefits"
    ],
    applyLink: "https://govtjobsalert.in/csir-serc-project-associate-recruitment-2026/",
    postedDate: "2026-05-11",
    lastDate: "2026-05-21"
  },

  {
    id: "iaf-group-c-civilian-2026-029",
    title: "Group C Civilian Recruitment",
    company: "Indian Air Force",
    category: "Defense",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass / 12th Pass",
    salary: "₹19,900 – ₹63,200",
    skills: [
      "Typing",
      "Administration",
      "Driving"
    ],
    responsibilities: [
      "Handle civilian duties",
      "Maintain office operations",
      "Support department activities"
    ],
    requirements: [
      "Relevant eligibility criteria",
      "Basic skills as per role"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "Defense Sector Opportunity"
    ],
    applyLink: "https://govtjobsalert.in/iaf-group-c-civilian-recruitment-2026/",
    postedDate: "2026-05-11",
    lastDate: "2026-06-01"
  },

  {
    id: "indian-navy-anc-ldc-mts-2026-030",
    title: "HQ ANC LDC & MTS Recruitment",
    company: "Indian Navy",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th / 12th Pass",
    salary: "₹18,000 – ₹63,200",
    skills: [
      "Administration",
      "Typing",
      "Office Support"
    ],
    responsibilities: [
      "Perform LDC duties",
      "Support office management",
      "Handle clerical work"
    ],
    requirements: [
      "10th/12th qualification",
      "Basic administrative skills"
    ],
    certifications: [],
    benefits: [
      "Government Benefits",
      "Stable Career"
    ],
    applyLink: "https://govtjobsalert.in/indian-navy-anc-ldc-mts-recruitment-2026/",
    postedDate: "2026-05-11",
    lastDate: "2026-05-15"
  },

  {
    id: "latest-graduate-govt-jobs-2026-031",
    title: "Latest Graduate Govt Jobs",
    company: "Multiple Government Departments",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹25,500 – ₹1,77,500",
    skills: [
      "Communication",
      "General Aptitude",
      "Administration"
    ],
    responsibilities: [
      "Department-specific responsibilities",
      "Administrative operations",
      "Public service duties"
    ],
    requirements: [
      "Graduate qualification",
      "Department eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "10,000+ Vacancies",
      "Government Salary"
    ],
    applyLink: "https://govtjobsalert.in/graduate-govt-jobs/",
    postedDate: "2026-05-11"
  },


  {
    id: "rockwell-data-analyst-2026-032",
    title: "Data Analyst",
    company: "Rockwell Automation",
    category: "Data Analytics",
    jobType: "Full Time",
    location: "Pune, India (Hybrid)",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Reporting",
      "Analytics",
      "Problem Solving"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports and insights",
      "Support decision making"
    ],
    requirements: [
      "Strong analytical skills",
      "Relevant experience required"
    ],
    certifications: [],
    benefits: [
      "Hybrid Work",
      "Career Growth"
    ],
    applyLink: "https://rockwellautomation.wd1.myworkdayjobs.com/en-US/External_Rockwell_Automation/job/Data-Analyst_R26-2881",
    postedDate: "2026-05-11"
  },

  {
    id: "argano-intern-2026-033",
    title: "Intern",
    company: "Argano",
    category: "Internship",
    jobType: "Internship",
    location: "Hyderabad",
    experience: "Freshers",
    qualification: "2024 / 2025 / 2026 Graduates",
    salary: "Not Disclosed",
    skills: [
      "Communication",
      "Problem Solving",
      "Technical Fundamentals"
    ],
    responsibilities: [
      "Assist project teams",
      "Support technical operations",
      "Learn enterprise workflows"
    ],
    requirements: [
      "Recent graduates eligible",
      "Willingness to learn"
    ],
    certifications: [],
    benefits: [
      "Internship Opportunity",
      "Corporate Exposure"
    ],
    applyLink: "https://fa-eyau-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Argano-Careers/job/1577",
    postedDate: "2026-05-11"
  },

  {
    id: "kla-software-engineer-2026-034",
    title: "Software Engineer / Test Automation",
    company: "KLA",
    category: "Software Development",
    jobType: "Full Time",
    location: "Chennai",
    experience: "Freshers / 0-2 Years",
    qualification: "BE / BTech / BSc – CS/IT & Related Branches",
    salary: "Not Disclosed",
    skills: [
      "Software Development",
      "Test Automation",
      "Programming",
      "Debugging"
    ],
    responsibilities: [
      "Develop software solutions",
      "Work on test automation",
      "Support engineering teams"
    ],
    requirements: [
      "CS/IT background",
      "Basic programming skills"
    ],
    certifications: [],
    benefits: [
      "Semiconductor Industry Exposure",
      "Career Growth"
    ],
    applyLink: "https://kla.wd1.myworkdayjobs.com/Search/job/Chennai-India/Software-Engineer_2635457?bid=370&source=Job_Board_LinkedIn",
    postedDate: "2026-05-11"
  },

  {
    id: "csg-systems-admin-grad-2026-035",
    title: "Systems Administrator Grad",
    company: "CSG",
    category: "System Administration",
    jobType: "Full Time",
    location: "Remote, India",
    experience: "Freshers / 0-1 Years",
    qualification: "BE / BTech – CS/IT & Related Branches",
    salary: "Not Disclosed",
    skills: [
      "SQL",
      "Database Basics",
      "Windows Server",
      "MySQL"
    ],
    responsibilities: [
      "Support system administration tasks",
      "Manage databases",
      "Maintain server operations"
    ],
    requirements: [
      "Basic database knowledge",
      "CS/IT educational background"
    ],
    certifications: [],
    benefits: [
      "Work From Home",
      "Freshers Opportunity"
    ],
    applyLink: "https://csgi.wd5.myworkdayjobs.com/CSGCareers/job/India-Remote/Systems-Administrator-Grad_31901",
    postedDate: "2026-05-11"
  },

  {
    id: "accenture-multiple-roles-2026-036",
    title: "Associate / Analyst / Operations / Tech Roles",
    company: "Accenture",
    category: "IT Services",
    jobType: "Full Time",
    location: "PAN India",
    experience: "Freshers & Experienced",
    qualification: "Any Graduate / BE / BTech / MBA",
    salary: "Not Disclosed",
    skills: [
      "AI",
      "Cloud",
      "Analytics",
      "Digital Transformation"
    ],
    responsibilities: [
      "Work on client projects",
      "Support digital transformation",
      "Collaborate with teams"
    ],
    requirements: [
      "Relevant qualification",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "PAN India Opportunities",
      "Global Projects"
    ],
    applyLink: "https://www.accenture.com/in-en/careers/jobdetails?id=AIOC-S01642929_en&src=LINKEDINJP",
    postedDate: "2026-05-11"
  },

  {
    id: "google-tech-opportunities-2026-037",
    title: "Software / Tech Opportunities",
    company: "Google",
    category: "Software Engineering",
    jobType: "Full Time",
    location: "Bengaluru",
    experience: "Freshers & Experienced",
    qualification: "BE / BTech / ME / MTech / MCA",
    salary: "Not Disclosed",
    skills: [
      "AI",
      "Cloud",
      "Large-scale Systems",
      "Networking"
    ],
    responsibilities: [
      "Work on Google products",
      "Develop scalable systems",
      "Support cloud operations"
    ],
    requirements: [
      "Strong technical background",
      "Relevant degree"
    ],
    certifications: [],
    benefits: [
      "Top Tech Company",
      "Advanced Technology Exposure"
    ],
    applyLink: "https://www.google.com/about/careers/applications/jobs/results/127757644021539526-network-operations-residency-program/?src=Online/LinkedIn/linkedin_us&utm_source=linkedin&utm_medium=jobposting&utm_campaign=contract",
    postedDate: "2026-05-11"
  },





  {
    id: "fairmont-account-receivable-executive-2026-038",
    title: "Account Receivable Executive",
    company: "Fairmont",
    category: "Accounting",
    jobType: "Full Time",
    location: "Coimbatore",
    experience: "1-3 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Cash Application",
      "Accounts Receivable",
      "Financial Reporting",
      "MS Office Suite",
      "Compliance Management"
    ],
    responsibilities: [
      "Manage accounts receivable operations",
      "Prepare financial reports",
      "Handle compliance processes"
    ],
    requirements: [
      "Accounting software knowledge",
      "Good analytical skills"
    ],
    certifications: [],
    benefits: [
      "Corporate Exposure",
      "Career Growth"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=131099231&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "wns-lead-associate-accounts-2026-039",
    title: "Lead Associate - Accounts Receivable Billing",
    company: "WNS",
    category: "Finance",
    jobType: "Full Time",
    location: "Thane",
    experience: "4-6 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "VLOOKUP",
      "Pivot Tables",
      "NetSuite ERP",
      "Data Validation"
    ],
    responsibilities: [
      "Handle billing operations",
      "Manage accounts receivable",
      "Prepare financial validations"
    ],
    requirements: [
      "ERP system experience",
      "Advanced Excel knowledge"
    ],
    certifications: [],
    benefits: [
      "US Shift Opportunity",
      "Corporate Work Environment"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146578487&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "icon-accounts-receivable-associate-2026-040",
    title: "Accounts Receivable Associate",
    company: "ICON plc",
    category: "Accounting",
    jobType: "Full Time",
    location: "Chennai",
    experience: "2-4 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Oracle Financials",
      "Excel",
      "Data Entry"
    ],
    responsibilities: [
      "Maintain receivable records",
      "Handle invoicing tasks",
      "Support accounting operations"
    ],
    requirements: [
      "Oracle Financials knowledge",
      "Good Excel skills"
    ],
    certifications: [],
    benefits: [
      "Professional Growth",
      "Corporate Environment"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=147020985&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "rrayze-account-receivable-executive-2026-041",
    title: "Account Receivable Executive",
    company: "Rrayze Business Solutions",
    category: "Accounting",
    jobType: "Full Time",
    location: "Gurugram",
    experience: "2-4 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Tally",
      "MS Excel",
      "Accounting Software"
    ],
    responsibilities: [
      "Handle receivable operations",
      "Maintain accounting records",
      "Support finance team"
    ],
    requirements: [
      "Knowledge of Tally",
      "Accounting experience"
    ],
    certifications: [],
    benefits: [
      "Career Stability",
      "Growth Opportunity"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146995377&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "nexdigm-fixed-asset-associate-2026-042",
    title: "Sr. Associate - Fixed Asset and Invoice Processing",
    company: "Nexdigm",
    category: "Finance",
    jobType: "Full Time",
    location: "Hyderabad",
    experience: "3-5 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Fixed Asset Management",
      "Invoice Processing",
      "Reporting"
    ],
    responsibilities: [
      "Manage fixed assets",
      "Process invoices",
      "Generate reports"
    ],
    requirements: [
      "Finance process knowledge",
      "Reporting skills"
    ],
    certifications: [],
    benefits: [
      "Corporate Exposure",
      "Professional Growth"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146829753&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "valeo-site-accounting-support-2026-043",
    title: "Site Accounting Support",
    company: "Valeo",
    category: "Accounting",
    jobType: "Full Time",
    location: "Pune",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Account Payables",
      "Account Receivables",
      "General Ledger",
      "Invoicing"
    ],
    responsibilities: [
      "Support accounting operations",
      "Handle invoicing",
      "Maintain ledgers"
    ],
    requirements: [
      "Basic accounting knowledge",
      "Attention to detail"
    ],
    certifications: [],
    benefits: [
      "Freshers Opportunity",
      "Corporate Learning"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146871613&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "studio-monique-junior-accountant-2026-044",
    title: "Junior Accountant",
    company: "Studio Monique Designs",
    category: "Accounting",
    jobType: "Full Time",
    location: "Pune",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Accounts Receivable",
      "Accounts Payable",
      "Payroll Processing",
      "Data Entry"
    ],
    responsibilities: [
      "Maintain financial records",
      "Process payroll",
      "Handle invoices and receipts"
    ],
    requirements: [
      "Basic accounting skills",
      "MS Excel knowledge"
    ],
    certifications: [],
    benefits: [
      "Freshers Friendly",
      "Learning Opportunity"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146829851&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "globelancer-advanced-excel-executive-2026-045",
    title: "Advanced Excel Executive",
    company: "GlobeLancer",
    category: "Finance",
    jobType: "Full Time",
    location: "Delhi",
    experience: "Freshers",
    qualification: "B.Com",
    salary: "Not Disclosed",
    skills: [
      "Advanced Excel",
      "QuickBooks",
      "Bank Reconciliation",
      "Tally ERP 9"
    ],
    responsibilities: [
      "Handle payroll processing",
      "Maintain accounting records",
      "Perform reconciliation tasks"
    ],
    requirements: [
      "B.Com only",
      "Excel expertise"
    ],
    certifications: [],
    benefits: [
      "Freshers Opportunity",
      "Accounting Exposure"
    ],
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146835797&spl=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25&utm_source=Adsolave&utm_medium=affiliate&utm_campaign=IN_paid_display_direct_acq_affiliate_Adsolave_VM2311LN1_Aug25",
    postedDate: "2026-05-11"
  },

  {
    id: "cyber-hospitality-sales-executive-2026-046",
    title: "Sales Executive",
    company: "Cyber Hospitality Private Limited",
    category: "Sales",
    jobType: "Full Time",
    location: "Vadodara",
    experience: "6 Months - 1 Year",
    qualification: "Bachelor’s Degree",
    salary: "₹15,000 – ₹25,000/month",
    skills: [
      "Sales",
      "English Communication",
      "MS Excel",
      "Negotiation"
    ],
    responsibilities: [
      "Communicate with US clients",
      "Close sales deals",
      "Maintain client records"
    ],
    requirements: [
      "Night shift availability",
      "Sales experience"
    ],
    certifications: [],
    benefits: [
      "International Sales Exposure",
      "Career Growth"
    ],
    applyLink: "mailto:hr@cyberhospitalities.com",
    postedDate: "2026-05-11"
  },

  {
    id: "rupeedot-walkin-drive-2026-047",
    title: "Business Development Intern / Telecaller / Sales Intern",
    company: "RupeeDot",
    category: "Sales & Finance",
    jobType: "Internship / Full Time",
    location: "Pune",
    experience: "Freshers / Experienced",
    qualification: "Any Graduate",
    salary: "₹8,000 – ₹15,000/month + Incentives",
    skills: [
      "Communication",
      "Sales",
      "Business Development"
    ],
    responsibilities: [
      "Handle sales activities",
      "Support business development",
      "Assist customer interactions"
    ],
    requirements: [
      "Immediate joiners preferred",
      "Updated resume required"
    ],
    certifications: [],
    benefits: [
      "Startup Exposure",
      "Performance Incentives"
    ],
    applyLink: "tel:+917977471289",
    postedDate: "2026-05-11"
  },


  {
    id: "mercor-mlops-engineer-remote-2026-ks904",
    title: "MLOps Engineer (JAX, PyTorch, Pallas/Triton)",
    company: "Mercor",
    category: "IT",
    jobType: "Contract",
    location: "Remote, India",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "$35 - $45 per hour",
    skills: [
      "JAX",
      "PyTorch",
      "Triton",
      "Pallas",
      "MLOps",
      "Distributed Systems"
    ],
    responsibilities: [
      "Build ML infrastructure",
      "Optimize AI training pipelines",
      "Evaluate ML systems"
    ],
    requirements: [
      "Production experience with JAX or PyTorch",
      "Experience with GPU kernels"
    ],
    certifications: [],
    benefits: [
      "Remote work",
      "AI lab exposure"
    ],
    applyLink: "https://t.mercor.com/iRvZF",
    postedDate: "2026-05-10",
    duration: "Contract"
  },

  {
    id: "sap-cpi-support-engineer-hyd-2026-ks905",
    title: "SAP Integration Suite Support Engineer",
    company: "SAP",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "3 - 5 Years",
    qualification: "BE / BTech in Computer Science",
    salary: "₹10 - ₹21 LPA",
    skills: [
      "SAP CPI",
      "Groovy",
      "REST",
      "SOAP",
      "OData",
      "Apache Camel"
    ],
    responsibilities: [
      "Handle SAP integration tickets",
      "Troubleshoot CPI flows",
      "Maintain API integrations"
    ],
    requirements: [
      "Hands-on SAP CPI experience",
      "Knowledge of integration protocols"
    ],
    certifications: [],
    benefits: [
      "Hybrid work",
      "Global customer exposure"
    ],
    applyLink: "https://optimhire.com/developers/jv/309770?ref_code=mukesh-agrawal",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "amplelogic-dotnet-developer-hyd-2026-ks906",
    title: ".NET Developer",
    company: "AmpleLogic",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "1 - 2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      ".NET",
      "ASP.NET",
      "Angular",
      "C#",
      "SQL Server",
      "REST APIs"
    ],
    responsibilities: [
      "Develop web applications",
      "Build backend services",
      "Optimize applications"
    ],
    requirements: [
      "Experience with .NET and Angular",
      "Knowledge of SQL Server"
    ],
    certifications: [],
    benefits: [
      "Career growth",
      "Cloud exposure"
    ],
    applyLink: "mailto:preethi.g@amplelogic.com",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "codemind-automation-test-engineer-che-2026-ks907",
    title: "Automation Test Engineer",
    company: "Codemind Staffing Solutions",
    category: "IT",
    jobType: "Full Time",
    location: "Chennai, India",
    experience: "3 - 5 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹4 - ₹7 LPA",
    skills: [
      "Selenium",
      "Java",
      "Rest Assured",
      "Postman",
      "TestNG",
      "Cucumber"
    ],
    responsibilities: [
      "Develop automation frameworks",
      "Execute test cases",
      "Report defects"
    ],
    requirements: [
      "Experience in Selenium and API testing"
    ],
    certifications: [],
    benefits: [
      "QA automation exposure",
      "Agile environment"
    ],
    applyLink: "https://unstop.com/o/pqBMyUE?lb=Bnie7Jo",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "senior-software-developer-bangalore-2026-ks908",
    title: "Sr. Software Developer",
    company: "Write Your Destiny",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "5 - 7 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Core Java",
      "Spring Boot",
      "AWS",
      "Microservices",
      "REST APIs"
    ],
    responsibilities: [
      "Develop scalable applications",
      "Build backend services",
      "Maintain cloud systems"
    ],
    requirements: [
      "Strong Java and AWS experience"
    ],
    certifications: [],
    benefits: [
      "Backend engineering exposure"
    ],
    applyLink: "mailto:bharati@writeyourdestiny.in",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "divum-business-analyst-blr-2026-ks909",
    title: "Business Analyst",
    company: "Divum Corporate Services",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "2 - 5 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹5L - ₹15L /year",
    skills: [
      "Business Analysis",
      "Product Management",
      "Requirement Gathering",
      "SDLC"
    ],
    responsibilities: [
      "Gather business requirements",
      "Collaborate with product teams",
      "Support project planning"
    ],
    requirements: [
      "Strong analytical skills",
      "Experience in SDLC"
    ],
    certifications: [],
    benefits: [
      "Onsite opportunity",
      "Cross-functional exposure"
    ],
    applyLink: "https://abekus.ai/public-job-search/business-analyst-2?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "vqcodes-mern-developer-mohali-2026-ks910",
    title: "MERN Stack Developer",
    company: "VQCodes Software Solutions",
    category: "IT",
    jobType: "Full Time",
    location: "Mohali, India",
    experience: "1 - 4 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "MongoDB",
      "Express.js",
      "React.js",
      "Node.js",
      "REST APIs"
    ],
    responsibilities: [
      "Develop MERN applications",
      "Build APIs",
      "Maintain scalable systems"
    ],
    requirements: [
      "Experience in MERN stack"
    ],
    certifications: [],
    benefits: [
      "Walk-in interview",
      "Tech growth opportunity"
    ],
    applyLink: "mailto:hr@vqcodes.com",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "sceniuz-data-scientist-onsite-2026-ks911",
    title: "Data Scientist",
    company: "Sceniuz IT Pvt. Ltd.",
    category: "IT",
    jobType: "Internship",
    location: "India",
    experience: "Freshers",
    qualification: "Any Degree",
    salary: "₹3.5 - ₹4 LPA",
    skills: [
      "SQL",
      "Python",
      "Machine Learning"
    ],
    responsibilities: [
      "Work on ML models",
      "Analyze datasets",
      "Support AI projects"
    ],
    requirements: [
      "2025 / 2026 graduates"
    ],
    certifications: [],
    benefits: [
      "Internship stipend",
      "Data science exposure"
    ],
    applyLink: "https://placement.acciojob.com/job-drive-details/?utm_source=referral&utm_medium=share&jobDriveId=760b42c0-8f6e-49de-94c7-60d52b7ef77f&utm_content=760b42c0-8f6e-49de-94c7-60d52b7ef77f&utm_campaign=copy_link&referralId=bf41b401-93f9-45be-b563-5b6bcbd123a7",
    postedDate: "2026-05-10",
    duration: "Internship"
  },

  {
    id: "imminent-web-designer-mohali-2026-ks912",
    title: "Web Designer",
    company: "Imminent Software's",
    category: "IT",
    jobType: "Full Time",
    location: "Mohali, India",
    experience: "1 - 2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Figma",
      "WordPress",
      "Shopify"
    ],
    responsibilities: [
      "Design responsive websites",
      "Create UI layouts",
      "Optimize website performance"
    ],
    requirements: [
      "Knowledge of UI/UX principles",
      "Experience with WordPress and Shopify"
    ],
    certifications: [],
    benefits: [
      "Creative work environment"
    ],
    applyLink: "mailto:palak.imminent@gmail.com",
    postedDate: "2026-05-10",
    duration: "Full Time"
  },

  {
    id: "dsc-delhi-non-teaching-2026-001",
    title: "Non-Teaching Staff",
    company: "DSC College Delhi",
    category: "Government",
    jobType: "Full Time",
    location: "Delhi",
    experience: "Freshers / Experienced",
    qualification: "10+2 / Graduate / Master's",
    salary: "Pay Level 1 to Level 6 (7th CPC)",
    skills: [
      "Administration",
      "Office Management",
      "Communication"
    ],
    responsibilities: [
      "Handle non-teaching duties",
      "Support college administration",
      "Maintain office records"
    ],
    requirements: [
      "Relevant qualification as per post",
      "Basic computer knowledge"
    ],
    certifications: [],
    benefits: [
      "Government Job",
      "7th CPC Benefits"
    ],
    applyLink: "https://govtjobsalert.in/dsc-college-delhi-non-teaching-recruitment-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-06-10"
  },

  {
    id: "cgpsc-assistant-engineer-2026-002",
    title: "Assistant Engineer",
    company: "CGPSC",
    category: "Engineering",
    jobType: "Full Time",
    location: "Chhattisgarh",
    experience: "Freshers Eligible",
    qualification: "B.E. / B.Tech",
    salary: "₹56,100 – ₹1,77,500",
    skills: [
      "Civil Engineering",
      "Project Management",
      "Technical Analysis"
    ],
    responsibilities: [
      "Manage engineering projects",
      "Prepare technical reports",
      "Monitor construction activities"
    ],
    requirements: [
      "Engineering degree",
      "Valid technical knowledge"
    ],
    certifications: [],
    benefits: [
      "Government Pay Scale",
      "Career Growth"
    ],
    applyLink: "https://govtjobsalert.in/cgpsc-state-engineering-service-recruitment-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-06-11"
  },

  {
    id: "ntpc-assistant-officer-env-2026-003",
    title: "Assistant Officer (Environment Management)",
    company: "NTPC",
    category: "Environment",
    jobType: "Full Time",
    location: "India",
    experience: "Experienced Preferred",
    qualification: "B.E./B.Tech OR Graduate + PG in Environment",
    salary: "₹30,000 – ₹1,20,000 (IDA)",
    skills: [
      "Environmental Management",
      "Sustainability",
      "Compliance"
    ],
    responsibilities: [
      "Monitor environmental standards",
      "Prepare compliance reports",
      "Implement sustainability practices"
    ],
    requirements: [
      "Relevant environmental qualification",
      "Knowledge of environmental laws"
    ],
    certifications: [],
    benefits: [
      "IDA Pay Scale",
      "PSU Benefits"
    ],
    applyLink: "https://govtjobsalert.in/ntpc-assistant-officer-recruitment-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-05-22"
  },

  {
    id: "upsc-special-drive-2026-004",
    title: "UPSC Special Recruitment Drive 04/2026",
    company: "UPSC",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Varies by Post",
    qualification: "Graduate / Engineer / Master's",
    salary: "₹44,900 – ₹2,17,100",
    skills: [
      "Administration",
      "Technical Expertise",
      "Public Service"
    ],
    responsibilities: [
      "Perform government duties",
      "Handle departmental operations",
      "Prepare official reports"
    ],
    requirements: [
      "Relevant educational qualification",
      "UPSC eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "Central Government Job",
      "High Salary Structure"
    ],
    applyLink: "https://govtjobsalert.in/upsc-special-recruitment-drive-04-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-05-29"
  },

  {
    id: "uksssc-livestock-officer-2026-005",
    title: "Livestock Extension Officer",
    company: "UKSSSC",
    category: "Agriculture",
    jobType: "Full Time",
    location: "Uttarakhand",
    experience: "Freshers Eligible",
    qualification: "Graduation (Biology / Agriculture / Animal Husbandry / Others)",
    salary: "₹35,400 – ₹1,12,400",
    skills: [
      "Animal Husbandry",
      "Livestock Management",
      "Field Work"
    ],
    responsibilities: [
      "Assist livestock programs",
      "Conduct field inspections",
      "Support rural development"
    ],
    requirements: [
      "Graduation in relevant field",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Government Benefits",
      "Stable Career"
    ],
    applyLink: "https://govtjobsalert.in/uksssc-livestock-extension-officer-recruitment-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-06-02"
  },

  {
    id: "eil-special-drive-2026-006",
    title: "Special Recruitment Drive",
    company: "EIL",
    category: "Engineering",
    jobType: "Full Time",
    location: "India",
    experience: "Experienced / Freshers",
    qualification: "BE / B.Tech / Diploma / MBA HR / BBA / Hotel Mgmt Graduate",
    salary: "₹25,000 – ₹2,40,000 (IDA)",
    skills: [
      "Engineering",
      "Management",
      "Operations"
    ],
    responsibilities: [
      "Handle project operations",
      "Support engineering teams",
      "Manage assigned tasks"
    ],
    requirements: [
      "Relevant qualification",
      "Category eligibility (SC/ST/OBC)"
    ],
    certifications: [],
    benefits: [
      "CTC up to ₹30.29 LPA",
      "PSU Benefits"
    ],
    applyLink: "https://govtjobsalert.in/eil-special-recruitment-drive-2026/",
    postedDate: "2026-05-10",
    lastDate: "2026-05-25"
  },

  {
    id: "govt-12th-pass-jobs-2026-007",
    title: "Latest 12th Pass Govt Jobs",
    company: "Multiple Departments",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers Eligible",
    qualification: "12th Pass / Intermediate",
    salary: "₹18,000 – ₹1,42,400",
    skills: [
      "Basic Computer Knowledge",
      "Communication",
      "General Aptitude"
    ],
    responsibilities: [
      "Department-specific duties",
      "Office support",
      "Field operations"
    ],
    requirements: [
      "12th Pass qualification",
      "Department eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "Multiple Opportunities",
      "Government Salary"
    ],
    applyLink: "https://govtjobsalert.in/12th-pass-govt-jobs/",
    postedDate: "2026-05-10",
    vacancies: "6100+"
  },

  {
    id: "golang-dev-noida-2026-008",
    title: "Golang Developer",
    company: "NCS",
    category: "IT",
    jobType: "Full Time",
    location: "Noida / Hybrid / Remote",
    experience: "6+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹1.1 LPM",
    skills: [
      "Golang",
      "REST APIs",
      "gRPC",
      "Docker",
      "Kubernetes",
      "PostgreSQL",
      "Microservices"
    ],
    responsibilities: [
      "Develop Golang applications",
      "Build scalable microservices",
      "Maintain CI/CD pipelines"
    ],
    requirements: [
      "Strong Go expertise",
      "Optical networking knowledge"
    ],
    certifications: [],
    benefits: [
      "Long-term project",
      "Remote flexibility"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-10",
    duration: "2 Years"
  },

  {
    id: "american-express-data-analytics-2026-009",
    title: "Analyst - Data Analytics",
    company: "American Express",
    category: "Data Analytics",
    jobType: "Full Time",
    location: "Gurugram, India (Hybrid)",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s Degree / Master’s Degree / MBA",
    salary: "Not Disclosed",
    skills: [
      "Data Analytics",
      "SQL",
      "Excel",
      "Business Analysis",
      "Reporting"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports and insights",
      "Support data-driven decisions"
    ],
    requirements: [
      "Strong analytical skills",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Hybrid Work",
      "Career Growth"
    ],
    applyLink: "https://careers.americanexpress.com/en/sites/CX_1/jobs/preview/26007022/?location=India&keyword=Analyst-Data+Analytics&intlink=us-amex-career-en-us-search",
    postedDate: "2026-05-10"
  },

  {
    id: "nike-software-engineer-2026-010",
    title: "Software Engineer I",
    company: "Nike",
    category: "Software Development",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "Freshers",
    qualification: "2023 / 2024 / 2025 Graduates",
    salary: "Not Disclosed",
    skills: [
      "Software Development",
      "Programming",
      "Problem Solving",
      "Debugging",
      "Team Collaboration"
    ],
    responsibilities: [
      "Develop software applications",
      "Write clean and efficient code",
      "Collaborate with engineering teams"
    ],
    requirements: [
      "Strong coding skills",
      "Computer Science fundamentals"
    ],
    certifications: [],
    benefits: [
      "Work with global teams",
      "Career Development"
    ],
    applyLink: "https://careers.nike.com/software-engineer-i-itc/job/R-83689",
    postedDate: "2026-05-10"
  },

  {
    id: "nttdata-associate-data-engineer-2026-011",
    title: "Associate Graduate Data Engineer",
    company: "NTT DATA",
    category: "Data Engineering",
    jobType: "Full Time",
    location: "Bangalore, India (Hybrid)",
    experience: "Freshers",
    qualification: "Bachelor’s Degree in Relevant Field",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Reporting",
      "Communication",
      "Problem Solving"
    ],
    responsibilities: [
      "Analyze data sets",
      "Prepare reports",
      "Support data engineering operations"
    ],
    requirements: [
      "Relevant bachelor’s degree",
      "Strong analytical skills"
    ],
    certifications: [],
    benefits: [
      "Hybrid Work",
      "Career Growth"
    ],
    applyLink: "https://careers.services.global.ntt/global/en/job/NTT1GLOBALR144540EXTERNALENGLOBAL/Associate-Graduate-Data-Engineer",
    postedDate: "2026-05-10"
  },

  {
    id: "ups-associate-quality-engineer-2026-012",
    title: "Associate Software Quality Engineer",
    company: "UPS",
    category: "Quality Assurance",
    jobType: "Full Time",
    location: "Chennai, India",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "QA Processes",
      "Software Testing",
      "Problem Solving",
      "Collaboration"
    ],
    responsibilities: [
      "Perform software testing",
      "Maintain QA standards",
      "Collaborate with development teams"
    ],
    requirements: [
      "Knowledge of testing concepts",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Permanent Role",
      "Professional Growth"
    ],
    applyLink: "https://www.jobs-ups.com/imea/en/job/UPBUPSGLOBALR25030096EXTERNALENIMEA/Associate-Software-Quality-Engineer",
    postedDate: "2026-05-10"
  },

  {
    id: "vrdella-onboarding-specialist-2026-013",
    title: "Onboarding Specialist",
    company: "VRDella",
    category: "Operations",
    jobType: "Full Time",
    location: "Trichy, India (Onsite)",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: [
      "Basic Computer Knowledge",
      "Communication Skills",
      "Coordination",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist onboarding process",
      "Coordinate with candidates",
      "Maintain onboarding records"
    ],
    requirements: [
      "Freshers only",
      "Willingness to work night shift"
    ],
    certifications: [],
    benefits: [
      "Entry Level Opportunity",
      "Onsite Work Environment"
    ],
    applyLink: "mailto:jestin@vrdella.com",
    postedDate: "2026-05-10"
  },


  {
    id: "golang-dev-noida-ncs-56291",
    title: "Golang Developer",
    company: "NCS",
    category: "IT",
    jobType: "Full Time",
    location: "Noida / Hybrid / Remote",
    experience: "6+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹1.1 LPM",
    skills: [
      "Golang",
      "REST APIs",
      "gRPC",
      "Docker",
      "Kubernetes",
      "PostgreSQL",
      "Microservices"
    ],
    responsibilities: [
      "Develop Golang applications",
      "Build scalable microservices",
      "Maintain CI/CD pipelines"
    ],
    requirements: [
      "Strong Go expertise",
      "Optical networking knowledge"
    ],
    certifications: [],
    benefits: [
      "Long-term project",
      "Remote flexibility"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-05-09",
    duration: "2 Years"
  },

  {
    id: "cloud-engineer-devops-azure-whizzdreambig-48172",
    title: "Cloud Engineer (DevOps & Azure)",
    company: "Whizzdreambig",
    category: "IT",
    jobType: "Full Time",
    location: "Noida, India",
    experience: "3 - 5 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹3 LPA - ₹7 LPA",
    skills: [
      "Azure",
      "DevOps",
      "Terraform",
      "CI/CD",
      "Linux",
      "Python"
    ],
    responsibilities: [
      "Manage Azure infrastructure",
      "Build CI/CD pipelines",
      "Automate deployments"
    ],
    requirements: [
      "Azure cloud experience",
      "DevOps expertise"
    ],
    certifications: [
      "AZ-104",
      "AZ-400"
    ],
    benefits: [
      "Enterprise projects",
      "Growth opportunities"
    ],
    applyLink: "https://unstop.com/o/RNMzQ2m?lb=Bnie7Jo",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "developer-srdeveloper-qpodtech-73485",
    title: "Developer / Sr. Developer",
    company: "Qpodtech",
    category: "IT",
    jobType: "Full Time",
    location: "Mumbai, India",
    experience: "4 - 8 Years",
    qualification: "Bachelor’s Degree",
    salary: "20% - 30% Hike",
    skills: [
      "Software Development",
      "Coding",
      "Debugging",
      "Performance Optimization"
    ],
    responsibilities: [
      "Develop end-to-end applications",
      "Debug software issues",
      "Improve application performance"
    ],
    requirements: [
      "4+ years software development experience"
    ],
    certifications: [],
    benefits: [
      "Salary hike",
      "Immediate joining"
    ],
    applyLink: "mailto:Molinasharma@qpodtech.com",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "desktop-support-engineer-bridgeloyalty-21947",
    title: "Desktop Support Engineer",
    company: "BridgeLoyalty Customer Experience Management LLP",
    category: "IT",
    jobType: "Full Time",
    location: "Mumbai, India",
    experience: "1 - 2 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹2 LPA - ₹3 LPA",
    skills: [
      "Technical Support",
      "Computer Hardware",
      "Windows Applications",
      "Troubleshooting"
    ],
    responsibilities: [
      "Provide desktop support",
      "Resolve hardware issues",
      "Maintain Windows applications"
    ],
    requirements: [
      "Technical troubleshooting skills"
    ],
    certifications: [],
    benefits: [
      "Onsite opportunity",
      "Hands-on IT support experience"
    ],
    applyLink: "https://abekus.ai/public-job-search/desktop-support-engineer-2?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "lead-backend-engineer-java-remote-60834",
    title: "Lead Backend Engineer",
    company: "Progress Innotech",
    category: "IT",
    jobType: "Remote",
    location: "Remote",
    experience: "8 - 12+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Spring Boot",
      "AWS",
      "Microservices",
      "REST APIs"
    ],
    responsibilities: [
      "Lead backend architecture",
      "Develop scalable systems",
      "Mentor engineering teams"
    ],
    requirements: [
      "Microservices expertise",
      "AWS experience"
    ],
    certifications: [],
    benefits: [
      "Remote work",
      "Leadership opportunity"
    ],
    applyLink: "mailto:juhi@progressinnotech.com",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "medhaai-data-engineer-bangalore-39418",
    title: "Data Engineer",
    company: "Medha AI",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "2025 / 2026 Graduates",
    qualification: "Any Degree",
    salary: "₹6 LPA - ₹7 LPA",
    skills: [
      "SQL",
      "Python",
      "Pandas",
      "Data Engineering"
    ],
    responsibilities: [
      "Build data pipelines",
      "Analyze healthcare data",
      "Support data engineering tasks"
    ],
    requirements: [
      "Knowledge of SQL and Python"
    ],
    certifications: [],
    benefits: [
      "Healthcare industry exposure",
      "Career growth"
    ],
    applyLink: "https://placement.acciojob.com/job-drive-details/?utm_source=referral&utm_medium=share&jobDriveId=366e1db8-5185-4e8b-ad4a-74a0128480cf&utm_content=366e1db8-5185-4e8b-ad4a-74a0128480cf&utm_campaign=copy_link&referralId=bf41b401-93f9-45be-b563-5b6bcbd123a7",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "dotnet-developer-goa-91hr-84263",
    title: ".NET Developer",
    company: "91HR",
    category: "IT",
    jobType: "Full Time",
    location: "Panaji, Goa",
    experience: "3+ Years",
    qualification: "B.E / B.Tech / CS",
    salary: "₹3 LPA - ₹7.2 LPA",
    skills: [
      "ASP.NET",
      "C#",
      "SQL",
      "jQuery",
      "Ajax"
    ],
    responsibilities: [
      "Develop .NET applications",
      "Maintain web systems",
      "Troubleshoot software issues"
    ],
    requirements: [
      "3+ years .NET experience"
    ],
    certifications: [],
    benefits: [
      "Career growth",
      "Tech-driven company"
    ],
    applyLink: "mailto:riana@91hr.in",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "senior-java-backend-infor-51726",
    title: "Senior Java Backend Developer",
    company: "Infor",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "7 - 10 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Spring Boot",
      "Microservices",
      "AWS",
      "Docker",
      "Kubernetes"
    ],
    responsibilities: [
      "Develop backend systems",
      "Lead microservice architecture",
      "Mentor junior developers"
    ],
    requirements: [
      "Java 17/21 expertise",
      "Cloud-native development"
    ],
    certifications: [],
    benefits: [
      "Enterprise SaaS exposure",
      "Leadership opportunities"
    ],
    applyLink: "https://careers.infor.com/en_US/careers/JobDetail/Senior-Java-Backend-Developer/19607",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "associate-info-security-analyst-paralok-37591",
    title: "Associate Information Security Analyst",
    company: "Paralok",
    category: "IT",
    jobType: "Full Time",
    location: "Remote",
    experience: "6 Months / Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Cyber Security",
      "Information Security",
      "Security Analysis"
    ],
    responsibilities: [
      "Monitor security systems",
      "Assist in security analysis",
      "Support cybersecurity operations"
    ],
    requirements: [
      "Cybersecurity knowledge"
    ],
    certifications: [],
    benefits: [
      "Remote work",
      "Freshers welcome"
    ],
    applyLink: "mailto:anupama@paralok.com",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "micron-systems-software-engineer-65028",
    title: "Sr. Systems Software Engineer",
    company: "Micron Technology",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "C",
      "C++",
      "Python",
      "Embedded Linux",
      "Linux"
    ],
    responsibilities: [
      "Develop embedded software",
      "Debug hardware systems",
      "Work on semiconductor equipment"
    ],
    requirements: [
      "Embedded software experience",
      "Linux expertise"
    ],
    certifications: [],
    benefits: [
      "Semiconductor industry exposure",
      "Hands-on hardware projects"
    ],
    applyLink: "https://micron.eightfold.ai/careers?start=60&location=India&pid=30464709&sort_by=distance&filter_include_remote=1",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },
  {
    id: "citi-sr-data-scientist-genai-avp-2026",
    title: "Sr. Data Scientist – Gen AI Engineer - Assistant Vice President",
    company: "Citi",
    category: "IT",
    jobType: "Full Time",
    location: "Pune, India",
    experience: "8 - 12 Years",
    qualification: "Bachelor’s / Master’s Degree / PhD",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Generative AI",
      "LLM",
      "LangChain",
      "TensorFlow",
      "PyTorch",
      "RAG",
      "Machine Learning"
    ],
    responsibilities: [
      "Develop and deploy GenAI solutions",
      "Build scalable AI applications",
      "Work on prompt engineering and LLM fine-tuning",
      "Lead AI projects and mentor teams"
    ],
    requirements: [
      "Strong GenAI project experience",
      "Expert Python skills",
      "Experience with LLMs and APIs"
    ],
    certifications: [],
    benefits: [
      "Global banking exposure",
      "Career growth opportunities"
    ],
    applyLink: "https://jobs.citi.com/job/pune/sr-data-scientist-gen-ai-engineer-assistant-vice-president/287/94729519968",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "genx-intern-software-developer-2026",
    title: "Intern Software Developer",
    company: "GenX Company",
    category: "IT",
    jobType: "Internship",
    location: "Delhi NCR, India",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "Performance Based",
    skills: [
      "Programming",
      "Problem Solving",
      "Software Development"
    ],
    responsibilities: [
      "Work on live projects",
      "Assist development teams",
      "Learn software development practices"
    ],
    requirements: [
      "Passion for coding",
      "Good analytical skills"
    ],
    certifications: [],
    benefits: [
      "Hands-on experience",
      "Full-time opportunity after internship"
    ],
    applyLink: "mailto:khushboo@gen-xt.com",
    postedDate: "2026-05-09",
    duration: "6 Months Internship"
  },

  {
    id: "rockwell-graduate-engineer-trainee-2026",
    title: "Graduate Engineer Trainee",
    company: "Rockwell Automation",
    category: "IT",
    jobType: "Full Time",
    location: "Pune, India",
    experience: "0 - 1 Year",
    qualification: "Computer Science / IT Degree",
    salary: "Not Disclosed",
    skills: [
      "C#",
      "SQL",
      "ASP.NET",
      "Node.js",
      "HTML",
      "CSS",
      "JavaScript",
      "Git"
    ],
    responsibilities: [
      "Develop software applications",
      "Perform testing and debugging",
      "Work in Agile teams"
    ],
    requirements: [
      "2025 / 2026 graduates",
      "CGPA 7+"
    ],
    certifications: [],
    benefits: [
      "Hybrid work",
      "Industrial automation exposure"
    ],
    applyLink: "https://rockwellautomation.wd1.myworkdayjobs.com/en-GB/External_Rockwell_Automation/job/Pune-India/Graduate-Engineer-Trainee_R26-2361?source=LinkedIn",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "onsite-development-interns-2026",
    title: "Development Intern",
    company: "Confidential Company",
    category: "IT",
    jobType: "Internship",
    location: "Faridabad, Haryana",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "₹5,000 - ₹7,000/month",
    skills: [
      "React.js",
      "Python",
      "Node.js"
    ],
    responsibilities: [
      "Work on development projects",
      "Collaborate with developers",
      "Improve coding skills"
    ],
    requirements: [
      "Basic technical knowledge",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Mentorship",
      "Hands-on project experience"
    ],
    applyLink: "tel:8796391200",
    postedDate: "2026-05-09",
    duration: "Internship"
  },

  {
    id: "syniverse-graduate-apprentice-trainee-2026",
    title: "Graduate Apprentice Trainee",
    company: "Syniverse",
    category: "IT",
    jobType: "Apprenticeship",
    location: "Bangalore, India",
    experience: "Freshers",
    qualification: "Full Time Graduate",
    salary: "Not Disclosed",
    skills: [
      "Communication",
      "Microsoft Office",
      "Technology Fundamentals"
    ],
    responsibilities: [
      "Work across functional teams",
      "Attend training sessions",
      "Support business projects"
    ],
    requirements: [
      "No backlogs",
      "First class academics"
    ],
    certifications: [],
    benefits: [
      "Professional coaching",
      "Technology industry exposure"
    ],
    applyLink: "https://syniverse.wd1.myworkdayjobs.com/SyniverseCareers/job/India-Bangalore/Graduate-Apprentice-Trainee_R0007343?source=LinkedIn",
    postedDate: "2026-05-09",
    duration: "12 Months"
  },

  {
    id: "product-company-software-engineer-fresher-2026",
    title: "Software Engineer (Developer) - Fresher",
    company: "Product Based IT Company",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "Freshers",
    qualification: "Graduate / Post Graduate",
    salary: "3.6 LPA",
    skills: [
      "Java",
      "Python",
      ".NET",
      "Testing"
    ],
    responsibilities: [
      "Develop applications",
      "Perform testing",
      "Work with development teams"
    ],
    requirements: [
      "Trained freshers"
    ],
    certifications: [],
    benefits: [
      "Product company exposure"
    ],
    applyLink: "mailto:prem@jpgroupservices.com",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "sap-linux-sm-pacemaker-specialist-2026",
    title: "IT Technology Services Senior Specialist - Linux SM, Pacemaker",
    company: "SAP",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "8 - 10 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Linux",
      "Pacemaker",
      "AWS",
      "Azure",
      "GCP",
      "Python",
      "Ansible",
      "Networking"
    ],
    responsibilities: [
      "Manage Linux infrastructure",
      "Implement HA clustering",
      "Automate server operations",
      "Handle escalations and RCA"
    ],
    requirements: [
      "Linux administration expertise",
      "Cloud platform experience"
    ],
    certifications: [],
    benefits: [
      "Enterprise cloud exposure",
      "Global SAP environment"
    ],
    applyLink: "https://jobs.sap.com/job/Bangalore-IT-Technology-Services-Senior-Specialist-Linux-SM%2C-Pacemaker-560066/1292246401/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "wordpress-developer-indore-2026",
    title: "WordPress Developer",
    company: "Namastetu Technologies",
    category: "IT",
    jobType: "Full Time",
    location: "Indore, India",
    experience: "2 - 4 Years",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: [
      "WordPress",
      "PHP",
      "Web Development"
    ],
    responsibilities: [
      "Develop WordPress websites",
      "Maintain web applications",
      "Work on responsive design"
    ],
    requirements: [
      "Portfolio required"
    ],
    certifications: [],
    benefits: [
      "Creative work environment"
    ],
    applyLink: "mailto:hr@namastetu.com",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  

  {
    id: "drdo-tbrl-paid-internship-2026",
    title: "Paid Internship 2026",
    company: "DRDO TBRL Chandigarh",
    category: "Government",
    jobType: "Internship",
    location: "Chandigarh, India",
    experience: "Freshers",
    qualification: "B.E. / B.Tech Final Year or M.Sc 2nd Year",
    salary: "₹30,000 Total Stipend",
    skills: [
      "Research",
      "Engineering Fundamentals",
      "Technical Analysis"
    ],
    responsibilities: [
      "Assist DRDO research projects",
      "Support technical teams",
      "Work on defense technologies"
    ],
    requirements: [
      "Final year B.E./B.Tech or M.Sc 2nd year"
    ],
    certifications: [],
    benefits: [
      "Government internship exposure",
      "Research experience"
    ],
    applyLink: "https://govtjobsalert.in/drdo-tbrl-chandigarh-paid-internship-2026/",
    postedDate: "2026-05-09",
    duration: "Internship"
  },

  {
    id: "jssc-jtglcce-recruitment-2026",
    title: "JTGLCCE Recruitment 2026",
    company: "JSSC",
    category: "Government",
    jobType: "Full Time",
    location: "Jharkhand, India",
    experience: "Freshers / Experienced",
    qualification: "Graduation / Postgraduation",
    salary: "₹29,200 – ₹1,42,400/month",
    skills: [
      "Administration",
      "General Knowledge",
      "Government Procedures"
    ],
    responsibilities: [
      "Handle administrative duties",
      "Work in government departments",
      "Support public services"
    ],
    requirements: [
      "Graduate or Postgraduate degree"
    ],
    certifications: [],
    benefits: [
      "Government job security",
      "High salary benefits"
    ],
    applyLink: "https://govtjobsalert.in/jssc-jtglcce-recruitment-2026/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "mcl-assistant-foreman-technician-2026",
    title: "Assistant Foreman & Technician Recruitment",
    company: "MCL",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "ITI or Diploma",
    salary: "₹47,330/month Basic",
    skills: [
      "Technical Operations",
      "Maintenance",
      "Industrial Safety"
    ],
    responsibilities: [
      "Maintain mining equipment",
      "Support operational activities",
      "Ensure technical efficiency"
    ],
    requirements: [
      "ITI or Diploma qualification"
    ],
    certifications: [],
    benefits: [
      "Government PSU benefits",
      "Stable career"
    ],
    applyLink: "https://govtjobsalert.in/mcl-assistant-foreman-technician-recruitment-2026/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "latest-10th-pass-govt-jobs-2026",
    title: "10th Pass Govt Jobs 2026",
    company: "Multiple Government Departments",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass / Matriculation",
    salary: "₹18,000 – ₹1,42,400",
    skills: [
      "Basic Administration",
      "Physical Fitness",
      "Communication"
    ],
    responsibilities: [
      "Department-specific duties",
      "Field and office support",
      "Public service tasks"
    ],
    requirements: [
      "10th Pass"
    ],
    certifications: [],
    benefits: [
      "Government benefits",
      "Job security"
    ],
    applyLink: "https://govtjobsalert.in/10th-pass-govt-jobs/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "crpf-constable-recruitment-2026",
    title: "Constable Recruitment 2026",
    company: "CRPF",
    category: "Government",
    jobType: "Full Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass",
    salary: "₹21,700 – ₹69,100",
    skills: [
      "Physical Fitness",
      "Discipline",
      "Security Operations"
    ],
    responsibilities: [
      "Maintain national security",
      "Support law enforcement operations",
      "Perform field duties"
    ],
    requirements: [
      "10th Pass",
      "Physical eligibility criteria"
    ],
    certifications: [],
    benefits: [
      "Government allowances",
      "Pension and benefits"
    ],
    applyLink: "https://govtjobsalert.in/crpf-constable-recruitment-2026/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "ge-healthcare-trainee-engineer-2026",
    title: "Trainee Engineer",
    company: "GE HealthCare",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Engineering",
      "Problem Solving",
      "Technical Support"
    ],
    responsibilities: [
      "Support engineering projects",
      "Assist technical teams",
      "Work on healthcare technology solutions"
    ],
    requirements: [
      "Bachelor’s Degree"
    ],
    certifications: [],
    benefits: [
      "Healthcare industry exposure",
      "Career growth opportunities"
    ],
    applyLink: "https://careers.gehealthcare.com/global/en/job/R4037608/Trainee-Engineer",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "ey-associate-analyst-2026",
    title: "Associate Analyst",
    company: "EY",
    category: "IT",
    jobType: "Full Time",
    location: "India",
    experience: "0 - 2 Years",
    qualification: "Graduate / Postgraduate",
    salary: "Not Disclosed",
    skills: [
      "Research",
      "Analysis",
      "Communication"
    ],
    responsibilities: [
      "Conduct research and analysis",
      "Support business operations",
      "Prepare reports and documentation"
    ],
    requirements: [
      "Graduate or Postgraduate degree"
    ],
    certifications: [],
    benefits: [
      "Global consulting exposure",
      "Professional career development"
    ],
    applyLink: "https://careers.ey.com/ey/job/Kochi-Associate-Analyst-BRIDGE-Research-Independence-KL-682313/1388386933/",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "rockwell-automation-get-2026-hybrid",
    title: "Graduate Engineer Trainee",
    company: "Rockwell Automation",
    category: "IT",
    jobType: "Full Time",
    location: "Pune, India",
    experience: "0 - 1 Years",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "SQL",
      "C#",
      "ASP.NET",
      "JavaScript",
      "Node.js"
    ],
    responsibilities: [
      "Develop software applications",
      "Perform debugging and testing",
      "Collaborate in Agile teams"
    ],
    requirements: [
      "Bachelor’s or Master’s degree"
    ],
    certifications: [],
    benefits: [
      "Hybrid work model",
      "Industrial automation exposure"
    ],
    applyLink: "https://rockwellautomation.wd1.myworkdayjobs.com/en-US/External_Rockwell_Automation/job/Graduate-Engineer-Trainee_R26-2361",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "ge-aerospace-data-science-intern-2026",
    title: "Data Science Intern",
    company: "GE Aerospace",
    category: "IT",
    jobType: "Internship",
    location: "Bengaluru, India",
    experience: "Freshers",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Machine Learning",
      "Data Analysis",
      "Statistics"
    ],
    responsibilities: [
      "Work on data science projects",
      "Analyze datasets",
      "Support AI and analytics teams"
    ],
    requirements: [
      "Bachelor’s or Master’s degree"
    ],
    certifications: [],
    benefits: [
      "Aerospace industry exposure",
      "Hands-on internship experience"
    ],
    applyLink: "https://careers.geaerospace.com/global/en/job/R5033774/Data-Science-Intern",
    postedDate: "2026-05-09",
    duration: "Internship"
  },

  {
    id: "salesforce-trainee-idrms-blr-2026-ks901",
    title: "Salesforce Trainee",
    company: "IDRMS Technologies Pvt Ltd",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "Freshers",
    qualification: "Any Graduate / Salesforce Trained Candidates",
    salary: "Not Disclosed",
    skills: ["Salesforce", "CRM", "Communication"],
    responsibilities: [
      "Support Salesforce projects",
      "Assist CRM implementation",
      "Work with development teams"
    ],
    requirements: [
      "Freshers can apply",
      "Salesforce training preferred"
    ],
    certifications: ["Salesforce Certification (Preferred)"],
    benefits: [
      "Career growth",
      "Salesforce ecosystem exposure"
    ],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLScHY4VPGPOWFuIyg2g-OPxNJWVwpjjJ7Nbaq8PKYVB5nN8NYA/viewform",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "trimble-software-engineer1-chn-2026-ks902",
    title: "Software Engineer 1",
    company: "Trimble",
    category: "IT",
    jobType: "Full Time",
    location: "Chennai, India",
    experience: "2024 / 2025 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [".NET", "Java", "React", "AI Coding Tools"],
    responsibilities: [
      "Develop software applications",
      "Collaborate with engineering teams",
      "Maintain scalable systems"
    ],
    requirements: [
      "2024 or 2025 graduates",
      "Knowledge of software development"
    ],
    certifications: [],
    benefits: [
      "Hybrid work model",
      "Tech industry exposure"
    ],
    applyLink: "https://trimble.eightfold.ai/careers/job/171840270493?microsite=trimble.com&domain=trimble.com&src=LinkedIN",
    postedDate: "2026-05-09",
    duration: "Full Time"
  },

  {
    id: "symphonyai-apprentice-dataanalyst-blr-2026-ks903",
    title: "Apprentice Data Analyst",
    company: "SymphonyAI",
    category: "IT",
    jobType: "Internship",
    location: "Bengaluru, India",
    experience: "Freshers",
    qualification: "BS in CS / Statistics / Economics / Mathematics",
    salary: "Not Disclosed",
    skills: [
      "SQL",
      "Excel",
      "Power BI",
      "Python",
      "R",
      "GenAI"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate reports and insights",
      "Support analytics projects"
    ],
    requirements: [
      "Knowledge of analytics tools",
      "Strong analytical thinking"
    ],
    certifications: [],
    benefits: [
      "AI industry exposure",
      "Hands-on analytics experience"
    ],
    applyLink: "https://jobs.symphonyai.com/jobs/2967?lang=en-us",
    postedDate: "2026-05-09",
    duration: "Internship"
  },

  {
    id: "mercor-cybersecurity-researcher-2026",
    title: "Cybersecurity Researcher / Engineer",
    company: "Mercor",
    category: "IT",
    jobType: "Contract",
    location: "Remote",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "$100 per hour",
    skills: [
      "Cybersecurity",
      "OSINT",
      "Threat Intelligence",
      "Disinformation Analysis"
    ],
    responsibilities: [
      "Analyze online information environments",
      "Identify manipulation patterns",
      "Conduct OSINT investigations"
    ],
    requirements: [
      "Experience in cybersecurity research",
      "Strong investigative skills"
    ],
    certifications: [],
    benefits: [
      "Remote work",
      "Flexible schedule",
      "Weekly payments"
    ],
    applyLink: "https://t.mercor.com/K0Unv",
    postedDate: "2026-05-07",
    duration: "Contract"
  },

  {
    id: "optimhire-data-architect-2026",
    title: "Data Architect",
    company: "Optimhire",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "12 - 14 Years",
    qualification: "BE / BTech in Computer Science",
    salary: "₹25 - ₹27 LPA",
    skills: [
      "SQL",
      "ETL",
      "Data Modeling",
      "Azure Synapse",
      "AWS Redshift",
      "BigQuery"
    ],
    responsibilities: [
      "Define enterprise data architecture",
      "Design data models and frameworks",
      "Lead cloud data initiatives"
    ],
    requirements: [
      "12+ years experience",
      "Strong data architecture expertise"
    ],
    certifications: [],
    benefits: [
      "Leadership role",
      "Enterprise-scale projects"
    ],
    applyLink: "https://optimhire.com/developers/jv/309503?ref_code=mukesh-agrawal",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "pioneerit-lead-data-engineer-2026",
    title: "Lead Data Engineer",
    company: "Pioneer IT Systems",
    category: "IT",
    jobType: "Full Time",
    location: "Dallas TX / McLean VA / NY",
    experience: "14+ Years",
    qualification: "Bachelor’s Degree",
    salary: "$160K - $180K per year",
    skills: [
      "AWS",
      "Python",
      "Scala",
      "Data Engineering"
    ],
    responsibilities: [
      "Develop data engineering solutions",
      "Complete coding assessments",
      "Manage cloud data systems"
    ],
    requirements: [
      "Strong AWS expertise",
      "Python or Scala coding skills"
    ],
    certifications: [],
    benefits: [
      "Full benefits",
      "Hybrid work"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "pioneerit-python-developer-cloud-2026",
    title: "Python Developer with Java & Cloud",
    company: "Pioneer IT Systems",
    category: "IT",
    jobType: "Remote",
    location: "USA Remote",
    experience: "14 - 20 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Java",
      "AWS Lambda",
      "Cloud"
    ],
    responsibilities: [
      "Develop cloud applications",
      "Work on backend systems",
      "Handle AWS Lambda functions"
    ],
    requirements: [
      "Strong coding experience",
      "Excellent communication skills"
    ],
    certifications: [],
    benefits: [
      "Remote opportunity"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com",
    postedDate: "2026-05-07",
    duration: "Contract"
  },

  {
    id: "pioneerit-multicloud-network-architect-2026",
    title: "Sr. Multi-Cloud Network Architect",
    company: "Pioneer IT Systems",
    category: "IT",
    jobType: "Hybrid",
    location: "Renton WA / Greensboro NC",
    experience: "12 - 18 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "AWS",
      "Azure",
      "GCP",
      "BGP",
      "OSPF",
      "Network Security"
    ],
    responsibilities: [
      "Design cloud networking solutions",
      "Manage hybrid connectivity",
      "Implement network security"
    ],
    requirements: [
      "Hands-on cloud networking experience"
    ],
    certifications: [],
    benefits: [
      "Hybrid work setup"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com",
    postedDate: "2026-05-07",
    duration: "Contract"
  },

  {
    id: "pioneerit-platform-architect-2026",
    title: "Platform Architect (Cloud / AI Landing Zones)",
    company: "Pioneer IT Systems",
    category: "IT",
    jobType: "Hybrid",
    location: "Renton WA / Greensboro NC",
    experience: "12 - 18 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "AWS",
      "Azure",
      "Terraform",
      "IAM",
      "SSO"
    ],
    responsibilities: [
      "Build cloud landing zones",
      "Design cloud architecture",
      "Implement IAM solutions"
    ],
    requirements: [
      "Terraform expertise",
      "Cloud architecture knowledge"
    ],
    certifications: [],
    benefits: [
      "AI and cloud projects"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com",
    postedDate: "2026-05-07",
    duration: "Contract"
  },

  {
    id: "pioneerit-security-product-manager-2026",
    title: "Product Manager - Security Engineering SME",
    company: "Pioneer IT Systems",
    category: "IT",
    jobType: "Hybrid",
    location: "Washington DC",
    experience: "12 - 18 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "DevOps",
      "NIST",
      "Cybersecurity",
      "Security Engineering"
    ],
    responsibilities: [
      "Manage security engineering projects",
      "Handle DevOps processes",
      "Ensure compliance standards"
    ],
    requirements: [
      "Knowledge of NIST frameworks"
    ],
    certifications: [],
    benefits: [
      "Government security projects"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com",
    postedDate: "2026-05-07",
    duration: "Contract"
  },

  {
    id: "airbus-data-engineering-intern-2026-so",
    title: "Intern - Data Engineering",
    company: "Airbus",
    category: "IT",
    jobType: "Internship",
    location: "Bangalore, India",
    experience: "Freshers",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Engineering",
      "SQL",
      "Python",
      "Analytics"
    ],
    responsibilities: [
      "Support data engineering workflows",
      "Work with large datasets",
      "Assist analytics teams"
    ],
    requirements: [
      "Bachelor’s or Master’s Degree"
    ],
    certifications: [],
    benefits: [
      "Internship at Airbus",
      "Industry exposure",
      "Hands-on learning"
    ],
    applyLink: "https://ag.wd3.myworkdayjobs.com/en-US/Airbus/job/Intern---Data-Engineering_JR10366673-1?locationCountry=c4f78be1a8f14da0ab49ce1162348a5e",
    postedDate: "2026-05-07",
    duration: "Internship"
  },

  {
    id: "enterpret-machine-learning-intern-2026-emli",
    title: "Machine Learning Intern",
    company: "Enterpret",
    category: "IT",
    jobType: "Internship",
    location: "Bangalore, India",
    experience: "2026 / 2027 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Machine Learning",
      "Python",
      "AI",
      "Data Analysis"
    ],
    responsibilities: [
      "Build ML models",
      "Work on AI systems",
      "Analyze datasets"
    ],
    requirements: [
      "2026 or 2027 graduates"
    ],
    certifications: [],
    benefits: [
      "AI startup exposure",
      "Real-world ML experience"
    ],
    applyLink: "http://job-boards.greenhouse.io/enterpret/jobs/7723230003?gh_src=8gtnr2u63us",
    postedDate: "2026-05-07",
    duration: "Internship"
  },

  {
    id: "sinope-associate-software-engineer-2026-sase",
    title: "Associate Software Engineer",
    company: "Sinope",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "2023 / 2024 / 2025 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Mobile Applications",
      "Software Development",
      "Programming"
    ],
    responsibilities: [
      "Develop mobile applications",
      "Collaborate with engineering teams",
      "Maintain application performance"
    ],
    requirements: [
      "2023 to 2025 graduates"
    ],
    certifications: [],
    benefits: [
      "Tech startup environment",
      "Career growth opportunities"
    ],
    applyLink: "https://sinope.co.in/jobs/associate-software-engineer-mobile-applications/",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "enterpret-software-engineer-intern-2026-esei",
    title: "Software Engineer Intern",
    company: "Enterpret",
    category: "IT",
    jobType: "Internship",
    location: "Bangalore, India",
    experience: "2026 / 2027 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Software Development",
      "Programming",
      "Backend Development"
    ],
    responsibilities: [
      "Build software features",
      "Work with development teams",
      "Support product engineering"
    ],
    requirements: [
      "2026 or 2027 graduates"
    ],
    certifications: [],
    benefits: [
      "Startup experience",
      "Hands-on coding exposure"
    ],
    applyLink: "http://job-boards.greenhouse.io/enterpret/jobs/6691182003?gh_src=p9f0iznr3us",
    postedDate: "2026-05-07",
    duration: "Internship"
  },

  {
    id: "adobe-reactjs-software-engineer-2026-arse",
    title: "Software Engineer (React.js)",
    company: "Adobe",
    category: "IT",
    jobType: "Full Time",
    location: "Noida, India",
    experience: "2021 / 2022 / 2023 / 2024 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "React.js",
      "JavaScript",
      "Frontend Development",
      "UI Engineering"
    ],
    responsibilities: [
      "Develop frontend applications",
      "Build responsive UI",
      "Optimize user experience"
    ],
    requirements: [
      "Frontend development knowledge",
      "React.js experience"
    ],
    certifications: [],
    benefits: [
      "Adobe career opportunity",
      "Product-based company exposure"
    ],
    applyLink: "https://careers.adobe.com/us/en/job/R165379/Front-End-Engineer-React-js",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },


  {
    id: "wipro-junior-data-science-2026",
    title: "Junior Data Science",
    company: "Wipro",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: ["Python", "Machine Learning", "Data Analysis"],
    responsibilities: [
      "Analyze datasets",
      "Build data models",
      "Support AI and analytics projects"
    ],
    requirements: ["Bachelor’s or Master’s degree"],
    certifications: [],
    benefits: ["Career growth", "Enterprise project exposure"],
    applyLink: "https://careers.wipro.com/job/JUNIR-DATA-SCIENCE/151455-en_US",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "caterpillar-associate-engineer-2026",
    title: "Associate Engineer",
    company: "Caterpillar",
    category: "Non-IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "0 - 2 Years",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: ["Engineering", "Problem Solving", "Software Development"],
    responsibilities: [
      "Develop engineering solutions",
      "Support technical teams",
      "Maintain system performance"
    ],
    requirements: ["Bachelor’s or Master’s degree"],
    certifications: [],
    benefits: ["Global company exposure"],
    applyLink: "https://careers.caterpillar.com/en/jobs/r0000364471/associate-engineer/",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "symphonyai-apprentice-data-analyst-2026",
    title: "Apprentice - Data Analyst",
    company: "SymphonyAI",
    category: "IT",
    jobType: "Internship",
    location: "Bangalore, India",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Excel", "SQL", "Data Analysis"],
    responsibilities: [
      "Analyze datasets",
      "Generate reports",
      "Support analytics teams"
    ],
    requirements: ["Bachelor’s Degree"],
    certifications: [],
    benefits: ["Hands-on internship", "Industry exposure"],
    applyLink: "https://jobs.symphonyai.com/jobs/2967?lang=en-us",
    postedDate: "2026-05-07",
    duration: "Internship"
  },

  {
    id: "harmonic-qa-software-engineer-2026",
    title: "QA Software Engineer",
    company: "Harmonic",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "2021 - 2024 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Testing", "Automation", "Debugging"],
    responsibilities: [
      "Perform software testing",
      "Identify bugs",
      "Ensure software quality"
    ],
    requirements: ["Graduates from 2021-2024"],
    certifications: [],
    benefits: ["QA engineering exposure"],
    applyLink: "https://egmn.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Harmonic/job/260094",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "compugroup-frontend-developer-2026",
    title: "Frontend Developer",
    company: "CompuGroup Medical",
    category: "IT",
    jobType: "Full Time",
    location: "Noida, India",
    experience: "2021 - 2023 Graduates",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["HTML", "CSS", "JavaScript", "React.js"],
    responsibilities: [
      "Develop frontend applications",
      "Create responsive UI",
      "Integrate APIs"
    ],
    requirements: ["Frontend development skills"],
    certifications: [],
    benefits: ["Healthcare tech exposure"],
    applyLink: "https://cgm.wd3.myworkdayjobs.com/de-DE/cgm/job/Full-Stack-Developer_JR107909",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "google-web-solutions-engineer-2026",
    title: "Web Solutions Engineer I",
    company: "Google",
    category: "IT",
    jobType: "Full Time",
    location: "India",
    experience: "2023 / 2024 Passouts",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Web Development", "JavaScript", "Problem Solving"],
    responsibilities: [
      "Develop scalable web solutions",
      "Support client requirements",
      "Optimize web applications"
    ],
    requirements: ["2023 or 2024 graduates"],
    certifications: [],
    benefits: ["Google career opportunity"],
    applyLink: "https://www.google.com/about/careers/applications/jobs/results/78887535811404486-web-solutions-engineer-i/",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "qualcomm-engineer-2026",
    title: "Engineer",
    company: "Qualcomm",
    category: "IT",
    jobType: "Full Time",
    location: "India",
    experience: "2024 / 2025 Passouts",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Engineering", "Programming", "Problem Solving"],
    responsibilities: [
      "Develop technical solutions",
      "Support engineering teams"
    ],
    requirements: ["2024 or 2025 graduates"],
    certifications: [],
    benefits: ["Semiconductor industry exposure"],
    applyLink: "https://careers.qualcomm.com/careers/job/446718335413",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "amazon-adtech-sde-2026",
    title: "Software Development Engineer",
    company: "Amazon AdTech",
    category: "IT",
    jobType: "Contract",
    location: "India",
    experience: "2024 / 2025 Passouts",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "DSA", "System Design"],
    responsibilities: [
      "Develop scalable software",
      "Optimize systems",
      "Collaborate with teams"
    ],
    requirements: ["Strong coding skills"],
    certifications: [],
    benefits: ["Amazon experience"],
    applyLink: "https://www.amazon.jobs/en/jobs/10390699/software-development-engineer-ftc",
    postedDate: "2026-05-07",
    duration: "1 Year Contract"
  },

{
    id: "gravity-full-stack-developer-2026",
    title: "Full Stack Developer",
    company: "Gravity",
    category: "IT",
    jobType: "Remote",
    location: "WFH - Remote",
    experience: "1 - 4 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹3L - ₹6L /year",
    skills: ["React.js", "Node.js", "Python", "AWS"],
    responsibilities: [
      "Develop frontend and backend applications",
      "Build REST APIs",
      "Manage PostgreSQL databases"
    ],
    requirements: ["React.js", "Node.js", "AWS knowledge"],
    certifications: [],
    benefits: ["Remote work", "AI product exposure"],
    applyLink: "https://abekus.ai/public-job-search/full-stack-developer-9?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "kyzer-java-backend-developer-2026",
    title: "Java Backend Developer",
    company: "Kyzer Software",
    category: "IT",
    jobType: "Full Time",
    location: "Mumbai, India",
    experience: "Fresher / Experienced",
    qualification: "Bachelor’s Degree",
    salary: "₹3L - ₹7L /year",
    skills: ["Java", "Spring Boot", "Hibernate"],
    responsibilities: [
      "Develop backend services",
      "Maintain databases",
      "Integrate APIs"
    ],
    requirements: ["Java", "Spring Boot"],
    certifications: [],
    benefits: ["Career growth", "Backend experience"],
    applyLink: "https://unstop.com/o/eW9p1Yt?lb=Bnie7Jo",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "thoughtworks-software-developer-2026",
    title: "Software Developer",
    company: "Thoughtworks",
    category: "IT",
    jobType: "Full Time",
    location: "Gurgaon, India",
    experience: "5+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "React", "AWS"],
    responsibilities: [
      "Develop scalable applications",
      "Collaborate with engineering teams"
    ],
    requirements: ["Java", "Cloud experience"],
    certifications: [],
    benefits: ["Top tech environment"],
    applyLink: "mailto:akshit.batra@thoughtworks.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "optimhire-dotnet-fullstack-developer-2026",
    title: "Dot Net FullStack Developer",
    company: "Optimhire",
    category: "IT",
    jobType: "Full Time",
    location: "Bengaluru, India",
    experience: "4 - 6 Years",
    qualification: "BE / BTech",
    salary: "₹7 - ₹13 LPA",
    skills: [".NET Core", "ReactJS", "FastAPI", "Docker"],
    responsibilities: [
      "Lead full-stack development",
      "Build microservices",
      "Implement CI/CD"
    ],
    requirements: ["ReactJS", ".NET", "Cloud knowledge"],
    certifications: [],
    benefits: ["Cloud-native architecture exposure"],
    applyLink: "https://optimhire.com/developers/jv/309727?ref_code=mukesh-agrawal",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "deloitte-servicenow-consultant-2026",
    title: "ServiceNow Consultant - ITOM/CSM",
    company: "Deloitte",
    category: "IT",
    jobType: "Full Time",
    location: "Pune, India",
    experience: "4+ Years",
    qualification: "UG and Above",
    salary: "Not Disclosed",
    skills: ["ServiceNow", "ATF", "REST APIs"],
    responsibilities: [
      "Develop automated tests",
      "Perform regression testing",
      "Validate integrations"
    ],
    requirements: ["ServiceNow ATF experience"],
    certifications: [],
    benefits: ["Enterprise projects"],
    applyLink: "https://southasiacareers.deloitte.com/job/Pune-ET&P-ServiceNow-Consultant-ITOMCSM-Pune/54592144/",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "siemens-cybersecurity-architect-2026",
    title: "Cybersecurity Solution Architect",
    company: "Siemens Energy",
    category: "Cyber Security",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "13+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Cyber Security", "IEC62443", "OT Security"],
    responsibilities: [
      "Design cybersecurity solutions",
      "Support sales teams",
      "Develop security roadmaps"
    ],
    requirements: ["Industrial cybersecurity expertise"],
    certifications: [],
    benefits: ["Global exposure"],
    applyLink: "https://jobs.siemens.com/en_US/externaljobs/JobDetail/498215",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "writer-product-manager-2026",
    title: "Product Manager / Business Analyst",
    company: "Writer Corporation",
    category: "Management",
    jobType: "Full Time",
    location: "Mumbai, India",
    experience: "1+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Product Management", "Business Analysis"],
    responsibilities: [
      "Handle product workflows",
      "Coordinate with tech teams"
    ],
    requirements: ["PM or BA experience"],
    certifications: [],
    benefits: ["Multi-domain exposure"],
    applyLink: "mailto:saurabh.gupta@writerrelocations.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "openshift-redhat-consultant-2026",
    title: "Openshift - RedHat Consultant",
    company: "Rpersonify",
    category: "IT",
    jobType: "Full Time",
    location: "Mumbai, India",
    experience: "4+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["OpenShift", "RedHat", "Linux"],
    responsibilities: [
      "Manage OpenShift environments",
      "Support infrastructure"
    ],
    requirements: ["4+ years experience"],
    certifications: [],
    benefits: ["Enterprise infrastructure projects"],
    applyLink: "mailto:hr@rpersonify.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "implementation-consultant-goa-2026",
    title: "Implementation Consultant",
    company: "91HR",
    category: "Consulting",
    jobType: "Full Time",
    location: "Panaji, Goa",
    experience: "4+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹40,000 – ₹80,000/month",
    skills: ["Client Management", "Travel Tech"],
    responsibilities: [
      "Manage implementations",
      "Provide client training"
    ],
    requirements: ["Travel tech experience"],
    certifications: [],
    benefits: ["Weekends off"],
    applyLink: "mailto:dipti@91hr.in",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "tcs-react-developer-2026",
    title: "React Developer",
    company: "TCS",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹4L - ₹8L /year",
    skills: ["React.js", "JavaScript", "Redux"],
    responsibilities: [
      "Build frontend applications",
      "Integrate REST APIs"
    ],
    requirements: ["React.js experience"],
    certifications: [],
    benefits: ["Large-scale projects"],
    applyLink: "https://www.tcs.com/careers",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "infosys-nodejs-developer-2026",
    title: "Node.js Developer",
    company: "Infosys",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "1 - 3 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹4L - ₹7L /year",
    skills: ["Node.js", "MongoDB", "Express.js"],
    responsibilities: [
      "Develop APIs",
      "Handle backend services"
    ],
    requirements: ["Node.js knowledge"],
    certifications: [],
    benefits: ["Learning opportunities"],
    applyLink: "https://www.infosys.com/careers",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "wipro-python-developer-2026",
    title: "Python Developer",
    company: "Wipro",
    category: "IT",
    jobType: "Full Time",
    location: "Chennai, India",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "₹3L - ₹5L /year",
    skills: ["Python", "Django", "REST APIs"],
    responsibilities: [
      "Develop backend applications",
      "Maintain APIs"
    ],
    requirements: ["Python basics"],
    certifications: [],
    benefits: ["Training programs"],
    applyLink: "https://careers.wipro.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "accenture-frontend-engineer-2026",
    title: "Frontend Engineer",
    company: "Accenture",
    category: "IT",
    jobType: "Full Time",
    location: "Pune, India",
    experience: "1+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹4L - ₹6L /year",
    skills: ["React.js", "HTML", "CSS"],
    responsibilities: [
      "Create responsive UI",
      "Optimize frontend performance"
    ],
    requirements: ["Frontend development skills"],
    certifications: [],
    benefits: ["Hybrid work"],
    applyLink: "https://www.accenture.com/in-en/careers",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "amazon-sde1-2026",
    title: "Software Development Engineer I",
    company: "Amazon",
    category: "IT",
    jobType: "Full Time",
    location: "Hyderabad, India",
    experience: "0 - 2 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹12L - ₹18L /year",
    skills: ["Java", "DSA", "System Design"],
    responsibilities: [
      "Build scalable systems",
      "Write optimized code"
    ],
    requirements: ["Strong coding skills"],
    certifications: [],
    benefits: ["High salary", "Global exposure"],
    applyLink: "https://www.amazon.jobs",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "flipkart-software-engineer-2026",
    title: "Software Engineer",
    company: "Flipkart",
    category: "IT",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "1 - 3 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹8L - ₹14L /year",
    skills: ["Java", "Spring Boot", "Microservices"],
    responsibilities: [
      "Develop scalable services",
      "Collaborate with product teams"
    ],
    requirements: ["Backend experience"],
    certifications: [],
    benefits: ["Product-based company"],
    applyLink: "https://www.flipkartcareers.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "zoho-web-developer-2026",
    title: "Web Developer",
    company: "Zoho",
    category: "IT",
    jobType: "Full Time",
    location: "Chennai, India",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "₹4L - ₹7L /year",
    skills: ["HTML", "CSS", "JavaScript"],
    responsibilities: [
      "Develop web applications",
      "Maintain UI components"
    ],
    requirements: ["Frontend basics"],
    certifications: [],
    benefits: ["Good work culture"],
    applyLink: "https://careers.zohocorp.com",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "capgemini-java-engineer-2026",
    title: "Java Engineer",
    company: "Capgemini",
    category: "IT",
    jobType: "Full Time",
    location: "Noida, India",
    experience: "1 - 2 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹4L - ₹6L /year",
    skills: ["Java", "Spring", "SQL"],
    responsibilities: [
      "Develop enterprise applications",
      "Write optimized SQL queries"
    ],
    requirements: ["Java programming knowledge"],
    certifications: [],
    benefits: ["Enterprise exposure"],
    applyLink: "https://www.capgemini.com/careers",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },

  {
    id: "hcl-cloud-engineer-2026",
    title: "Cloud Engineer",
    company: "HCLTech",
    category: "Cloud",
    jobType: "Full Time",
    location: "Bangalore, India",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹5L - ₹9L /year",
    skills: ["AWS", "Docker", "Kubernetes"],
    responsibilities: [
      "Manage cloud infrastructure",
      "Handle deployments"
    ],
    requirements: ["Cloud platform knowledge"],
    certifications: [],
    benefits: ["Cloud projects"],
    applyLink: "https://www.hcltech.com/careers",
    postedDate: "2026-05-07",
    duration: "Full Time"
  },



  {
    id: "cornerstone-junior-support-specialist-intern-2026",
    title: "Junior Support Specialist",
    company: "Cornerstone",
    category: "IT",
    jobType: "Internship",
    location: "Pune, India",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Technical Support", "Customer Support", "Troubleshooting"],
    responsibilities: [
      "Provide technical support",
      "Resolve customer issues",
      "Assist internal teams"
    ],
    requirements: ["Bachelor’s Degree"],
    certifications: [],
    benefits: ["Hands-on experience", "Industry exposure"],
    applyLink: "https://cornerstone.csod.com/ux/ats/careersite/2/home/requisition/11145?c=cornerstone&sq=Junior%20Support%20Specialist&lq=India&pl=ChIJkbeSa_BfYzARphNChaFPjNc&country=in",
    contact: {},
    postedDate: "2026-05-04",
    duration: "12 Months"
  },

  {
    id: "redhat-junior-consultant-2026",
    title: "Junior Consultant",
    company: "Red Hat",
    category: "IT",
    jobType: "Full-Time",
    location: "New Delhi, India",
    experience: "Fresher",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: ["Consulting", "Problem Solving", "Technical Knowledge"],
    responsibilities: [
      "Support consulting projects",
      "Work with clients",
      "Assist senior consultants"
    ],
    requirements: ["Bachelor’s or Master’s Degree"],
    certifications: [],
    benefits: ["Career growth", "Corporate exposure"],
    applyLink: "https://redhat.wd5.myworkdayjobs.com/en-US/jobs/job/Junior-Consultant_R-054554-1",
    contact: {},
    postedDate: "2026-05-04"
  },
  {
    id: "cornerstone-junior-support-specialist-intern-2026",
    title: "Junior Support Specialist",
    company: "Cornerstone",
    category: "IT",
    jobType: "Internship",
    location: "Pune, India",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Technical Support", "Customer Support", "Troubleshooting"],
    responsibilities: [
      "Provide technical support",
      "Resolve customer issues",
      "Assist internal teams"
    ],
    requirements: ["Bachelor’s Degree"],
    certifications: [],
    benefits: ["Hands-on experience", "Industry exposure"],
    applyLink: "https://cornerstone.csod.com/ux/ats/careersite/2/home/requisition/11145?c=cornerstone&sq=Junior%20Support%20Specialist&lq=India&pl=ChIJkbeSa_BfYzARphNChaFPjNc&country=in",
    contact: {},
    postedDate: "2026-05-04",
    duration: "12 Months"
  },

  {
    id: "redhat-junior-consultant-2026",
    title: "Junior Consultant",
    company: "Red Hat",
    category: "IT",
    jobType: "Full-Time",
    location: "New Delhi, India",
    experience: "Fresher",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: ["Consulting", "Problem Solving", "Technical Knowledge"],
    responsibilities: [
      "Support consulting projects",
      "Work with clients",
      "Assist senior consultants"
    ],
    requirements: ["Bachelor’s or Master’s Degree"],
    certifications: [],
    benefits: ["Career growth", "Corporate exposure"],
    applyLink: "https://redhat.wd5.myworkdayjobs.com/en-US/jobs/job/Junior-Consultant_R-054554-1",
    contact: {},
    postedDate: "2026-05-04"
  },

  {
    id: "indian-army-csbo-grade-ii-2026",
    title: "CSBO Grade II",
    company: "Indian Army",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Experience / Fresher",
    qualification: "10th Pass",
    salary: "₹21,700 – ₹69,100",
    skills: ["Communication", "Clerical Work"],
    responsibilities: [
      "Handle office communication",
      "Support army operations"
    ],
    requirements: ["10th pass or relevant experience"],
    certifications: [],
    benefits: ["Government job security", "Allowances"],
    applyLink: "https://govtjobsalert.in/indian-army-csbo-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-31",
    vacancies: 190
  },

  {
    id: "punjab-psssb-warder-matron-2026",
    title: "Warder & Matron",
    company: "PSSSB Punjab",
    category: "Government",
    jobType: "Full-Time",
    location: "Punjab",
    experience: "Fresher",
    qualification: "12th Pass",
    salary: "₹19,900 – ₹63,200",
    skills: ["Security", "Discipline"],
    responsibilities: [
      "Maintain prison security",
      "Monitor inmates"
    ],
    requirements: ["12th pass"],
    certifications: [],
    benefits: ["Govt benefits", "Stable career"],
    applyLink: "https://govtjobsalert.in/punjab-psssb-warder-matron-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-05",
    vacancies: 532
  },

  {
    id: "karnataka-high-court-group-d-2026",
    title: "Group D",
    company: "Karnataka High Court",
    category: "Government",
    jobType: "Full-Time",
    location: "Karnataka",
    experience: "Fresher",
    qualification: "10th Pass",
    salary: "₹19,900 – ₹69,100",
    skills: ["Basic Office Work"],
    responsibilities: [
      "Support court operations",
      "Maintain records"
    ],
    requirements: ["10th pass"],
    certifications: [],
    benefits: ["Govt perks", "Job stability"],
    applyLink: "https://govtjobsalert.in/karnataka-high-court-group-d-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-21",
    vacancies: 101
  },

  {
    id: "meecl-assistant-engineer-2026",
    title: "Assistant Engineer",
    company: "MeECL",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher / Experienced",
    qualification: "B.E / B.Tech",
    salary: "₹83,000 – ₹1,96,100",
    skills: ["Electrical Engineering", "Technical Knowledge"],
    responsibilities: [
      "Manage power systems",
      "Handle technical operations"
    ],
    requirements: ["Engineering degree"],
    certifications: [],
    benefits: ["High salary", "Govt benefits"],
    applyLink: "https://govtjobsalert.in/meecl-assistant-engineer-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-15"
  },

  {
    id: "rlda-site-engineer-2026",
    title: "Site Engineer",
    company: "RLDA",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Experienced",
    qualification: "B.E / B.Tech",
    salary: "₹76,000 / month",
    skills: ["Civil Engineering", "Site Management"],
    responsibilities: [
      "Manage construction sites",
      "Ensure project execution"
    ],
    requirements: ["Engineering + experience"],
    certifications: [],
    benefits: ["Good salary", "Project exposure"],
    applyLink: "https://govtjobsalert.in/rlda-site-engineer-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-22",
    vacancies: 40
  },

  {
    id: "kribhco-graduate-engineer-trainee-2026",
    title: "Graduate Engineer Trainee",
    company: "KRIBHCO",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "B.E / B.Tech",
    salary: "₹55,000 – ₹1,30,000",
    skills: ["Engineering Basics", "Problem Solving"],
    responsibilities: [
      "Training under engineers",
      "Assist in operations"
    ],
    requirements: ["Engineering degree"],
    certifications: [],
    benefits: ["Training program", "Growth opportunity"],
    applyLink: "https://govtjobsalert.in/kribhco-graduate-engineer-trainee-recruitment-2026/",
    contact: {},
    postedDate: "2026-05-04",
    lastDate: "2026-05-21"
  },

  {
    id: "latest-graduate-govt-jobs-2026",
    title: "Graduate Govt Jobs (Multiple)",
    company: "Various Govt Organizations",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "Any Graduate",
    salary: "₹25,500 – ₹1,77,500",
    skills: ["General Skills"],
    responsibilities: [
      "Varies by role"
    ],
    requirements: ["Graduate degree"],
    certifications: [],
    benefits: ["Multiple opportunities", "Govt benefits"],
    applyLink: "https://govtjobsalert.in/graduate-govt-jobs/",
    contact: {},
    postedDate: "2026-05-04",
    vacancies: "10000+"
  },

  {
    id: "vestas-senior-software-architect-2026",
    title: "Senior Software Architect",
    company: "Vestas",
    category: "IT",
    jobType: "Full-Time",
    location: "Chennai",
    experience: "5+ Years",
    qualification: "B.E / B.Tech / M.E",
    salary: "Not Disclosed",
    skills: ["Software Architecture", "CI/CD", "DevOps", "Jira", "Jenkins"],
    responsibilities: [
      "Design scalable turbine software",
      "Define architecture guidelines",
      "Collaborate with teams",
      "Improve processes"
    ],
    requirements: [
      "5+ years experience",
      "CI/CD knowledge",
      "Agile environment experience"
    ],
    certifications: ["ISTQB (Optional)"],
    benefits: ["Global exposure", "Career growth", "Innovation-driven work"],
    applyLink: "https://careers.vestas.com/job/Aarhus-N-Senior-Software-Architect-Regi-8200/1287594201/",
    contact: {},
    postedDate: "2026-05-04"
  },

  {
    id: "associative-ai-automation-expert-fresher-2026",
    title: "AI Automation Expert (Fresher)",
    company: "Associative",
    category: "IT",
    jobType: "Full-Time",
    location: "Pune (On-site)",
    experience: "Fresher",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: ["AI", "Machine Learning", "Automation", "Python"],
    responsibilities: [
      "Work on AI solutions",
      "Develop automation tools",
      "Support product development"
    ],
    requirements: [
      "Fluent in Hindi, English, Marathi",
      "Own laptop",
      "Full-time availability"
    ],
    certifications: [],
    benefits: ["Career start", "Hands-on experience"],
    applyLink: "",
    contact: {
      email: "info@associative.in",
      phone: "9028850524"
    },
    contactLinks: {
      email: "mailto:info@associative.in",
      phone: "tel:9028850524"
    },
    postedDate: "2026-05-04"
  },

  {
    id: "cisco-software-engineer-2026",
    title: "Software Engineer",
    company: "Cisco",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore / Hyderabad",
    experience: "0 - 1 Years",
    qualification: "B.E / B.Tech",
    salary: "Not Disclosed",
    skills: ["SDLC", "Generative AI", "CRM", "Secure Coding"],
    responsibilities: [
      "Develop secure applications",
      "Work with cross-functional teams",
      "Build scalable systems"
    ],
    requirements: [
      "0-1 years experience",
      "Basic AI/LLM knowledge",
      "Problem-solving skills"
    ],
    certifications: [],
    benefits: ["Global exposure", "Learning opportunity"],
    applyLink: "https://careers.cisco.com/global/en/job/CISCISGLOBAL2011632EXTERNALENGLOBAL/Software-Engineer",
    contact: {},
    postedDate: "2026-05-04"
  },

  {
    id: "bndigitech-technical-support-2026",
    title: "Technical Remote Support",
    company: "BNDigitech",
    category: "IT",
    jobType: "Full-Time",
    location: "Mumbai (Goregaon)",
    experience: "Fresher",
    qualification: "Any",
    salary: "Not Disclosed",
    skills: ["Technical Support", "Customer Handling"],
    responsibilities: [
      "Provide remote support",
      "Handle customer queries"
    ],
    requirements: [],
    certifications: [],
    benefits: [],
    applyLink: "",
    contact: {
      email: "bharati.a@bndigitech.com"
    },
    contactLinks: {
      email: "mailto:bharati.a@bndigitech.com"
    },
    postedDate: "2026-05-04"
  },

  {
    id: "honeywell-advanced-software-engineer-2026",
    title: "Advanced Software Engineer",
    company: "Honeywell",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore (On-site)",
    experience: "5+ Years",
    qualification: "B.E / B.Tech",
    salary: "Not Disclosed",
    skills: ["HTML", "CSS", "JavaScript", "Angular", ".NET Core", "SQL"],
    responsibilities: [
      "Develop web applications",
      "Collaborate with teams",
      "Ensure performance & security"
    ],
    requirements: [
      "5+ years experience",
      "Frontend + Backend skills",
      "Agile knowledge"
    ],
    certifications: [],
    benefits: ["Career growth", "Enterprise projects"],
    applyLink: "https://ibqbjb.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Honeywell/jobs/preview/145752/",
    contact: {},
    postedDate: "2026-05-04"
  },

  {
    id: "techmojo-incident-manager-2026",
    title: "Incident Manager",
    company: "Techmojo",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad (On-site)",
    experience: "6+ Years",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: ["ITIL", "Incident Management", "ServiceNow", "Jira"],
    responsibilities: [
      "Manage major incidents",
      "Coordinate teams",
      "Perform root cause analysis"
    ],
    requirements: [
      "6+ years experience",
      "ITIL knowledge",
      "Strong communication"
    ],
    certifications: ["ITIL 4 (Preferred)"],
    benefits: ["Leadership role", "High impact"],
    applyLink: "",
    contact: {
      email: "manideep.thatipamula@techmojo.in"
    },
    contactLinks: {
      email: "mailto:manideep.thatipamula@techmojo.in"
    },
    postedDate: "2026-05-04"
  },
      
  {
    id: "business-analyst-plan-inventory-2026",
    title: "Business Analyst - Plan & Inventory",
    company: "Confidential",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore (Remote)",
    experience: "3 - 5 Years",
    qualification: "B.E / B.Tech",
    salary: "₹14 - ₹21 LPA",
    skills: ["SQL", "SAP", "Inventory Management", "Data Governance"],
    responsibilities: [
      "Analyze planning data",
      "Collaborate with stakeholders",
      "Maintain data models"
    ],
    requirements: ["SQL & SAP knowledge", "Supply chain understanding"],
    certifications: ["CDMP (Optional)"],
    benefits: ["Remote work", "High salary", "Career growth"],
    applyLink: "https://optimhire.com/developers/jv/309740?ref_code=mukesh-agrawal",
    postedDate: "2026-05-03"
  },
  {
    id: "dotnet-developer-massist-2026",
    title: "Senior .NET Developer",
    company: "Massist CRM",
    category: "IT",
    jobType: "Full-Time",
    location: "Noida",
    experience: "4 - 8 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["C#", "ASP.NET", "MVC", "SQL Server"],
    responsibilities: ["Develop apps", "Maintain systems", "Debug code"],
    requirements: ["Strong .NET experience"],
    certifications: [],
    benefits: ["Tech growth"],
    applyLink: "mailto:simran@massistcrm.com",
    postedDate: "2026-05-03"
  },
  {
    id: "wenodo-it-support-2026",
    title: "IT Support Specialist",
    company: "Wenodo",
    category: "IT",
    jobType: "Full-Time",
    location: "Bhopal",
    experience: "1+ Year",
    qualification: "BCA / MCA / BE",
    salary: "₹4.2 LPA",
    skills: ["Technical Support", "Troubleshooting"],
    responsibilities: ["Handle tickets", "Fix issues"],
    requirements: ["IT support experience"],
    certifications: [],
    benefits: ["Learning growth"],
    applyLink: "https://unstop.com/o/nKCvt24?lb=Bnie7Jo",
    postedDate: "2026-05-03"
  },
  {
    id: "data-analyst-intern-2026",
    title: "Data Analyst Intern",
    company: "7S IQ Pvt Ltd",
    category: "IT",
    jobType: "Internship",
    location: "Remote",
    experience: "0 - 1 Years",
    qualification: "Graduate / Student",
    salary: "Negotiable",
    skills: ["Excel", "Power BI", "Tableau", "SQL"],
    responsibilities: ["Analyze data", "Create dashboards"],
    requirements: ["Basic analytics knowledge"],
    certifications: [],
    benefits: ["Remote", "Hands-on"],
    applyLink: "https://abekus.ai/public-job-search/data-analyst-intern-1",
    postedDate: "2026-05-03"
  },
  {
    id: "cornerstone-support-2026",
    title: "Junior Support Specialist",
    company: "Cornerstone",
    category: "IT",
    jobType: "Internship",
    location: "Pune",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "₹8 - ₹14 LPA",
    skills: ["Customer Support", "SaaS"],
    responsibilities: ["Handle client issues", "Provide support"],
    requirements: ["Good communication"],
    certifications: [],
    benefits: ["MNC exposure"],
    applyLink: "https://cornerstone.csod.com",
    postedDate: "2026-05-03"
  },
  {
    id: "virtusa-genai-2026",
    title: "Gen AI Developer",
    company: "Virtusa",
    category: "IT",
    jobType: "Full-Time",
    location: "Pune",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Python", "LLMs", "Prompt Engineering"],
    responsibilities: ["Build AI apps", "Integrate APIs"],
    requirements: ["Python + AI knowledge"],
    certifications: [],
    benefits: ["AI career growth"],
    applyLink: "https://www.virtusa.com",
    postedDate: "2026-05-03"
  },
  {
    id: "ibm-app-dev-2026",
    title: "Application Developer",
    company: "IBM",
    category: "IT",
    jobType: "Full-Time",
    location: "Navi Mumbai",
    experience: "4 - 6 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "APIs", "Git"],
    responsibilities: ["Develop enterprise apps"],
    requirements: ["Java experience"],
    certifications: [],
    benefits: ["Top MNC"],
    applyLink: "https://careers.ibm.com",
    postedDate: "2026-05-03"
  },
  {
    id: "office365-admin-2026",
    title: "Office 365 Administrator",
    company: "Team Computers",
    category: "IT",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "5+ Years",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: ["O365", "Azure AD"],
    responsibilities: ["Manage O365"],
    requirements: ["O365 experience"],
    certifications: [],
    benefits: ["Enterprise exposure"],
    applyLink: "mailto:shruti.bansal@teamcomputers.com",
    postedDate: "2026-05-03"
  },
  {
    id: "flutter-dev-vqcodes-2026",
    title: "Flutter Developer",
    company: "VQCodes",
    category: "IT",
    jobType: "Walk-in",
    location: "Mohali",
    experience: "1 - 4 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Flutter", "Dart", "Mobile Development"],
    responsibilities: ["Build mobile apps"],
    requirements: ["Flutter experience"],
    certifications: [],
    benefits: ["Walk-in"],
    applyLink: "mailto:hr@vqcodes.com",
    postedDate: "2026-05-03"
  },
  {
    id: "cognitive-engineer-2026",
    title: "Cognitive Systems Engineer",
    company: "Archelos Tech",
    category: "IT",
    jobType: "Full-Time",
    location: "Remote/Hybrid",
    experience: "0 - 1 Years",
    qualification: "BTech / MCA",
    salary: "Not Disclosed",
    skills: ["AI", "Java", "Python", "Automation"],
    responsibilities: ["Work on AI systems"],
    requirements: ["Basic programming"],
    certifications: [],
    benefits: ["AI career"],
    applyLink: "mailto:hr@archelostech.in",
    postedDate: "2026-05-03"
  },
  {
    id: "labview-dev-2026",
    title: "LabView Developer",
    company: "Ceryle Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "0 - 4 Years",
    qualification: "BTech / Diploma",
    salary: "Not Disclosed",
    skills: ["LabVIEW", "PLC"],
    responsibilities: ["Develop automation systems"],
    requirements: ["PLC knowledge"],
    certifications: [],
    benefits: ["Core engineering role"],
    applyLink: "mailto:career@ceryletech.com",
    postedDate: "2026-05-03"
  },


      {
  id: "hsbc-multiple-roles-2026-hmr",
  title: "Multiple Roles (Tech & Non-Tech)",
  company: "HSBC",
  category: "Mixed",
  jobType: "Full-Time",
  location: "PAN India",
  experience: "0 - 8 Years",
  qualification: "Graduate / Post Graduate",
  salary: "₹8 LPA – ₹30 LPA (Expected)",
  skills: [
    "Communication",
    "Technical Skills",
    "Analytical Thinking",
    "Problem Solving"
  ],
  responsibilities: [
    "Work on assigned projects",
    "Collaborate with teams",
    "Analyze business/technical requirements",
    "Deliver quality solutions"
  ],
  requirements: [
    "Graduate or Post Graduate",
    "Relevant skills based on role",
    "Willingness to learn"
  ],
  certifications: [],
  benefits: [
    "Top MNC",
    "High salary packages",
    "Career growth",
    "Pan India opportunities"
  ],
  applyLink: "https://lnkd.in/gt_jTyPX",
  postedDate: "2026-05-03"
},
      {
  id: "vqcodes-flutter-developer-2026-vf",
  title: "Flutter Developer",
  company: "VQCodes Software Solutions",
  category: "IT",
  jobType: "Walk-in",
  location: "Mohali",
  experience: "1 - 4 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Flutter",
    "Dart",
    "Mobile App Development",
    "API Integration",
    "UI Design"
  ],
  responsibilities: [
    "Develop mobile applications",
    "Integrate APIs",
    "Design UI components",
    "Maintain app performance"
  ],
  requirements: [
    "Experience in Flutter & Dart",
    "Knowledge of Android/iOS",
    "Good problem-solving skills"
  ],
  certifications: [],
  benefits: [
    "Walk-in opportunity",
    "Tech growth",
    "Hands-on projects"
  ],
  applyLink: "mailto:hr@vqcodes.com",
  postedDate: "2026-05-03"
},
{
  id: "punjab-psssb-warder-matron-2026-pb",
  title: "Warder & Matron",
  company: "Punjab PSSSB",
  category: "Government",
  jobType: "Full-Time",
  location: "Punjab",
  experience: "Freshers",
  qualification: "12th Pass",
  salary: "₹19,900 – ₹63,200",
  skills: [
    "Physical Fitness",
    "Security Management",
    "Discipline"
  ],
  responsibilities: [
    "Maintain prison security",
    "Monitor inmates",
    "Ensure safety protocols"
  ],
  requirements: [
    "12th pass",
    "Physical eligibility"
  ],
  certifications: [],
  benefits: [
    "Government job",
    "Job security",
    "Stable income"
  ],
  applyLink: "https://govtjobsalert.in/punjab-psssb-warder-matron-recruitment-2026/",
  postedDate: "2026-05-03"
},
{
  id: "wns-mega-walkin-nonit-2026-wmwn",
  title: "Backend Operations / Data Entry",
  company: "WNS Holdings",
  category: "Non-IT",
  jobType: "Walk-in",
  location: "Pune (Viman Nagar)",
  experience: "Freshers",
  qualification: "Non-IT Graduates",
  salary: "Not Disclosed",
  skills: [
    "Backend Operations",
    "Data Entry",
    "Communication"
  ],
  responsibilities: [
    "Handle backend operations",
    "Perform data entry tasks",
    "Support business processes"
  ],
  requirements: [
    "Graduate (Non-IT)",
    "Good communication skills",
    "Available for walk-in"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Walk-in hiring",
    "Quick joining"
  ],
  applyLink: "https://www.naukri.com/job-listings-mega-walk-in-non-it-graduates-wns-holdings-pune-0-to-0-years-300426039924",
  postedDate: "2026-05-03"
},

{
  id: "unstop-platform-2026-2",
  title: "Multiple Roles (Job Portal)",
  company: "Unstop",
  category: "IT",
  jobType: "Full-Time / Internship",
  location: "India",
  experience: "Freshers",
  qualification: "Any Graduate",
  salary: "Not Disclosed",
  skills: [
    "Finance",
    "Data Analysis",
    "Banking",
    "Communication"
  ],
  responsibilities: [
    "Apply for jobs",
    "Explore internships",
    "Participate in hiring drives"
  ],
  requirements: [
    "Active job seeker",
    "Basic domain knowledge"
  ],
  certifications: [],
  benefits: [
    "Multiple opportunities",
    "Fresher friendly",
    "Better HR response"
  ],
  applyLink: "https://unstop.gotrackier.io/click?campaign_id=386&pub_id=95&source=VG15",
  postedDate: "2026-05-03"
},
{
  id: "wns-associate-operations-2026",
  title: "Associate Operations",
  company: "WNS (Capgemini)",
  category: "Non-IT",
  jobType: "Full-Time",
  location: "Pune",
  experience: "Freshers",
  qualification: "BBA, BA, BCom, MA, MCom, BPharm",
  salary: "Not Disclosed",
  skills: [
    "Communication",
    "Adaptability",
    "Operations Support"
  ],
  responsibilities: [
    "Handle operations tasks",
    "Support business processes",
    "Work in rotational shifts"
  ],
  requirements: [
    "Graduate (Non-Tech)",
    "Immediate joiner",
    "Pune-based candidates only"
  ],
  certifications: [],
  benefits: [
    "Global exposure",
    "Career growth",
    "Learning opportunities"
  ],
  applyLink: "mailto:aarti.kulkarni2@wns.com",
  postedDate: "2026-05-03"
},
{
  id: "blackrock-data-analyst-2026",
  title: "Analyst, Data Management",
  company: "BlackRock",
  category: "IT",
  jobType: "Full-Time",
  location: "Bengaluru",
  experience: "Entry Level",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Data Analysis",
    "Excel",
    "Data Management"
  ],
  responsibilities: [
    "Manage datasets",
    "Analyze data",
    "Support business teams"
  ],
  requirements: [
    "Relevant degree",
    "Analytical skills"
  ],
  certifications: [],
  benefits: [
    "Top MNC",
    "Career growth",
    "Learning exposure"
  ],
  applyLink: "https://careers.blackrock.com/job/bengaluru/analyst-data-management/45831/94523644896",
  postedDate: "2026-05-03"
},
{
  id: "fullstack-intern-nerowink-2026",
  title: "Full Stack Developer Intern",
  company: "Nerowink",
  category: "IT",
  jobType: "Internship",
  location: "India",
  experience: "Freshers",
  qualification: "Students / Graduates",
  salary: "Paid Internship",
  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "Backend Basics"
  ],
  responsibilities: [
    "Develop web applications",
    "Work on real projects",
    "Collaborate with team"
  ],
  requirements: [
    "Basic frontend & backend knowledge",
    "Willingness to learn"
  ],
  certifications: [],
  benefits: [
    "Stipend",
    "Internship certificate",
    "PPO opportunity"
  ],
  applyLink: "mailto:nerowink@gmail.com",
  postedDate: "2026-05-03"
},

{
  id: "soc-manager-yash-2026",
  title: "SOC Manager",
  company: "Yash Technologies",
  category: "IT",
  jobType: "Full-Time",
  location: "Pune / Indore",
  experience: "10+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Cybersecurity",
    "SIEM",
    "Azure Sentinel",
    "Incident Response",
    "SOAR"
  ],
  responsibilities: [
    "Lead SOC team",
    "Manage security incidents",
    "Define SOC processes",
    "Handle escalations"
  ],
  requirements: [
    "10+ years cybersecurity experience",
    "SOC leadership experience",
    "Immediate joiner preferred"
  ],
  certifications: [],
  benefits: [
    "Leadership role",
    "Enterprise exposure",
    "High responsibility"
  ],
  applyLink: "mailto:nikhil.panchal@yash.com",
  postedDate: "2026-05-02"
},
{
  id: "akamai-business-analyst-2026",
  title: "Associate Business Systems Analyst",
  company: "Akamai",
  category: "IT",
  jobType: "Full-Time",
  location: "Bengaluru",
  experience: "1 - 3 Years",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Business Analysis",
    "CRM",
    "Salesforce",
    "Agile",
    "JIRA"
  ],
  responsibilities: [
    "Analyze business requirements",
    "Work with stakeholders",
    "Support ERP/CRM systems"
  ],
  requirements: [
    "1-3 years experience",
    "Knowledge of SDLC",
    "CRM exposure"
  ],
  certifications: [],
  benefits: [
    "Global company",
    "Career growth",
    "Tech exposure"
  ],
  applyLink: "https://fa-extu-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/jobs/preview/2260/",
  postedDate: "2026-05-02"
},
{
  id: "rinovea-angular-node-2026",
  title: "Software Developer (Angular + Node.js)",
  company: "Rinovea Technologies",
  category: "IT",
  jobType: "Full-Time",
  location: "Pune",
  experience: "Experienced",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Angular",
    "Node.js",
    "RxJS",
    "NgRx"
  ],
  responsibilities: [
    "Develop scalable applications",
    "Work on frontend & backend",
    "Build real-world products"
  ],
  requirements: [
    "Strong Angular + Node.js",
    "Immediate joiner preferred"
  ],
  certifications: [],
  benefits: [
    "Product-based work",
    "Career growth",
    "Hands-on development"
  ],
  applyLink: "mailto:hr@rinovea.com",
  postedDate: "2026-05-02"
},
{
  id: "gainwell-aws-engineer-2026",
  title: "AWS Cloud Engineer",
  company: "Gainwell Technologies",
  category: "IT",
  jobType: "Full-Time",
  location: "Bangalore",
  experience: "10+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "AWS",
    "Terraform",
    "CI/CD",
    "Linux",
    "Cloud Architecture"
  ],
  responsibilities: [
    "Design cloud infrastructure",
    "Deploy AWS solutions",
    "Monitor systems",
    "Implement CI/CD pipelines"
  ],
  requirements: [
    "10+ years IT experience",
    "4+ years cloud experience",
    "AWS knowledge"
  ],
  certifications: [
    "AWS Certification"
  ],
  benefits: [
    "Enterprise exposure",
    "Cloud expertise",
    "Career growth"
  ],
  applyLink: "https://jobs.gainwelltechnologies.com/job/Bangalore-AWS-Cloud-Engineer-KA-560100/1369009500/",
  postedDate: "2026-05-02"
},
{
  id: "dotnet-developer-scloud-2026",
  title: ".NET Developer",
  company: "SCloud",
  category: "IT",
  jobType: "Full-Time",
  location: "Pune",
  experience: "2 - 3 Years",
  qualification: "Bachelor’s Degree",
  salary: "₹6 - 10 LPA",
  skills: [
    ".NET",
    "C#",
    "Web Development"
  ],
  responsibilities: [
    "Develop applications",
    "Maintain codebase",
    "Fix bugs"
  ],
  requirements: [
    "2+ years experience",
    "Immediate joiner"
  ],
  certifications: [],
  benefits: [
    "Good salary",
    "Growth",
    "Learning"
  ],
  applyLink: "mailto:Contactus@scloudin.in",
  postedDate: "2026-05-02"
},
{
  id: "cognizant-databricks-architect-2026",
  title: "Databricks Solution Architect",
  company: "Cognizant",
  category: "IT",
  jobType: "Full-Time",
  location: "Chennai",
  experience: "Experienced",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Databricks",
    "Cloud",
    "Data Architecture",
    "AWS",
    "Azure"
  ],
  responsibilities: [
    "Design data solutions",
    "Lead architecture discussions",
    "Drive cloud migration"
  ],
  requirements: [
    "Strong Databricks experience",
    "Cloud expertise"
  ],
  certifications: [],
  benefits: [
    "Leadership role",
    "High impact",
    "Career growth"
  ],
  applyLink: "https://careers.cognizant.com/global-en/jobs/00066927831/databricks-solution-architect/",
  postedDate: "2026-05-02"
},
{
  id: "software-dev-manager-2026",
  title: "Software Development Manager",
  company: "Archelos Tech",
  category: "IT",
  jobType: "Full-Time",
  location: "Bangalore / Noida",
  experience: "8+ Years",
  qualification: "Bachelor’s Degree",
  salary: "₹35 - 38 LPA",
  skills: [
    "Java",
    "Microservices",
    "AWS",
    "Kafka",
    "Team Management"
  ],
  responsibilities: [
    "Lead development team",
    "Build scalable systems",
    "Manage projects"
  ],
  requirements: [
    "8+ years experience",
    "Team handling"
  ],
  certifications: [],
  benefits: [
    "High salary",
    "Leadership role",
    "Hybrid work"
  ],
  applyLink: "mailto:jobs@archelostech.com",
  postedDate: "2026-05-02"
},
{
  id: "zycus-it-intern-2026",
  title: "ITIS Intern (AI Operations)",
  company: "Zycus",
  category: "IT",
  jobType: "Internship",
  location: "Bangalore",
  experience: "0 - 1 Years",
  qualification: "BE/BTech",
  salary: "Not Disclosed",
  skills: [
    "AI Tools",
    "IT Support",
    "Automation",
    "Networking"
  ],
  responsibilities: [
    "Support IT systems",
    "Use AI tools",
    "Automate tasks"
  ],
  requirements: [
    "Basic IT knowledge",
    "Interest in AI"
  ],
  certifications: [],
  benefits: [
    "AI exposure",
    "Internship",
    "Learning"
  ],
  applyLink: "https://zycus.talismatic.com/jobs/JJZBRUPTF",
  postedDate: "2026-05-02"
},
{
  id: "cloud-destinations-fresher-2026",
  title: "Software/Data Engineering Roles",
  company: "Cloud Destinations",
  category: "IT",
  jobType: "Full-Time",
  location: "Chennai / Coimbatore",
  experience: "0 - 1 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Software Engineering",
    "Data Engineering",
    "Problem Solving"
  ],
  responsibilities: [
    "Develop systems",
    "Work on data pipelines",
    "Collaborate in teams"
  ],
  requirements: [
    "Willingness to learn",
    "Curiosity"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Learning environment",
    "Growth"
  ],
  applyLink: "mailto:careers@clouddestinations.com",
  postedDate: "2026-05-02"
},
{
  id: "visa-ai-engineer-2026",
  title: "Senior AI Engineer",
  company: "Visa",
  category: "IT",
  jobType: "Full-Time",
  location: "Bengaluru",
  experience: "5+ Years",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "AI/ML",
    "GenAI",
    "LLMs",
    "Python",
    "Cloud"
  ],
  responsibilities: [
    "Build AI systems",
    "Develop ML models",
    "Lead AI initiatives"
  ],
  requirements: [
    "5+ years experience",
    "AI expertise"
  ],
  certifications: [],
  benefits: [
    "Top company",
    "High impact",
    "Innovation"
  ],
  applyLink: "https://www.visa.com/careers",
  postedDate: "2026-05-02"
},
{
  id: "cisco-software-engineer-2026",
  title: "Software Engineer",
  company: "Cisco",
  category: "IT",
  jobType: "Full-Time",
  location: "Hyderabad / Bangalore",
  experience: "0 - 1 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Programming",
    "Networking",
    "Problem Solving"
  ],
  responsibilities: [
    "Develop software",
    "Test applications",
    "Collaborate"
  ],
  requirements: [
    "Basic coding knowledge"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "MNC",
    "Career growth"
  ],
  applyLink: "https://careers.cisco.com/global/en/job/2011632/Software-Engineer",
  postedDate: "2026-05-02"
},
{
  id: "spglobal-data-analyst-2026",
  title: "Data Analyst",
  company: "S&P Global",
  category: "IT",
  jobType: "Full-Time",
  location: "Ahmedabad / Gurgaon / Hyderabad",
  experience: "Freshers / Experienced",
  qualification: "MBA / M.Com",
  salary: "Not Disclosed",
  skills: [
    "Data Analysis",
    "Excel",
    "SQL"
  ],
  responsibilities: [
    "Analyze data",
    "Generate reports",
    "Support business decisions"
  ],
  requirements: [
    "Relevant degree",
    "Analytical skills"
  ],
  certifications: [],
  benefits: [
    "Global exposure",
    "Growth",
    "Learning"
  ],
  applyLink: "https://careers.spglobal.com/jobs/326641",
  postedDate: "2026-05-02"
},
{
  id: "amc-fireman-2026",
  title: "Sahayak Fireman",
  company: "AMC",
  category: "Government",
  jobType: "Full-Time",
  location: "India",
  experience: "Freshers",
  qualification: "10th Pass",
  salary: "₹19,900 – ₹63,200",
  skills: [
    "Physical Fitness",
    "Emergency Response"
  ],
  responsibilities: [
    "Fire safety operations",
    "Emergency handling"
  ],
  requirements: [
    "10th pass"
  ],
  certifications: [],
  benefits: [
    "Government job",
    "Job security"
  ],
  applyLink: "https://govtjobsalert.in/amc-sahayak-fireman-recruitment-2026/",
  postedDate: "2026-05-02"
},
{
  id: "iaf-group-c-2026",
  title: "Group C Civilian",
  company: "Indian Air Force",
  category: "Government",
  jobType: "Full-Time",
  location: "India",
  experience: "Freshers",
  qualification: "10th / 12th",
  salary: "₹19,900 – ₹63,200",
  skills: [
    "Clerical",
    "Typing",
    "Driving"
  ],
  responsibilities: [
    "Office support",
    "Administrative tasks"
  ],
  requirements: [
    "Basic qualification"
  ],
  certifications: [],
  benefits: [
    "Government job",
    "Security"
  ],
  applyLink: "https://govtjobsalert.in/iaf-group-c-civilian-recruitment-2026/",
  postedDate: "2026-05-02"
},

{
  id: "it-support-pune-2026",
  title: "IT Support Executive",
  company: "Confidential IT Company",
  category: "Tech",
  jobType: "Full-Time",
  location: "Pune",
  experience: "Freshers / Entry Level",
  qualification: "Any Graduate",
  salary: "Not Disclosed",
  skills: [
    "MySQL",
    "MS Excel",
    "Networking Basics",
    "Technical Support"
  ],
  responsibilities: [
    "Install software and systems",
    "Train end users",
    "Provide technical support",
    "Travel for client support"
  ],
  requirements: [
    "Basic IT knowledge",
    "Willing to travel (70%)",
    "Good communication skills"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Hands-on IT experience",
    "Field exposure"
  ],
  applyLink: "tel:8411991414",
  postedDate: "2026-05-02"
},
{
  id: "java-developer-optimhire-2026",
  title: "Java Developer",
  company: "OptimHire",
  category: "Tech",
  jobType: "Contract",
  location: "Remote / Hyderabad",
  experience: "5 - 14 Years",
  qualification: "B.E / B.Tech",
  salary: "₹12 - 15 LPA",
  skills: [
    "Java",
    "Microservices",
    "Spring Boot",
    "AWS",
    "NoSQL"
  ],
  responsibilities: [
    "Develop Java-based microservices",
    "Build scalable applications",
    "Work with AWS cloud",
    "Integrate NoSQL databases",
    "Collaborate with teams"
  ],
  requirements: [
    "Strong Java experience",
    "Microservices architecture knowledge",
    "Cloud experience (AWS)"
  ],
  certifications: [],
  benefits: [
    "Remote work",
    "High salary",
    "Long-term contract"
  ],
  applyLink: "https://optimhire.com/developers/jv/309476?ref_code=mukesh-agrawal",
  postedDate: "2026-05-02"
},


{
  id: "cgi-jr-developer-2026",
  title: "Junior Developer",
  company: "CGI",
  category: "Tech",
  jobType: "Full-Time",
  location: "Hyderabad",
  experience: "0 - 1 Years",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Programming",
    "Problem Solving",
    "Software Development Basics"
  ],
  responsibilities: [
    "Develop and maintain applications",
    "Write clean code",
    "Collaborate with teams"
  ],
  requirements: [
    "Relevant degree",
    "Basic coding knowledge"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "MNC exposure",
    "Career growth"
  ],
  applyLink: "https://lnkd.in/gpid7RWb",
  postedDate: "2026-05-02"
},
{
  id: "alcon-software-apprentice-2026",
  title: "Software Engineer Apprentice",
  company: "Alcon",
  category: "Tech",
  jobType: "Apprenticeship",
  location: "India",
  experience: "Entry Level",
  qualification: "Bachelor’s/Graduate Degree",
  salary: "Not Disclosed",
  skills: [
    "Programming",
    "Software Development",
    "Problem Solving"
  ],
  responsibilities: [
    "Assist development team",
    "Work on coding tasks",
    "Learn software engineering practices"
  ],
  requirements: [
    "Graduate degree",
    "Basic technical skills"
  ],
  certifications: [],
  benefits: [
    "Apprenticeship opportunity",
    "Hands-on experience",
    "Learning environment"
  ],
  applyLink: "https://alcon.wd5.myworkdayjobs.com/en-US/careers_alcon/job/Software-Engineer-Apprentices_R-2026-46681",
  postedDate: "2026-05-02"
},
{
  id: "eaton-data-engineering-apprentice-2026",
  title: "Data Engineering Apprentice",
  company: "Eaton",
  category: "Tech",
  jobType: "Apprenticeship",
  location: "India",
  experience: "Freshers",
  qualification: "Graduate/Undergraduate Degree",
  salary: "Not Disclosed",
  skills: [
    "Data Engineering",
    "SQL",
    "Python",
    "Data Analysis"
  ],
  responsibilities: [
    "Assist in data pipelines",
    "Work with datasets",
    "Support engineering team"
  ],
  requirements: [
    "Basic data knowledge",
    "Willingness to learn"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Industry exposure",
    "Career growth"
  ],
  applyLink: "https://eaton.eightfold.ai/careers/job/687236453778?domain=eaton.com&hl=en",
  postedDate: "2026-05-02"
},

{
  id: "unstop-platform-2026",
  title: "Multiple Roles (Job Portal)",
  company: "Unstop",
  category: "Mixed",
  jobType: "Full-Time / Internship",
  location: "India",
  experience: "Freshers",
  qualification: "Any Graduate",
  salary: "Not Disclosed",
  skills: [
    "Finance",
    "Data Analysis",
    "Banking",
    "Communication"
  ],
  responsibilities: [
    "Apply for relevant roles",
    "Participate in hiring drives",
    "Explore internships"
  ],
  requirements: [
    "Active job seeker",
    "Basic domain knowledge"
  ],
  certifications: [],
  benefits: [
    "Multiple opportunities",
    "Fresher friendly",
    "Better HR response"
  ],
  applyLink: "https://unstop.gotrackier.io/click?campaign_id=386&pub_id=95&source=VG15",
  postedDate: "2026-05-02"
},
{
  id: "candorworks-research-analyst-2026",
  title: "Research Analyst (Level 1)",
  company: "Candorworks",
  category: "Non-Tech",
  jobType: "Full-Time",
  location: "Pune",
  experience: "Freshers",
  qualification: "Any Graduation",
  salary: "₹22,000 CTC",
  skills: [
    "MS Excel",
    "Data Research",
    "Communication"
  ],
  responsibilities: [
    "Conduct research",
    "Generate leads",
    "Manage data"
  ],
  requirements: [
    "Good Excel skills",
    "Good communication"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Incentives",
    "Career start in research"
  ],
  applyLink: "mailto:shrawani.borhade@candorworks.com",
  postedDate: "2026-05-02"
},
{
  id: "ey-business-consulting-analyst-2026",
  title: "Analyst - Business Consulting",
  company: "Ernst & Young (EY)",
  category: "Non-Tech",
  jobType: "Full-Time",
  location: "Mumbai",
  experience: "1 - 6 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Business Transformation",
    "Consulting",
    "Analysis"
  ],
  responsibilities: [
    "Support consulting projects",
    "Analyze business data",
    "Work with stakeholders"
  ],
  requirements: [
    "Relevant experience",
    "Analytical mindset"
  ],
  certifications: [],
  benefits: [
    "Top consulting firm",
    "Career growth",
    "Exposure"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146270929",
  postedDate: "2026-05-02"
},
{
  id: "zeiss-supply-chain-lead-2026",
  title: "Lead - Supply Chain Project Management",
  company: "ZEISS",
  category: "Non-Tech",
  jobType: "Full-Time",
  location: "Bengaluru",
  experience: "3 - 5 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Supply Chain",
    "Project Management",
    "Demand Planning"
  ],
  responsibilities: [
    "Manage supply chain projects",
    "Plan demand",
    "Coordinate teams"
  ],
  requirements: [
    "3+ years experience",
    "Project management skills"
  ],
  certifications: [],
  benefits: [
    "Global company",
    "Leadership role",
    "Growth"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146439363",
  postedDate: "2026-05-02"
},
{
  id: "hitachi-energy-project-role-2026",
  title: "Energy System Project Management",
  company: "Hitachi Energy",
  category: "Tech",
  jobType: "Full-Time",
  location: "Bengaluru",
  experience: "Freshers",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Supply Chain",
    "Risk Management",
    "Project Management"
  ],
  responsibilities: [
    "Support project execution",
    "Analyze systems",
    "Assist operations"
  ],
  requirements: [
    "Basic technical knowledge",
    "Analytical skills"
  ],
  certifications: [],
  benefits: [
    "Fresher opportunity",
    "Global exposure",
    "Learning"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146433145",
  postedDate: "2026-05-02"
},
{
  id: "mphasis-tech-support-2026",
  title: "Technical Support Engineer",
  company: "Mphasis",
  category: "Tech",
  jobType: "Full-Time",
  location: "Pune",
  experience: "Freshers",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "ServiceNow",
    "Windows",
    "Ticketing Tools",
    "Troubleshooting"
  ],
  responsibilities: [
    "Resolve tickets",
    "Provide tech support",
    "Handle incidents"
  ],
  requirements: [
    "Basic IT knowledge",
    "Good communication"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "IT exposure",
    "Learning"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146112929",
  postedDate: "2026-05-02"
},
{
  id: "upgrad-tech-support-2026",
  title: "Technical Support Engineer",
  company: "upGrad",
  category: "Tech",
  jobType: "Full-Time",
  location: "Pune",
  experience: "1 - 4 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "SQL",
    "Python",
    "APIs",
    "Docker",
    "Cloud"
  ],
  responsibilities: [
    "Support SaaS systems",
    "Debug issues",
    "Assist customers"
  ],
  requirements: [
    "1+ year experience",
    "Technical background"
  ],
  certifications: [],
  benefits: [
    "Tech exposure",
    "Growth",
    "Learning"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146097383",
  postedDate: "2026-05-02"
},
{
  id: "bairesdev-java-support-2026",
  title: "Java Technical Support Engineer",
  company: "BairesDev",
  category: "Tech",
  jobType: "Remote",
  location: "India",
  experience: "Freshers",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Java",
    "Technical Support",
    "Incident Handling"
  ],
  responsibilities: [
    "Support Java applications",
    "Handle incidents",
    "Troubleshoot issues"
  ],
  requirements: [
    "Java knowledge",
    "Problem-solving skills"
  ],
  certifications: [],
  benefits: [
    "Remote work",
    "Global exposure",
    "Fresher friendly"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146432517",
  postedDate: "2026-05-02"
},
{
  id: "agilegrid-tech-support-2026",
  title: "Technical Support Engineer",
  company: "AgileGrid",
  category: "Tech",
  jobType: "Full-Time",
  location: "India",
  experience: "2 - 4 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "AWS",
    "Azure",
    "Technical Support"
  ],
  responsibilities: [
    "Provide cloud support",
    "Handle incidents",
    "Maintain systems"
  ],
  requirements: [
    "2+ years experience",
    "Cloud knowledge"
  ],
  certifications: [],
  benefits: [
    "Cloud exposure",
    "Career growth",
    "Good learning"
  ],
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=146442567",
  postedDate: "2026-05-02"
},
{
  id: "mpesb-hospital-assistant-2026",
  title: "Hospital Assistant",
  company: "MPESB",
  category: "Government",
  jobType: "Full-Time",
  location: "Madhya Pradesh",
  experience: "Freshers",
  qualification: "10th Pass",
  salary: "₹15,500 – ₹49,000",
  skills: [
    "Basic Healthcare Support",
    "Communication",
    "Patient Assistance"
  ],
  responsibilities: [
    "Assist hospital staff",
    "Support patient care",
    "Maintain records"
  ],
  requirements: [
    "10th pass",
    "Basic communication skills"
  ],
  certifications: [],
  benefits: [
    "Government job",
    "Stable career",
    "Good salary range"
  ],
  applyLink: "https://govtjobsalert.in/mpesb-hospital-assistant-recruitment-2026/",
  postedDate: "2026-05-02"
},
{
  id: "rssb-teaching-associate-2026",
  title: "Teaching Associate",
  company: "RSSB",
  category: "Government",
  jobType: "Full-Time",
  location: "Rajasthan",
  experience: "Freshers / Experienced",
  qualification: "Master's + NET / Ph.D",
  salary: "₹28,850",
  skills: [
    "Teaching",
    "Subject Knowledge",
    "Communication"
  ],
  responsibilities: [
    "Teach students",
    "Prepare study materials",
    "Conduct assessments"
  ],
  requirements: [
    "Master's degree",
    "NET or PhD qualification"
  ],
  certifications: [
    "NET",
    "PhD"
  ],
  benefits: [
    "Government job",
    "Teaching career",
    "Job security"
  ],
  applyLink: "https://govtjobsalert.in/rssb-teaching-associate-recruitment-2026/",
  postedDate: "2026-05-02"
},
{
  id: "icsil-deo-mts-2026",
  title: "DEO & MTS",
  company: "ICSIL",
  category: "Government",
  jobType: "Walk-in",
  location: "Delhi",
  experience: "Freshers",
  qualification: "10th Pass / Graduate",
  salary: "₹24,356 (DEO) / ₹22,411 (MTS)",
  skills: [
    "Data Entry",
    "Computer Knowledge",
    "Basic Administration"
  ],
  responsibilities: [
    "Perform data entry tasks",
    "Assist office operations",
    "Maintain records"
  ],
  requirements: [
    "Basic computer skills",
    "Eligible qualification"
  ],
  certifications: [],
  benefits: [
    "Government opportunity",
    "Walk-in hiring",
    "Quick joining"
  ],
  applyLink: "https://govtjobsalert.in/icsil-deo-and-mts-recruitment-2026/",
  postedDate: "2026-05-02"
},






{
  id: "payu-business-analyst-2026",
  title: "Business Analyst",
  company: "PayU",
  category: "Non-Tech",
  jobType: "Full-Time",
  location: "Gurgaon",
  experience: "Freshers",
  qualification: "Bachelor's Degree",
  salary: "Not Disclosed",
  skills: [
    "Data Analysis",
    "Communication",
    "Problem Solving"
  ],
  responsibilities: [
    "Analyze business requirements",
    "Work with stakeholders",
    "Prepare reports and insights"
  ],
  requirements: [
    "Bachelor's degree",
    "Strong analytical skills"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Corporate exposure",
    "Career growth"
  ],
  applyLink: "https://careers.payu.in/PayU/job/Gurgaon-Business-Analyst/4043480/",
  postedDate: "2026-05-02"
},
{
  id: "oracle-software-developer-2026",
  title: "Software Developer 1",
  company: "Oracle",
  category: "Tech",
  jobType: "Full-Time",
  location: "Bengaluru / Hyderabad",
  experience: "0 - 2 Years",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Java",
    "SQL",
    "Problem Solving",
    "Data Structures"
  ],
  responsibilities: [
    "Develop software applications",
    "Write clean code",
    "Collaborate with teams"
  ],
  requirements: [
    "Degree in relevant field",
    "Basic programming knowledge"
  ],
  certifications: [],
  benefits: [
    "Top MNC",
    "Learning opportunities",
    "Growth career path"
  ],
  applyLink: "https://careers.oracle.com/en/sites/jobsearch/jobs/preview/321672/?keyword=Software+Developer+1&location=India&locationId=300000000106947",
  postedDate: "2026-05-02"
},
{
  id: "wipro-trainee-2026",
  title: "Trainee",
  company: "Wipro",
  category: "Tech",
  jobType: "Full-Time",
  location: "Gurugram",
  experience: "Freshers",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Basic Programming",
    "Communication",
    "Analytical Skills"
  ],
  responsibilities: [
    "Assist in project tasks",
    "Learn new technologies",
    "Support development teams"
  ],
  requirements: [
    "Graduate/Postgraduate",
    "Willingness to learn"
  ],
  certifications: [],
  benefits: [
    "Fresher friendly",
    "Training programs",
    "MNC exposure"
  ],
  applyLink: "https://careers.wipro.com/job/TRAINEE/165563-en_US",
  postedDate: "2026-05-02"
},
{
  id: "tiaa-associate-director-2026",
  title: "Associate Director - Full Stack Development",
  company: "TIAA Global",
  category: "Tech",
  jobType: "Full-Time",
  location: "Pune (Hybrid)",
  experience: "8+ Years",
  qualification: "Bachelor’s/Master’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Java",
    "Spring Boot",
    "React",
    "SQL",
    "Kafka",
    "CI/CD"
  ],
  responsibilities: [
    "Lead full stack development",
    "Design scalable applications",
    "Mentor team members"
  ],
  requirements: [
    "8+ years experience",
    "Strong backend & frontend skills"
  ],
  certifications: [],
  benefits: [
    "Leadership role",
    "Hybrid work",
    "High growth"
  ],
  applyLink: "https://tiaa.wd1.myworkdayjobs.com/en-US/Search/details/Associate-Director---Full-Stack-Development---IN_R251100359?Country=c4f78be1a8f14da0ab49ce1162348a5e",
  postedDate: "2026-05-01"
},
{
  id: "extentia-dotnet-fullstack-2026",
  title: ".NET Fullstack Developer",
  company: "Extentia",
  category: "Tech",
  jobType: "Full-Time",
  location: "India",
  experience: "6+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    "Next.js",
    ".NET Core",
    "React",
    "SQL",
    "Docker",
    "Azure"
  ],
  responsibilities: [
    "Develop full stack applications",
    "Build APIs",
    "Optimize performance"
  ],
  requirements: [
    "6+ years experience",
    "Strong frontend and backend knowledge"
  ],
  certifications: [],
  benefits: [
    "Remote flexibility",
    "Tech growth",
    "Advanced projects"
  ],
  applyLink: "https://www.extentia.com/job/net-fullstack-developer/",
  postedDate: "2026-05-02"
},
{
  id: "delivery-manager-noida-2026",
  title: "Delivery Manager",
  company: "Delphic",
  category: "Tech",
  jobType: "Full-Time",
  location: "Noida",
  experience: "12+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [
    ".NET",
    "PHP",
    "AWS",
    "Agile",
    "CI/CD"
  ],
  responsibilities: [
    "Manage delivery lifecycle",
    "Lead teams",
    "Handle stakeholders"
  ],
  requirements: [
    "12+ years experience",
    "Strong leadership skills"
  ],
  certifications: [],
  benefits: [
    "Leadership role",
    "Enterprise exposure",
    "High responsibility"
  ],
  applyLink: "mailto:prashant.hada@delphic.in",
  postedDate: "2026-05-02"
},


{
    id: "vqcodes-flutter-2026",
    title: "Flutter Developer",
    company: "VQCodes Software Solutions LLP",
    category: "IT",
    jobType: "Full-Time",
    location: "Mohali Phase 8B",
    experience: "1–4 Years",
    interviewMode: "Face-to-Face",
    applyLink: "mailto:hr@vqcodes.com",
    contactLink: "tel:7743072137",
    postedDate: "2026-05-01"
  },

  {
    id: "kyzer-support-2026",
    title: "Product & Application Support",
    company: "Kyzer Software",
    category: "IT ",
    jobType: "Full-Time",
    location: "Mumbai",
    eligibility: ["B.E Computer", "BCA", "MCA", "Fresher/Experienced"],
    skills: [
      "Linux (RHEL)", "Windows OS", "SQL", "Java Basics",
      "Shell Scripting", "Apache", "Tomcat", "JBoss",
      "Postman", "API (JSON/XML)"
    ],
    responsibilities: [
      "Server configuration",
      "Application configuration",
      "SQL queries",
      "Debug logs",
      "Root cause analysis"
    ],
    applyLink: "https://unstop.com/o/9Lzh1H4?lb=Bnie7Jo",
    postedDate: "2026-05-01"
  },

  {
    id: "dotnet-wfh-2026",
    title: ".NET Core Developer",
    company: "Aastra Tech",
    category: "IT ",
    jobType: "Work From Home",
    experience: "3–5 Years",
    skills: [
      "C#", ".NET Core", "ASP.NET MVC", "Web API",
      "SQL Server", "Entity Framework", "Azure",
      "Git", "REST APIs"
    ],
    responsibilities: [
      "Full stack development",
      "API integration",
      "Database management",
      "Azure deployment",
      "Agile workflow"
    ],
    applyLink: "mailto:preethib@aastratech.com",
    postedDate: "2026-05-01"
  },

  {
    id: "frugality-cyber-intern-2026",
    title: "Cybersecurity Intern",
    company: "Frugality Fintech",
    category: "IT",
    jobType: "Internship",
    location: "Pune (Hybrid)",
    duration: "3 Months",
    stipend: "₹5000 - ₹8000/month",
    skills: [
      "Kali Linux", "Burp Suite", "Wireshark", "Nmap",
      "OWASP Top 10", "Python", "Bash", "AWS/GCP"
    ],
    responsibilities: [
      "Vulnerability analysis",
      "Security monitoring",
      "Log analysis",
      "Secure authentication",
      "Audit documentation"
    ],
    applyLink: "https://abekus.ai/public-job-search/cybersecurity-intern-1?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-05-01"
  },

  {
    id: "abap-dev-remote-2026",
    title: "ABAP Application Developer",
    company: "Bizware International",
    category: "IT",
    jobType: "Remote",
    experience: "5+ Years",
    skills: ["ABAP", "ODATA", "AMDP", "SAPUI5", "Fiori"],
    responsibilities: [
      "SAP development",
      "Bug fixing",
      "Enhancements",
      "Documentation",
      "Customer support"
    ],
    applyLink: "mailto:recruitment@bizwareinternational.com",
    postedDate: "2026-05-01"
  },

  {
    id: "drdo-dlrl-intern-2026",
    title: "DRDO DLRL Internship",
    company: "DRDO",
    category: "Government ",
    jobType: "Internship",
    stipend: "₹30,000 (Total)",
    eligibility: "Pre-final year B.E/B.Tech",
    applyLink: "https://govtjobsalert.in/drdo-dlrl-hyderabad-internship-2026/",
    postedDate: "2026-05-01"
  },

  {
    id: "rrb-ntpc-mock-2026",
    title: "RRB NTPC UG Mock Test",
    company: "Indian Railways (RRB)",
    category: "Government",
    type: "Mock Test",
    examDates: ["2026-05-07", "2026-05-08", "2026-05-09"],
    applyLink: "https://govtjobsalert.in/rrb-ntpc-under-graduate-level-recruitment-2025/",
    postedDate: "2026-05-01"
  },

  {
    id: "infosys-spde-2026",
    title: "Specialist Programmer / DSE",
    company: "Infosys",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "2026 Batch Freshers",
    salary: "₹6.25L – ₹21L",
    skills: ["DSA", "Programming", "Problem Solving"],
    applyLink: "https://surveys.infosysapps.com/r/a/SPOffCampusregistration_apr26",
    postedDate: "2026-05-01"
  },

  // =========================
  // 1. INFOSYS OFF CAMPUS
  // =========================
  {
    id: "infosys-offcampus-2026",
    title: "Specialist Programmer / Digital Specialist Engineer",
    company: "Infosys",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "Freshers (2026 Batch)",
    qualification: "BE/BTech, ME/MTech, MCA, MSc",
    salary: "₹6.25L – ₹21L",
    skills: [
      "Programming",
      "Data Structures",
      "Algorithms",
      "Problem Solving"
    ],
    responsibilities: [
      "Develop software solutions",
      "Work on enterprise applications",
      "Collaborate with teams"
    ],
    requirements: [
      "2026 batch only",
      "CS/IT & related branches"
    ],
    certifications: [],
    benefits: [
      "High salary packages",
      "MNC exposure",
      "Career growth"
    ],
    applyLink: "https://surveys.infosysapps.com/r/a/SPOffCampusregistration_apr26",
    postedDate: "2026-04-30"
  },

  // =========================
  // 2. SNOWFLAKE - DATA ENGINEER INTERN
  // =========================
  {
    id: "data-engineer-intern-snowflake-2026",
    title: "Data Engineer Intern",
    company: "Snowflake",
    category: "IT",
    jobType: "Internship",
    location: "Pune",
    experience: "Students",
    qualification: "BE/BTech/ME/MTech (Pursuing)",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Data Engineering",
      "SQL",
      "Cloud"
    ],
    responsibilities: [
      "Work on data pipelines",
      "Assist engineering team",
      "Handle data processing tasks"
    ],
    requirements: [
      "Pursuing degree",
      "Basic data knowledge"
    ],
    certifications: [],
    benefits: [
      "Top product company",
      "Internship exposure",
      "Career growth"
    ],
    applyLink: "https://careers.snowflake.com/us/en/job/SNCOUS97879D11040B471CAB908A9497E6D01EEXTERNALENUS8904ED8575D648CFB01B7941677FDE4A/",
    postedDate: "2026-04-30"
  },

  // =========================
  // 3. CEDCOSS - BUSINESS DEVELOPMENT ASSOCIATE
  // =========================
  {
    id: "bda-cedcoss-2026",
    title: "Business Development Associate",
    company: "Cedcoss Technologies",
    category: "Non-Tech",
    jobType: "Full-Time",
    location: "Lucknow",
    experience: "Freshers",
    qualification: "Any Graduate (BBA Preferred)",
    salary: "Not Disclosed",
    skills: [
      "Communication",
      "Sales",
      "Business Development"
    ],
    responsibilities: [
      "Generate leads",
      "Communicate with clients",
      "Support sales process"
    ],
    requirements: [
      "Good communication skills",
      "Immediate joiner preferred"
    ],
    certifications: [],
    benefits: [
      "Fresher friendly",
      "Sales experience",
      "Career growth"
    ],
    applyLink: "https://www.linkedin.com/posts/ekta-verma-8675b014a_hiring-businessdevelopment-bda-share-7455158586587971585-CvY9",
    postedDate: "2026-04-30"
  },


  // =========================
  // 1. WHATMORE - SOFTWARE ENGINEER
  // =========================
  {
    id: "software-engineer-whatmore-2026",
    title: "Software Engineer",
    company: "Whatmore",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore",
    experience: "Freshers (2023–2025)",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving"
    ],
    responsibilities: [
      "Develop software applications",
      "Work with engineering team",
      "Write clean and scalable code"
    ],
    requirements: [
      "Graduate (2023–2025)",
      "Basic coding knowledge"
    ],
    certifications: [],
    benefits: [
      "Fresher opportunity",
      "Tech exposure",
      "Career growth"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4406511896/",
    postedDate: "2026-04-30"
  },

  // =========================
  // 2. DOTPE - FRONTEND DEVELOPER
  // =========================
  {
    id: "frontend-developer-dotpe-2026",
    title: "Frontend Developer",
    company: "DotPe",
    category: "IT",
    jobType: "Full-Time",
    location: "Gurugram",
    experience: "Freshers (2021–2025)",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    responsibilities: [
      "Build UI components",
      "Develop frontend features",
      "Optimize performance"
    ],
    requirements: [
      "Graduate",
      "Frontend knowledge"
    ],
    certifications: [],
    benefits: [
      "Startup exposure",
      "Growth opportunity"
    ],
    applyLink: "https://forms.gle/GpW4TUFVMUWg1naP8",
    postedDate: "2026-04-30"
  },

  // =========================
  // 3. WISDOM AI - ML/NLP INTERN
  // =========================
  {
    id: "ml-nlp-intern-wisdomai-2026",
    title: "NLP / Machine Learning Intern",
    company: "Wisdom AI",
    category: "IT",
    jobType: "Internship",
    location: "Bangalore",
    experience: "Freshers (2027–2028)",
    qualification: "Student",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Machine Learning",
      "NLP",
      "Data Science"
    ],
    responsibilities: [
      "Work on ML models",
      "Assist in NLP projects",
      "Analyze datasets"
    ],
    requirements: [
      "Student (2027–2028)",
      "Basic ML knowledge"
    ],
    certifications: [],
    benefits: [
      "AI domain exposure",
      "Internship experience"
    ],
    applyLink: "https://jobs.ashbyhq.com/Wisdom%20AI/dc2a3764-c02c-4d56-b127-95486299cca3",
    postedDate: "2026-04-30"
  },

  // =========================
  // 1. CGPSC SUB AUDITOR
  // =========================
  {
    id: "cgpsc-sub-auditor-2026",
    title: "Sub Auditor",
    company: "CGPSC (CG Vyapam)",
    category: "Government",
    jobType: "Full-Time",
    location: "Chhattisgarh",
    experience: "Fresher",
    qualification: "Any Graduate",
    salary: "₹25,300 – ₹80,500 / month",
    vacancies: 69,
    skills: [
      "Accounting Basics",
      "Auditing",
      "Analytical Skills"
    ],
    responsibilities: [
      "Assist in auditing processes",
      "Maintain financial records",
      "Support audit reports"
    ],
    requirements: [
      "Graduate degree",
      "Eligibility as per notification"
    ],
    certifications: [],
    benefits: [
      "Government job",
      "Stable career",
      "Good salary"
    ],
    applyLink: "https://govtjobsalert.in/cgpsc-assistant-auditor-recruitment-2026/",
    lastDate: "2026-05-22",
    postedDate: "2026-04-30"
  },

  // =========================
  // 2. GUJARAT METRO NON-EXECUTIVE
  // =========================
  {
    id: "gujarat-metro-non-executive-2026",
    title: "Non-Executive Roles",
    company: "Gujarat Metro (GMRCL)",
    category: "Government",
    jobType: "Full-Time",
    location: "Gujarat",
    experience: "Fresher / Experienced",
    qualification: "Diploma / 10th + ITI",
    salary: "₹20,000 – ₹1,00,000",
    vacancies: 383,
    skills: [
      "Technical Skills",
      "ITI Trade Skills",
      "Basic Engineering Knowledge"
    ],
    responsibilities: [
      "Perform assigned metro operations",
      "Maintenance & technical tasks"
    ],
    requirements: [
      "Diploma or ITI",
      "Eligibility as per role"
    ],
    certifications: [],
    benefits: [
      "Govt job",
      "High vacancies",
      "Career growth"
    ],
    applyLink: "https://govtjobsalert.in/gmrcl-non-executive-recruitment-2026/",
    lastDate: "2026-05-28",
    postedDate: "2026-04-30"
  },

  // =========================
  // 3. CRPF CONSTABLE
  // =========================
  {
    id: "crpf-constable-2026",
    title: "Constable",
    company: "CRPF",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "10th Pass",
    salary: "₹21,700 – ₹69,100",
    vacancies: 9195,
    skills: [
      "Physical Fitness",
      "Discipline",
      "Basic Knowledge"
    ],
    responsibilities: [
      "Security duties",
      "Field operations"
    ],
    requirements: [
      "10th pass",
      "Physical eligibility"
    ],
    certifications: [],
    benefits: [
      "Government job",
      "High vacancy",
      "Job security"
    ],
    applyLink: "https://govtjobsalert.in/crpf-constable-recruitment-2026/",
    lastDate: "2026-05-19",
    postedDate: "2026-04-30"
  },

{
    id: "apprentice-union-bank-india-2026",
    title: "Apprentice",
    company: "Union Bank of India",
    category: "Government",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Fresher",
    qualification: "Any Graduate",
    salary: "₹15,000 – ₹20,000 / month (Stipend)",
    skills: [
      "Banking Basics",
      "Communication",
      "Customer Handling",
      "Clerical Skills"
    ],
    responsibilities: [
      "Assist in banking operations",
      "Handle customer queries",
      "Support branch activities",
      "Learn banking processes"
    ],
    requirements: [
      "Graduate from recognized university",
      "Basic communication skills",
      "Willingness to learn"
    ],
    certifications: [],
    benefits: [
      "Banking experience",
      "Government sector exposure",
      "Skill development"
    ],
    applyLink: "https://govtjobsalert.in/union-bank-of-india-apprentice-recruitment-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-05-19"
  },
{
    id: "devops-platform-engineer-mercor-2026",
    title: "DevOps / Platform Engineer (Expert Network)",
    company: "Mercor",
    category: "IT",
    jobType: "Contract (Remote)",
    location: "Remote",
    experience: "Experienced",
    qualification: "Relevant experience in DevOps / Cloud",
    salary: "$100 / hour",
    skills: [
      "CI/CD",
      "AWS",
      "GCP",
      "Azure",
      "Docker",
      "Kubernetes",
      "DevOps",
      "Cloud Infrastructure"
    ],
    responsibilities: [
      "Work on AI-related DevOps projects",
      "Build and evaluate real-world engineering tasks",
      "Provide domain expertise for AI models",
      "Collaborate remotely on global projects"
    ],
    requirements: [
      "Strong DevOps experience",
      "Cloud and containerization knowledge",
      "Good communication skills",
      "Ability to work independently"
    ],
    certifications: [],
    benefits: [
      "High hourly pay",
      "Remote flexibility",
      "Work with AI companies",
      "Flexible schedule"
    ],
    applyLink: "https://t.mercor.com/cLiEV",
    postedDate: "2026-04-29"
  },

  // =========================
  // 2. SR SOFTWARE DEVELOPER (REACT + .NET)
  // =========================
  {
    id: "sr-software-developer-react-dotnet-2026",
    title: "Senior Software Developer (React + .NET)",
    company: "Confidential",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore (WFO)",
    experience: "5–12 Years",
    qualification: "Bachelor’s Degree in CS/IT",
    salary: "Not Disclosed",
    skills: [
      "React",
      "TypeScript",
      "C#",
      ".NET Core",
      "Microservices",
      "REST APIs",
      "GraphQL",
      "SQL",
      "Docker",
      "Kubernetes"
    ],
    responsibilities: [
      "Develop frontend using React",
      "Build backend with .NET Core",
      "Design scalable microservices",
      "Collaborate with teams",
      "Maintain code quality and performance"
    ],
    requirements: [
      "Strong React + TypeScript experience",
      "Strong backend skills in .NET",
      "Experience in APIs and microservices",
      "Good understanding of design patterns"
    ],
    certifications: [],
    benefits: [
      "Work on modern tech stack",
      "Career growth",
      "Enterprise-level projects"
    ],
    applyLink: "mailto:divyacodechavo@gmail.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 3. QA SPECIALIST - BENGALURU
  // =========================
  {
    id: "qa-specialist-bangalore-2026",
    title: "QA Specialist (OMS / RELEX)",
    company: "Confidential",
    category: "IT",
    jobType: "Full-Time",
    location: "Bengaluru",
    experience: "5+ Years",
    qualification: "B.E / B.Tech",
    salary: "₹6 – ₹23 LPA",
    skills: [
      "QA Automation",
      "RELEX",
      "SQL",
      "CI/CD",
      "JIRA",
      "Agile",
      "Testing",
      "Postman"
    ],
    responsibilities: [
      "Manage testing for OMS systems",
      "Drive automation strategies",
      "Integrate tests into CI/CD pipelines",
      "Handle defect lifecycle",
      "Improve QA processes"
    ],
    requirements: [
      "Strong QA experience",
      "RELEX expertise",
      "SQL knowledge",
      "CI/CD familiarity"
    ],
    certifications: [],
    benefits: [
      "High salary range",
      "Work on supply chain tech",
      "Leadership exposure"
    ],
    applyLink: "https://optimhire.com/developers/jv/309490?ref_code=mukesh-agrawal",
    postedDate: "2026-04-29"
  },

  // =========================
  // 4. AAMBY VALLEY - .NET DEVELOPER
  // =========================
  {
    id: "dotnet-developer-aamby-valley-2026",
    title: ".NET Developer",
    company: "Aamby Valley City",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree in CS/IT",
    salary: "Not Disclosed",
    skills: [
      ".NET",
      "C#",
      "ASP.NET",
      "SQL",
      "MVC",
      "Web API",
      "OOP",
      "Git"
    ],
    responsibilities: [
      "Develop scalable applications",
      "Write clean and efficient code",
      "Debug and optimize systems",
      "Collaborate with teams",
      "Maintain software solutions"
    ],
    requirements: [
      "Strong .NET experience",
      "SQL knowledge",
      "Problem-solving skills",
      "Team collaboration"
    ],
    certifications: [],
    benefits: [
      "Stable development role",
      "Growth opportunities",
      "Enterprise exposure"
    ],
    applyLink: "tel:9970404748",
    postedDate: "2026-04-29"
  },


{
    id: "agniveer-mr-musician-indian-navy-2026",
    title: "Agniveer MR (Musician)",
    company: "Indian Navy",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "10th Pass",
    salary: "₹30,000 – ₹40,000 / month",
    skills: [
      "Musical Skills",
      "Discipline",
      "Teamwork"
    ],
    responsibilities: [
      "Perform as musician in Navy bands",
      "Participate in official ceremonies",
      "Maintain discipline and training"
    ],
    requirements: [
      "10th pass",
      "Musical proficiency",
      "Physical fitness"
    ],
    certifications: [],
    benefits: [
      "Government job benefits",
      "Training and career exposure",
      "Defense service experience"
    ],
    applyLink: "https://govtjobsalert.in/indian-navy-agniveer-mr-musician-recruitment-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-04-30"
  },

  // =========================
  // 2. RBI - GRADE B OFFICER
  // =========================
  {
    id: "rbi-grade-b-officer-2026",
    title: "Grade B Officer",
    company: "Reserve Bank of India (RBI)",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher / Experienced",
    qualification: "Graduate",
    salary: "₹1.16 – ₹1.25 Lakh / month",
    skills: [
      "Finance",
      "Economics",
      "Analytical Skills",
      "Decision Making"
    ],
    responsibilities: [
      "Manage financial systems",
      "Policy implementation",
      "Economic analysis",
      "Regulatory functions"
    ],
    requirements: [
      "Graduate degree",
      "Strong analytical skills",
      "Interest in banking sector"
    ],
    certifications: [],
    benefits: [
      "High salary",
      "Prestigious government role",
      "Job security"
    ],
    applyLink: "https://govtjobsalert.in/rbi-grade-b-recruitment-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-05-20"
  },

  // =========================
  // 3. DRDO - CHESS INTERNSHIP
  // =========================
  {
    id: "drdo-chess-internship-2026",
    title: "Paid Internship (CHESS)",
    company: "DRDO",
    category: "Government Internship",
    jobType: "Internship",
    location: "Hyderabad",
    experience: "Fresher",
    qualification: "Final Year B.E./B.Tech",
    salary: "₹30,000 (Total Stipend)",
    skills: [
      "Engineering Fundamentals",
      "Research",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on defense research projects",
      "Assist in technical development",
      "Support research teams"
    ],
    requirements: [
      "Final year engineering students",
      "Technical knowledge",
      "Interest in R&D"
    ],
    certifications: [],
    benefits: [
      "Work with DRDO scientists",
      "Research exposure",
      "Government internship"
    ],
    applyLink: "https://govtjobsalert.in/drdo-chess-hyderabad-internship-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-05-11"
  },

  // =========================
  // 4. CSIR NEIST - MTS & DRIVER
  // =========================
  {
    id: "csir-neist-mts-driver-2026",
    title: "MTS & Driver",
    company: "CSIR NEIST",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "10th Pass / Matriculation",
    salary: "₹33,375 – ₹36,700 / month",
    skills: [
      "Basic Operations",
      "Driving Skills",
      "Discipline"
    ],
    responsibilities: [
      "Perform assigned duties",
      "Support organizational operations",
      "Maintain discipline"
    ],
    requirements: [
      "10th pass",
      "Valid driving license (for driver)",
      "Basic skills"
    ],
    certifications: [],
    benefits: [
      "Government benefits",
      "Stable job",
      "Career growth"
    ],
    applyLink: "https://govtjobsalert.in/csir-neist-mts-recruitment-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-06-04"
  },

  // =========================
  // 5. IREL - APPRENTICE
  // =========================
  {
    id: "irel-apprentice-2026",
    title: "Apprentice",
    company: "IREL",
    category: "Government",
    jobType: "Apprenticeship",
    location: "India",
    experience: "Fresher",
    qualification: "B.E./B.Tech / Diploma / ITI / Graduate",
    salary: "₹7,700 – ₹9,000 / month",
    skills: [
      "Technical Skills",
      "Learning Ability",
      "Teamwork"
    ],
    responsibilities: [
      "Assist in technical tasks",
      "Learn industry processes",
      "Support operations"
    ],
    requirements: [
      "Relevant qualification",
      "Willingness to learn"
    ],
    certifications: [],
    benefits: [
      "Industry exposure",
      "Skill development",
      "Apprenticeship experience"
    ],
    applyLink: "https://govtjobsalert.in/irel-apprentice-recruitment-2026/",
    postedDate: "2026-04-29"
  },

  // =========================
  // 6. INDIAN AIR FORCE - GROUP C
  // =========================
  {
    id: "iaf-group-c-civilian-2026",
    title: "Group C Civilian (LDC, Typist, Driver)",
    company: "Indian Air Force",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Fresher",
    qualification: "10th / 12th Pass",
    salary: "₹19,900 – ₹63,200 (Level-2)",
    skills: [
      "Clerical Skills",
      "Typing",
      "Driving",
      "Administration"
    ],
    responsibilities: [
      "Clerical and administrative tasks",
      "Typing and documentation",
      "Operational support"
    ],
    requirements: [
      "10th/12th pass",
      "Typing skills (for typist)",
      "Driving license (for driver)"
    ],
    certifications: [],
    benefits: [
      "Government job security",
      "Allowances and benefits",
      "Career growth"
    ],
    applyLink: "https://govtjobsalert.in/iaf-group-c-civilian-recruitment-2026/",
    postedDate: "2026-04-29",
    lastDate: "2026-06-01"
  },

{
    id: "junior-software-engineer-daiviksoft-2026",
    title: "Junior Software Engineer",
    company: "Daiviksoft Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "Kochi",
    experience: "Fresher",
    qualification: "Bachelor’s Degree in Computer Science / IT or related field",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Python",
      "JavaScript",
      "React",
      "SQL",
      "OOP",
      "SDLC",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in developing and maintaining applications",
      "Write clean and reusable code",
      "Debug and troubleshoot issues",
      "Collaborate with development teams",
      "Participate in code reviews"
    ],
    requirements: [
      "Basic knowledge of programming languages",
      "Understanding of OOP and SDLC",
      "Strong analytical skills",
      "Willingness to learn"
    ],
    certifications: [],
    benefits: [
      "Great opportunity for freshers",
      "Hands-on experience",
      "Career growth environment"
    ],
    applyLink: "mailto:Neha@daiviktech.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 2. WIPRO - SUPPORT ENGINEER
  // =========================
  {
    id: "support-engineer-wipro-2026",
    title: "Support Engineer",
    company: "Wipro",
    category: "IT",
    jobType: "Full-Time",
    location: "Bengaluru",
    experience: "0–2 Years",
    qualification: "Bachelor’s Degree in Engineering / IT",
    salary: "Not Disclosed",
    skills: [
      "Application Support",
      "CAD",
      "CAE",
      "Debugging",
      "Troubleshooting",
      "FMEA",
      "Software Testing"
    ],
    responsibilities: [
      "Design and develop solutions based on client requirements",
      "Perform testing and simulations",
      "Troubleshoot and debug systems",
      "Provide customer support and resolve tickets",
      "Maintain documentation and reports"
    ],
    requirements: [
      "Knowledge of application support",
      "Understanding of engineering tools (CAD/CAE)",
      "Problem-solving skills",
      "Ability to work with clients"
    ],
    certifications: [],
    benefits: [
      "Work with global clients",
      "Skill development opportunities",
      "Enterprise-level exposure"
    ],
    applyLink: "https://careers.wipro.com/job/SUPPORT-ENGINEER/164970-en_US",
    postedDate: "2026-04-29"
  },

  // =========================
  // 3. APIDEL TECHNOLOGIES - SOFTWARE DEVELOPER L2
  // =========================
  {
    id: "software-developer-l2-apidel-2026",
    title: "Software Developer (Level 2)",
    company: "Apidel Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "4+ Years",
    qualification: "Computer Science or related degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "React",
      "AWS",
      "Lambda",
      "API Gateway",
      "DynamoDB",
      "Distributed Systems",
      "GenAI",
      "SQL",
      "Linux"
    ],
    responsibilities: [
      "Build AI-enabled solutions",
      "Develop and troubleshoot applications",
      "Design scalable systems using AWS",
      "Work on GenAI integration",
      "Collaborate with cross-functional teams"
    ],
    requirements: [
      "4+ years IT experience",
      "Strong Java and AWS skills",
      "Experience in distributed systems",
      "Immediate availability preferred"
    ],
    certifications: [],
    benefits: [
      "Work on cutting-edge AI projects",
      "Cloud-native development exposure",
      "Growth-focused environment"
    ],
    applyLink: "mailto:Hamna.m@apideltech.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 4. EPSILON CARBON - SENIOR MANAGER TA
  // =========================
  {
    id: "senior-manager-talent-acquisition-epsilon-2026",
    title: "Senior Manager - Talent Acquisition",
    company: "Epsilon Carbon",
    category: "HR",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "12+ Years",
    qualification: "Graduate / Postgraduate in HR or related field",
    salary: "Not Disclosed",
    skills: [
      "Talent Acquisition",
      "Leadership",
      "Recruitment Strategy",
      "Stakeholder Management"
    ],
    responsibilities: [
      "Lead talent acquisition strategies",
      "Manage recruitment teams",
      "Drive hiring processes",
      "Coordinate with stakeholders"
    ],
    requirements: [
      "12+ years experience in HR",
      "Strong leadership skills",
      "Experience in large-scale hiring"
    ],
    certifications: [],
    benefits: [
      "Leadership role",
      "Strategic exposure",
      "High-impact position"
    ],
    applyLink: "mailto:swapna.iyer@epsiloncarbon.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 5. NUTRABAY - GENERAL MANAGER HR
  // =========================
  {
    id: "general-manager-hr-nutrabay-2026",
    title: "General Manager - HR",
    company: "Nutrabay",
    category: "HR",
    jobType: "Full-Time",
    location: "Gurgaon",
    experience: "10+ Years",
    qualification: "Graduate / MBA in HR preferred",
    salary: "Not Disclosed",
    skills: [
      "HR Management",
      "Leadership",
      "Recruitment",
      "Employee Relations"
    ],
    responsibilities: [
      "Oversee HR operations",
      "Develop HR strategies",
      "Manage workforce planning",
      "Improve employee engagement"
    ],
    requirements: [
      "10+ years HR experience",
      "Strong leadership and communication",
      "Strategic mindset"
    ],
    certifications: [],
    benefits: [
      "Leadership opportunity",
      "Organizational impact",
      "Career growth"
    ],
    applyLink: "mailto:gursharan.kaur@nutrabay.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 6. COFORGE - DIRECTOR TALENT ACQUISITION
  // =========================
  {
    id: "director-talent-acquisition-coforge-2026",
    title: "Director - Talent Acquisition (BPO Hiring)",
    company: "Coforge",
    category: "HR",
    jobType: "Full-Time",
    location: "Pune",
    experience: "10+ Years",
    qualification: "Graduate / MBA in HR preferred",
    salary: "Not Disclosed",
    skills: [
      "Talent Acquisition",
      "BPO Hiring",
      "Leadership",
      "Recruitment Strategy"
    ],
    responsibilities: [
      "Lead BPO hiring strategies",
      "Manage recruitment teams",
      "Drive large-scale hiring",
      "Collaborate with leadership"
    ],
    requirements: [
      "10+ years experience",
      "Expertise in BPO hiring",
      "Strong leadership skills"
    ],
    certifications: [],
    benefits: [
      "Senior leadership role",
      "Strategic impact",
      "Growth opportunities"
    ],
    applyLink: "mailto:vrinda.gupta@coforge.com",
    postedDate: "2026-04-29"
  },



  // =========================
  // 1. DAIVIKSOFT - JUNIOR SOFTWARE ENGINEER
  // =========================
  {
    id: "junior-software-engineer-daiviksoft-2026",
    title: "Junior Software Engineer",
    company: "Daiviksoft Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "Kochi",
    experience: "Fresher",
    qualification: "Bachelor’s Degree in Computer Science / IT or related field",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Python",
      "JavaScript",
      "React",
      "SQL",
      "OOP",
      "SDLC",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in developing and maintaining applications",
      "Write clean and reusable code",
      "Debug and troubleshoot issues",
      "Collaborate with development teams",
      "Participate in code reviews"
    ],
    requirements: [
      "Basic knowledge of programming languages",
      "Understanding of OOP and SDLC",
      "Strong analytical skills",
      "Willingness to learn"
    ],
    certifications: [],
    benefits: [
      "Great opportunity for freshers",
      "Hands-on experience",
      "Career growth environment"
    ],
    applyLink: "mailto:Neha@daiviktech.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 2. WIPRO - SUPPORT ENGINEER
  // =========================
  {
    id: "support-engineer-wipro-2026",
    title: "Support Engineer",
    company: "Wipro",
    category: "IT",
    jobType: "Full-Time",
    location: "Bengaluru",
    experience: "0–2 Years",
    qualification: "Bachelor’s Degree in Engineering / IT",
    salary: "Not Disclosed",
    skills: [
      "Application Support",
      "CAD",
      "CAE",
      "Debugging",
      "Troubleshooting",
      "FMEA",
      "Software Testing"
    ],
    responsibilities: [
      "Design and develop solutions based on client requirements",
      "Perform testing and simulations",
      "Troubleshoot and debug systems",
      "Provide customer support and resolve tickets",
      "Maintain documentation and reports"
    ],
    requirements: [
      "Knowledge of application support",
      "Understanding of engineering tools (CAD/CAE)",
      "Problem-solving skills",
      "Ability to work with clients"
    ],
    certifications: [],
    benefits: [
      "Work with global clients",
      "Skill development opportunities",
      "Enterprise-level exposure"
    ],
    applyLink: "https://careers.wipro.com/job/SUPPORT-ENGINEER/164970-en_US",
    postedDate: "2026-04-29"
  },

  // =========================
  // 3. APIDEL TECHNOLOGIES - SOFTWARE DEVELOPER L2
  // =========================
  {
    id: "software-developer-l2-apidel-2026",
    title: "Software Developer (Level 2)",
    company: "Apidel Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "4+ Years",
    qualification: "Computer Science or related degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "React",
      "AWS",
      "Lambda",
      "API Gateway",
      "DynamoDB",
      "Distributed Systems",
      "GenAI",
      "SQL",
      "Linux"
    ],
    responsibilities: [
      "Build AI-enabled solutions",
      "Develop and troubleshoot applications",
      "Design scalable systems using AWS",
      "Work on GenAI integration",
      "Collaborate with cross-functional teams"
    ],
    requirements: [
      "4+ years IT experience",
      "Strong Java and AWS skills",
      "Experience in distributed systems",
      "Immediate availability preferred"
    ],
    certifications: [],
    benefits: [
      "Work on cutting-edge AI projects",
      "Cloud-native development exposure",
      "Growth-focused environment"
    ],
    applyLink: "mailto:Hamna.m@apideltech.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 4. EPSILON CARBON - SENIOR MANAGER TA
  // =========================
  {
    id: "senior-manager-talent-acquisition-epsilon-2026",
    title: "Senior Manager - Talent Acquisition",
    company: "Epsilon Carbon",
    category: "HR",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "12+ Years",
    qualification: "Graduate / Postgraduate in HR or related field",
    salary: "Not Disclosed",
    skills: [
      "Talent Acquisition",
      "Leadership",
      "Recruitment Strategy",
      "Stakeholder Management"
    ],
    responsibilities: [
      "Lead talent acquisition strategies",
      "Manage recruitment teams",
      "Drive hiring processes",
      "Coordinate with stakeholders"
    ],
    requirements: [
      "12+ years experience in HR",
      "Strong leadership skills",
      "Experience in large-scale hiring"
    ],
    certifications: [],
    benefits: [
      "Leadership role",
      "Strategic exposure",
      "High-impact position"
    ],
    applyLink: "mailto:swapna.iyer@epsiloncarbon.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 5. NUTRABAY - GENERAL MANAGER HR
  // =========================
  {
    id: "general-manager-hr-nutrabay-2026",
    title: "General Manager - HR",
    company: "Nutrabay",
    category: "HR",
    jobType: "Full-Time",
    location: "Gurgaon",
    experience: "10+ Years",
    qualification: "Graduate / MBA in HR preferred",
    salary: "Not Disclosed",
    skills: [
      "HR Management",
      "Leadership",
      "Recruitment",
      "Employee Relations"
    ],
    responsibilities: [
      "Oversee HR operations",
      "Develop HR strategies",
      "Manage workforce planning",
      "Improve employee engagement"
    ],
    requirements: [
      "10+ years HR experience",
      "Strong leadership and communication",
      "Strategic mindset"
    ],
    certifications: [],
    benefits: [
      "Leadership opportunity",
      "Organizational impact",
      "Career growth"
    ],
    applyLink: "mailto:gursharan.kaur@nutrabay.com",
    postedDate: "2026-04-29"
  },

  // =========================
  // 6. COFORGE - DIRECTOR TALENT ACQUISITION
  // =========================
  {
    id: "director-talent-acquisition-coforge-2026",
    title: "Director - Talent Acquisition (BPO Hiring)",
    company: "Coforge",
    category: "HR",
    jobType: "Full-Time",
    location: "Pune",
    experience: "10+ Years",
    qualification: "Graduate / MBA in HR preferred",
    salary: "Not Disclosed",
    skills: [
      "Talent Acquisition",
      "BPO Hiring",
      "Leadership",
      "Recruitment Strategy"
    ],
    responsibilities: [
      "Lead BPO hiring strategies",
      "Manage recruitment teams",
      "Drive large-scale hiring",
      "Collaborate with leadership"
    ],
    requirements: [
      "10+ years experience",
      "Expertise in BPO hiring",
      "Strong leadership skills"
    ],
    certifications: [],
    benefits: [
      "Senior leadership role",
      "Strategic impact",
      "Growth opportunities"
    ],
    applyLink: "mailto:vrinda.gupta@coforge.com",
    postedDate: "2026-04-29"
  },

{
    id: "symphonyai-associate-software-engineer-2026",
    title: "Associate Software Engineer",
    company: "SymphonyAI",
    category: "IT",
    jobType: "Full-Time",
    location: "Remote",
    experience: "1+ Year",
    salary: "Up to ₹12 LPA",
    skills: ["Software Development", "Problem Solving", "Debugging"],
    applyLink: "https://jobs.symphonyai.com/jobs/2920?mode=apply&iis=LinkedIn",
    postedDate: "2026-04-28",
  },

  // =========================
  // IRIS SOFTWARE
  // =========================
  {
    id: "iris-python-graduate-engineer-2026",
    title: "Python Graduate Engineer",
    company: "Iris Software",
    category: "IT",
    jobType: "Full-Time",
    location: "Noida",
    experience: "Freshers",
    salary: "₹3 - ₹5 LPA",
    skills: ["Python", "SQL", "OOP"],
    applyLink:
      "https://careers.irissoftware.com/job/Noida-Python-Graduate-Engineer-UP/54716144/",
    postedDate: "2026-04-28",
  },

  // =========================
  // MEDPACE
  // =========================
  {
    id: "medpace-entry-level-software-engineer-2026",
    title: "Entry Level Software Engineer",
    company: "Medpace",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "Entry Level",
    salary: "Not Disclosed",
    skills: ["Programming", "SDLC"],
    applyLink: "https://careers.medpace.com/jobs/11927?lang=en-us",
    postedDate: "2026-04-28",
  },

  // =========================
  // CONTROL-M ADMIN
  // =========================
  {
    id: "controlm-admin-chennai-bangalore-2026",
    title: "Control-M Administrator",
    company: "Confidential",
    category: "IT",
    jobType: "Full-Time",
    location: "Chennai / Bangalore (Hybrid)",
    experience: "3+ Years",
    skills: ["Control-M", "Job Scheduling", "Monitoring"],
    applyLink: "mailto:sonali.pawar@satincorp.com",
    postedDate: "2026-04-28",
  },

  // =========================
  // ALTER DOMUS
  // =========================
  {
    id: "alter-domus-fullstack-engineer-2026",
    title: "Lead Full Stack Engineer",
    company: "Alter Domus",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad (Hybrid)",
    experience: "3+ Years",
    skills: ["React", "Python", "AWS", "PostgreSQL"],
    applyLink:
      "https://careers.alterdomus.com/en/job/hyderabad/technical-analyst/38735/36577056064",
    postedDate: "2026-04-28",
  },

  // =========================
  // INCIDENT MANAGER
  // =========================
  {
    id: "incident-manager-techmojo-2026",
    title: "Incident Manager",
    company: "Techmojo",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "6+ Years",
    skills: ["ITIL", "Incident Management", "ServiceNow"],
    applyLink: "mailto:manideep.thatipamula@techmojo.in",
    postedDate: "2026-04-28",
  },

  // =========================
  // SALESFORCE
  // =========================
  {
    id: "salesforce-mts-fullstack-2026",
    title: "Software Engineering MTS (Full Stack)",
    company: "Salesforce",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "3 - 6 Years",
    skills: ["Node.js", "React", "APIs", "System Design"],
    applyLink:
      "https://careers.salesforce.com/en/jobs/jr339748/software-engineering-mts-full-stack/",
    postedDate: "2026-04-28",
  },

  // =========================
  // DHL
  // =========================
  {
    id: "dhl-software-engineer-java-2026",
    title: "Software Engineer (Java Full Stack)",
    company: "DHL",
    category: "IT",
    jobType: "Full-Time",
    location: "Indore",
    experience: "Freshers",
    skills: ["Java", "Spring Boot", "DevOps"],
    applyLink:
      "https://careers.dhl.com/global/en/job/DPDHGLOBALAV314386ENGLOBALEXTERNAL/Software-Engineer",
    postedDate: "2026-04-28",
  },

  // =========================
  // MORGAN STANLEY
  // =========================
  {
    id: "morgan-stanley-java-developer-2026",
    title: "Java Developer (Associate)",
    company: "Morgan Stanley",
    category: "IT",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "4+ Years",
    skills: ["Java", "Spring Boot", "Kafka", "SQL"],
    applyLink:
      "https://morganstanley.eightfold.ai/careers?source=mscom",
    postedDate: "2026-04-28",
  },

  // =========================
  // SAP B1 MANAGER
  // =========================
  {
    id: "sap-b1-manager-goa-2026",
    title: "SAP B1 Manager",
    company: "Confidential",
    category: "IT",
    jobType: "Full-Time",
    location: "Goa",
    experience: "5+ Years",
    salary: "₹50K - ₹90K/month",
    skills: ["SAP B1", "Finance", "Inventory"],
    applyLink: "mailto:suzanne@91hr.in",
    postedDate: "2026-04-28",
  },

  // =========================
  // 1. ONEDRIVE SUPPORT ENGINEER (REMOTE)
  // =========================
  {
    id: "onedrive-support-engineer-remote-2026",
    title: "OneDrive Support Engineer (Contract)",
    company: "Linkage IT",
    category: "IT",
    jobType: "Contract",
    location: "Remote",
    experience: "5–6 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "OneDrive",
      "M365 (Teams, SharePoint, Exchange)",
      "SLA Support",
      "Compliance & Security"
    ],
    shift: "Australian Shift (Rotational): 3 AM – 1 PM",
    responsibilities: [
      "Support OneDrive & Microsoft 365 users with troubleshooting",
      "Handle incident resolution and migrations",
      "Monitor services and ensure SLA compliance"
    ],
    applyLink: [
      "mailto:leena.popli@linkageit.com",
      "mailto:talent@linkageit.com"
    ],
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. MORGAN STANLEY JAVA DEVELOPER
  // =========================
  {
    id: "java-developer-morgan-stanley-mumbai-2026",
    title: "Java Developer - Associate (Software Engineering)",
    company: "Morgan Stanley",
    category: "IT",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "4+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Spring Boot",
      "Python",
      "Kafka",
      "Microservices",
      "REST APIs",
      "SQL"
    ],
    responsibilities: [
      "Design, develop, test and deploy applications",
      "Work on Non-Financial Risk Technology systems",
      "Build scalable backend systems",
      "Collaborate with global teams",
      "Follow Agile and DevOps practices"
    ],
    requirements: [
      "Strong Java & Python experience",
      "Microservices & database knowledge",
      "Strong communication skills",
      "Ability to work in Agile environment"
    ],
    applyLink: "https://morganstanley.eightfold.ai/careers?source=mscom&start=0&pid=549797214434&sort_by=timestamp&filter_businessarea=technology&filter_city=Mumbai%2CBengaluru",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. SAP B1 MANAGER (GOA)
  // =========================
  {
    id: "sap-b1-manager-goa-2026",
    title: "SAP B1 Manager",
    company: "91HR",
    category: "IT",
    jobType: "Full-Time",
    location: "Ponda - Kundaim, Goa",
    experience: "5+ Years",
    qualification: "Bachelor’s Degree",
    salary: "₹50,000 – ₹90,000 / Month",
    skills: [
      "SAP Business One",
      "Finance Module",
      "Inventory Management",
      "Production Planning",
      "Implementation & Support"
    ],
    responsibilities: [
      "SAP B1 implementation and support",
      "Handle Finance, Inventory & Production modules",
      "Train and guide end users",
      "Manage system operations",
      "Ensure smooth business processes"
    ],
    requirements: [
      "5+ years SAP B1 experience",
      "Strong accounting knowledge",
      "Manufacturing domain experience preferred",
      "Good communication skills"
    ],
    applyLink: [
      "mailto:suzanne@91hr.in",
      "tel:7387684191"
    ],
    postedDate: "2026-04-28"
  },



  // =========================
  // 1. GE AEROSPACE - DATA SCIENCE INTERN
  // =========================
  {
    id: "data-science-intern-ge-aerospace-2026",
    title: "Data Science Intern",
    company: "GE Aerospace",
    category: "IT",
    jobType: "Internship",
    location: "Bengaluru",
    experience: "Fresher (Students Only)",
    qualification: "B.Tech (3rd/4th Year) or M.Tech (1st/2nd Year) - CS/IT (Data Science/AI preferred)",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "Machine Learning",
      "Deep Learning",
      "Statistics",
      "Data Science",
      "GenAI Basics",
      "Analytical Thinking",
      "Communication Skills"
    ],
    responsibilities: [
      "Work on Data Science technologies including ML, DL, and GenAI",
      "Collaborate with mentors on real-world projects",
      "Analyze, design, test, and integrate solutions",
      "Document technical work as per company standards",
      "Prepare and present project results and findings"
    ],
    requirements: [
      "Minimum 7 CGPA or 70%",
      "No active backlogs",
      "NOC from college required",
      "Strong Python and ML fundamentals",
      "Good communication skills"
    ],
    certifications: [],
    benefits: [
      "Hands-on industry experience",
      "Mentorship from experts",
      "Exposure to real-world Data Science projects"
    ],
    applyLink: "https://careers.geaerospace.com/global/en/job/GAOGAYGLOBALR5032952EXTERNALENGLOBAL/Data-Science-Intern",
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. MATHWORKS - SOFTWARE ENGINEER (COMPILER)
  // =========================
  {
    id: "software-engineer-mathworks-compiler-2026",
    title: "Software Engineer - Compiler Technologies",
    company: "MathWorks",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore",
    experience: "0–2 Years (2021–2024 Graduates)",
    qualification: "Bachelor’s Degree in Computer Science or related field",
    salary: "Not Disclosed",
    skills: [
      "C/C++",
      "Compiler Design",
      "Data Structures",
      "Algorithms",
      "Operating Systems",
      "Problem Solving"
    ],
    responsibilities: [
      "Design and develop compiler technologies",
      "Work on performance optimization",
      "Collaborate with engineering teams",
      "Write clean and efficient code",
      "Debug and improve existing systems"
    ],
    requirements: [
      "Strong programming skills in C/C++",
      "Good understanding of Data Structures & Algorithms",
      "Knowledge of compiler concepts is a plus",
      "Strong problem-solving ability"
    ],
    certifications: [],
    benefits: [
      "Work with cutting-edge technologies",
      "Collaborative engineering environment",
      "Career growth opportunities"
    ],
    applyLink: "https://www.mathworks.com/company/jobs/opportunities/37146-software-engineer-complier-technologies",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. MACTORES - PROJECT MANAGER
  // =========================
  {
    id: "project-manager-mactores-remote-2026",
    title: "Project Manager",
    company: "Mactores",
    category: "IT",
    jobType: "Full-Time",
    location: "Remote (WFH)",
    experience: "3–5 Years",
    qualification: "Bachelor’s Degree (Preferred in Engineering / Management)",
    salary: "₹6L – ₹15L / year",
    skills: [
      "AWS",
      "Project Management",
      "Scrum",
      "JIRA",
      "Smartsheet",
      "Clockify",
      "Data Lake",
      "Communication",
      "Negotiation",
      "Problem Solving",
      "Facilitation",
      "Coaching"
    ],
    responsibilities: [
      "Manage project scope, timelines, and budgets",
      "Create project plans using Smartsheet",
      "Identify dependencies and timelines",
      "Conduct stand-ups, sprint planning, retrospectives",
      "Collaborate with India & US teams",
      "Handle stakeholder communication and reporting",
      "Manage escalations and resolve issues",
      "Maintain documentation and meeting notes"
    ],
    requirements: [
      "2+ years in cloud/data engineering projects",
      "2+ years as Project Manager or Scrum Master",
      "Experience with US clients",
      "Strong knowledge of Jira, Smartsheet, Clockify",
      "AWS Data Lake experience preferred"
    ],
    certifications: [
      "Professional Scrum Master",
      "Jira Certification",
      "Smartsheet Certification"
    ],
    benefits: [
      "Remote work flexibility",
      "Global exposure",
      "Growth-oriented environment"
    ],
    applyLink: "https://abekus.ai/public-job-search/project-manager-4?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-04-27"
  },

  // =========================
  // 1. NICE SOFTWARE ENGINEER I
  // =========================
  {
    id: "software-engineer-nice-pune-2026",
    title: "Software Engineer I",
    company: "NiCE",
    category: "IT",
    jobType: "Full-Time",
    location: "Pune",
    experience: "Freshers (2021–2024 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "AWS",
      "Software Development",
      "Programming",
      "Problem Solving"
    ],
    responsibilities: [
      "Develop and maintain software applications",
      "Work on AWS-based systems",
      "Collaborate with teams",
      "Debug and optimize code"
    ],
    applyLink: "http://job-boards.eu.greenhouse.io/nice/jobs/4774027101?gh_jid=4774027101&source=LinkedIn",
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. DOVER SOFTWARE ENGINEER I
  // =========================
  {
    id: "software-engineer-dover-bangalore-2026",
    title: "Software Engineer I",
    company: "Dover",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore",
    experience: "Freshers (2021–2024 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Debugging"
    ],
    responsibilities: [
      "Develop software solutions",
      "Work with engineering teams",
      "Write clean and efficient code",
      "Participate in testing and debugging"
    ],
    applyLink: "https://careers.dovercorporation.com/job/Bengaluru-Software-Engineer-I-KA/1378793533/",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. BNP AI/ML JUNIOR DEVELOPER
  // =========================
  {
    id: "ai-ml-junior-developer-bnp-mumbai-2026",
    title: "AI/ML Junior Developer",
    company: "BNP Paribas",
    category: "IT",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "Freshers (2022–2024 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Machine Learning",
      "Python",
      "Data Analysis",
      "AI Development"
    ],
    responsibilities: [
      "Develop AI/ML models",
      "Work on data analysis tasks",
      "Support ML projects",
      "Collaborate with teams"
    ],
    applyLink: "https://group.bnpparibas/en/careers/job-offer/ai-ml-junior-developer",
    postedDate: "2026-04-28"
  },

  // =========================
  // 4. ECI ASSOCIATE SOFTWARE ENGINEER
  // =========================
  {
    id: "associate-software-engineer-eci-indore-2026",
    title: "Associate Software Engineer",
    company: "ECI",
    category: "IT",
    jobType: "Full-Time",
    location: "Indore",
    experience: "Freshers (2022–2025 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Debugging"
    ],
    responsibilities: [
      "Develop and maintain applications",
      "Work on backend/frontend tasks",
      "Fix bugs and issues",
      "Collaborate with developers"
    ],
    applyLink: "https://recruiting.ultipro.com/EZE1000EZECI/JobBoard/97cf9268-5a5a-480b-b7b6-5ed694da88c5/OpportunityDetail?opportunityId=81a629af-46ba-44a5-bb78-e236e8eea274&source=LinkedIn&utm_source=LINKEDIN",
    postedDate: "2026-04-28"
  },

  // =========================
  // 5. COPART SOFTWARE ENGINEER
  // =========================
  {
    id: "software-engineer-copart-hyderabad-2026",
    title: "Software Engineer",
    company: "Copart",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "Freshers (2022–2024 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "APIs",
      "Debugging"
    ],
    responsibilities: [
      "Build and maintain software systems",
      "Develop APIs and backend services",
      "Collaborate with teams",
      "Ensure code quality"
    ],
    applyLink: "https://copart.wd12.myworkdayjobs.com/en-US/Copart/job/Software-Engineer_JR107301",
    postedDate: "2026-04-28"
  },

  // =========================
  // 6. DISPRZ SOFTWARE ENGINEER INTERN
  // =========================
  {
    id: "software-engineer-intern-disprz-chennai-2026",
    title: "Software Engineer Intern",
    company: "Disprz",
    category: "IT",
    jobType: "Internship",
    location: "Chennai",
    experience: "Students (2025–2026 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Learning Mindset"
    ],
    responsibilities: [
      "Assist in software development",
      "Work with senior engineers",
      "Write clean code",
      "Learn real-world development"
    ],
    applyLink: "https://disprz.keka.com/careers/jobdetails/126640",
    postedDate: "2026-04-28"
  },

  // =========================
  // 7. PLV TECHNOLOGIES PROJECT TRAINEE
  // =========================
  {
    id: "project-trainee-plv-bangalore-2026",
    title: "Project Trainee",
    company: "PLV Technologies",
    category: "IT",
    jobType: "Trainee",
    location: "Bangalore",
    experience: "Freshers (2023–2025 Grads)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Technical Skills",
      "Programming Basics",
      "Teamwork",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in project execution",
      "Work with development teams",
      "Learn industry tools",
      "Support technical tasks"
    ],
    applyLink: "https://in.indeed.com/viewjob?jk=545e031e6ce355fc",
    postedDate: "2026-04-28"
  },

  // =========================
  // 1. DRDO DLRL INTERNSHIP 2026
  // =========================
  {
    id: "drdo-dlrl-internship-2026",
    title: "DRDO DLRL Internship",
    company: "DRDO DLRL",
    category: "Government",
    jobType: "Internship",
    location: "Hyderabad",
    experience: "Students",
    qualification: "Pre-final Year B.E / B.Tech",
    salary: "₹30,000 (Total Stipend)",
    skills: [
      "Engineering Basics",
      "Research",
      "Technical Knowledge",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in research and development projects",
      "Work on real-time defense projects",
      "Support technical teams",
      "Learn advanced engineering concepts"
    ],
    vacancies: "75 Positions",
    lastDate: "15 May 2026 (Postal)",
    startDate: "1 July 2026",
    applyLink: "https://govtjobsalert.in/drdo-dlrl-hyderabad-internship-2026/",
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. SSB CONSTABLE RECRUITMENT 2026
  // =========================
  {
    id: "ssb-constable-recruitment-2026",
    title: "SSB Constable (Tradesman)",
    company: "SSB",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th Pass / ITI / Others",
    salary: "₹21,700 – ₹69,100",
    skills: [
      "Physical Fitness",
      "Basic Technical Skills",
      "Discipline",
      "Teamwork"
    ],
    responsibilities: [
      "Perform duties as constable tradesman",
      "Maintain discipline and security",
      "Support field operations",
      "Follow government protocols"
    ],
    vacancies: "827",
    lastDate: "04 May 2026",
    applyLink: "https://govtjobsalert.in/ssb-constable-tradesman-recruitment-2026/",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. SSC SELECTION POSTS PHASE XIV 2026
  // =========================
  {
    id: "ssc-selection-posts-phase14-2026",
    title: "SSC Selection Posts Phase XIV",
    company: "SSC",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Freshers",
    qualification: "10th / 12th / Graduation",
    salary: "₹18,000 – ₹1,42,400",
    skills: [
      "General Knowledge",
      "Aptitude",
      "Communication",
      "Basic Computer Skills"
    ],
    responsibilities: [
      "Perform assigned government duties",
      "Handle administrative tasks",
      "Work in various departments",
      "Follow government guidelines"
    ],
    vacancies: "3003",
    lastDate: "04 May 2026",
    applyLink: "https://govtjobsalert.in/ssc-selection-posts-phase-xiv-recruitment-2026/",
    postedDate: "2026-04-28"
  },

  // =========================
  // 4. SSC GD 2026 IMPORTANT NOTICE
  // =========================
  {
    id: "ssc-gd-admit-card-notice-2026",
    title: "SSC GD Admit Card Re-download Notice",
    company: "SSC",
    category: "Government",
    jobType: "Notice",
    location: "India",
    experience: "N/A",
    qualification: "Applied Candidates",
    salary: "N/A",
    skills: [
      "Attention to Detail",
      "Awareness",
      "Exam Preparation"
    ],
    responsibilities: [
      "Check admit card details carefully",
      "Re-download if barcode is missing",
      "Follow official instructions",
      "Prepare for exam"
    ],
    importantDates: "Affects: 28, 29 & 30 April 2026",
    applyLink: "https://govtjobsalert.in/ssc-constable-gd-exam-2026/",
    postedDate: "2026-04-28"
  },


  // =========================
  // 1. MEDPACE ENTRY LEVEL SOFTWARE ENGINEER
  // =========================
  {
    id: "entry-level-software-engineer-medpace-2026",
    title: "Entry Level Software Engineer",
    company: "Medpace",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "Entry Level",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "OOP Concepts",
      "Debugging"
    ],
    responsibilities: [
      "Develop and maintain software applications",
      "Write clean and efficient code",
      "Work with development teams",
      "Debug and troubleshoot issues",
      "Follow coding standards"
    ],
    applyLink: "https://careers.medpace.com/jobs/11927?lang=en-us",
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. BACK OFFICE EXECUTIVE (FEMALE)
  // =========================
  {
    id: "back-office-executive-pune-2026",
    title: "Back Office Executive (Female)",
    company: "ITFMS",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Aundh, Pune",
    experience: "3+ Years",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: [
      "CRM Tools",
      "Communication",
      "MS Office",
      "Email Handling",
      "Coordination"
    ],
    responsibilities: [
      "Manage back office operations using CRM tools",
      "Coordinate with vendors and teams",
      "Handle customer queries",
      "Manage calls and emails",
      "Maintain documentation and workflow"
    ],
    requirements: [
      "Minimum 3+ years experience",
      "Strong communication skills",
      "CRM knowledge required",
      "Ability to multitask"
    ],
    applyLink: "mailto:career2@itfms.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. MICROLAND SERVICE DELIVERY MANAGER
  // =========================
  {
    id: "associate-service-delivery-manager-microland-2026",
    title: "Associate Service Delivery Manager",
    company: "Microland",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore (WFO)",
    experience: "10–12 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Service Delivery Management",
      "ITIL",
      "Stakeholder Management",
      "SLA/KPI Governance",
      "Incident Management"
    ],
    responsibilities: [
      "Manage end-to-end service delivery",
      "Ensure SLA and KPI adherence",
      "Handle incident, problem, and change management",
      "Lead cross-functional teams",
      "Drive operational excellence"
    ],
    requirements: [
      "10–12 years experience mandatory",
      "Strong ITIL knowledge",
      "Service management background required",
      "Good communication skills"
    ],
    applyLink: "mailto:naga.peruru@microland.com",
    postedDate: "2026-04-28"
  },


{
    id: "controlm-admin-chennai-bangalore-2026",
    title: "Control-M Administrator",
    company: "SatinCorp",
    category: "IT",
    jobType: "Full-Time",
    location: "Chennai / Bangalore (Hybrid)",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Control-M","Job Scheduling","Monitoring","Automation","Troubleshooting"],
    responsibilities: [
      "Manage job scheduling environments",
      "Monitor workflows",
      "Handle configuration & troubleshooting"
    ],
    applyLink: "mailto:sonali.pawar@satincorp.com",
    postedDate: "2026-04-27"
  },

  // =========================
  // 2. ALTER DOMUS
  // =========================
  {
    id: "fullstack-alterdomus-hyderabad-2026",
    title: "Lead Full Stack Engineer",
    company: "Alter Domus",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad (Hybrid)",
    experience: "5+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["React","Python","PostgreSQL","AWS","Docker","Kubernetes"],
    responsibilities: [
      "Develop full stack apps",
      "Build APIs",
      "Deploy on AWS",
      "Optimize databases"
    ],
    applyLink: "https://careers.alterdomus.com/en/job/hyderabad/technical-analyst/38735/36577056064",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. INCIDENT MANAGER
  // =========================
  {
    id: "incident-manager-techmojo-2026",
    title: "Incident Manager",
    company: "Techmojo",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "6+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["ITIL","ServiceNow","JIRA","Incident Handling"],
    responsibilities: [
      "Handle P1/P2 incidents",
      "Coordinate teams",
      "Perform RCA"
    ],
    applyLink: "mailto:manideep.thatipamula@techmojo.in",
    postedDate: "2026-04-28"
  },

  // =========================
  // 4. CISCO
  // =========================
  {
    id: "cisco-software-engineer-2026",
    title: "Software Engineer",
    company: "Cisco",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore",
    experience: "1–3 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java","Python","Go","Linux"],
    responsibilities: [
      "Develop backend systems",
      "Work on cloud infra",
      "Collaborate in agile teams"
    ],
    applyLink: "https://careers.cisco.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 5. FMC TESTER
  // =========================
  {
    id: "sap-tester-fmc-2026",
    title: "SAP Automation Tester",
    company: "FMC",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore",
    experience: "8+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Up to ₹17 LPA",
    skills: ["SAP","Tosca","Automation Testing","CI/CD"],
    responsibilities: [
      "Build automation frameworks",
      "Execute testing",
      "Ensure zero defects"
    ],
    applyLink: "mailto:varuna.m@freseniusmedicalcare.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 6. SALESFORCE
  // =========================
  {
    id: "salesforce-mts-2026",
    title: "Software Engineering MTS",
    company: "Salesforce",
    category: "IT",
    jobType: "Full-Time",
    location: "Hyderabad",
    experience: "3–6 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Node.js","React","APIs","Git"],
    responsibilities: [
      "Build internal platforms",
      "Develop APIs",
      "Improve performance"
    ],
    applyLink: "https://careers.salesforce.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 7. DEUTSCHE TELEKOM
  // =========================
  {
    id: "mobile-engineer-deutsche-2026",
    title: "Software Engineer (Android/iOS)",
    company: "Deutsche Telekom",
    category: "IT",
    jobType: "Full-Time",
    location: "Gurgaon",
    experience: "2–6 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Android","iOS","Mobile Dev"],
    responsibilities: [
      "Develop mobile apps",
      "Work with teams",
      "Improve app performance"
    ],
    applyLink: "mailto:gargmohit2912@gmail.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 8. DHL
  // =========================
  {
    id: "dhl-java-fullstack-2026",
    title: "Software Engineer (Java Full Stack)",
    company: "DHL",
    category: "IT",
    jobType: "Full-Time",
    location: "Indore",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java","Angular","DevOps","Security"],
    responsibilities: [
      "Develop secure apps",
      "Build CI/CD pipelines",
      "Work on cloud deployments"
    ],
    applyLink: "https://careers.dhl.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 9. RECRUITER REMOTE
  // =========================
  {
    id: "recruiter-remote-2026",
    title: "Recruiter",
    company: "Nextech GCC",
    category: "Non-IT",
    jobType: "Remote",
    location: "Work From Home",
    experience: "1+ Year",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: ["Recruitment","Screening","Hiring"],
    responsibilities: [
      "Handle bulk hiring",
      "Manage candidates",
      "Meet hiring targets"
    ],
    applyLink: "mailto:sweta.b@nextechgcc.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 10. HR INTERN
  // =========================
  {
    id: "hr-intern-redient-2026",
    title: "HR Intern",
    company: "Redient Security",
    category: "Internship",
    jobType: "Internship",
    location: "Remote/Hybrid",
    experience: "Freshers",
    qualification: "BBA/MBA/B.Com",
    salary: "Unpaid",
    skills: ["Recruitment","MS Excel","HR Basics"],
    responsibilities: [
      "Assist hiring",
      "Post jobs",
      "Support HR operations"
    ],
    applyLink: "mailto:priyanka.danane@redientsecurity.co.in",
    postedDate: "2026-04-28"
  },

  // =========================
  // 11. DATA ANALYST APPRENTICE
  // =========================
  {
    id: "data-analyst-apprentice-2026",
    title: "Data Analyst Apprentice",
    company: "Sanjivani Edge",
    category: "IT",
    jobType: "Full-Time",
    location: "Pune",
    experience: "0–1 Year",
    qualification: "Graduate",
    salary: "Up to ₹30K",
    skills: ["Data Analysis","Excel","SQL"],
    responsibilities: [
      "Analyze data",
      "Prepare reports",
      "Support analytics team"
    ],
    applyLink: "mailto:Amarja.Aras@sanjivaniedge.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 12. SITE INCHARGE
  // =========================
  {
    id: "solar-site-incharge-2026",
    title: "Site Incharge (Solar)",
    company: "Solar Projects Hiring",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Maharashtra",
    experience: "5+ Years",
    qualification: "B.Tech Electrical",
    salary: "Best in Industry",
    skills: ["Solar","Electrical","Site Management"],
    responsibilities: [
      "Manage site",
      "Supervise installation",
      "Ensure safety"
    ],
    applyLink: "mailto:hraayushtyagi@gmail.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 1. DEUTSCHE TELEKOM MOBILE ENGINEER
  // =========================
  {
    id: "mobile-engineer-deutsche-telekom-gurgaon-2026",
    title: "Software Engineer I (Android) / Software Engineer II (iOS)",
    company: "Deutsche Telekom Digital Labs",
    category: "IT",
    jobType: "Full-Time",
    location: "Gurgaon (Hybrid)",
    experience: "2–6 Years",
    qualification: "Bachelor’s Degree (CS/IT Preferred)",
    salary: "Not Disclosed",
    skills: [
      "Android Development",
      "iOS Development",
      "Mobile App Development",
      "Problem Solving",
      "Team Collaboration"
    ],
    responsibilities: [
      "Develop high-quality mobile applications",
      "Work on Android or iOS platforms",
      "Collaborate with cross-functional teams",
      "Ensure performance and quality of applications"
    ],
    applyLink: "mailto:gargmohit2912@gmail.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 2. DHL SOFTWARE ENGINEER
  // =========================
  {
    id: "software-engineer-dhl-indore-2026",
    title: "Software Engineer (Java Full Stack & Security Automation)",
    company: "DHL",
    category: "IT",
    jobType: "Full-Time",
    location: "Indore (Hybrid)",
    experience: "Not Specified",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Angular",
      "DevOps",
      "CI/CD",
      "Security Automation",
      "Maven",
      "API Development",
      "OWASP",
      "Ansible"
    ],
    responsibilities: [
      "Develop and automate security solutions",
      "Build CI/CD pipelines and deployments",
      "Perform application security testing",
      "Develop APIs and integrate systems",
      "Work with global teams"
    ],
    benefits: [
      "Hybrid work model",
      "42 days leave",
      "Medical insurance",
      "Training & certifications"
    ],
    applyLink: "https://careers.dhl.com/global/en/job/DPDHGLOBALAV314386ENGLOBALEXTERNAL/Software-Engineer",
    postedDate: "2026-04-28"
  },

  // =========================
  // 3. RECRUITER (REMOTE BULK HIRING)
  // =========================
  {
    id: "recruiter-remote-nextech-2026",
    title: "Recruiter (Bulk Hiring)",
    company: "Nextech GCC",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Remote",
    experience: "Not Specified",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "Recruitment",
      "Sourcing",
      "Screening",
      "KPI Management",
      "Communication"
    ],
    responsibilities: [
      "Handle end-to-end bulk hiring",
      "Work on IT & Non-IT roles",
      "Manage sourcing and screening",
      "Meet recruitment targets"
    ],
    applyLink: "mailto:sweta.b@nextechgcc.com",
    postedDate: "2026-04-28"
  },

  // =========================
  // 4. RECRUITER (CLIENT MANAGEMENT)
  // =========================
  {
    id: "recruiter-client-management-remote-2026",
    title: "Recruiter (Client Management)",
    company: "Latinum HR",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Remote",
    experience: "1–4 Years",
    qualification: "Graduate",
    salary: "₹25K – ₹30K / Month",
    skills: [
      "Client Management",
      "Recruitment",
      "Communication",
      "Coordination",
      "Target Handling"
    ],
    responsibilities: [
      "Manage client relationships",
      "Handle end-to-end recruitment",
      "Coordinate interviews",
      "Deliver quality candidates"
    ],
    applyLink: "mailto:neha@latinumhr.com",
    postedDate: "2026-04-27"
  },

  // =========================
  // 5. PLANT ADMIN EXECUTIVE
  // =========================
  {
    id: "plant-admin-varroc-aurangabad-2026",
    title: "Plant Admin Executive",
    company: "Varroc",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Sambhajinagar (Aurangabad)",
    experience: "5+ Years",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: [
      "Administration",
      "Vendor Management",
      "Coordination",
      "Documentation",
      "Operations"
    ],
    responsibilities: [
      "Manage plant administration",
      "Coordinate vendors and teams",
      "Handle documentation and compliance",
      "Support plant operations"
    ],
    applyLink: "mailto:gen_ebu.ta@varroc.com",
    postedDate: "2026-04-27"
  },

  // =========================
  // 6. LEAD HR
  // =========================
  {
    id: "lead-hr-mumbai-2026",
    title: "Lead HR",
    company: "Unison International",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Mumbai",
    experience: "5–15 Years",
    qualification: "Graduate / MBA HR",
    salary: "Up to ₹24 LPA",
    skills: [
      "HR Management",
      "Culture Building",
      "Recruitment",
      "Leadership",
      "Communication"
    ],
    responsibilities: [
      "Build organizational culture",
      "Manage HR operations",
      "Support business growth",
      "Handle HR strategy"
    ],
    applyLink: "mailto:mukul.narula@unisoninternational.net",
    postedDate: "2026-04-27"
  },

  // =========================
  // 7. RESEARCH ANALYST
  // =========================
  {
    id: "research-analyst-vereigen-pune-2026",
    title: "Research Analyst",
    company: "Vereigen Media",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Kharadi, Pune",
    experience: "Freshers",
    qualification: "Any Graduate",
    salary: "Not Disclosed",
    skills: [
      "Typing",
      "Data Analysis",
      "Communication",
      "Research"
    ],
    responsibilities: [
      "Perform research and data tasks",
      "Maintain records",
      "Support business operations"
    ],
    applyLink: "mailto:kalyani.gadre@vereigenmedia.in",
    postedDate: "2026-04-27"
  },

  // =========================
  // 8. HR INTERN
  // =========================
  {
    id: "hr-intern-redient-2026",
    title: "HR Intern",
    company: "Redient Security",
    category: "Non-IT",
    jobType: "Internship",
    location: "Remote / Hybrid",
    experience: "Freshers",
    qualification: "BBA / MBA / B.Com (HR)",
    salary: "Unpaid",
    skills: [
      "Recruitment",
      "HR Operations",
      "Communication",
      "MS Excel",
      "Coordination"
    ],
    responsibilities: [
      "Assist in recruitment process",
      "Post jobs and screen resumes",
      "Support onboarding",
      "Handle HR operations"
    ],
    benefits: [
      "Certificate",
      "Letter of Recommendation",
      "Practical HR exposure"
    ],
    applyLink: "mailto:priyanka.danane@redientsecurity.co.in",
    postedDate: "2026-04-27"
  },

  // =========================
  // 9. DATA ANALYST APPRENTICE
  // =========================
  {
    id: "data-analyst-apprentice-pune-2026",
    title: "Data Analyst Apprentice",
    company: "Sanjivani Edge",
    category: "IT",
    jobType: "Apprenticeship",
    location: "Pune",
    experience: "Freshers – 1 Year",
    qualification: "Graduate",
    salary: "Up to ₹30K / Month",
    skills: [
      "Data Analysis",
      "Excel",
      "SQL",
      "Reporting",
      "Analytics"
    ],
    responsibilities: [
      "Analyze datasets",
      "Create reports",
      "Support analytics tasks",
      "Work with business teams"
    ],
    applyLink: "mailto:Amarja.Aras@sanjivaniedge.com",
    postedDate: "2026-04-27"
  },




  // =========================
  // 1. PROJECT MANAGER (MACTORES)
  // =========================
  {
    id: "project-manager-mactores-remote-2026",
    title: "Project Manager",
    company: "Mactores",
    category: "IT",
    jobType: "Full-Time",
    location: "Remote (WFH)",
    experience: "3–5 Years",
    qualification: "Bachelor’s Degree (Preferred in Engineering / Management)",
    salary: "₹6L – ₹15L / year",
    skills: [
      "AWS",
      "Project Management",
      "Scrum",
      "JIRA",
      "Smartsheet",
      "Clockify",
      "Data Lake",
      "Communication",
      "Negotiation",
      "Problem Solving",
      "Facilitation",
      "Coaching"
    ],
    responsibilities: [
      "Manage project scope, timelines, and budgets",
      "Create project plans using Smartsheet",
      "Identify activities, dependencies, and time estimates",
      "Onboard engineering teams and manage project deliverables",
      "Conduct daily stand-ups, sprint planning, and retrospectives",
      "Collaborate with India and US teams across time zones",
      "Facilitate architecture discussions and document decisions",
      "Prepare meeting notes and weekly customer presentations",
      "Manage team schedules, timesheets, and leaves",
      "Communicate project status, risks, and updates to stakeholders",
      "Handle customer escalations and ensure resolution",
      "Negotiate scope changes and maintain documentation"
    ],
    requirements: [
      "2+ years experience in cloud/data engineering projects",
      "2+ years as Project Manager or Scrum Master",
      "Experience working with US time zone clients",
      "Expertise in Smartsheet, Jira/Confluence, Clockify",
      "Strong communication and stakeholder management skills",
      "Experience in AWS Data Lake projects",
      "Strong prioritization and problem-solving skills"
    ],
    certifications: [
      "Professional Scrum Master Certification",
      "Jira Project Management Certification",
      "Smartsheet Certification"
    ],
    benefits: [
      "Remote work flexibility",
      "Global exposure (India & US teams)",
      "Growth-oriented environment",
      "Work on data platform projects"
    ],
    applyLink: "https://abekus.ai/public-job-search/project-manager-4?referral_hash=IIHT.VIMANNAGAR0138",
    postedDate: "2026-04-27"
  },

  // =========================
  // 1. XYLOFY AI INTERN
  // =========================
  {
    id: "ai-data-analyst-intern-xylofy-2026",
    title: "AI & Data Analyst Intern",
    company: "XYlofy AI",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Unpaid / Not Disclosed",
    skills: [
      "Data Analysis",
      "AI Basics",
      "Python",
      "Analytics",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on AI and data analysis tasks",
      "Assist in real-world data projects",
      "Analyze datasets and generate insights",
      "Collaborate with team remotely"
    ],
    requirements: [
      "Basic knowledge of data analysis",
      "Interest in AI and analytics",
      "Good communication skills"
    ],
    applyLink: "https://tinyurl.com/27bysr9r",
    postedDate: "2026-04-27"
  },

  // =========================
  // 2. EY ANALYTICS INTERN
  // =========================
  {
    id: "analytics-intern-ey-2026",
    title: "Analytics Intern",
    company: "EY",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Analytics",
      "Excel",
      "SQL",
      "Reporting",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in analytics and reporting",
      "Work on data-driven insights",
      "Support business analytics team",
      "Prepare reports and dashboards"
    ],
    requirements: [
      "Basic analytics knowledge",
      "Good communication skills",
      "Willingness to learn"
    ],
    applyLink: "https://tinyurl.com/bdepmd37",
    postedDate: "2026-04-27"
  },

  // =========================
  // 3. TECHIEHELP INTERN
  // =========================
  {
    id: "data-analyst-intern-techiehelp-2026",
    title: "Data Analyst Intern",
    company: "TechieHelp",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Excel",
      "Python",
      "SQL",
      "Analytics"
    ],
    responsibilities: [
      "Analyze datasets",
      "Assist in reporting",
      "Work on analytics tasks",
      "Support data team"
    ],
    requirements: [
      "Basic data knowledge",
      "Analytical thinking",
      "Learning attitude"
    ],
    applyLink: "https://tinyurl.com/y9esamnv",
    postedDate: "2026-04-27"
  },

  // =========================
  // 4. RESEARCH ENGINE INTERN
  // =========================
  {
    id: "data-analyst-intern-researchengine-2026",
    title: "Data Analyst Intern",
    company: "Research Engine",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Research",
      "Excel",
      "Reporting",
      "Analytics"
    ],
    responsibilities: [
      "Perform data research",
      "Analyze business datasets",
      "Prepare reports",
      "Support analytics projects"
    ],
    requirements: [
      "Interest in data analytics",
      "Basic technical knowledge",
      "Communication skills"
    ],
    applyLink: "https://tinyurl.com/3k462bj7",
    postedDate: "2026-04-27"
  },

  // =========================
  // 5. FLATUIUX INTERN
  // =========================
  {
    id: "data-analyst-intern-flatuiux-2026",
    title: "Data Analyst Intern",
    company: "FlatUIUX",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "UI Data Insights",
      "Excel",
      "Analytics",
      "Reporting"
    ],
    responsibilities: [
      "Analyze UI/UX data",
      "Generate insights",
      "Support analytics team",
      "Prepare reports"
    ],
    requirements: [
      "Basic analytics skills",
      "Interest in UI/UX data",
      "Good communication"
    ],
    applyLink: "https://tinyurl.com/5haxxy85",
    postedDate: "2026-04-27"
  },

  // =========================
  // 6. VEDHAAI INTERN
  // =========================
  {
    id: "data-science-intern-vedhaai-2026",
    title: "Data Science Intern",
    company: "VedhaAI Infotech",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Science",
      "Python",
      "Machine Learning",
      "Statistics",
      "Analytics"
    ],
    responsibilities: [
      "Work on data science projects",
      "Build ML models",
      "Analyze datasets",
      "Support AI solutions"
    ],
    requirements: [
      "Basic ML knowledge",
      "Python understanding",
      "Analytical mindset"
    ],
    applyLink: "https://tinyurl.com/39cyp5cu",
    postedDate: "2026-04-27"
  },

  // =========================
  // 7. INTERNSELITE INTERN
  // =========================
  {
    id: "data-science-intern-internselite-2026",
    title: "Data Science Intern",
    company: "Internselite Edutech Pvt Ltd",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Science",
      "Python",
      "Analytics",
      "Machine Learning",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in data science tasks",
      "Work on ML models",
      "Analyze datasets",
      "Collaborate with team"
    ],
    requirements: [
      "Basic programming knowledge",
      "Interest in data science",
      "Learning attitude"
    ],
    applyLink: "https://tinyurl.com/3zkacz77",
    postedDate: "2026-04-27"
  },

  // =========================
  // 8. INTECHNATIVE INTERN
  // =========================
  {
    id: "data-scientist-intern-intechnative-2026",
    title: "Data Scientist Intern",
    company: "InTechNative Systems and Services",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Data Science",
      "Machine Learning",
      "Python",
      "Statistics",
      "Analytics"
    ],
    responsibilities: [
      "Work on data science problems",
      "Build ML models",
      "Analyze datasets",
      "Support AI team"
    ],
    requirements: [
      "Basic ML knowledge",
      "Analytical thinking",
      "Communication skills"
    ],
    applyLink: "https://tinyurl.com/322jvavw",
    postedDate: "2026-04-27"
  },

  // =========================
  // 9. KARBON BUSINESS INTERN
  // =========================
  {
    id: "ai-engineer-intern-karbon-2026",
    title: "AI Engineer Intern",
    company: "Karbon Business",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "AI",
      "Machine Learning",
      "Python",
      "Deep Learning",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on AI engineering tasks",
      "Develop ML models",
      "Support AI development",
      "Research AI solutions"
    ],
    requirements: [
      "Basic AI/ML knowledge",
      "Programming skills",
      "Interest in AI"
    ],
    applyLink: "https://tinyurl.com/3kvnnvud",
    postedDate: "2026-04-27"
  },

  // =========================
  // 10. NEOTECHE INTERN
  // =========================
  {
    id: "software-engineering-intern-neoteche-2026",
    title: "Software Engineering Intern",
    company: "Neoteche",
    category: "IT",
    jobType: "Internship",
    location: "Work From Home",
    experience: "Freshers / Students",
    qualification: "All College Students",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "JavaScript",
      "React",
      "Problem Solving"
    ],
    responsibilities: [
      "Assist in software development",
      "Write clean code",
      "Debug and test applications",
      "Collaborate with team"
    ],
    requirements: [
      "Basic coding knowledge",
      "Willingness to learn",
      "Good communication"
    ],
    applyLink: "https://tinyurl.com/muzj58h2",
    postedDate: "2026-04-27"
  },

  // =========================
  // 1. MERCOR ML ENGINEER (REMOTE)
  // =========================
  {
    id: "ml-engineer-mercor-remote-2026",
    title: "Machine Learning Engineer (Contract Network)",
    company: "Mercor",
    category: "IT",
    jobType: "Contract / Remote",
    location: "Remote",
    experience: "Experienced",
    qualification: "Bachelor’s Degree (CS/AI/ML Preferred)",
    salary: "$60 – $100 per hour",
    skills: [
      "Machine Learning",
      "Python",
      "PyTorch",
      "TensorFlow",
      "MLOps",
      "Model Deployment"
    ],
    responsibilities: [
      "Train and evaluate machine learning models",
      "Create real-world AI tasks and deliverables",
      "Provide domain-specific feedback for AI research",
      "Work on ML engineering-based projects",
      "Collaborate remotely with global teams"
    ],
    requirements: [
      "Experience in ML model development",
      "Strong knowledge of ML frameworks",
      "Good communication skills",
      "Ability to work independently"
    ],
    benefits: [
      "Remote work flexibility",
      "High hourly pay",
      "Global project exposure",
      "Flexible schedule"
    ],
    contractDetails: [
      "Independent contractor role",
      "Weekly payments via Stripe/Wise",
      "15–30 hrs/week typical workload",
      "Projects vary in duration",
      "No H1-B / STEM OPT support"
    ],
    applyLink: "https://t.mercor.com/FhTqM",
    postedDate: "2026-04-27"
  },

  // =========================
  // 2. SOFTWARE DEVELOPER (.NET)
  // =========================
  {
    id: "dotnet-developer-udaipur-2026",
    title: "Software Developer (C#, .NET)",
    company: "Rudr Services",
    category: "IT",
    jobType: "Full-Time",
    location: "Udaipur, Rajasthan",
    experience: "2–7 Years",
    qualification: "B.Tech (CS/IT/EC), BCA, MCA",
    salary: "Best in Industry",
    skills: [
      "C#",
      ".NET Framework",
      ".NET Core",
      "ASP.NET MVC",
      "Entity Framework",
      "Microservices",
      "SQL Server",
      "MySQL",
      "REST APIs"
    ],
    responsibilities: [
      "Develop and maintain desktop applications",
      "Build scalable and high-performance systems",
      "Work on API integrations",
      "Manage databases and backend logic",
      "Collaborate with development teams"
    ],
    requirements: [
      "Strong .NET development experience",
      "Knowledge of MVC architecture",
      "Experience in database handling",
      "Good problem-solving skills"
    ],
    benefits: [
      "Competitive salary",
      "Growth-oriented environment",
      "Modern tech exposure"
    ],
    contact: [
      "hr@rudrservices.com",
      "7737678246",
      "8949185956",
      "8276607432",
      "707369126"
    ],
    postedDate: "2026-04-27"
  },

  // =========================
  // 3. EMBEDDED SYSTEMS ENGINEER
  // =========================
  {
    id: "embedded-robotics-engineer-mumbai-2026",
    title: "Embedded Systems & Robotics Engineer",
    company: "Grok Learning Pvt Ltd",
    category: "IT",
    jobType: "Full-Time",
    location: "Sion, Mumbai",
    experience: "2–3 Years",
    qualification: "Engineering Background (Electronics/CS)",
    salary: "Not Disclosed",
    skills: [
      "Embedded Systems",
      "Robotics",
      "ESP32",
      "Arduino",
      "Raspberry Pi",
      "C Programming",
      "Python",
      "MicroPython",
      "PCB Design",
      "PLC / SCADA"
    ],
    responsibilities: [
      "Design and develop embedded systems",
      "Build robotics and IoT solutions",
      "Develop firmware and applications",
      "Design PCBs and circuits",
      "Integrate automation systems",
      "Debug and optimize performance"
    ],
    requirements: [
      "Hands-on robotics/IoT experience",
      "Knowledge of I2C, SPI, UART, MQTT",
      "Strong electronics fundamentals",
      "Problem-solving skills"
    ],
    applyLink: "https://unstop.com/o/tQOJB8F",
    postedDate: "2026-04-27"
  },

  // =========================
  // 4. FULL STACK AI ENGINEER
  // =========================
  {
    id: "fullstack-ai-engineer-carvia-2026",
    title: "Full Stack Engineer (AI/LLM Systems)",
    company: "Carvia Technologies",
    category: "IT",
    jobType: "Full-Time",
    location: "Chandigarh (Mohali)",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Python",
      "ReactJS",
      "TypeScript",
      "FastAPI / Flask / Django",
      "LLMs",
      "RAG",
      "LangChain",
      "Azure AI",
      "PostgreSQL",
      "Docker",
      "CI/CD"
    ],
    responsibilities: [
      "Build AI-native full stack applications",
      "Design LLM and RAG systems",
      "Develop APIs and backend services",
      "Work on distributed systems",
      "Deploy applications on Azure cloud",
      "Optimize performance and scalability"
    ],
    requirements: [
      "3+ years full stack experience",
      "Experience with AI/LLM systems",
      "Knowledge of cloud deployment",
      "Strong system design skills"
    ],
    applyLink : 
      "mailto:hr@carvia.tech",
      
    
    postedDate: "2026-04-27"
  },





{
    id: "associate-software-engineer-symphonyai-2026",
    title: "Associate Software Engineer",
    company: "SymphonyAI",
    category: "IT",
    jobType: "Full-Time",
    location: "Not Disclosed",
    experience: "1+ Year",
    qualification: "Bachelor’s Degree (CS/IT Preferred)",
    salary: "Up to ₹12 LPA",
    skills: [
      "Software Development",
      "Programming",
      "Problem Solving",
      "Debugging",
      "System Design Basics"
    ],
    responsibilities: [
      "Develop and maintain software applications",
      "Write clean and efficient code",
      "Work with development teams on features",
      "Debug and fix technical issues",
      "Follow coding standards and best practices"
    ],
    requirements: [
      "1+ year experience in software development",
      "Strong programming fundamentals",
      "Knowledge of DSA and OOP concepts",
      "Good communication skills"
    ],
    applyLink: "https://jobs.symphonyai.com/jobs/2920?mode=apply&iis=LinkedIn",
    postedDate: "2026-04-26"
  },

  // =========================
  // 2. IRIS SOFTWARE PYTHON GRADUATE ENGINEER
  // =========================
  {
    id: "python-graduate-engineer-iris-noida-2026",
    title: "Python Graduate Engineer",
    company: "Iris Software",
    category: "IT",
    jobType: "Full-Time",
    location: "Noida, India",
    experience: "Freshers",
    qualification: "B.Tech / B.E / MCA / CS/IT",
    salary: "₹3 – ₹5 LPA",
    skills: [
      "Python",
      "Programming Fundamentals",
      "Problem Solving",
      "SQL Basics",
      "OOP Concepts"
    ],
    responsibilities: [
      "Develop applications using Python",
      "Support backend development tasks",
      "Write reusable and clean code",
      "Participate in testing and debugging",
      "Work with senior engineers on projects"
    ],
    requirements: [
      "Fresh graduates eligible",
      "Strong knowledge of Python basics",
      "Understanding of DSA and OOP",
      "Good analytical skills"
    ],
    applyLink: "https://careers.irissoftware.com/job/Noida-Python-Graduate-Engineer-UP/54716144/",
    postedDate: "2026-04-26"
  },
 {
    id: "international-baggage-process-pune-2026",
    title: "International Baggage Process Executive",
    company: "International Process Hiring (Pune)",
    category: "Non-IT",
    jobType: "Full-Time",
    location: "Kalyani Nagar, Pune",
    experience: "Freshers / Experienced",
    qualification: "Any Graduate",
    salary: "₹16,000 – ₹20,000 + Incentives",
    skills: [
      "Customer Support",
      "Communication",
      "International Voice Process",
      "English Fluency",
      "Problem Solving"
    ],
    responsibilities: [
      "Handle international baggage-related customer queries",
      "Assist passengers with lost or delayed baggage issues",
      "Provide accurate resolutions with empathy",
      "Maintain proper documentation and follow-ups"
    ],
    requirements: [
      "Fluent English communication required",
      "Comfortable with US / UK / European accents",
      "Willing to work in 24/7 rotational shifts",
      "Freshers can apply"
    ],
    benefits: [
      "International client exposure",
      "Performance incentives",
      "Transport allowance",
      "Career growth opportunity"
    ],
    shift: "24/7 Rotational Shift (2 Week Off)",
    applyLink: "mailto:9284644983",
    postedDate: "2026-04-26"
  },

{
    id: "java-springboot-tcs-chennai-2026",
    title: "Java Spring Boot Developer",
    company: "Porselvi Software Pvt Ltd (Client: TCS)",
    category: "IT",
    jobType: "Full-Time",
    location: "Chennai – Nungambakkam",
    experience: "3–5 Years",
    qualification: "BE / BTech / IT / CS",
    salary: "Not Disclosed",
    skills: ["Java", "Spring Boot", "Backend Development"],
    responsibilities: [
      "Develop backend services using Java & Spring Boot",
      "Work on enterprise-level project delivery",
      "Handle API development and integration"
    ],
    selectionProcess: [
      "TCS Evaluation (Telephonic / Online)",
      "Customer Interview (L1 & L2 Face to Face)"
    ],
    joining: "Immediate Preferred",
    applyLink: "mailto:hr@pssoftglobal.com",
    postedDate: "2026-04-27"
  },

  // =========================
  // 2. CISCO SUPPORT ENGINEER
  // =========================
  {
    id: "cisco-m365-support-bangalore-2026",
    title: "Productivity Applications Support Engineer (M365)",
    company: "Cisco",
    category: "IT",
    jobType: "Full-Time",
    location: "Bangalore (Hybrid)",
    experience: "4–9 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Microsoft 365",
      "Miro",
      "Figma",
      "Asana",
      "Lucidchart",
      "Technical Support"
    ],
    responsibilities: [
      "Support enterprise M365 applications",
      "Handle third-party tool troubleshooting",
      "Manage license and access provisioning",
      "Collaborate with global engineering teams",
      "Monitor and resolve system issues"
    ],
    requirements: [
      "Experience in enterprise support environment",
      "Strong communication skills",
      "Phone/chat support experience",
      "Hybrid work flexibility"
    ],
    applyLink:
      "https://careers.cisco.com/global/en/job/2005969",
    postedDate: "2026-04-27"
  },

  // =========================
  // 3. FRONTEND DEVELOPER (ZENSAR)
  // =========================
  {
    id: "frontend-angular-zensar-2026",
    title: "Frontend Developer (Angular 21+)",
    company: "Zensar",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "6+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Angular",
      "TypeScript",
      "JavaScript",
      "HTML",
      "CSS",
      "NgRx",
      "Azure (Preferred)"
    ],
    responsibilities: [
      "Build responsive Angular applications",
      "Work with UI/UX designers",
      "Improve performance and scalability",
      "Follow secure coding standards",
      "Participate in code reviews"
    ],
    requirements: [
      "Strong Angular 21+ experience",
      "Good knowledge of TypeScript",
      "Performance optimization skills",
      "Ability to join within 10 days"
    ],
    applyLink: "mailto:Shital.salunkhe@zensar.com",
    postedDate: "2026-04-27"
  },

  {
    id: "joveo-ai-software-engineer-2026",
    title: "Software Engineer",
    company: "Joveo AI",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "0 - 1 Year",
    qualification: "Bachelor’s Degree (CS / IT or related)",
    salary: "Not Disclosed",
    skills: [
      "JavaScript",
      "Python",
      "Software Development",
      "Problem Solving",
      "Data Structures"
    ],
    responsibilities: [
      "Develop and maintain software applications",
      "Write clean and efficient code",
      "Collaborate with team members",
      "Debug and fix issues",
      "Participate in code reviews"
    ],
    requirements: [
      "0-1 year experience in software development",
      "Strong coding fundamentals",
      "Knowledge of programming languages",
      "Good communication skills"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4407109518/",
    postedDate: "2026-04-26"
  },

  {
    id: "cargill-software-engineer-aiml-2026",
    title: "Software Engineer (AI/ML)",
    company: "Cargill",
    category: "IT",
    jobType: "Full-Time",
    location: "India",
    experience: "2+ Years",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Machine Learning",
      "Python",
      "AI",
      "Data Science",
      "Algorithms"
    ],
    responsibilities: [
      "Build AI/ML models",
      "Develop scalable software solutions",
      "Work on data pipelines",
      "Collaborate with data teams",
      "Optimize model performance"
    ],
    requirements: [
      "2+ years experience in AI/ML",
      "Strong Python skills",
      "Understanding of ML algorithms",
      "Problem-solving ability"
    ],
    applyLink: "https://careers.cargill.com/en/job/-/-/23251/91192362464",
    postedDate: "2026-04-26"
  },
  {
    id: "an-police-recruitment-2026",
    title: "SI, Constable, Firemen, Driver & More",
    company: "A&N Police",
    category: "Government",
    jobType: "Full-Time",
    location: "Andaman & Nicobar Islands, India",
    experience: "Freshers / Experienced",
    qualification: "10th / 12th / Graduation",
    salary: "₹18,000 – ₹1,12,400 per month",
    skills: [
      "Physical Fitness",
      "Discipline",
      "Basic Law Knowledge",
      "Teamwork"
    ],
    responsibilities: [
      "Maintain law and order",
      "Perform security duties",
      "Handle emergency situations",
      "Assist in investigations"
    ],
    requirements: [
      "Minimum educational qualification as per post",
      "Physical fitness standards",
      "Age limit as per government rules"
    ],
    applyLink: "https://govtjobsalert.in/an-police-recruitment-2026/",
    postedDate: "2026-04-26",
    lastDate: "2026-05-17"
  },

  {
    id: "iffco-get-recruitment-2026",
    title: "Graduate Engineer Trainee (GET)",
    company: "IFFCO",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Freshers",
    qualification: "B.E / B.Tech",
    salary: "₹65,000 / month (Stipend)",
    skills: [
      "Engineering Fundamentals",
      "Problem Solving",
      "Technical Knowledge",
      "Communication"
    ],
    responsibilities: [
      "Assist in engineering projects",
      "Support technical operations",
      "Work with senior engineers",
      "Maintain project documentation"
    ],
    requirements: [
      "B.E / B.Tech degree",
      "Strong technical skills",
      "Willingness to learn"
    ],
    applyLink: "https://govtjobsalert.in/iffco-get-recruitment-2026/",
    postedDate: "2026-04-26",
    lastDate: "2026-04-30"
  },

  {
    id: "wbpsc-misc-services-2026",
    title: "Miscellaneous Services (Multiple Posts)",
    company: "WBPSC",
    category: "Government",
    jobType: "Full-Time",
    location: "West Bengal, India",
    experience: "Freshers / Experienced",
    qualification: "Graduation",
    salary: "₹28,900 – ₹82,900 per month",
    skills: [
      "General Knowledge",
      "Administration",
      "Communication",
      "Problem Solving"
    ],
    responsibilities: [
      "Perform administrative duties",
      "Assist in government operations",
      "Maintain records",
      "Support departmental tasks"
    ],
    requirements: [
      "Graduate degree",
      "Basic computer knowledge",
      "Eligibility as per notification"
    ],
    applyLink: "https://govtjobsalert.in/wbpsc-miscellaneous-services-recruitment-2024/",
    postedDate: "2026-04-26",
    lastDate: "2026-05-20"
  },

  {
    id: "neiafmr-recruitment-2026",
    title: "Teaching, Specialist & Non-Teaching Roles",
    company: "NEIAFMR",
    category: "Government",
    jobType: "Full-Time",
    location: "India",
    experience: "Freshers / Experienced",
    qualification: "12th / Graduation / PG / MD / Ph.D",
    salary: "₹25,500 – ₹2,15,900",
    skills: [
      "Subject Knowledge",
      "Research",
      "Teaching Skills",
      "Administration"
    ],
    responsibilities: [
      "Teaching and academic duties",
      "Research and development",
      "Administrative responsibilities",
      "Support institutional activities"
    ],
    requirements: [
      "Relevant qualification as per post",
      "Experience (if required)",
      "Eligibility criteria as per official notification"
    ],
    applyLink: "https://govtjobsalert.in/neiafmr-recruitment-2026/",
    postedDate: "2026-04-26",
    lastDate: "2026-06-15"
  },
{
  id: "hr-recruiter-bfsi-lucknow-2026",
  title: "HR Recruiter (BFSI Manpower)",
  company: "Halfpace HR",
  category: "Non-IT",
  jobType: "Full-Time",
  location: "Lucknow – Vibhuti Khand, India",
  experience: "1+ Year",
  qualification: "Graduate / MBA (HR Preferred)",
  salary: "Not Disclosed",
  skills: [
    "Recruitment",
    "Talent Acquisition",
    "Communication",
    "Candidate Screening",
    "Interview Coordination"
  ],
  responsibilities: [
    "Handle end-to-end recruitment for BFSI roles",
    "Source candidates through multiple channels",
    "Screen and shortlist candidates",
    "Conduct interviews and coordinate with clients",
    "Maintain recruitment pipeline"
  ],
  requirements: [
    "Minimum 1 year recruitment experience",
    "Strong communication skills",
    "Ability to manage multiple hiring roles",
    "Basic knowledge of BFSI hiring"
  ],
  applyLink: "mailto:pooja@halfpacehr.com",
  postedDate: "2026-04-26"
},

{
  id: "google-se-intern-2026",
  title: "Software Engineering Intern",
  company: "Google",
  category: "Internship",
  jobType: "Internship",
  location: "Bengaluru / Hyderabad / Pune, India",
  experience: "Freshers (Master’s Students)",
  qualification: "Master’s Degree (CS / IT / Related Fields)",
  salary: "Paid Internship (Not Disclosed)",
  duration: "12+ Weeks (May – Aug 2026)",
  skills: [
    "Java",
    "Python",
    "C++",
    "JavaScript",
    "Data Structures & Algorithms",
    "System Design",
    "Concurrency"
  ],
  responsibilities: [
    "Work on scalable software systems",
    "Develop and optimize backend/frontend features",
    "Collaborate with engineering teams",
    "Build AI-driven and high-performance applications",
    "Write clean, efficient, and maintainable code"
  ],
  requirements: [
    "Currently pursuing Master’s degree",
    "Strong coding skills",
    "Good understanding of DSA",
    "Knowledge of system design concepts",
    "Ability to work in team environment"
  ],
  applyLink: "https://www.google.com/about/careers/applications/jobs/results/121166815916106438-software-engineering-intern-summer-2026",
  postedDate: "2026-04-26"
},

/* ===================== WIPRO SUPPORT ENGINEER ===================== */
{
  id: "wipro-support-engineer-2026-0426",
  title: "Support Engineer",
  company: "Wipro",
  category: "IT",  
  location: "Bengaluru, India",
  jobType: "Full-Time",
  experience: "Fresher / Experienced",
  qualification: "Bachelor’s / Master’s Degree",
  salary: "Not Disclosed",
  skills: ["Technical Support", "Troubleshooting", "Networking Basics", "Customer Handling"],
  responsibilities: [
    "Provide technical support to users",
    "Resolve system and application issues",
    "Handle incident tickets",
    "Collaborate with internal teams",
    "Ensure SLA compliance"
  ],
  requirements: [
    "Bachelor’s or Master’s degree",
    "Good communication skills",
    "Basic IT knowledge"
  ],
  applyLink: "https://careers.wipro.com/job/SUPPORT-ENGINEER/164970-en_US",
  postedDate: "2026-04-26"
},

/* ===================== ROCKWELL AUTOMATION TEST ENGINEER ===================== */
{
  id: "rockwell-automation-test-engineer-2026-0426",
  title: "Automation Test Engineer (Cypress)",
  company: "Rockwell Automation",
  location: "Bangalore, India (Hybrid)",
  jobType: "Full-Time",
  category: "IT",  
  experience: "Experienced",
  qualification: "Bachelor’s / Master’s Degree",
  salary: "Not Disclosed",
  skills: ["Cypress", "Automation Testing", "JavaScript", "API Testing", "Selenium", "QA"],
  responsibilities: [
    "Develop automation test scripts using Cypress",
    "Perform functional and regression testing",
    "Work with CI/CD pipelines",
    "Identify and report defects",
    "Collaborate with development teams",
    "Improve test coverage"
  ],
  requirements: [
    "Experience in automation testing",
    "Strong knowledge of Cypress",
    "Good understanding of QA processes"
  ],
  applyLink: "https://rockwellautomation.wd1.myworkdayjobs.com/en-US/External_Rockwell_Automation/job/Automation-Test-Engineer---Cypress_R26-1022",
  postedDate: "2026-04-26"
},
/* ===================== JAVA DEVELOPER PUNE ===================== */
{
  id: "java-dev-pune-2026-0426",
  title: "Java Software Developer",
  company: "Confidential (Pune Hiring Partner)",
  location: "Pune, India",
  jobType: "Full-Time",
  category: "IT",  
  experience: "Fresher – 6 Months",
  qualification: "BE / BTech / MCA / MSc (CS/IT)",
  salary: "₹3.5 LPA",
  skills: ["Core Java", "Spring Boot", "SQL", "REST APIs", "Git", "DSA"],
  responsibilities: [
    "Develop Java applications",
    "Write clean and maintainable code",
    "Debug and fix issues",
    "Work with Spring Boot",
    "Collaborate with teams"
  ],
  requirements: [
    "Certified Full Stack Java",
    "Minimum 60% academics",
    "2023–2025 pass outs"
  ],
  applyLink: "tel:9175382821",
  postedDate: "2026-04-26"
},

/* ===================== FULL STACK NOIDA ===================== */
{
  id: "fullstack-noida-2026-0426",
  title: "Full Stack Developer",
  company: "Capline Services",
  location: "Noida Sector 62",
  jobType: "Full-Time",
  category: "IT",  
  experience: "1+ Year",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["HTML", "CSS", "JavaScript", "Angular", "Node.js", "Python", "Git"],
  responsibilities: [
    "Build web applications",
    "Develop backend APIs",
    "UI development using Angular",
    "Integrate databases",
    "Performance optimization"
  ],
  requirements: [
    "1+ year experience",
    "Frontend + Backend knowledge",
    "Cloud exposure preferred"
  ],
  applyLink: "mailto:tanushreekarua@caplineservices.com",
  postedDate: "2026-04-26"
},

/* ===================== GOOGLE SOFTWARE ENGINEER ===================== */
{
  id: "google-swe-cloud-2026-0426",
  title: "Software Engineer III (Google Cloud)",
  company: "Google",
  category: "IT",  
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "2+ Years",
  qualification: "Bachelor’s / Master’s Degree",
  salary: "Not Disclosed",
  skills: ["C++", "Java", "Python", "DSA", "Distributed Systems", "Cloud"],
  responsibilities: [
    "Build scalable cloud systems",
    "Write production-grade code",
    "Participate in design reviews",
    "Debug large-scale systems",
    "Improve system performance"
  ],
  requirements: [
    "Strong DSA knowledge",
    "2+ years experience",
    "Cloud/system design exposure"
  ],
  applyLink: "https://www.google.com/about/careers/applications/jobs/results/74939955737961158",
  postedDate: "2026-04-26"
},

/* ===================== QA AUTOMATION ===================== */
{
  id: "qa-automation-bangalore-2026-0426",
  title: "QA Automation Engineer",
  company: "Consero Global",
  location: "Bangalore, India",
  jobType: "Full-Time",
  category: "IT",  
  experience: "5–7 Years",
  qualification: "Bachelor’s Degree",
  salary: "₹16–17 LPA",
  skills: ["Selenium", "Playwright", "API Testing", "JavaScript", "SQL", "CI/CD", "Azure DevOps"],
  responsibilities: [
    "Build automation frameworks",
    "API testing",
    "Regression testing",
    "CI/CD integration",
    "Sprint testing support"
  ],
  requirements: [
    "5+ years automation testing",
    "ERP/WMS experience preferred",
    "Strong API testing skills"
  ],
  applyLink: "mailto:durga@indizeal.in",
  postedDate: "2026-04-26"
},

/* ===================== ANDROID HARMAN ===================== */
{
  id: "android-harman-2026-0426",
  title: "Advanced Android Developer",
  company: "HARMAN",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "6–9 Years",
  category: "IT",  
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Kotlin", "Android SDK", "BLE", "Bluetooth", "MVVM", "Jetpack"],
  responsibilities: [
    "Develop Bluetooth Android apps",
    "Build UI for device control",
    "Optimize performance",
    "Integrate hardware devices",
    "Debug connectivity issues"
  ],
  requirements: [
    "Strong Kotlin experience",
    "Bluetooth/IoT knowledge",
    "6+ years Android experience"
  ],
  applyLink: "https://jobsearch.harman.com/en_US/careers/JobDetail/Advanced-Engineer-Android-Developer/30063",
  postedDate: "2026-04-26"
},

/* ===================== HONEYWELL DEVOPS ===================== */
{
  id: "devops-honeywell-2026-0426",
  title: "Software Engineer (DevOps - Entry Level)",
  company: "Honeywell",
  location: "Bangalore, India",
  category: "IT",  
  jobType: "Full-Time",
  experience: "Fresher (2024–2026)",
  qualification: "Bachelor’s Degree",
  salary: "₹5.2 LPA",
  skills: ["Python", "GitHub Actions", "CI/CD", "Linux", "Automation"],
  responsibilities: [
    "Build CI/CD pipelines",
    "Automate workflows",
    "Maintain repositories",
    "Support deployments",
    "Write scripts"
  ],
  requirements: [
    "Python basics",
    "Git knowledge",
    "CI/CD understanding"
  ],
  applyLink: "https://ibqbjb.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Honeywell/job/142360/",
  postedDate: "2026-04-26"
},

/* ===================== SNOWFLAKE ADMIN ===================== */
{
  id: "snowflake-admin-2026-0426",
  title: "Snowflake Platform Administrator",
  company: "Vivanet",
  location: "Remote",
  category: "IT",  
  jobType: "Contract",
  experience: "5–8 Years",
  qualification: "Bachelor’s Degree",
  salary: "₹15–24 LPA",
  skills: ["Snowflake", "SQL", "Python", "Azure AD", "CI/CD", "RBAC", "Power BI", "Tableau"],
  responsibilities: [
    "Manage Snowflake platform",
    "Implement RBAC security",
    "Optimize performance",
    "Build CI/CD pipelines",
    "Manage data sharing"
  ],
  requirements: [
    "Snowflake expertise",
    "Cloud experience",
    "Automation skills"
  ],
  applyLink: "https://abekus.ai/public-job-search/snowflake-platform-administrator-1",
  postedDate: "2026-04-26"
},

{
  id: "vivanet-snowflake-admin-2026-0425",
  title: "Snowflake Platform Administrator",
  company: "Vivanet",
  category: "IT",  
  location: "Remote (WFH)",
  jobType: "Contract (6–12 Months)",
  experience: "5–8 Years",
  qualification: "Bachelor’s Degree",
  salary: "₹15L – ₹24L /year",
  skills: [
    "Snowflake Administration",
    "SQL",
    "Python",
    "Azure AD Integration",
    "CI/CD",
    "GitHub Actions",
    "RBAC",
    "Data Lakes",
    "Power BI",
    "Tableau",
    "Real-Time Processing",
    "Network Policies",
    "Data Sharing",
    "Cloning",
    "Data Recovery",
    "Automation",
    "Snowflake Architecture"
  ],
  responsibilities: [
    "Administer Snowflake objects (warehouses, DBs, schemas, users, roles)",
    "Implement RBAC, network policies, and security governance",
    "Integrate Snowflake with Azure AD and manage SSO",
    "Monitor performance, cost optimization, and resource tuning",
    "Manage data sharing, cloning, and recovery features",
    "Build automation using SQL and Python",
    "Develop CI/CD pipelines using GitHub Actions",
    "Collaborate with data engineering and analytics teams",
    "Define COE standards and governance practices",
    "Explore AI-driven automation in platform operations"
  ],
  requirements: [
    "5–8 years Snowflake administration experience",
    "Strong Snowflake architecture knowledge",
    "Experience with Azure AD integration",
    "Strong SQL and Python skills",
    "CI/CD experience using GitHub Actions",
    "Knowledge of data lakes and BI tools",
    "Strong problem-solving and troubleshooting skills"
  ],
  applyLink: "https://abekus.ai/public-job-search/snowflake-platform-administrator-1?referral_hash=IIHT.VIMANNAGAR0138",
  postedDate: "2026-04-25"
},






/* ===================== UBER ===================== */
{
  id: "uber-data-analyst-hyderabad-2026-0424",
  title: "Data Analyst / Data Science",
  company: "Uber",
  location: "Hyderabad, India",
  category: "IT",  
  jobType: "Full-Time",
  experience: "Experienced",
  qualification: "Bachelor’s / Master’s Degree",
  salary: "Not Disclosed",
  skills: ["Data Analysis", "SQL", "Python", "Data Science"],
  responsibilities: [
    "Analyze data sets",
    "Build insights",
    "Support business decisions"
  ],
  requirements: [
    "Strong analytical skills",
    "Data science knowledge"
  ],
  applyLink: "https://www.uber.com/global/en/careers/list/157510/?uclick_id=899952d1-cff6-4f6f-a1c1-736a0ef4bd54",
  postedDate: "2026-04-25"
},

/* ===================== HP ===================== */
{
  id: "hp-financial-analyst-bangalore-2026-0424",
  title: "Financial Analyst",
  company: "HP",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "0–2 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Finance", "Excel", "Reporting", "Analytics"],
  responsibilities: [
    "Financial reporting",
    "Data analysis",
    "Support finance operations"
  ],
  requirements: [
    "Finance knowledge",
    "Analytical skills"
  ],
  applyLink: "https://apply.hp.com/careers/job/39062613?domain=hp.com&hl=en",
  postedDate: "2026-04-25"
},

/* ===================== SALESFORCE ===================== */
{
  id: "salesforce-intern-hyderabad-bangalore-2026-0424",
  title: "Summer Intern - Software Engineer",
  company: "Salesforce",
  location: "Hyderabad / Bangalore, India",
  jobType: "Internship",
  experience: "Fresher",
  qualification: "Bachelor’s / Master’s Degree",
  salary: "Internship Stipend",
  skills: ["Java", "Python", "Software Development", "DSA"],
  responsibilities: [
    "Work on real projects",
    "Develop features",
    "Learn engineering practices"
  ],
  requirements: [
    "Basic programming knowledge",
    "Problem-solving skills"
  ],
  applyLink: "https://careers.salesforce.com/en/jobs/jr337715/summer-2027-intern-software-engineer/",
  postedDate: "2026-04-25"
},


/* ===================== MERCOR DATA SCIENCE ===================== */
{
  id: "mercor-data-science-2026-0425",
  title: "Data Science Expert",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "3+ Years",
  qualification: "Relevant Experience",
  salary: "$70–$120/hour",
  skills: ["SQL", "Python", "Data Analysis", "A/B Testing", "ETL"],
  responsibilities: [
    "Design data workflows",
    "Evaluate AI agents",
    "Build analytics scenarios"
  ],
  requirements: [
    "Strong SQL skills",
    "Data science experience",
    "BI/Analytics background"
  ],
  applyLink: "https://t.mercor.com/Y9VxD",
  postedDate: "2026-04-25"
},

/* ===================== JAVA DEVELOPER ===================== */
{
  id: "java-developer-dehradun-2026-0425",
  title: "Java / Software Developer",
  company: "Confidential",
  location: "Dehradun, India",
  jobType: "Full-Time",
  experience: "2–6 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Java", "Spring Boot", "REST APIs", "Microservices"],
  responsibilities: ["Develop backend services", "Build APIs"],
  requirements: ["Java experience", "Problem solving"],
  applyLink: "mailto:mehrotrakriti2@gmail.com",
  postedDate: "2026-04-25"
},

/* ===================== QA BLUE YONDER ===================== */
{
  id: "blueyonder-qa-2026-0425",
  title: "JDA Blue Yonder QA Engineer",
  company: "Confidential",
  location: "Remote",
  jobType: "Contract",
  experience: "5+ Years",
  qualification: "B.Tech / Diploma",
  salary: "₹10–20 LPA",
  skills: ["SQL", "Jira", "QA Testing", "Blue Yonder"],
  responsibilities: [
    "Test supply chain systems",
    "Validate upgrades",
    "Perform QA automation"
  ],
  requirements: ["QA experience", "SQL knowledge"],
  applyLink: "https://optimhire.com/developers/jv/309701?ref_code=mukesh-agrawal",
  postedDate: "2026-04-25"
},

/* ===================== FULL STACK CAREREVENUE ===================== */
{
  id: "fullstack-careevenue-2026-0425",
  title: "Full Stack Developer",
  company: "CareRevenue",
  location: "Kochi / Trivandrum",
  jobType: "Full-Time",
  experience: "3–10 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["React", "Node.js", "AWS", "APIs"],
  responsibilities: [
    "Build full-stack apps",
    "Integrate APIs",
    "Develop scalable systems"
  ],
  requirements: ["Full stack experience", "Cloud knowledge"],
  applyLink: "mailto:visakhgoommen@carestack.com",
  postedDate: "2026-04-25"
},

/* ===================== IT SUPPORT ===================== */
{
  id: "it-support-ahmedabad-2026-0425",
  title: "IT Support Engineer",
  company: "Hi-Tech Applicator",
  location: "Ahmedabad",
  jobType: "Full-Time",
  experience: "Fresher / Experienced",
  qualification: "Hardware & Networking Course",
  salary: "Not Disclosed",
  skills: ["Networking", "Hardware", "OS Installation"],
  responsibilities: ["System troubleshooting", "Network support"],
  requirements: ["Basic IT knowledge"],
  applyLink: "https://unstop.com/o/YV9SrkK?lb=Bnie7Jo",
  postedDate: "2026-04-25"
},

/* ===================== JUNIOR DEV ===================== */
{
  id: "junior-dev-kochi-2026-0425",
  title: "Junior Software Engineer",
  company: "Daiviksoft",
  location: "Kochi, India",
  jobType: "Full-Time",
  experience: "Fresher",
  qualification: "B.Tech / IT Degree",
  salary: "Not Disclosed",
  skills: ["Java", "Python", "JavaScript", "SQL"],
  responsibilities: [
    "Write code",
    "Fix bugs",
    "Assist senior developers"
  ],
  requirements: ["Basic programming knowledge"],
  applyLink: "mailto:neha@daiviktech.com",
  postedDate: "2026-04-25"
},

/* ===================== MERCOR STORAGE ===================== */
{
  id: "mercor-storage-2026-0425",
  title: "Cloud Storage Expert",
  company: "Mercor",
  location: "Remote (US)",
  jobType: "Contract",
  experience: "3+ Years",
  qualification: "Relevant Experience",
  salary: "$45–$60/hour",
  skills: ["AWS", "GCP", "Cloud Storage"],
  responsibilities: ["Evaluate storage systems"],
  requirements: ["Cloud experience"],
  applyLink: "https://t.mercor.com/EsA4n",
  postedDate: "2026-04-25"
},

/* ===================== SOFTWARE ENGINEER ===================== */
{
  id: "software-dev-boeing-2026-0425",
  title: "Software Programmer (.NET)",
  company: "Boeing",
  location: "Bangalore",
  jobType: "Full-Time",
  experience: "Experienced",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: [".NET", "C#", "Backend"],
  responsibilities: ["Develop systems", "Maintain applications"],
  requirements: [".NET experience"],
  applyLink: "https://www.boeing.com/careers",
  postedDate: "2026-04-25"
},


{
  id: "mercor-cloud-storage-remote-2026-0423",
  title: "Cloud Storage Management Expert",
  company: "Mercor (Cincinnatus LLC)",
  location: "Remote, US",
  jobType: "Contract (W2)",
  experience: "Experienced",
  qualification: "Relevant Experience",
  salary: "$45–$60/hour",
  skills: ["AWS S3", "GCS", "Azure", "Cloud Migration", "AI Evaluation"],
  responsibilities: [
    "Evaluate AI storage agents",
    "Test migration workflows",
    "Analyze agent responses",
    "Simulate storage traffic",
    "Provide feedback reports"
  ],
  requirements: [
    "Cloud storage expertise",
    "Migration experience",
    "Strong analysis skills"
  ],
  applyLink: "https://t.mercor.com/EsA4n",
  postedDate: "2026-04-23"
},
{
  id: "quarterfold-dev-mumbai-2026-0423",
  title: "Software Developer",
  company: "Quarterfold Printabilities",
  location: "Navi Mumbai, India",
  jobType: "Full-Time",
  experience: "3–5 Years",
  qualification: "Any Degree",
  salary: "₹7.5 – ₹10 LPA",
  skills: ["Software Development", "Adobe", "Enfocus"],
  responsibilities: [
    "Develop software solutions",
    "Work on automation workflows",
    "Solve technical issues"
  ],
  requirements: [
    "Adobe tools experience",
    "Problem-solving skills",
    "Team collaboration"
  ],
  applyLink: "mailto:hr@quarterfoldltd.com",
  postedDate: "2026-04-23"
},
{
  id: "vedha-tester-indore-2026-0423",
  title: "Senior Software Tester",
  company: "Vedha Infotech",
  location: "Indore, India",
  jobType: "Full-Time",
  experience: "1–5 Years",
  qualification: "B.E / B.Tech / Diploma",
  salary: "₹5–9 LPA",
  skills: ["Selenium", "QA Automation", "Testing"],
  responsibilities: [
    "Execute testing strategies",
    "Identify bugs",
    "Collaborate with teams"
  ],
  requirements: [
    "Testing experience",
    "Automation tools knowledge",
    "Agile understanding"
  ],
  applyLink: "https://optimhire.com/developers/jv/304404?ref_code=mukesh-agrawal",
  postedDate: "2026-04-23"
},
{
  id: "angular-sap-bangalore-2026-0423",
  title: "Senior Angular / SAP Spartacus Developer",
  company: "Shashwath Solution",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "6–10 Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Angular", "SAP Spartacus", "TypeScript", "RxJS"],
  responsibilities: [
    "Build eCommerce storefronts",
    "Optimize performance",
    "Develop UI components"
  ],
  requirements: [
    "Angular expertise",
    "Spartacus experience",
    "API knowledge"
  ],
  applyLink: "mailto:recruitment@shashwathsolution.com",
  postedDate: "2026-04-23"
},
{
  id: "resobrand-cv-ahmedabad-2026-0423",
  title: "Lead Computer Vision Engineer",
  company: "Resobrand Dynamics Industries LLP",
  location: "Ahmedabad, India",
  jobType: "Full-Time",
  experience: "3–10 Years",
  qualification: "Relevant Degree",
  salary: "₹7–10 LPA",
  skills: ["Computer Vision", "OpenCV", "YOLO", "Python"],
  responsibilities: [
    "Build CV pipelines",
    "Deploy AI models",
    "Integrate cloud APIs"
  ],
  requirements: [
    "Python expertise",
    "Video streaming knowledge",
    "Cloud deployment experience"
  ],
  applyLink: "https://unstop.com/o/62Mvo5k?lb=Bnie7Jo",
  postedDate: "2026-04-23"
},
{
  id: "randstad-sourcing-hyderabad-2026-0423",
  title: "Sourcing Specialist",
  company: "Randstad",
  location: "Hyderabad, India",
  jobType: "Hybrid",
  experience: "6+ Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Recruitment", "Boolean Search", "Talent Mapping"],
  responsibilities: [
    "Source candidates",
    "Manage stakeholders",
    "Perform talent mapping"
  ],
  requirements: [
    "Recruitment experience",
    "Search expertise",
    "Communication skills"
  ],
  applyLink: "mailto:shubhika.a@randstad.in",
  postedDate: "2026-04-23"
},
{
  id: "kg-invicta-walkin-hyderabad-2026-0423",
  title: "Process Executive - P2P / AP",
  company: "KG Invicta Services",
  location: "Hyderabad, India",
  jobType: "Walk-In",
  experience: "1–5 Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Invoice Processing", "Accounts Payable"],
  responsibilities: [
    "Handle P2P cycle",
    "Process invoices",
    "Manage accounts"
  ],
  requirements: [
    "P2P experience",
    "Accounting knowledge"
  ],
  applyLink: "tel:9994263810",
  postedDate: "2026-04-23"
},
{
  id: "cotiviti-walkin-pune-2026-0423",
  title: "Data Process (Non Voice)",
  company: "Cotiviti",
  location: "Pune, India",
  jobType: "Walk-In",
  experience: "Fresher",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Non Voice Process", "Email Support"],
  responsibilities: [
    "Handle backend operations",
    "Process data",
    "Support customers"
  ],
  requirements: [
    "Good communication",
    "Basic computer knowledge"
  ],
  applyLink: "https://www.naukri.com/",
  postedDate: "2026-04-23"
},


{
  id: "mphasis-healthcare-pune-2026-0423",
  title: "Non Voice Process - US Healthcare (Back Office)",
  company: "Mphasis",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "1–3 Years",
  qualification: "Any Degree",
  salary: "₹4.5 LPA",
  skills: ["Healthcare Claims", "Adjudication", "Provider Enrollment"],
  responsibilities: [
    "Adjudicate healthcare claims",
    "Handle provider maintenance",
    "Process insurance claims"
  ],
  requirements: [
    "Healthcare knowledge",
    "Attention to detail",
    "Basic communication"
  ],
  applyLink: "tel:9767676851",
  postedDate: "2026-04-23"
},
{
  id: "jobzkart-hr-mumbai-2026-0423",
  title: "Senior HR Executive",
  company: "Jobzkart",
  location: "Mumbai, India",
  jobType: "Full-Time",
  experience: "2–4 Years",
  qualification: "Bachelor’s Degree",
  salary: "As per market",
  skills: ["Recruitment", "HR Operations", "Stakeholder Management"],
  responsibilities: [
    "Manage recruitment lifecycle",
    "Handle onboarding",
    "Coordinate HR operations"
  ],
  requirements: [
    "HR experience",
    "Communication skills",
    "Organizational skills"
  ],
  applyLink: "mailto:tanvi@jobzkart.in",
  postedDate: "2026-04-23"
},
{
  id: "v2soft-java-usa-2026-0423",
  title: "Senior Java Developer (Azure Migration)",
  company: "V2Soft",
  location: "Texas, USA",
  jobType: "Full-Time",
  experience: "12+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Java", "Spring Boot", "Azure", "Docker"],
  responsibilities: [
    "Lead Azure migration",
    "Build microservices",
    "Design scalable systems"
  ],
  requirements: [
    "Strong Java experience",
    "Cloud expertise",
    "System design knowledge"
  ],
  applyLink: "mailto:Dkumarmr@v2soft.com",
  postedDate: "2026-04-23"
},
{
  id: "axa-french-pune-2026-0423",
  title: "Process Lead (French Language)",
  company: "AXA GBS",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "3–6 Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["French B1+", "Accounting"],
  responsibilities: [
    "Handle accounting processes",
    "Communicate with French clients",
    "Manage operations"
  ],
  requirements: [
    "French proficiency",
    "Accounting knowledge",
    "Communication skills"
  ],
  applyLink: "mailto:pooja.rathi@axa.com",
  postedDate: "2026-04-23"
},
{
  id: "muthoot-hr-mumbai-2026-0423",
  title: "HR - Talent Acquisition & Business Partner",
  company: "Muthoot Fincorp",
  location: "Mumbai, India",
  jobType: "Full-Time",
  experience: "3+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["HRBP", "Hiring"],
  responsibilities: [
    "Manage recruitment",
    "Handle onboarding",
    "Support business teams"
  ],
  requirements: [
    "HR experience",
    "People management",
    "Communication skills"
  ],
  applyLink: "mailto:zarna.r@muthoot.com",
  postedDate: "2026-04-23"
},
{
  id: "tcs-walkin-mumbai-2026-0423",
  title: "Walk-In Drive (Java, Testing, Automation)",
  company: "TCS",
  location: "Mumbai, India",
  jobType: "Walk-In",
  experience: "Experienced",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Java", "Testing", "Automation"],
  responsibilities: [
    "Develop and test applications",
    "Ensure software quality",
    "Collaborate with teams"
  ],
  requirements: [
    "Relevant experience",
    "Technical skills",
    "Problem-solving"
  ],
  applyLink: "https://www.tcs.com/careers",
  postedDate: "2026-04-23"
},
{
  id: "rupeedot-intern-pune-2026-0423",
  title: "Business Development Intern",
  company: "RupeeDot",
  location: "Pune, India",
  jobType: "Internship",
  experience: "Fresher",
  qualification: "Any Degree",
  salary: "₹8,000 + Incentives",
  skills: ["Sales", "Communication"],
  responsibilities: [
    "Acquire clients",
    "Support sales team",
    "Drive growth"
  ],
  requirements: [
    "Good communication",
    "Interest in sales"
  ],
  applyLink: "https://wa.me/917977471289",
  postedDate: "2026-04-23"
},
{
  id: "ushealthcare-pune-2026-0423",
  title: "Medical Records Retrieval Executive",
  company: "US Healthcare Process",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "Fresher / 1+ Year",
  qualification: "Any Degree",
  salary: "₹23K – ₹40K",
  skills: ["Communication"],
  responsibilities: [
    "Retrieve medical records",
    "Handle calls",
    "Maintain data"
  ],
  requirements: [
    "Communication skills",
    "Basic knowledge"
  ],
  applyLink: "tel:9373267861",
  postedDate: "2026-04-23"
},
{
  id: "telecaller-pune-2026-0423",
  title: "Telecaller",
  company: "Telecalling Company",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "Fresher",
  qualification: "Any Degree",
  salary: "₹15K – ₹30K",
  skills: ["Communication", "Sales"],
  responsibilities: [
    "Handle calls",
    "Generate leads",
    "Support customers"
  ],
  requirements: [
    "Good communication",
    "Basic sales knowledge"
  ],
  applyLink: "tel:7972640688",
  postedDate: "2026-04-23"
},
{
  id: "oracle-datascientist-2026-0423",
  title: "Applied Data Scientist 3",
  company: "Oracle",
  location: "Not Specified",
  jobType: "Full-Time",
  experience: "3–5+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Python", "ML", "NLP", "PySpark"],
  responsibilities: [
    "Build AI models",
    "Work on NLP",
    "Develop scalable systems"
  ],
  requirements: [
    "ML experience",
    "Python skills",
    "Data knowledge"
  ],
  applyLink: "https://www.oracle.com/careers",
  postedDate: "2026-04-23"
},
{
  id: "techcloud-fullstack-2026-0423",
  title: "Software Developer / Full Stack",
  company: "TechCloud",
  location: "Work From Home",
  jobType: "Full-Time",
  experience: "0–7 Years",
  qualification: "Any Degree",
  salary: "₹4 – ₹34 LPA",
  skills: ["Java", "Python", "React", "APIs"],
  responsibilities: [
    "Develop applications",
    "Work on frontend & backend",
    "Solve problems"
  ],
  requirements: [
    "Programming skills",
    "API knowledge"
  ],
  applyLink: "mailto:hr_sujal@techcloud.co",
  postedDate: "2026-04-23"
},
{
  id: "accenture-support-coimbatore-2026-0423",
  title: "IT Customer Support Associate",
  company: "Accenture",
  location: "Coimbatore, India",
  jobType: "Full-Time",
  experience: "0–2 Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Troubleshooting", "Cloud Basics"],
  responsibilities: [
    "Resolve technical issues",
    "Support users",
    "Maintain systems"
  ],
  requirements: [
    "Basic IT knowledge",
    "Communication skills"
  ],
  applyLink: "https://www.accenture.com/in-en/careers",
  postedDate: "2026-04-23"
},
{
  id: "winlancer-intern-indore-2026-0423",
  title: "Software Developer Intern",
  company: "Winlancer",
  location: "Indore, India",
  jobType: "Internship",
  experience: "Fresher",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Programming", "APIs"],
  responsibilities: [
    "Work on projects",
    "Support development",
    "Learn technologies"
  ],
  requirements: [
    "Programming basics",
    "Interest in development"
  ],
  applyLink: "mailto:swati.raghuvanshi@winlancers.com",
  postedDate: "2026-04-23"
},
{
  id: "cgi-azure-pune-2026-0423",
  title: "Azure Infra Expert",
  company: "CGI",
  location: "Pune / Bangalore, India",
  jobType: "Full-Time",
  experience: "6+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Azure", "Cloud", "Networking"],
  responsibilities: [
    "Manage cloud infrastructure",
    "Ensure security",
    "Deploy solutions"
  ],
  requirements: [
    "Azure experience",
    "Networking knowledge"
  ],
  applyLink: "https://www.cgi.com/careers",
  postedDate: "2026-04-23"
},
{
  id: "logitech-cpp-chennai-2026-0423",
  title: "Senior Software Engineer (C++)",
  company: "Logitech",
  location: "Chennai, India",
  jobType: "Full-Time",
  experience: "5–8 Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["C++", "OOP"],
  responsibilities: [
    "Develop applications",
    "Debug systems",
    "Optimize performance"
  ],
  requirements: [
    "Strong C++ skills",
    "Debugging experience"
  ],
  applyLink: "mailto:manjula@softpathtech.com",
  postedDate: "2026-04-23"
},
{
  id: "insight-soc-2026-0423",
  title: "Sr. SOC Analyst (Zscaler)",
  company: "Insight",
  location: "Bangalore / Hyderabad / Delhi NCR, India",
  jobType: "Full-Time",
  experience: "5+ Years",
  qualification: "Bachelor’s Degree",
  salary: "Not Disclosed",
  skills: ["Zscaler", "Security"],
  responsibilities: [
    "Monitor threats",
    "Ensure network security",
    "Analyze incidents"
  ],
  requirements: [
    "Security experience",
    "Networking knowledge"
  ],
  applyLink: "https://www.insight.com/en_US/careers.html",
  postedDate: "2026-04-23"
},
{
  id: "agastik-dev-gurgaon-2026-0423",
  title: "Software Developer",
  company: "Agastik",
  location: "Gurgaon, India",
  jobType: "Full-Time",
  experience: "Fresher",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["HTML", "CSS", "JavaScript"],
  responsibilities: [
    "Develop web apps",
    "Write clean code",
    "Solve problems"
  ],
  requirements: [
    "Basic web skills",
    "DSA knowledge"
  ],
  applyLink: "mailto:rupika.singh@agastik.com",
  postedDate: "2026-04-23"
},
{
  id: "blackhawk-engineer-2026-0423",
  title: "Software Engineer II",
  company: "Blackhawk Network",
  location: "Not Specified",
  jobType: "Full-Time",
  experience: "2–4 Years",
  qualification: "Any Degree",
  salary: "Not Disclosed",
  skills: ["Java", "APIs", "Backend"],
  responsibilities: [
    "Develop backend systems",
    "Maintain applications",
    "Collaborate with teams"
  ],
  requirements: [
    "Java experience",
    "Problem-solving"
  ],
  applyLink: "https://apac-blackhawknetwork.icims.com/jobs/25917/software-engineer-ii/job",
  postedDate: "2026-04-23"
},
  {
    id: "software-engineer-ii-blackhawk-2026-0422",
    title: "Software Engineer II",
    company: "Blackhawk Network",
    location: "Not Specified",
    jobType: "Full-Time",
    experience: "2–4 Years",
    qualification: "Any Degree",
    salary: "Not Disclosed",
    skills: ["Java", "Backend Development", "APIs", "System Design"],
    responsibilities: [
      "Develop and maintain software solutions",
      "Work on backend systems",
      "Collaborate with engineering teams"
    ],
    requirements: [
      "2–4 years experience",
      "Strong programming skills",
      "Problem-solving ability"
    ],
    applyLink: "https://apac-blackhawknetwork.icims.com/jobs/25917/software-engineer-ii/job",
    postedDate: "2026-04-22"
  },
  {
    id: "software-engineer-yokogawa-2026-0422",
    title: "Software Engineer",
    company: "Yokogawa",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "2–3 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "Python", "Software Development", "APIs"],
    responsibilities: [
      "Develop software applications",
      "Maintain systems",
      "Collaborate with teams"
    ],
    requirements: [
      "2–3 years experience",
      "Software development knowledge"
    ],
    applyLink: "https://wd3.myworkdaysite.com/en-US/recruiting/yokogawa",
    postedDate: "2026-04-22"
  },
  {
    id: "software-engineer-nielsen-2026-0422",
    title: "Software Engineer (Backend Java)",
    company: "Nielsen",
    location: "Not Specified",
    jobType: "Full-Time",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "Backend Development", "SQL", "APIs"],
    responsibilities: [
      "Develop backend services",
      "Maintain scalable systems",
      "Optimize performance"
    ],
    requirements: [
      "2+ years experience",
      "Strong Java skills"
    ],
    applyLink: "https://jobs.smartrecruiters.com/TheNielsenCompany",
    postedDate: "2026-04-22"
  },
  {
    id: "junior-sdet-apple-2026-0422",
    title: "Junior Software Developer in Test",
    company: "Apple",
    location: "India",
    jobType: "Full-Time",
    experience: "1–2 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹15–24 LPA",
    skills: ["Testing", "Automation", "SDET", "Python", "Java"],
    responsibilities: [
      "Develop automated test systems",
      "Ensure software quality",
      "Work with engineering teams"
    ],
    requirements: [
      "1–2 years experience",
      "Testing knowledge",
      "Programming skills"
    ],
    applyLink: "https://jobs.apple.com/en-us/details/200638113-0321",
    postedDate: "2026-04-22"
  },
  {
    id: "associate-devops-engineer-dhl-2026-0422",
    title: "Associate DevOps Engineer",
    company: "DHL IT Services",
    location: "Chennai, India",
    jobType: "Full-Time",
    experience: "1–3 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["DevOps", "CI/CD", "AWS", "Docker", "Kubernetes", "GitHub Actions"],
    responsibilities: [
      "Maintain production systems",
      "Support deployments",
      "Work on AI-driven workflows",
      "Incident management"
    ],
    requirements: [
      "DevOps knowledge",
      "CI/CD experience",
      "Good communication skills"
    ],
    applyLink: "https://careers.dhl.com/global/en/job/DPDHGLOBALAV348184",
    postedDate: "2026-04-22"
  },
  {
    id: "dotnet-developer-goa-2026-0422",
    title: "Software Developer (.NET)",
    company: "Diligent Growth",
    location: "Goa, India",
    jobType: "Full-Time",
    experience: "2+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["C#", ".NET", "ASP.NET", "SQL Server", "APIs"],
    responsibilities: [
      "Develop web applications",
      "Maintain backend systems",
      "Debug and test applications"
    ],
    requirements: [
      ".NET experience",
      "SQL knowledge",
      "Web development skills"
    ],
    applyLink: "mailto:Janhavi@diligentgrowth.com",
    postedDate: "2026-04-22"
  },
  {
    id: "cognizant-genc-2026-0422",
    title: "Analyst Trainee (GenC)",
    company: "Cognizant",
    location: "PAN India",
    jobType: "Full-Time",
    experience: "Freshers (2024/2025 batch)",
    qualification: "BCA / BSc / IT / Related",
    salary: "Not Disclosed",
    skills: ["SQL", "DBMS", "ITSM", "Problem Solving", "Testing"],
    responsibilities: [
      "Work on IT services",
      "Perform database operations",
      "Support production systems",
      "Resolve tickets"
    ],
    requirements: [
      "Freshers only",
      "60% academic criteria",
      "Good communication skills"
    ],
    applyLink: "https://app.joinsuperset.com",
    postedDate: "2026-04-22"
  },
  {
    id: "software-developer-intern-aju-2026-0422",
    title: "Software Developer Intern",
    company: "AJU ED Solutions LLP",
    location: "Trivandrum, India",
    jobType: "Internship",
    experience: "Freshers / Students",
    qualification: "2024–2026 Batch",
    salary: "₹20,000/month",
    skills: ["MERN", "Python", "Django", "FastAPI", "MongoDB"],
    responsibilities: [
      "Build real-world applications",
      "Develop backend systems",
      "Work on APIs",
      "Collaborate with team"
    ],
    requirements: [
      "MERN knowledge",
      "Python basics",
      "Willingness to learn"
    ],
    applyLink: "mailto:Info@ajuedsolutions.com",
    postedDate: "2026-04-22"
  },
  {
    id: "trainee-siemens-2026-0422",
    title: "Trainee",
    company: "Siemens",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Basic Technical Skills", "Communication", "Problem Solving"],
    responsibilities: [
      "Assist in project tasks",
      "Learn and support engineering processes",
      "Collaborate with teams"
    ],
    requirements: [
      "Bachelor’s degree",
      "Willingness to learn",
      "Good communication skills"
    ],
    applyLink: "https://jobs.siemens.com/en_US/externaljobs/JobDetail/502641",
    postedDate: "2026-04-22"
  },
  {
    id: "software-engineer-associate-infor-2026-0422",
    title: "Software Engineer, Associate",
    company: "Infor",
    location: "Hyderabad, India",
    jobType: "Full-Time",
    experience: "Freshers/Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Programming", "Java", "SQL", "Problem Solving"],
    responsibilities: [
      "Develop and maintain applications",
      "Collaborate with teams",
      "Debug and test software"
    ],
    requirements: [
      "Bachelor’s degree",
      "Basic coding knowledge",
      "Analytical thinking"
    ],
    applyLink: "https://careers.infor.com/en_US/careers/JobDetail/Software-Engineer-Associate/19766",
    postedDate: "2026-04-22"
  },
  {
    id: "laravel-developer-getlead-2026-0422",
    title: "Laravel Developer",
    company: "Getlead Analytics Pvt Ltd",
    location: "Kozhikode, India",
    jobType: "Full-Time",
    experience: "3–10 Years",
    qualification: "Any Degree",
    salary: "₹3–6 LPA",
    skills: ["Laravel", "PHP", "Backend Development", "APIs", "Database"],
    responsibilities: [
      "Develop backend applications",
      "Maintain scalable systems",
      "Work with APIs and databases"
    ],
    requirements: [
      "Strong Laravel knowledge",
      "Backend development experience",
      "Team collaboration skills"
    ],
    applyLink: "https://unstop.com/o/QaAbg1S",
    postedDate: "2026-04-22"
  },
  {
    id: "automation-engineer-archelos-2026-0422",
    title: "Automation Engineer",
    company: "Archelos Tech",
    location: "Remote/Hybrid",
    jobType: "Full-Time",
    experience: "3+ Years",
    qualification: "Any Degree",
    salary: "Up to ₹1.2 LPM",
    skills: ["JavaScript", "Excel VBA", "Power Automate", "Power BI"],
    responsibilities: [
      "Build automation systems",
      "Work on campaign QA",
      "Improve workflows"
    ],
    requirements: [
      "Automation experience",
      "JavaScript knowledge",
      "Analytical skills"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-04-22"
  },
  {
    id: "devops-engineer-archelos-2026-0422",
    title: "DevOps Engineer",
    company: "Archelos Tech",
    location: "Noida/Delhi",
    jobType: "Full-Time",
    experience: "4+ Years",
    qualification: "Any Degree",
    salary: "Up to ₹1.5 LPM",
    skills: ["CI/CD", "AWS", "Azure", "Docker", "Kubernetes"],
    responsibilities: [
      "Manage CI/CD pipelines",
      "Deploy cloud infrastructure",
      "Maintain DevOps workflows"
    ],
    requirements: [
      "4+ years experience",
      "Cloud knowledge",
      "CI/CD expertise"
    ],
    applyLink: "mailto:jobs@archelostech.com",
    postedDate: "2026-04-22"
  },
  {
    id: "react-native-intern-solveease-2026-0422",
    title: "React Native Developer Intern",
    company: "SolveEase Technologies",
    location: "Remote",
    jobType: "Internship",
    experience: "Freshers",
    qualification: "Any Degree",
    salary: "₹15K–₹25K/month",
    skills: ["React Native", "Android", "Git", "Mobile Development"],
    responsibilities: [
      "Develop mobile apps",
      "Collaborate with teams",
      "Debug and maintain apps"
    ],
    requirements: [
      "React Native knowledge",
      "Android basics",
      "Team collaboration"
    ],
    applyLink: "https://abekus.ai/public-job-search/react-native-mobile-application-developer",
    postedDate: "2026-04-22"
  },
  {
    id: "itsm-manager-2026-0422",
    title: "Problem & Knowledge Manager",
    company: "Confidential",
    location: "Open/Global",
    jobType: "Full-Time",
    experience: "15+ Years",
    qualification: "Any Degree",
    salary: "Not Disclosed",
    skills: ["ITIL", "ServiceNow", "RCA", "ITSM"],
    responsibilities: [
      "Manage ITSM processes",
      "Drive RCA improvements",
      "Enhance service quality"
    ],
    requirements: [
      "15+ years experience",
      "ITIL expertise",
      "ServiceNow knowledge"
    ],
    applyLink: "mailto:Himabindu.n@teizosoft.com",
    postedDate: "2026-04-22"
  },
  {
    id: "junior-web-developer-2026-0422",
    title: "Junior Web Developer",
    company: "QSAP Poultry",
    location: "Karnal, India",
    jobType: "Full-Time",
    experience: "2–4 Years",
    qualification: "IT/CS Graduate",
    salary: "Not Disclosed",
    skills: ["Google Apps Script", "HTML", "CSS", "JavaScript", "Automation"],
    responsibilities: [
      "Develop internal tools",
      "Automate workflows",
      "Manage dashboards"
    ],
    requirements: [
      "Google Sheets expertise",
      "Apps Script knowledge",
      "Basic web dev skills"
    ],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSc0-VsqcEM-wmufcxXyunmQRdiw00FAyE9tjLdvWID5h2-4oA/viewform",
    postedDate: "2026-04-22"
  },
  {
    id: "data-analyst-intern-2026-0422",
    title: "Data Analyst Intern",
    company: "Demandify Media",
    location: "Pune, India",
    jobType: "Internship",
    experience: "Freshers",
    qualification: "Graduate",
    salary: "Not Disclosed",
    skills: ["Excel", "Data Analysis", "Reporting"],
    responsibilities: [
      "Analyze datasets",
      "Create reports",
      "Assist in business insights"
    ],
    requirements: [
      "Excel knowledge",
      "Analytical skills",
      "Freshers welcome"
    ],
    applyLink: "mailto:pooja.chitale@demandifymedia.com",
    postedDate: "2026-04-22"
  },


{
  id: "mern-ai-python-developer-softborne-2026-0422",
  title: "MERN Stack - AI - Python Developer",
  company: "Softborne Technology Solutions Pte. Ltd.",
  location: "Chennai, India",
  jobType: "Full-Time",
  experience: "2–5 Years",
  qualification: "B.E / B.Tech / Diploma (Electrical / Electronics)",
  salary: "₹3–12 LPA",
  skills: [
    "React",
    "Node.js",
    "MongoDB",
    "Express.js",
    "Python",
    "FastAPI",
    "TensorFlow",
    "PyTorch",
    "scikit-learn",
    "REST APIs",
    "GraphQL",
    "Microservices",
    "Agentic AI",
    "LangGraph",
    "n8n",
    "Neo4j",
    "DevOps"
  ],
  responsibilities: [
    "Develop end-to-end MERN stack applications with AI features",
    "Integrate and optimize Python-based ML models",
    "Collaborate with data science and UI/UX teams",
    "Write clean, reusable, and scalable code",
    "Participate in agile development processes",
    "Monitor performance and improve scalability"
  ],
  requirements: [
    "2–5 years MERN stack experience",
    "Strong Python and AI/ML knowledge",
    "Experience with REST APIs and microservices",
    "Knowledge of Agentic AI applications",
    "Good communication and problem-solving skills"
  ],
  applyLink: "https://optimhire.com/developers/jv/309498",
  postedDate: "2026-04-22"
},
  {
    id: "software-engineering-data-science-expert-mercor-2026-0422",
    title: "Software Engineering / Data Science / Systems Design Expert",
    company: "Mercor",
    location: "Remote (Global)",
    jobType: "Contract (Full-time / Part-time)",
    experience: "3+ Years",
    qualification: "BS/MS/PhD in Computer Science or related field",
    salary: "$60–$100 per hour",
    skills: [
      "Python",
      "Java",
      "C++",
      "JavaScript",
      "System Design",
      "Data Structures & Algorithms",
      "LLMs",
      "Code Evaluation",
      "Problem Solving"
    ],
    responsibilities: [
      "Evaluate AI-generated coding responses",
      "Validate code outputs and logic",
      "Annotate and improve AI responses",
      "Assess code quality and reasoning",
      "Ensure alignment with engineering best practices"
    ],
    requirements: [
      "3+ years software engineering experience",
      "Strong DSA and problem-solving skills",
      "Expertise in at least 2 programming languages",
      "Experience with LLM tools",
      "Ability to solve medium/hard coding problems"
    ],
    applyLink: "https://t.mercor.com/NPt9K",
    postedDate: "2026-04-22"
  },

  {
    id: "platform-engineer-ai-devex-scrabble-2026-0422",
    title: "Platform Engineer (AI + DevEx)",
    company: "Scrabble",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "Not Specified (Mid/Senior Level)",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Platform Engineering",
      "DevEx",
      "CI/CD",
      "Infrastructure",
      "LLMs",
      "AI Workflows",
      "Automation",
      "DevOps"
    ],
    responsibilities: [
      "Build internal developer platforms",
      "Create CI/CD pipelines and tooling",
      "Develop AI-powered engineering systems",
      "Improve developer productivity",
      "Optimize infrastructure and costs"
    ],
    requirements: [
      "Experience in platform engineering or DevEx",
      "Hands-on with CI/CD and infra tools",
      "Experience with AI/LLM workflows",
      "Strong ownership mindset"
    ],
    applyLink: "mailto:rohit@scrabbleinc.in",
    postedDate: "2026-04-22"
  },

  {
    id: "graduate-apprentice-trainee-volvo-2026-0422",
    title: "Graduate Apprentice Trainee",
    company: "Volvo",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Finance Basics",
      "Business Support",
      "Communication",
      "Analytical Skills"
    ],
    responsibilities: [
      "Assist finance and business support operations",
      "Work with teams on daily activities",
      "Support reporting and analysis"
    ],
    requirements: [
      "Bachelor’s degree",
      "Good communication skills",
      "Willingness to learn"
    ],
    applyLink: "https://jobs.volvogroup.com/job/Bangalore-Graduate-Apprentice-Trainee-Finance-&-Business-Support-coordinator-562122/1349232155/",
    postedDate: "2026-04-22"
  },

  {
    id: "software-developer-ericsson-2026-0422",
    title: "Software Developer",
    company: "Ericsson",
    location: "Not Specified",
    jobType: "Full-Time",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s / Master’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Programming",
      "Software Development",
      "Problem Solving",
      "Debugging"
    ],
    responsibilities: [
      "Develop and maintain software applications",
      "Collaborate with teams",
      "Debug and optimize code"
    ],
    requirements: [
      "Relevant degree",
      "Basic programming knowledge",
      "Good problem-solving skills"
    ],
    applyLink: "https://jobs.ericsson.com/careers/job/563121774689542",
    postedDate: "2026-04-22"
  },

  {
    id: "analyst-razorpay-2026-0422",
    title: "Analyst",
    company: "Razorpay",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "Not Specified",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Data Analysis",
      "Excel",
      "SQL",
      "Problem Solving"
    ],
    responsibilities: [
      "Analyze business data",
      "Generate insights",
      "Support decision-making"
    ],
    requirements: [
      "Analytical mindset",
      "Good communication skills"
    ],
    applyLink: "http://job-boards.greenhouse.io/razorpaysoftwareprivatelimited/jobs/4686366005",
    postedDate: "2026-04-22"
  },

  {
    id: "operations-manager-hcltech-2026-0422",
    title: "Operations Manager",
    company: "HCLTech",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "10+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "People Management",
      "Operations",
      "Communication",
      "Service Management"
    ],
    responsibilities: [
      "Manage service teams",
      "Ensure smooth delivery operations",
      "Coordinate across teams"
    ],
    requirements: [
      "10+ years experience",
      "Strong communication skills",
      "Willingness to work in shifts"
    ],
    applyLink: "mailto:bppmoffice@hcltech.com",
    postedDate: "2026-04-22"
  },

  {
    id: "software-engineering-manager-data-apple-2026-0422",
    title: "Software Engineering Manager - Data",
    company: "Apple",
    location: "Hyderabad, India",
    jobType: "Full-Time",
    experience: "12+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Big Data",
      "AWS",
      "Snowflake",
      "Spark",
      "Kafka",
      "SQL",
      "Leadership"
    ],
    responsibilities: [
      "Lead data engineering teams",
      "Design scalable data pipelines",
      "Build analytics solutions",
      "Collaborate with global teams"
    ],
    requirements: [
      "12+ years experience",
      "4+ years leadership experience",
      "Strong cloud and data stack knowledge"
    ],
    applyLink: "https://jobs.apple.com/en-us/details/200631154/software-engineering-manager-data",
    postedDate: "2026-04-22"
  },

  {
    id: "software-test-engineer-remote-2026-0422",
    title: "Software Test Engineer",
    company: "MetaOption",
    location: "Remote",
    jobType: "Full-Time",
    experience: "5+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Testing",
      "Automation",
      "QA",
      "Debugging"
    ],
    responsibilities: [
      "Test software applications",
      "Ensure quality and performance",
      "Report bugs and issues"
    ],
    requirements: [
      "5+ years testing experience",
      "Attention to detail",
      "Night shift availability"
    ],
    applyLink: "mailto:nihal.khan@metaoption.com",
    postedDate: "2026-04-22"
  },

{
  id: "custom-software-engineer-sap-isu-accenture-2026-0421",
  title: "Custom Software Engineer (SAP IS-U Billing)",
  company: "Accenture",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "2–5 Years",
  qualification: "Any Graduation (15 years full-time education required)",
  salary: "Not Disclosed",
  skills: [
    "SAP IS-U Billing",
    "SAP ABAP Debugging",
    "Requirement Gathering",
    "Functional Design",
    "Agile Methodology",
    "Software Development Lifecycle",
    "Database Management"
  ],
  responsibilities: [
    "Design and implement SAP IS-U Billing solutions",
    "Analyze and redesign business processes",
    "Provide SAP functional design based on requirements",
    "Support issue resolution in IS-U Billing",
    "Collaborate with stakeholders for requirements",
    "Perform testing and debugging of applications",
    "Work independently as an SME"
  ],
  requirements: [
    "2–5 years experience in SAP IS-U Billing",
    "Strong understanding of SDLC and agile practices",
    "Experience with databases and programming frameworks",
    "Basic SAP ABAP debugging knowledge",
    "Ability to handle end-to-end project delivery"
  ],
  applyLink: "https://www.accenture.com/in-en/careers/jobdetails?id=ATCI-5373411-S1961111_en",
  postedDate: "2026-04-21"
},


  {
    id: "trainee-dotnet-developer-2026-0421",
    title: "Trainee .NET Developer",
    company: "Not Specified",
    location: "Not Specified",
    jobType: "Full-Time",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [".NET", "C#", "ASP.NET", "SQL"],
    responsibilities: [
      "Assist in .NET development",
      "Debug and maintain applications",
      "Work with senior developers"
    ],
    requirements: [
      "Basic .NET knowledge",
      "Willingness to learn"
    ],
    applyLink: "https://www.linkedin.com/posts/shivangi-kadam-005882131_we-are-hiring-trainee-net-share-7451932127958511616-bKQJ",
    postedDate: "2026-04-21"
  },

  {
    id: "junior-ai-engineer-2026-0421",
    title: "Junior AI Engineer",
    company: "Not Specified",
    location: "Not Specified",
    jobType: "Full-Time",
    experience: "0-2 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Python", "Machine Learning", "AI"],
    responsibilities: [
      "Assist in AI model development",
      "Work with datasets",
      "Support ML pipelines"
    ],
    requirements: [
      "Basic AI/ML knowledge",
      "Python skills"
    ],
    applyLink: "https://www.linkedin.com/posts/abdulrahman-ahmed-alemam-595446317_were-hiring-a-junior-ai-engineer-from-0-share-7451952599177584641-LjFY",
    postedDate: "2026-04-21"
  },

  {
    id: "internship-freshers-2026-0421",
    title: "Internship Opportunities",
    company: "Not Specified",
    location: "Not Specified",
    jobType: "Internship",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Basic Programming", "Communication"],
    responsibilities: [
      "Assist in projects",
      "Learn industry tools"
    ],
    requirements: [
      "Fresher candidates",
      "Learning attitude"
    ],
    applyLink: "https://www.linkedin.com/posts/shreejith-mani-284636172_hiring-internship-freshers-share-7451884116385378304-KuUo",
    postedDate: "2026-04-21"
  },

  {
    id: "campus-hiring-2026-0421",
    title: "Campus Hiring Roles",
    company: "Not Specified",
    location: "India",
    jobType: "Full-Time",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Communication", "Problem Solving"],
    responsibilities: [
      "Work in entry-level roles",
      "Participate in training"
    ],
    requirements: [
      "Recent graduates",
      "Basic skills"
    ],
    applyLink: "https://www.linkedin.com/posts/singh-poonam_campushiring-universitypartnerships-collegeplacements-share-7452237524703395840-WGhY",
    postedDate: "2026-04-21"
  },

  {
    id: "technical-support-engineer-microsoft-2026-0421",
    title: "Technical Support Engineering",
    company: "Microsoft",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Technical Support", "Networking", "Cloud"],
    responsibilities: [
      "Resolve customer issues",
      "Provide technical support",
      "Collaborate with teams"
    ],
    requirements: [
      "Technical troubleshooting skills",
      "Good communication"
    ],
    applyLink: "https://apply.careers.microsoft.com/careers/job/1970393556852814",
    postedDate: "2026-04-21"
  },

  {
    id: "it-services-consulting-expert-mercor-2026-0421",
    title: "IT Services Consulting Expert",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "$65–$85/hour",
    skills: ["Cloud", "Cybersecurity", "Data Engineering"],
    responsibilities: [
      "Evaluate AI outputs",
      "Create consulting workflows",
      "Provide feedback"
    ],
    requirements: [
      "3+ years IT consulting experience"
    ],
    applyLink: "https://t.mercor.com/gSyeO",
    postedDate: "2026-04-21"
  },

  {
    id: "software-developer-remote-japan-2026-0421",
    title: "Software Developer (Remote - India)",
    company: "Confidential",
    location: "Remote",
    jobType: "Full-Time",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["JavaScript", "Java", "C#", "React"],
    responsibilities: [
      "Develop applications",
      "Work with global team"
    ],
    requirements: [
      "3+ years experience",
      "API knowledge"
    ],
    applyLink: "mailto:shilpa@hafman.ca",
    postedDate: "2026-04-21"
  },

  {
    id: "sr-mlops-engineer-2026-0421",
    title: "Sr MLOps Engineer",
    company: "OptimHire",
    location: "Remote",
    jobType: "Full-Time",
    experience: "5–8 Years",
    qualification: "B.Tech",
    salary: "₹15–18 LPA",
    skills: ["Azure", "ML", "Kubernetes", "Docker"],
    responsibilities: [
      "Build ML pipelines",
      "Deploy models"
    ],
    requirements: [
      "5+ years experience",
      "Azure expertise"
    ],
    applyLink: "https://optimhire.com/developers/jv/309591",
    postedDate: "2026-04-21"
  },

  {
    id: "salesforce-developer-2026-0421",
    title: "Salesforce Developer",
    company: "Shrine Software",
    location: "Ahmedabad, India",
    jobType: "Full-Time",
    experience: "4+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Apex", "LWC", "Salesforce"],
    responsibilities: [
      "Develop Salesforce apps",
      "Work on integrations"
    ],
    requirements: [
      "4+ years experience"
    ],
    applyLink: "mailto:hr@shrinesoft.com",
    postedDate: "2026-04-21"
  },

  {
    id: "sap-dm-associate-2026-0421",
    title: "SAP DM Associate",
    company: "SAAP Technologies",
    location: "Chennai, India",
    jobType: "Full-Time",
    experience: "3–10 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹3–6 LPA",
    skills: ["SAP", "Data Migration"],
    responsibilities: [
      "Handle SAP migration",
      "Data validation"
    ],
    requirements: [
      "SAP experience"
    ],
    applyLink: "https://unstop.com/o/fyVWOwp",
    postedDate: "2026-04-21"
  },

  {
    id: "erp-application-manager-2026-0421",
    title: "ERP Application Manager",
    company: "SIES",
    location: "Navi Mumbai",
    jobType: "Full-Time",
    experience: "8–10 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["ERP", "HRMS"],
    responsibilities: [
      "Manage ERP implementation",
      "Coordinate stakeholders"
    ],
    requirements: [
      "ERP experience"
    ],
    applyLink: "mailto:jaid@sies.edu.in",
    postedDate: "2026-04-21"
  },

  {
    id: "data-analyst-intern-2026-0421",
    title: "Data Analyst Intern",
    company: "Frugality Fintech",
    location: "Pune (Hybrid)",
    jobType: "Internship",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "₹5K–₹10K/month",
    skills: ["Python", "SQL", "Pandas"],
    responsibilities: [
      "Data analysis",
      "Build pipelines"
    ],
    requirements: [
      "Basic Python & SQL"
    ],
    applyLink: "https://abekus.ai/public-job-search/data-analyst-internship-1",
    postedDate: "2026-04-21"
  },

  {
    id: "software-developers-thynk-2026-0421",
    title: "Software Developers (Multiple Roles)",
    company: "Thynk Unlimited",
    location: "South India",
    jobType: "Full-Time",
    experience: "Fresher/Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: ["Java", "Python", "React"],
    responsibilities: [
      "Develop applications",
      "Work in teams"
    ],
    requirements: [
      "Programming knowledge"
    ],
    applyLink: "mailto:thynkunlimitedcorparation@outlook.com",
    postedDate: "2026-04-21"
  },

  {
    id: "it-services-consulting-expert-mercor-2026-0421",
    title: "IT Services Consulting Expert",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree (Preferred)",
    salary: "$65–$85 per hour",
    skills: [
      "Cloud Architecture",
      "Cybersecurity",
      "Data Engineering",
      "IT Strategy",
      "Enterprise Architecture",
      "AWS/Azure/GCP",
      "AI Evaluation"
    ],
    responsibilities: [
      "Evaluate AI-generated outputs for IT consulting tasks",
      "Create real-world consulting scenarios",
      "Annotate and validate data",
      "Provide feedback on AI performance",
      "Collaborate with research teams"
    ],
    requirements: [
      "3+ years in IT services or consulting",
      "Experience in cloud, cybersecurity, or data engineering",
      "Strong analytical and communication skills"
    ],
    applyLink: "https://t.mercor.com/gSyeO",
    postedDate: "2026-04-21"
  },

  {
    id: "software-developer-remote-japan-team-2026-0421",
    title: "Software Developer (Remote – India)",
    company: "Confidential (Japanese Team)",
    location: "Remote (India)",
    jobType: "Full-Time",
    experience: "3+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "JavaScript",
      "Java",
      "C#",
      "React",
      "Vue",
      "REST APIs",
      "Web Development"
    ],
    responsibilities: [
      "Develop web applications",
      "Work with international clients",
      "Integrate APIs",
      "Collaborate with global teams"
    ],
    requirements: [
      "3+ years development experience",
      "Strong coding skills",
      "Frontend experience (React/Vue)"
    ],
    applyLink: "mailto:shilpa@hafman.ca",
    postedDate: "2026-04-21"
  },

  {
    id: "sr-mlops-engineer-remote-2026-0421",
    title: "Sr MLOps Engineer",
    company: "OptimHire",
    location: "Remote",
    jobType: "Full-Time",
    experience: "5–8 Years",
    qualification: "B.E / B.Tech / Diploma",
    salary: "₹15–18 LPA",
    skills: [
      "Machine Learning",
      "Azure",
      "Databricks",
      "PySpark",
      "Kubernetes",
      "Docker",
      "CI/CD",
      "GitHub Actions"
    ],
    responsibilities: [
      "Build ML pipelines",
      "Deploy models using AKS & Docker",
      "Manage CI/CD workflows",
      "Optimize ML lifecycle",
      "Collaborate with teams"
    ],
    requirements: [
      "5+ years experience",
      "Strong Azure ML knowledge",
      "Experience with Kubernetes and DevOps"
    ],
    applyLink: "https://optimhire.com/developers/jv/309591",
    postedDate: "2026-04-21"
  },

  {
    id: "salesforce-developer-shrine-software-2026-0421",
    title: "Salesforce Developer",
    company: "Shrine Software Services Pvt Ltd",
    location: "Ahmedabad, India",
    jobType: "Full-Time",
    experience: "4+ Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Apex",
      "Lightning Web Components",
      "Salesforce",
      "REST APIs",
      "SOAP APIs",
      "Git"
    ],
    responsibilities: [
      "Develop Salesforce solutions",
      "Work with LWC and Apex",
      "Handle integrations",
      "Maintain system architecture"
    ],
    requirements: [
      "4+ years Salesforce experience",
      "Strong knowledge of LWC and APIs",
      "Experience with Sales/Service Cloud"
    ],
    applyLink: "mailto:hr@shrinesoft.com",
    postedDate: "2026-04-21"
  },

  {
    id: "sap-dm-associate-saap-technologies-2026-0421",
    title: "SAP DM Associate",
    company: "SAAP Technologies",
    location: "Chennai, India",
    jobType: "Full-Time",
    experience: "3–10 Years",
    qualification: "Bachelor’s Degree",
    salary: "₹3–6 LPA",
    skills: [
      "SAP S/4HANA",
      "Data Migration",
      "ETL",
      "Data Analysis",
      "SAP Tools"
    ],
    responsibilities: [
      "Handle SAP data migration",
      "Perform data validation",
      "Work with SAP tools",
      "Collaborate with teams"
    ],
    requirements: [
      "Experience in SAP data migration",
      "Strong data analysis skills",
      "Knowledge of SAP tools"
    ],
    applyLink: "https://unstop.com/o/fyVWOwp",
    postedDate: "2026-04-21"
  },

  {
    id: "erp-application-manager-sies-2026-0421",
    title: "ERP Application Manager",
    company: "SIES",
    location: "Navi Mumbai, India",
    jobType: "Full-Time",
    experience: "8–10 Years",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "ERP",
      "HRMS",
      "Procurement Systems",
      "Data Migration",
      "Stakeholder Management"
    ],
    responsibilities: [
      "Lead ERP implementation",
      "Coordinate with stakeholders",
      "Manage rollout and support",
      "Ensure data integrity"
    ],
    requirements: [
      "8–10 years experience",
      "ERP system knowledge",
      "Strong communication skills"
    ],
    applyLink: "mailto:jaid@sies.edu.in",
    postedDate: "2026-04-21"
  },

  {
    id: "data-analyst-intern-frugality-fintech-2026-0421",
    title: "Data Analyst Intern",
    company: "Frugality Fintech",
    location: "Pune, India (Hybrid)",
    jobType: "Internship",
    experience: "Fresher",
    qualification: "Bachelor’s Degree",
    salary: "₹5,000–₹10,000/month",
    skills: [
      "Python",
      "SQL",
      "Pandas",
      "NumPy",
      "Selenium",
      "Data Analysis"
    ],
    responsibilities: [
      "Clean and process data",
      "Build data pipelines",
      "Assist ML models",
      "Create reports"
    ],
    requirements: [
      "Basic Python and SQL",
      "Understanding of ML concepts",
      "Analytical mindset"
    ],
    applyLink: "https://abekus.ai/public-job-search/data-analyst-internship-1",
    postedDate: "2026-04-21"
  },

  {
    id: "software-developers-thynk-unlimited-2026-0421",
    title: "Software Developers (Multiple Roles)",
    company: "Thynk Unlimited Corporation",
    location: "South India",
    jobType: "Full-Time",
    experience: "Fresher / Experienced",
    qualification: "Bachelor’s Degree",
    salary: "Not Disclosed",
    skills: [
      "Java",
      "Python",
      "JavaScript",
      "React",
      "Node.js",
      "SQL",
      "Cloud"
    ],
    responsibilities: [
      "Develop software applications",
      "Work on full-stack projects",
      "Collaborate with teams"
    ],
    requirements: [
      "Programming knowledge",
      "Problem-solving skills",
      "Team collaboration"
    ],
    applyLink: "mailto:thynkunlimitedcorparation@outlook.com",
    postedDate: "2026-04-21"
  },

{
  id: "senior-manager-data-engineering-walmart-2026-0421",
  title: "Senior Manager, Data Engineering",
  company: "Walmart",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "12+ Years",
  qualification: "Bachelor’s Degree in Computer Science / Data Science or related field",
  salary: "Not Disclosed",
  skills: [
    "Python",
    "GCP (BigQuery, Dataflow, Dataproc)",
    "PySpark",
    "Airflow",
    "SQL",
    "ETL/ELT Pipelines",
    "Data Warehousing",
    "Data Governance",
    "Tableau / Power BI",
    "Leadership & Team Management"
  ],
  responsibilities: [
    "Lead and mentor a team of data engineers",
    "Design and maintain Health & Wellness data lake",
    "Build scalable ETL/ELT pipelines (batch & real-time)",
    "Develop enterprise-level data warehouse solutions",
    "Collaborate with product managers and stakeholders",
    "Drive data product development and analytics solutions",
    "Ensure data quality, integrity, and reliability",
    "Implement data governance and security policies (HIPAA compliance)"
  ],
  requirements: [
    "Bachelor’s degree in Computer Science or related field",
    "12+ years experience in data engineering",
    "3+ years leadership experience",
    "Experience with large-scale data systems",
    "Strong expertise in Python and SQL",
    "Hands-on experience with GCP tools",
    "Experience with Airflow and PySpark",
    "Healthcare or pharmacy domain experience preferred",
    "Strong communication and problem-solving skills"
  ],
  applyLink: "https://walmart.wd5.myworkdayjobs.com/en-US/WalmartExternal/details/SENIOR-MANAGER--DATA-ENGINEERING_R-2473259-1?locationCountry=c4f78be1a8f14da0ab49ce1162348a5e",
  postedDate: "2026-04-21"
},
{
  id: "ai-ml-computational-science-analyst-accenture-2026-0421",
  title: "AI/ML Computational Science Analyst",
  company: "Accenture",
  location: "Gurugram, India",
  jobType: "Full-Time",
  experience: "0-3 Years (Assumed / Entry-Level)",
  qualification: "Any Graduation (15 years full-time education required)",
  salary: "₹7 – ₹12 LPA (Expected Range)",
  skills: [
    "Machine Learning",
    "Artificial Intelligence",
    "Data Analysis",
    "Python",
    "Statistical Modeling",
    "Problem Solving",
    "Analytical Thinking",
    "Communication Skills"
  ],
  responsibilities: [
    "Work on AI/ML models and computational analysis",
    "Analyze datasets to extract insights",
    "Support development of intelligent systems",
    "Collaborate with cross-functional teams",
    "Assist in research and implementation of ML solutions"
  ],
  requirements: [
    "Bachelor’s degree (any discipline with 15 years education)",
    "Basic understanding of AI/ML concepts",
    "Strong analytical and problem-solving skills",
    "Good communication skills",
    "Willingness to learn and adapt to new technologies"
  ],
  applyLink: "https://www.accenture.com/in-en/careers/jobdetails?id=AIOC-S01619012_en&src=LINKEDINJP",
  postedDate: "2026-04-21"
},
{
  id: "forward-deployment-engineer-realfast-2026-0421",
  title: "Forward Deployment Engineer",
  company: "realfast",
  location: "Remote",
  jobType: "Full-Time",
  experience: "2-5 Years",
  qualification: "Bachelor’s Degree (Assumed)",
  salary: "Not Disclosed",
  skills: [
    "Software Development",
    "Deployment",
    "Problem Solving",
    "APIs",
    "Cloud Technologies",
    "Debugging",
    "Communication"
  ],
  responsibilities: [
    "Deploy and integrate software solutions for clients",
    "Work closely with customers to understand requirements",
    "Troubleshoot and resolve technical issues",
    "Collaborate with engineering and product teams",
    "Ensure smooth implementation of systems"
  ],
  requirements: [
    "2-5 years of experience in software or deployment roles",
    "Strong problem-solving skills",
    "Experience with APIs and integrations",
    "Good communication skills",
    "Ability to work remotely and independently"
  ],
  applyLink: "https://jobs.ashbyhq.com/realfast/bb71c050-ec2a-4484-808d-2a1b9d7c9edc/application",
  postedDate: "2026-04-21"
},

{
  id: "software-engineer-java-celonis-2026-0421",
  title: "Software Engineer - Java",
  company: "Celonis",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "3+ Years",
  qualification: "Bachelor’s Degree in Computer Science or related field",
  salary: "Not Disclosed",
  skills: [
    "Java",
    "Spring Boot",
    "Microservices",
    "REST APIs",
    "SQL",
    "System Design",
    "Problem Solving"
  ],
  responsibilities: [
    "Develop and maintain backend services using Java",
    "Build scalable microservices architecture",
    "Collaborate with cross-functional teams",
    "Write clean, maintainable, and efficient code",
    "Participate in code reviews and system design"
  ],
  requirements: [
    "3+ years experience in Java development",
    "Strong knowledge of Spring Boot and backend systems",
    "Experience with APIs and databases",
    "Good problem-solving skills",
    "Strong communication and teamwork"
  ],
  applyLink: "https://careers.celonis.com/join-us/open-positions/job-detail?jobId=7559335003",
  postedDate: "2026-04-21"
},

{
  id: "jr-platform-engineer-equilibrium-2026-0421",
  title: "Jr. Platform Engineer",
  company: "Equilibrium",
  location: "Not Specified",
  jobType: "Full-Time",
  experience: "0.6-2 Years",
  qualification: "Bachelor’s Degree (Assumed)",
  salary: "Not Disclosed",
  skills: [
    "DevOps",
    "Cloud Computing",
    "Linux",
    "CI/CD",
    "Scripting",
    "Monitoring Tools",
    "Problem Solving"
  ],
  responsibilities: [
    "Assist in managing platform infrastructure",
    "Support CI/CD pipeline implementation",
    "Monitor system performance and reliability",
    "Collaborate with development teams",
    "Troubleshoot and resolve issues"
  ],
  requirements: [
    "0.6-2 years experience in DevOps/Platform roles",
    "Basic knowledge of cloud and infrastructure",
    "Familiarity with CI/CD tools",
    "Good problem-solving skills",
    "Willingness to learn and grow"
  ],
  applyLink: "https://www.linkedin.com/jobs/view/4403370607/",
  postedDate: "2026-04-21"
},



//19-04-26
  {
    id: "compliance-analyst-dbrs-2026-0419",
    title: "Compliance Analyst (DBRS)",
    company: "Morningstar",
    location: "Navi Mumbai, India",
    jobType: "Full-Time",
    experience: "0-3 Years (Assumed / Fresher Eligible if applicable)",
    qualification: "Any Bachelor’s Degree",
    salary: "₹5 – ₹7 LPA (Expected Range)",
    skills: [
      "Compliance",
      "Risk Analysis",
      "Attention to Detail",
      "MS Office",
      "Analytical Thinking"
    ],
    responsibilities: [
      "Support compliance monitoring activities",
      "Analyze financial and regulatory data",
      "Ensure adherence to internal policies",
      "Assist in reporting and documentation"
    ],
    requirements: [
      "Bachelor’s Degree in any discipline",
      "Good analytical and communication skills",
      "Basic understanding of compliance processes"
    ],
    applyLink:
      "https://careers.morningstar.com/us/en/job/MORMORUSREQ056277EXTERNALENUS/Compliance-Analyst-DBRS"
  },

  {
    id: "mercor-ai-training-designer-2026-0419-1",
    title: "AI Training Scenario Designer",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "2+ Years",
    postedDate: "2026-04-19",
    skills: [
      "Writing",
      "Creative Thinking",
      "JSON",
      "Airtable",
      "Analytical Skills"
    ],
    responsibilities: [
      "Design AI training scenarios",
      "Create digital environments",
      "Evaluate AI performance",
      "Provide structured feedback"
    ],
    requirements: [
      "Undergraduate degree",
      "2+ years experience",
      "Strong communication",
      "Attention to detail"
    ],
    tips: [
      "Improve writing skills",
      "Learn JSON basics",
      "Practice scenario design"
    ],
    perks: [
      { label: "Pay", value: "$50–$100/hour" },
      { label: "Mode", value: "Remote + Flexible" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Mercor link" }
    ],
    notes: [
      "Weekly payments via Stripe/Wise",
      "Independent contractor role"
    ],
    aboutCompany: "Mercor works on AI training and evaluation projects.",
    urgencyMessage: "🚀 High-paying remote AI role!",
    applyLink: "https://work.mercor.com/jobs/list_AAABnUb7mWpFOk40X5VII5H4?referralCode=f992208a-cb74-41f0-9bb1-cfbde17c495b"
  },
  {
    id: "pwc-oracle-senior-associate-2026-0419-2",
    title: "Senior Associate - Oracle Fusion Finance",
    company: "PwC India",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "4-7 Years",
    postedDate: "2026-04-19",
    skills: [
      "Oracle Financials",
      "PLSQL",
      "JSON",
      "Accounts Payable",
      "Accounts Receivable"
    ],
    responsibilities: [
      "Work on Oracle Fusion Finance",
      "Handle financial modules",
      "Support integrations"
    ],
    requirements: [
      "Oracle Finance experience",
      "4+ years experience"
    ],
    tips: [
      "Revise Oracle Financials",
      "Practice PLSQL"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "PwC is a global consulting firm.",
    urgencyMessage: "📊 Finance tech role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=145749161"
  },
  {
    id: "systechcorp-oracle-tech-2026-0419-3",
    title: "Oracle Apps Technical",
    company: "Systechcorp Inc",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "3-7 Years",
    postedDate: "2026-04-19",
    skills: [
      "Oracle",
      "AP",
      "AR",
      "Finance Modules"
    ],
    responsibilities: [
      "Work on Oracle applications",
      "Support finance modules"
    ],
    requirements: [
      "Oracle experience",
      "3+ years experience"
    ],
    tips: [
      "Learn Oracle Apps"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "IT services company.",
    urgencyMessage: "💻 Oracle role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=113303265"
  },
  {
    id: "siemens-process-associate-2026-0419-4",
    title: "Senior Process Associate - Finance & Procurement",
    company: "Siemens",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "2-4 Years",
    postedDate: "2026-04-19",
    skills: [
      "SAP",
      "Accounting",
      "Accounts Payable"
    ],
    responsibilities: [
      "Handle finance operations",
      "Manage procurement tasks"
    ],
    requirements: [
      "SAP experience",
      "Finance background"
    ],
    tips: [
      "Learn SAP modules"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "Global engineering company.",
    urgencyMessage: "📊 Finance role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=145740215"
  },
  {
    id: "willscot-te-associate-2026-0419-5",
    title: "Travel & Expense Associate",
    company: "WillScot",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "2-4 Years",
    postedDate: "2026-04-19",
    skills: [
      "SAP Concur",
      "Accounts Payable",
      "Procurement"
    ],
    responsibilities: [
      "Manage travel expenses",
      "Handle procurement tasks"
    ],
    requirements: [
      "Finance experience",
      "2+ years experience"
    ],
    tips: [
      "Learn SAP Concur"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "Equipment solutions company.",
    urgencyMessage: "✈️ Finance role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=145066729"
  },
  {
    id: "cummins-accounting-associate-2026-0419-6",
    title: "Accounting Associate Level II",
    company: "Cummins India",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "2-5 Years",
    postedDate: "2026-04-19",
    skills: [
      "Accounting",
      "Accounts Payable"
    ],
    responsibilities: [
      "Handle accounting tasks",
      "Manage payables"
    ],
    requirements: [
      "Accounting background"
    ],
    tips: [
      "Revise accounting basics"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "Engine manufacturing company.",
    urgencyMessage: "📊 Accounting role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=111853563"
  },
  {
    id: "alfalaval-erp-user-2026-0419-7",
    title: "ERP Key User - Accounts Payable",
    company: "Alfa Laval",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "3-5 Years",
    postedDate: "2026-04-19",
    skills: [
      "Excel",
      "Accounts Payable",
      "ERP"
    ],
    responsibilities: [
      "Manage ERP systems",
      "Handle accounts payable"
    ],
    requirements: [
      "ERP experience",
      "Finance background"
    ],
    tips: [
      "Improve Excel skills"
    ],
    perks: [],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Foundit" }
    ],
    notes: [],
    aboutCompany: "Industrial solutions company.",
    urgencyMessage: "📈 ERP role!",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=145781067"
  },



  {
    id: "mercor-ai-training-scenario-designer-2026-0419-1",
    title: "AI Training Scenario Designer",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "2+ Years",
    postedDate: "2026-04-19",
    skills: [
      "Creative Writing",
      "Analytical Thinking",
      "JSON",
      "Airtable",
      "AI Tools"
    ],
    responsibilities: [
      "Design AI training scenarios",
      "Build personas and environments",
      "Evaluate AI outputs",
      "Document tasks"
    ],
    requirements: [
      "Undergraduate degree",
      "2+ years experience",
      "Strong communication"
    ],
    tips: [
      "Improve writing",
      "Learn JSON basics"
    ],
    perks: [
      { label: "Pay", value: "$50–$100/hour" },
      { label: "Mode", value: "Remote" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Mercor link" }
    ],
    notes: [
      "Weekly payments",
      "Flexible work"
    ],
    aboutCompany: "Mercor focuses on AI training and evaluation.",
    urgencyMessage: "🚀 High-paying AI role!",
    applyLink: "https://work.mercor.com/jobs/list_AAABnUb7mWpFOk40X5VII5H4"
  },
  {
    id: "citi-business-analytics-2026-0418-2",
    title: "Business Analytics Analyst",
    company: "Citi",
    location: "Remote",
    jobType: "Full-Time",
    experience: "0-2 Years",
    postedDate: "2026-04-18",
    skills: [
      "SQL",
      "Excel",
      "Data Analysis"
    ],
    responsibilities: [
      "Analyze business data",
      "Create reports",
      "Support decisions"
    ],
    requirements: [
      "Bachelor’s degree",
      "Analytical skills"
    ],
    tips: [
      "Practice SQL",
      "Learn Excel dashboards"
    ],
    perks: [
      { label: "Mode", value: "Remote" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Citi portal" }
    ],
    notes: [
      "Good for freshers"
    ],
    aboutCompany: "Citi is a global financial services company.",
    urgencyMessage: "📊 Fresher analytics role!",
    applyLink: "https://jobs.citi.com/job/gurugram/business-analytics-analyst/287/94021793584"
  },

  {
    id: "deloitte-analyst-2026-0418-1",
    title: "Finance Service Desk Analyst",
    company: "Deloitte",
    location: "Hyderabad, India",
    jobType: "Full-Time",
    experience: "0-2 Years",
    postedDate: "2026-04-18",
    skills: ["Finance Basics", "MS Office", "Communication"],
    responsibilities: [
      "Handle finance service desk queries",
      "Support internal finance operations",
      "Resolve issues efficiently"
    ],
    requirements: ["B.Sc / B.Com / BCA / BBA"],
    tips: ["Revise accounting basics"],
    perks: [{ label: "Mode", value: "Onsite" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Deloitte portal" }],
    notes: ["Entry-level role"],
    aboutCompany: "Global consulting and professional services firm.",
    urgencyMessage: "🎯 Freshers hiring!",
    applyLink: "https://usijobs.deloitte.com/en_US/careersUSI/JobDetail?jobId=329224"
  },

  {
    id: "genpact-qa-2026-0418-2",
    title: "QA Automation Engineer (Consultant)",
    company: "Genpact",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "0-3 Years",
    postedDate: "2026-04-18",
    skills: ["Selenium", "Java", "Automation Testing"],
    responsibilities: [
      "Write automation scripts",
      "Test applications",
      "Ensure product quality"
    ],
    requirements: ["BE / B.Tech / MCA"],
    tips: ["Practice Selenium"],
    perks: [{ label: "Mode", value: "Onsite" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Genpact portal" }],
    notes: ["Good QA role"],
    aboutCompany: "Global services and consulting firm.",
    urgencyMessage: "🔥 Hiring now!",
    applyLink: "https://genpact.taleo.net/careersection/sgy_external_career_section/jobdetail.ftl?job=ITO100168"
  },

  {
    id: "citi-analytics-2026-0418-3",
    title: "Business Analytics Analyst",
    company: "Citi",
    location: "Remote",
    jobType: "Full-Time",
    experience: "0-2 Years",
    postedDate: "2026-04-18",
    skills: ["SQL", "Excel", "Analytics"],
    responsibilities: [
      "Analyze business data",
      "Generate insights",
      "Support decision making"
    ],
    requirements: ["Bachelor’s Degree"],
    tips: ["Learn SQL"],
    perks: [{ label: "Mode", value: "Remote" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Citi portal" }],
    notes: ["Analytics role"],
    aboutCompany: "Global banking and financial services company.",
    urgencyMessage: "📊 Hiring freshers!",
    applyLink: "https://jobs.citi.com/job/gurugram/business-analytics-analyst/287/94021793584"
  },

  {
    id: "cisco-ui-2026-0418-4",
    title: "Software UI Developer",
    company: "Cisco",
    location: "India",
    jobType: "Full-Time",
    experience: "1-3 Years",
    postedDate: "2026-04-18",
    skills: ["React", "JavaScript", "UI"],
    responsibilities: [
      "Develop UI components",
      "Improve UX",
      "Build frontend features"
    ],
    requirements: ["Frontend development experience"],
    tips: ["Focus on React"],
    perks: [{ label: "Salary", value: "15-25 LPA" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Cisco portal" }],
    notes: ["Product-based company"],
    aboutCompany: "Global networking and IT company.",
    urgencyMessage: "🔥 High salary role!",
    applyLink: "https://careers.cisco.com/global/en/job/CISCISGLOBAL2009755EXTERNALENGLOBAL/Software-UI-Developer"
  },

  {
    id: "postman-sde-2026-0418-5",
    title: "Software Engineer - Client Distribution",
    company: "Postman",
    location: "India",
    jobType: "Full-Time",
    experience: "2-4 Years",
    postedDate: "2026-04-18",
    skills: ["Node.js", "APIs", "JavaScript"],
    responsibilities: [
      "Develop APIs",
      "Build scalable features",
      "Optimize performance"
    ],
    requirements: ["Strong coding skills"],
    tips: ["Practice system design"],
    perks: [{ label: "Salary", value: "25-35 LPA" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Postman jobs" }],
    notes: ["Top product company"],
    aboutCompany: "API platform for developers.",
    urgencyMessage: "🚀 High-paying role!",
    applyLink: "https://job-boards.greenhouse.io/postman/jobs/7680144003"
  },

  {
    id: "accenture-customer-2026-0418-6",
    title: "Customer Service Associate (Voice)",
    company: "Accenture",
    location: "Bengaluru, India",
    jobType: "Full-Time",
    experience: "0-2 Years",
    postedDate: "2026-04-18",
    skills: ["Communication", "Customer Support"],
    responsibilities: [
      "Handle customer calls",
      "Resolve issues",
      "Provide support"
    ],
    requirements: ["12th / Graduate"],
    tips: ["Improve communication"],
    perks: [{ label: "Mode", value: "Onsite" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Accenture portal" }],
    notes: ["Voice process"],
    aboutCompany: "Global IT and consulting company.",
    urgencyMessage: "📞 Immediate hiring!",
    applyLink: "https://www.accenture.com/in-en/careers/jobdetails?id=AIOC-S01637757_en"
  },

  {
    id: "equifax-trainee-2026-0418-7",
    title: "Software Engineer Trainee",
    company: "Equifax",
    location: "India",
    jobType: "Full-Time",
    experience: "Entry Level",
    postedDate: "2026-04-18",
    skills: ["Programming", "Problem Solving"],
    responsibilities: [
      "Develop software",
      "Debug issues",
      "Support team"
    ],
    requirements: ["Bachelor’s Degree"],
    tips: ["Practice coding"],
    perks: [{ label: "Mode", value: "Hybrid" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via Equifax portal" }],
    notes: ["Fresher role"],
    aboutCompany: "Data analytics company.",
    urgencyMessage: "🚀 Tech fresher role!",
    applyLink: "https://careers.equifax.com/en/jobs/j00176110/software-engineer-entry/"
  },

  {
    id: "oracle-erp-consultant-2026-0418-8",
    title: "Oracle ERP Testing Consultant",
    company: "Code1",
    location: "Remote",
    jobType: "Full-Time",
    experience: "8+ Years",
    postedDate: "2026-04-18",
    skills: ["Oracle ERP", "Opkey", "UAT Testing", "Regression Testing"],
    responsibilities: [
      "Execute ERP testing",
      "Perform UAT and regression testing",
      "Validate business processes",
      "Manage defects"
    ],
    requirements: ["8+ years ERP testing experience"],
    tips: ["Learn Oracle ERP"],
    perks: [{ label: "Shift", value: "11 AM – 9 PM IST" }],
    applicationProcess: [{ title: "Apply", desc: "Email resume" }],
    notes: ["Senior role"],
    aboutCompany: "IT consulting firm.",
    urgencyMessage: "🔥 Immediate joiners needed!",
    applyLink: "mailto:isha@code1.dev"
  },

  {
    id: "pwc-azure-2026-0418-9",
    title: "Senior Associate – Azure .NET",
    company: "PwC",
    location: "Mumbai, India",
    jobType: "Full-Time",
    experience: "4-7 Years",
    postedDate: "2026-04-18",
    skills: ["Azure", ".NET", "C#", "APIs"],
    responsibilities: [
      "Build Azure functions",
      "Develop APIs",
      "Integrate services",
      "Monitor performance"
    ],
    requirements: ["Azure + .NET experience"],
    tips: ["Learn cloud services"],
    perks: [{ label: "Mode", value: "Onsite" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via PwC portal" }],
    notes: ["Consulting role"],
    aboutCompany: "Global consulting firm.",
    urgencyMessage: "🚀 Senior hiring!",
    applyLink: "https://www.pwc.com/gx/en/careers/job-results/description.html?wdjobreqid=702204WD"
  },

  {
    id: "ntt-helpdesk-2026-0418-10",
    title: "Helpdesk Associate - ITIL",
    company: "NTT Data",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "1+ Years",
    postedDate: "2026-04-18",
    skills: ["IT Support", "Windows", "MS Office"],
    responsibilities: [
      "Provide L1 support",
      "Resolve issues via chat/email",
      "Troubleshoot systems"
    ],
    requirements: ["Graduate", "Communication skills"],
    tips: ["Learn ITIL basics"],
    perks: [{ label: "Shift", value: "Rotational" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via NTT portal" }],
    notes: ["Support role"],
    aboutCompany: "Global IT services company.",
    urgencyMessage: "💻 IT support role!",
    applyLink: "https://careers.services.global.ntt/global/en/job/361003"
  },

  {
    id: "hpe-security-2026-0418-11",
    title: "Data Security Engineer",
    company: "HPE",
    location: "Bangalore, India",
    jobType: "Full-Time",
    experience: "8+ Years",
    postedDate: "2026-04-18",
    skills: ["Cybersecurity", "DLP", "Python", "Cloud"],
    responsibilities: [
      "Implement data security systems",
      "Manage DLP tools",
      "Handle security incidents"
    ],
    requirements: ["Cybersecurity experience"],
    tips: ["Learn security tools"],
    perks: [{ label: "Mode", value: "Hybrid" }],
    applicationProcess: [{ title: "Apply", desc: "Apply via HPE portal" }],
    notes: ["Advanced role"],
    aboutCompany: "Enterprise technology company.",
    urgencyMessage: "🔐 Security role!",
    applyLink: "https://careers.hpe.com/us/en/job/1202544/Data-Security-Engineer"
  },

  {
    id: "pune-dev-2026-0418-12",
    title: "Software Developer",
    company: "Confidential",
    location: "Pune, India",
    jobType: "Full-Time",
    experience: "1-3 Years",
    postedDate: "2026-04-18",
    skills: ["Java", "Python", ".NET", "SQL"],
    responsibilities: [
      "Develop software",
      "Fix bugs",
      "Optimize performance"
    ],
    requirements: ["CS/IT Degree"],
    tips: ["Practice coding"],
    perks: [{ label: "Mode", value: "Onsite" }],
    applicationProcess: [{ title: "Apply", desc: "Email resume" }],
    notes: ["Startup role"],
    aboutCompany: "Pune-based tech firm.",
    urgencyMessage: "🚀 Hiring developers!",
    applyLink: "mailto:pranoti.payoja@gmail.com"
  },





  {
    id: "mercor-software-engineering-expert-2026-0418-1",
    title: "Software Engineering Expert",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "2+ Years",
    postedDate: "2026-04-18",
    skills: [
      "Python",
      "JavaScript",
      "TypeScript",
      "Java",
      "Go",
      "C#",
      "C++"
    ],
    responsibilities: [
      "Write and evaluate code",
      "Review AI model outputs",
      "Annotate technical tasks",
      "Assess AI-generated solutions"
    ],
    requirements: [
      "2+ years software engineering experience",
      "Strong coding skills",
      "Ability to work independently"
    ],
    tips: [
      "Revise core programming concepts",
      "Practice problem solving"
    ],
    perks: [
      { label: "Pay", value: "$50–$150/hour" },
      { label: "Mode", value: "Remote + Flexible" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Mercor link" }
    ],
    notes: [
      "Weekly payments via Stripe/Wise",
      "Independent contractor role"
    ],
    aboutCompany: "Mercor works on AI-related engineering and evaluation projects.",
    urgencyMessage: "🚀 High-paying remote role!",
    applyLink: "https://t.mercor.com/a5D3c"
  },

  

  {
    id: "csharp-wpf-developer-2026-0418-3",
    title: "C# WPF Application Developer",
    company: "OptimHire (Client Hiring)",
    location: "Bengaluru",
    jobType: "Full-time",
    experience: "5–7 Years",
    postedDate: "2026-04-18",
    skills: [
      "C#",
      ".NET Core",
      "WPF",
      "REST APIs",
      "MVVM",
      "CI/CD",
      "Git",
      "CAD APIs",
      "Revit",
      "BIM"
    ],
    responsibilities: [
      "Develop desktop applications",
      "Collaborate with global teams",
      "Follow agile practices",
      "Optimize performance and debug issues",
      "Maintain documentation"
    ],
    requirements: [
      "Strong C# & WPF experience",
      "Experience with REST APIs",
      "Knowledge of CI/CD pipelines",
      "Agile experience"
    ],
    tips: [
      "Revise WPF & MVVM",
      "Prepare system design basics"
    ],
    perks: [
      { label: "Salary", value: "₹12–20 LPA" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via OptimHire portal" }
    ],
    notes: [],
    aboutCompany: "Client-focused hiring for advanced desktop and engineering tools.",
    urgencyMessage: "🚀 High-paying developer role!",
    applyLink: "https://optimhire.com/developers/jv/309578?ref_code=mukesh-agrawal"
  },


{
    id: "mega-drive-2026-0418-1",
    title: "Mega Hiring Drive 2026",
    company: "Multiple Companies",
    location: "India / Remote",
    jobType: "Full-time",
    experience: "Freshers (2026 Batch)",
    postedDate: "2026-04-18",
    skills: ["Programming","Problem Solving","Communication"],
    responsibilities: [
      "Participate in hiring drive",
      "Clear assessment rounds",
      "Work on software roles"
    ],
    requirements: [
      "2026 batch students",
      "Basic coding knowledge"
    ],
    tips: [
      "Prepare DSA",
      "Practice aptitude"
    ],
    perks: [
      { label: "Salary", value: "₹11–21 LPA" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn post" }
    ],
    notes: [],
    aboutCompany: "Mega hiring drive with multiple company opportunities.",
    urgencyMessage: "🚀 Limited slots – apply fast!",
    applyLink: "https://www.linkedin.com/posts/-aswathy-girishan-_mega-drive-2026-exclusive-opportunity-for-share-7450901599612461056-XvJz"
  },

  {
    id: "engineering-jobs-0418-2",
    title: "Engineering Jobs Hiring",
    company: "Multiple Companies",
    location: "India",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    postedDate: "2026-04-18",
    skills: ["Engineering","Software Development","Problem Solving"],
    responsibilities: [
      "Work on engineering projects",
      "Develop solutions",
      "Collaborate with teams"
    ],
    requirements: [
      "Engineering background",
      "Relevant skills"
    ],
    tips: [
      "Revise core subjects",
      "Practice coding"
    ],
    perks: [
      { label: "Type", value: "Multiple Roles" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn post" }
    ],
    notes: [],
    aboutCompany: "Various companies hiring engineers.",
    urgencyMessage: "🚀 Apply ASAP!",
    applyLink: "https://www.linkedin.com/posts/pooja-handel-0b8132273_hiring-jobs-engineeringjobs-share-7450865288025169920-7EGu"
  },

  {
    id: "cloud-devops-jobs-0418-3",
    title: "Cloud / DevOps Roles",
    company: "Multiple Companies",
    location: "India / Remote",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    postedDate: "2026-04-18",
    skills: ["AWS","Azure","DevOps","CI/CD","Docker","Kubernetes"],
    responsibilities: [
      "Manage cloud infrastructure",
      "Implement CI/CD pipelines",
      "Work on DevOps automation"
    ],
    requirements: [
      "Cloud basics",
      "DevOps tools knowledge"
    ],
    tips: [
      "Learn AWS basics",
      "Practice Docker & CI/CD"
    ],
    perks: [
      { label: "Demand", value: "High demand roles" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn post" }
    ],
    notes: [],
    aboutCompany: "Hiring for cloud and DevOps engineers.",
    urgencyMessage: "🚀 Trending roles!",
    applyLink: "https://www.linkedin.com/posts/ayushi-dixit-25b88815a_nowhiring-cloudcareers-devopsjobs-share-7450771377881767936-IJ_P"
  },

  {
    id: "walkin-hyderabad-0418-4",
    title: "International Voice Process (Walk-in)",
    company: "Multiple Companies",
    location: "Hyderabad",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    postedDate: "2026-04-18",
    skills: ["Communication","Customer Support","English Speaking"],
    responsibilities: [
      "Handle customer calls",
      "Provide support",
      "Resolve queries"
    ],
    requirements: [
      "Good communication skills",
      "Willing to work in shifts"
    ],
    tips: [
      "Improve English speaking",
      "Practice interview questions"
    ],
    perks: [
      { label: "Type", value: "Walk-in Interview" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Attend walk-in interview" }
    ],
    notes: [],
    aboutCompany: "Walk-in hiring for voice process roles.",
    urgencyMessage: "🚀 Immediate hiring!",
    applyLink: "https://www.linkedin.com/posts/anvesh-yadav-0256023b6_internationalvoiceprocess-hyderabadjobs-walkininterview-share-7450803517549658112-P7mw"
  },



  {
    id: "deloitte-finance-analyst-2026-0418-1",
    title: "Finance Service Desk - Analyst",
    company: "Deloitte",
    location: "Hyderabad",
    jobType: "Full-time",
    experience: "0–2 Years",
    postedDate: "2026-04-18",
    skills: ["Finance Basics","Communication","Support","MS Excel"],
    responsibilities: [
      "Handle finance service desk queries",
      "Provide support to clients",
      "Manage financial operations tasks"
    ],
    requirements: [
      "B.Sc / B.Com / BCA / BBA",
      "Freshers eligible"
    ],
    tips: ["Revise finance basics","Prepare communication skills"],
    perks: [{ label: "Eligibility", value: "Freshers" }],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Deloitte portal" }
    ],
    notes: [],
    aboutCompany: "Deloitte is a global leader in consulting and professional services.",
    urgencyMessage: "🚀 Freshers apply now!",
    applyLink: "https://usijobs.deloitte.com/en_US/careersUSI/JobDetail?jobId=329224"
  },

  {
    id: "genpact-qa-automation-2026-0418-2",
    title: "QA Automation Engineer",
    company: "Genpact",
    location: "Bangalore",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    postedDate: "2026-04-18",
    skills: ["Automation Testing","Java/Python","Selenium","QA"],
    responsibilities: [
      "Develop automation scripts",
      "Perform testing",
      "Ensure software quality"
    ],
    requirements: [
      "BE/B.Tech/MCA",
      "Basic testing knowledge"
    ],
    tips: ["Practice Selenium","Learn automation frameworks"],
    perks: [{ label: "Role", value: "QA Automation" }],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Genpact portal" }
    ],
    notes: [],
    aboutCompany: "Genpact is a global professional services firm.",
    urgencyMessage: "🚀 Apply now!",
    applyLink: "https://genpact.taleo.net/careersection/sgy_external_career_section/jobdetail.ftl?job=ITO100168"
  },

  {
    id: "byteridge-sde-2026-0418-3",
    title: "Software Development Engineer",
    company: "Byteridge Software Pvt Ltd",
    location: "Not Specified",
    jobType: "Full-time",
    experience: "Freshers (2026 Batch)",
    postedDate: "2026-04-18",
    skills: ["Programming","DSA","Web Development","Any Tech Stack"],
    responsibilities: [
      "Develop software applications",
      "Work on product development",
      "Collaborate with teams"
    ],
    requirements: [
      "B.Tech 2026 batch",
      "CS/IT/ECE/EEE",
      "Hands-on in one tech stack"
    ],
    tips: ["Practice DSA","Build projects"],
    perks: [{ label: "Batch", value: "2026" }],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Byteridge portal" }
    ],
    notes: [],
    aboutCompany: "Byteridge builds digital products and applications.",
    urgencyMessage: "🚀 Freshers 2026 – apply early!",
    applyLink: "https://byteridge.turbohire.co/jobdescription/45596017-1916-4a2e-908c-c2a1ab4242e4"
  },

  {
    id: "pega-ux-designer-2026-0418-4",
    title: "Senior UX Designer",
    company: "Pega",
    location: "Hyderabad",
    jobType: "Full-time",
    experience: "4–8 Years",
    postedDate: "2026-04-18",
    skills: ["UX Design","Figma","Design Systems","Interaction Design","Accessibility"],
    responsibilities: [
      "Design enterprise UX experiences",
      "Create prototypes",
      "Collaborate with cross-functional teams",
      "Improve design systems"
    ],
    requirements: [
      "4+ years UX experience",
      "Strong design and problem-solving skills",
      "Experience with Figma"
    ],
    tips: ["Prepare UX case studies","Show portfolio"],
    perks: [{ label: "Benefits", value: "Bonus + Equity" }],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Pega careers" }
    ],
    notes: [],
    aboutCompany: "Pega provides low-code platform solutions for enterprises.",
    urgencyMessage: "🚀 High-level UX role!",
    applyLink: "https://www.pega.com/about/careers/23498/senior-ux-designer"
  },

  {
    id: "cognizant-servicenow-2026-0418-5",
    title: "ServiceNow Roles (Multiple)",
    company: "Cognizant",
    location: "India",
    jobType: "Full-time",
    experience: "Various Levels",
    postedDate: "2026-04-18",
    skills: ["ServiceNow","ITSM","NowAssist","Automation"],
    responsibilities: [
      "Develop ServiceNow solutions",
      "Work on ITSM tools",
      "Build automation workflows"
    ],
    requirements: [
      "ServiceNow certification",
      "Relevant experience"
    ],
    tips: ["Prepare ServiceNow modules","Hands-on practice"],
    perks: [{ label: "Hiring", value: "Multiple Positions" }],
    applicationProcess: [
      { title: "Email", desc: "suhail.mukadam@cognizant.com" },
      { title: "Alternate", desc: "Elangovan.A3@cognizant.com" }
    ],
    notes: [],
    aboutCompany: "Cognizant is a leading IT services company.",
    urgencyMessage: "🚀 Multiple openings – apply now!",
    applyLink: "mailto:Elangovan.A3@cognizant.com"
  },

  {
    id: "kisanyodha-ai-ml-2026-0417-1",
    title: "AI / ML Engineer",
    company: "KisanYodha (Blackox Omniscience Pvt Ltd)",
    location: "Remote / Office",
    jobType: "Full-time",
    experience: "3–9 Years",
    postedDate: "2026-04-17",
    skills: ["Python","Machine Learning","Deep Learning","Time Series","Data Engineering","Satellite Data"],
    responsibilities: [
      "Build AI agriculture systems",
      "Crop price prediction",
      "Supply chain intelligence",
      "Model deployment"
    ],
    requirements: ["3+ years AI/ML experience","Strong Python","Deployment knowledge"],
    tips: ["Revise ML models","Prepare real-world use cases"],
    perks: [{ label: "Salary", value: "₹10L – ₹1.2Cr" }],
    applicationProcess: [
      { title: "Email", desc: "pavanhavale@kisanyodha.com" }
    ],
    notes: [],
    aboutCompany: "AI-driven agriculture intelligence platform.",
    urgencyMessage: "🚀 High salary role – apply fast!",
    applyLink: "https://www.kisanyodha.com"
  },

  {
    id: "zycus-java-fullstack-2026-0417-2",
    title: "Java Full Stack Developer",
    company: "Zycus",
    location: "Pune",
    jobType: "Full-time",
    experience: "2+ Years",
    postedDate: "2026-04-17",
    skills: ["Java","Spring Boot","Microservices","React","Angular","Cloud","CI/CD"],
    responsibilities: [
      "Build backend services",
      "Develop frontend UI",
      "API integration",
      "Use AI coding tools"
    ],
    requirements: ["2+ years Java","Spring Boot","Cloud basics"],
    tips: ["Prepare Spring Boot","Practice APIs"],
    perks: [{ label: "Mode", value: "Hybrid" }],
    applicationProcess: [
      { title: "Apply", desc: "Zycus portal" }
    ],
    notes: [],
    aboutCompany: "AI-powered procurement solutions.",
    urgencyMessage: "🚀 Virtual drive – limited time!",
    applyLink: "https://zycus.sensehq.com/careers/jobs/57523"
  },

  {
    id: "incident-manager-l2-2026-0417-3",
    title: "Incident Manager (L2)",
    company: "Apidel Technologies",
    location: "Bangalore",
    jobType: "Full-time",
    experience: "5+ Years",
    postedDate: "2026-04-17",
    skills: ["ITIL","ServiceNow","ITSM","Networking"],
    responsibilities: [
      "Handle incidents",
      "Manage ITSM tools",
      "Ensure SLA compliance"
    ],
    requirements: ["5+ years IT","ITIL certified","2+ years incident management"],
    tips: ["Prepare ITIL concepts","ServiceNow basics"],
    perks: [{ label: "Shift", value: "6AM–3PM" }],
    applicationProcess: [
      { title: "Email", desc: "hemanshi.b@apideltech.com" }
    ],
    notes: [],
    aboutCompany: "IT services and consulting firm.",
    urgencyMessage: "🚀 Immediate hiring!",
    applyLink: ""
  },

  {
    id: "ibm-java-developer-2026-0417-4",
    title: "Application Developer - Java & Web",
    company: "IBM",
    location: "Kochi",
    jobType: "Full-time",
    experience: "5–7 Years",
    postedDate: "2026-04-17",
    skills: ["Java","Spring","Hibernate","JSP","Servlets","Git"],
    responsibilities: [
      "Develop enterprise apps",
      "Work across SDLC",
      "Debug issues"
    ],
    requirements: ["3-5 years experience","Strong Java"],
    tips: ["Revise Java internals","Collections"],
    perks: [{ label: "Company", value: "MNC" }],
    applicationProcess: [
      { title: "Apply", desc: "IBM portal" }
    ],
    notes: [],
    aboutCompany: "Global technology and consulting leader.",
    urgencyMessage: "🚀 Apply soon!",
    applyLink: "https://careers.ibm.com/en_US/careers/JobDetail?jobId=60413"
  },

  {
    id: "edi-solution-manager-2026-0417-5",
    title: "EDI Solution Manager",
    company: "Infodigix",
    location: "Bangalore",
    jobType: "Full-time",
    experience: "10+ Years",
    postedDate: "2026-04-17",
    skills: ["EDI","Cloud","Project Management","Stakeholder Management"],
    responsibilities: [
      "Manage EDI platforms",
      "Handle enterprise clients",
      "Lead projects"
    ],
    requirements: ["10+ years experience","PMP preferred"],
    tips: ["Revise project management","Cloud basics"],
    perks: [{ label: "Shift", value: "Night" }],
    applicationProcess: [
      { title: "Email", desc: "career@infodigix.com" }
    ],
    notes: [],
    aboutCompany: "Enterprise integration solutions provider.",
    urgencyMessage: "🚀 Senior role!",
    applyLink: ""
  },

  {
    id: "cisco-tech-leader-2026-0417-6",
    title: "Embedded Software Engineering Technical Leader",
    company: "Cisco",
    location: "Bangalore",
    jobType: "Full-time",
    experience: "10+ Years",
    postedDate: "2026-04-17",
    skills: ["C","C++","Python","Networking","NPU","MPLS"],
    responsibilities: [
      "Lead architecture design",
      "Optimize NPU pipelines",
      "Mentor engineers"
    ],
    requirements: ["10+ years embedded","Networking expertise"],
    tips: ["Revise networking protocols","System design"],
    perks: [{ label: "Level", value: "Leadership" }],
    applicationProcess: [
      { title: "Apply", desc: "Cisco portal" }
    ],
    notes: [],
    aboutCompany: "Global networking and infrastructure leader.",
    urgencyMessage: "🚀 High-level role!",
    applyLink: "https://careers.cisco.com/global/en/job/2010633"
  },

  {
    id: "redis-edb-engineer-2026-0417-7",
    title: "Senior EDB & Redis Engineer",
    company: "Sasvati IT Solutions",
    location: "Mumbai",
    jobType: "Full-time",
    experience: "5–6 Years",
    postedDate: "2026-04-17",
    skills: ["Postgres","Redis","Linux","HA/DR","Performance Tuning"],
    responsibilities: [
      "Manage DB clusters",
      "Handle replication",
      "Performance tuning"
    ],
    requirements: ["5+ years DB","Banking domain experience"],
    tips: ["Revise DB tuning","Linux basics"],
    perks: [{ label: "Salary", value: "8–10 LPA" }],
    applicationProcess: [
      { title: "Email", desc: "supriya.k@sasvatitsolutions.com" }
    ],
    notes: [],
    aboutCompany: "IT solutions provider in banking domain.",
    urgencyMessage: "🚀 Immediate joiners preferred!",
    applyLink: ""
  },

  {
    id: "accenture-ase-2026-0417-8",
    title: "Associate Software Engineer",
    company: "Accenture",
    location: "India",
    jobType: "Full-time",
    experience: "Freshers",
    postedDate: "2026-04-17",
    skills: ["Problem Solving","Coding","Communication"],
    responsibilities: [
      "Develop applications",
      "Support solutions",
      "Work in teams"
    ],
    requirements: ["2023-2025 passouts","No arrears"],
    tips: ["Prepare aptitude","Coding basics"],
    perks: [{ label: "Role", value: "Fresher Entry" }],
    applicationProcess: [
      { title: "Apply", desc: "Accenture portal" }
    ],
    notes: [],
    aboutCompany: "Global consulting company.",
    urgencyMessage: "🚀 Freshers apply now!",
    applyLink: "https://indiacampus.accenture.com/myzone/accenture/1/jobs/1273421/job-details"
  },

  {
    id: "service-management-lead-2026-0417-9",
    title: "Service Management Lead",
    company: "Capgemini",
    location: "Mumbai / Bengaluru",
    jobType: "Full-time",
    experience: "6–12 Years",
    postedDate: "2026-04-17",
    skills: ["ITIL","ServiceNow","Incident Management","Leadership"],
    responsibilities: [
      "Lead service teams",
      "Manage incidents and changes",
      "Ensure SLA compliance"
    ],
    requirements: ["6+ years experience","ITIL certification"],
    tips: ["Prepare ITIL lifecycle","Leadership questions"],
    perks: [{ label: "Role", value: "Leadership" }],
    applicationProcess: [
      { title: "Email", desc: "rudrajit.saha@capgemini.com" }
    ],
    notes: [],
    aboutCompany: "Global IT services company.",
    urgencyMessage: "🚀 Leadership role!",
    applyLink: ""
  },

  {
    id: "enveu-role-2026-0417-10",
    title: "Career Opportunity",
    company: "Enveu",
    location: "India",
    jobType: "Full-time",
    experience: "Entry Level",
    postedDate: "2026-04-17",
    skills: ["OTT","Web Apps","Problem Solving"],
    responsibilities: ["Work on OTT platforms","Support development"],
    requirements: ["Basic tech knowledge"],
    tips: ["Revise basics","Practice logic"],
    perks: [{ label: "ID", value: "135554" }],
    applicationProcess: [{ title: "Apply", desc: "Enveu portal" }],
    notes: [],
    aboutCompany: "OTT platform provider.",
    urgencyMessage: "🚀 Apply ASAP!",
    applyLink: "https://enveu.keka.com/careers/jobdetails/135554"
  },

  {
    id: "wabtec-intern-2026-0417-11",
    title: "Engineering Intern",
    company: "Wabtec",
    location: "Bangalore",
    jobType: "Internship",
    experience: "Freshers",
    postedDate: "2026-04-17",
    skills: ["Engineering Basics","CAD","Documentation"],
    responsibilities: ["Assist engineering tasks","Documentation"],
    requirements: ["Engineering background"],
    tips: ["Revise basics","CAD tools"],
    perks: [{ label: "Type", value: "Internship" }],
    applicationProcess: [{ title: "Apply", desc: "Wabtec portal" }],
    notes: [],
    aboutCompany: "Transportation and engineering solutions company.",
    urgencyMessage: "🚀 Internship open!",
    applyLink: "https://careers.wabtec.com/job/intern-engineering-in-bengaluru-india-jid-2315"
  },

  {
    id: "viavi-intern-2026-0417-12",
    title: "Intern",
    company: "VIAVI Solutions",
    location: "Bangalore",
    jobType: "Internship",
    experience: "Freshers",
    postedDate: "2026-04-17",
    skills: ["Networking","Testing","Telecom"],
    responsibilities: ["Testing","Support telecom ops"],
    requirements: ["Basic networking"],
    tips: ["Prepare networking"],
    perks: [{ label: "Openings", value: "Multiple" }],
    applicationProcess: [{ title: "Apply", desc: "VIAVI portal" }],
    notes: [],
    aboutCompany: "Network testing solutions provider.",
    urgencyMessage: "🚀 Apply now!",
    applyLink: "https://viavisolutions.wd1.myworkdayjobs.com/careers/job/Bangalore-IND/Intern-1_260004308"
  },


{
  id: "amdocs-software-engineer-2026-0416-a1",
  title: "Software Engineer",
  company: "Amdocs",
  location: "India",
  jobType: "Full-time",
  experience: "1+ Years",
  postedDate: "2026-04-16",
  skills: ["Java", "Software Development", "Problem Solving"],
  responsibilities: ["Develop applications", "Write clean code", "Collaborate with team"],
  requirements: ["1+ years experience", "Strong coding skills"],
  tips: ["Practice DSA", "Revise Java basics"],
  perks: [{ label: "Salary", value: "9–11 LPA" }],
  applicationProcess: [
    { title: "Apply", desc: "Apply via job portal" }
  ],
  notes: [],
  aboutCompany: "Amdocs is a global software and services provider.",
  urgencyMessage: "🚀 Apply fast!",
  applyLink: "https://jobs.amdocs.com/careers/job/563431012628691"
},

{
  id: "sap-ml-engineer-bangalore-2026-0417-a2",
  title: "Associate Machine Learning Engineer",
  company: "SAP",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "Freshers/Experienced",
  postedDate: "2026-04-17",
  skills: ["Machine Learning", "Python", "AI"],
  responsibilities: ["Build ML models", "Work on AI solutions"],
  requirements: ["Bachelor’s/Master’s degree"],
  tips: ["Revise ML concepts", "Practice Python"],
  perks: [{ label: "Work", value: "Hybrid" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "SAP is a global enterprise software company.",
  urgencyMessage: "🔥 Hiring now!",
  applyLink: "https://jobs.sap.com/job/Bangalore-Associate-Machine-Learning-Engineer-KA-560066/1370510633/"
},

{
  id: "meesho-social-media-trainee-2026-0417-a3",
  title: "Trainee - Social Media",
  company: "Meesho",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-17",
  skills: ["Social Media", "Content", "Marketing"],
  responsibilities: ["Manage social media", "Create content"],
  requirements: ["Graduate"],
  tips: ["Prepare portfolio", "Show creativity"],
  perks: [{ label: "Company", value: "Startup Unicorn" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "Meesho is an Indian e-commerce platform.",
  urgencyMessage: "🚀 Freshers apply!",
  applyLink: "https://www.meesho.io/jobs/trainee---social-media?id=ff6dc089-5271-4965-b420-931fecdd7559"
},

{
  id: "hsbc-business-analyst-2026-0417-a4",
  title: "Business Analyst",
  company: "HSBC",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "Freshers/Experienced",
  postedDate: "2026-04-17",
  skills: ["Business Analysis", "Data Analysis", "Communication"],
  responsibilities: ["Analyze business data", "Work with stakeholders"],
  requirements: ["Degree required"],
  tips: ["Prepare BA concepts", "Learn Excel"],
  perks: [{ label: "Work", value: "Hybrid" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "HSBC is a global banking and financial services company.",
  urgencyMessage: "🔥 Apply ASAP!",
  applyLink: "https://portal.careers.hsbc.com/careers/job/563774610356982"
},

{
  id: "nttdata-analyst-developer-2026-0417-a5",
  title: "Analyst / Jr Analyst – Developer",
  company: "NTT DATA",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "0–6 Years",
  postedDate: "2026-04-17",
  skills: ["C#", "Python", "Java", "SQL"],
  responsibilities: ["Develop applications", "Work on APIs"],
  requirements: ["B.Tech/B.E"],
  tips: ["Practice coding", "Revise OOP"],
  perks: [{ label: "Company", value: "MNC" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "NTT DATA is a global IT services company.",
  urgencyMessage: "🚀 Freshers welcome!",
  applyLink: "https://nttdata.eightfold.ai/careers/job/563327930948807"
},

{
  id: "accelleron-devops-2026-0417-a6",
  title: "Software Engineer (DevOps)",
  company: "Accelleron",
  location: "Gurugram, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-17",
  skills: ["DevOps", "CI/CD", "Cloud"],
  responsibilities: ["Manage DevOps pipelines", "Deploy applications"],
  requirements: ["2023–2025 grads"],
  tips: ["Learn Docker", "Understand CI/CD"],
  perks: [{ label: "Growth", value: "Career start" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "Accelleron is a global engineering company.",
  urgencyMessage: "🔥 Freshers hiring!",
  applyLink: "https://accelleron.wd3.myworkdayjobs.com/en-US/Accelleron/job/Software-Engineer-Dev-Ops_JR101808"
},

{
  id: "mercor-it-consulting-remote-2026-0417-a7",
  title: "IT Services Consulting Expert",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "3+ Years",
  postedDate: "2026-04-17",
  skills: ["Cloud", "Cybersecurity", "AI", "Consulting"],
  responsibilities: ["Evaluate AI outputs", "Create scenarios"],
  requirements: ["3+ years experience"],
  tips: ["Revise cloud & consulting concepts"],
  perks: [{ label: "Salary", value: "$65–$85/hr" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "Mercor works with AI labs.",
  urgencyMessage: "💰 High paying role!",
  applyLink: "https://t.mercor.com/gSyeO"
},

{
  id: "sql-developer-mumbai-2026-0417-a8",
  title: "SQL Developer",
  company: "Simple Logic IT",
  location: "Mumbai, India",
  jobType: "Full-time",
  experience: "1+ Years",
  postedDate: "2026-04-17",
  skills: ["SQL", "T-SQL", "SSMS"],
  responsibilities: ["Write queries", "Optimize database"],
  requirements: ["1+ year experience"],
  tips: ["Practice SQL queries"],
  perks: [{ label: "Work", value: "Office" }],
  applicationProcess: [{ title: "Apply", desc: "Send email" }],
  notes: [],
  aboutCompany: "Simple Logic IT provides tech solutions.",
  urgencyMessage: "⚡ Immediate hiring!",
  applyLink: "mailto:Vijay.Bhutiya@simplelogic.in"
},

{
  id: "ml-engineer-remote-2026-0417-a9",
  title: "Machine Learning Engineer (Computer Vision)",
  company: "Canibuild",
  location: "Remote",
  jobType: "Full-time",
  experience: "5–7 Years",
  postedDate: "2026-04-17",
  skills: ["Python", "Computer Vision", "PyTorch"],
  responsibilities: ["Build ML models", "Deploy pipelines"],
  requirements: ["5+ years experience"],
  tips: ["Revise CV models", "Practice ML pipelines"],
  perks: [{ label: "Salary", value: "35–45 LPA" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "Canibuild is a SaaS platform.",
  urgencyMessage: "🔥 High salary!",
  applyLink: "https://optimhire.com/developers/jv/309674?ref_code=mukesh-agrawal"
},

{
  id: "c++-developer-bangalore-2026-0417-a10",
  title: "Software Developer - C++",
  company: "Confidential",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "5–8 Years",
  postedDate: "2026-04-17",
  skills: ["C++", "Embedded", "Linux", "IoT"],
  responsibilities: ["Develop embedded systems", "Work on protocols"],
  requirements: ["5+ years experience"],
  tips: ["Revise C++", "Learn embedded systems"],
  perks: [{ label: "Work", value: "WFO" }],
  applicationProcess: [{ title: "Apply", desc: "Send email" }],
  notes: [],
  aboutCompany: "Automotive embedded solutions company.",
  urgencyMessage: "🚀 Hiring now!",
  applyLink: "mailto:deepika.bp@stmpl.co.in"
},

{
  id: "sap-automation-pilot-2026-0417-a11",
  title: "SAP Automation Pilot Engineer",
  company: "Begig",
  location: "Remote",
  jobType: "Contract",
  experience: "3–10 Years",
  postedDate: "2026-04-17",
  skills: ["SAP BTP", "DevOps", "Automation"],
  responsibilities: ["Build automation workflows", "Manage runbooks"],
  requirements: ["SAP experience"],
  tips: ["Learn SAP BTP"],
  perks: [{ label: "Salary", value: "25–30K/month" }],
  applicationProcess: [{ title: "Apply", desc: "Apply online" }],
  notes: [],
  aboutCompany: "Begig provides tech solutions.",
  urgencyMessage: "🔥 Remote role!",
  applyLink: "https://unstop.com/o/pdO84GN?lb=Bnie7Jo"
},


  {
    id: "ardem-data-analyst-claim-processing-2026-0417",
    title: "Data Analyst - Claim Processing",
    company: "ARDEM",
    location: "Remote / India",
    jobType: "Full-time",
    experience: "0–2 Years",
    postedDate: "2026-04-17",
    skills: ["Data Analysis", "Excel", "Data Processing", "Analytics"],
    responsibilities: [
      "Analyze claim data",
      "Process datasets",
      "Generate reports"
    ],
    requirements: [
      "Basic data analysis knowledge",
      "Excel skills",
      "Attention to detail"
    ],
    tips: [
      "Practice Excel & SQL",
      "Understand data cleaning",
      "Show analytics projects"
    ],
    perks: [
      { label: "Work", value: "Remote opportunity" },
      { label: "Growth", value: "Analytics exposure" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Submit application online" },
      { title: "Interview", desc: "Screening + technical" }
    ],
    notes: ["Good for freshers"],
    aboutCompany: "ARDEM is a business process outsourcing company focused on data services.",
    urgencyMessage: "🔥 Apply fast – limited roles!",
    applyLink: "https://ardem.com/careers/data-analyst-claim-processing/"
  },

  {
    id: "associate-system-engineer-linkedin-2026-0417",
    title: "Associate System Engineer",
    company: "Confidential (LinkedIn Post)",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-17",
    skills: ["System Engineering", "Troubleshooting", "IT Basics"],
    responsibilities: [
      "Support system operations",
      "Assist engineering teams",
      "Resolve technical issues"
    ],
    requirements: [
      "Basic IT knowledge",
      "Good communication",
      "Problem-solving skills"
    ],
    tips: [
      "Revise OS & Networking basics",
      "Prepare HR questions",
      "Be ready for aptitude"
    ],
    perks: [
      { label: "Work", value: "Entry-level role" },
      { label: "Growth", value: "IT career start" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn post" },
      { title: "Interview", desc: "HR + technical round" }
    ],
    notes: ["Fresher friendly"],
    aboutCompany: "Hiring shared via LinkedIn community.",
    urgencyMessage: "⚡ Quick hiring – apply now!",
    applyLink: "https://www.linkedin.com/posts/shivam-dubey-2738201a0_were-hiring-associate-system-engineer-share-7450136884745523200-EqAQ"
  },

  {
    id: "multiple-openings-linkedin-2026-0417",
    title: "Multiple Job Openings",
    company: "Various (LinkedIn Post)",
    location: "India",
    jobType: "Full-time",
    experience: "0–3 Years",
    postedDate: "2026-04-17",
    skills: ["IT Skills", "Communication", "Domain Knowledge"],
    responsibilities: [
      "Work on assigned roles",
      "Collaborate with teams",
      "Deliver tasks"
    ],
    requirements: [
      "Relevant skills",
      "Good communication",
      "Adaptability"
    ],
    tips: [
      "Customize resume",
      "Apply quickly",
      "Follow recruiter"
    ],
    perks: [
      { label: "Work", value: "Multiple roles" },
      { label: "Growth", value: "Various opportunities" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Check LinkedIn post" },
      { title: "Interview", desc: "Depends on role" }
    ],
    notes: ["Multiple openings"],
    aboutCompany: "Shared via LinkedIn hiring post.",
    urgencyMessage: "🚀 Many openings – apply fast!",
    applyLink: "https://www.linkedin.com/posts/sachin-kalburgi-22436910b_hey-all-we-have-few-openings-currently-activity-7450570927475671040-3kUY"
  },

  {
    id: "trainee-recruiter-night-shift-2026-0417",
    title: "Trainee Recruiter",
    company: "Confidential (LinkedIn Post)",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-17",
    skills: ["Recruitment", "Communication", "Sourcing"],
    responsibilities: [
      "Source candidates",
      "Screen profiles",
      "Schedule interviews"
    ],
    requirements: [
      "Good communication",
      "Interest in HR",
      "Basic recruitment knowledge"
    ],
    tips: [
      "Learn LinkedIn sourcing",
      "Practice communication",
      "Understand HR basics"
    ],
    perks: [
      { label: "Shift", value: "Night shift" },
      { label: "Growth", value: "HR career start" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn" },
      { title: "Interview", desc: "HR discussion" }
    ],
    notes: ["Night shift role"],
    aboutCompany: "Hiring via LinkedIn recruiter.",
    urgencyMessage: "⚡ Immediate hiring!",
    applyLink: "https://www.linkedin.com/posts/saitejamarojuassistantgeneralmanager_were-hiring-trainee-recruiter-night-shift-share-7450431636703244288-iThe"
  },

  {
    id: "mtech-freshers-hiring-2026-0417",
    title: "MTech Freshers Hiring",
    company: "Confidential (LinkedIn Post)",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-17",
    skills: ["Engineering", "Technical Skills", "Problem Solving"],
    responsibilities: [
      "Work on technical tasks",
      "Support engineering teams",
      "Learn and contribute"
    ],
    requirements: [
      "MTech qualification",
      "Technical knowledge",
      "Willingness to learn"
    ],
    tips: [
      "Revise core subjects",
      "Prepare projects explanation",
      "Practice coding basics"
    ],
    perks: [
      { label: "Work", value: "Fresher opportunity" },
      { label: "Growth", value: "Engineering role" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn post" },
      { title: "Interview", desc: "Technical rounds" }
    ],
    notes: ["For MTech freshers"],
    aboutCompany: "Shared hiring opportunity.",
    urgencyMessage: "🔥 Freshers apply now!",
    applyLink: "https://www.linkedin.com/posts/deepika-srithar-40a08a173_hiring-mtechjobs-freshershiring-share-7450508170541654016-1qc0"
  },

  {
    id: "inside-sales-intern-whitefield-2026-0417",
    title: "Inside Sales Intern",
    company: "Confidential (LinkedIn Post)",
    location: "Bangalore (Whitefield)",
    jobType: "Internship",
    experience: "Fresher",
    postedDate: "2026-04-17",
    skills: ["Sales", "Communication", "Lead Generation"],
    responsibilities: [
      "Generate leads",
      "Assist sales team",
      "Follow up with clients"
    ],
    requirements: [
      "Good communication",
      "Interest in sales",
      "Basic knowledge of CRM"
    ],
    tips: [
      "Practice sales pitch",
      "Improve communication",
      "Be confident"
    ],
    perks: [
      { label: "Work", value: "Internship" },
      { label: "Growth", value: "Sales exposure" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn" },
      { title: "Interview", desc: "HR round" }
    ],
    notes: ["Intern role"],
    aboutCompany: "Hiring shared on LinkedIn.",
    urgencyMessage: "🚀 Immediate internship hiring!",
    applyLink: "https://www.linkedin.com/posts/hiring-inside-sales-interns-whitefield-share-7449454600060973056-H-Ok"
  },

  {
    id: "python-developer-chennai-2026-0417",
    title: "Python Developer",
    company: "Confidential (LinkedIn Post)",
    location: "Chennai",
    jobType: "Full-time",
    experience: "1–3 Years",
    postedDate: "2026-04-17",
    skills: ["Python", "Django", "Flask", "APIs"],
    responsibilities: [
      "Develop backend applications",
      "Work on APIs",
      "Maintain systems"
    ],
    requirements: [
      "Python experience",
      "Framework knowledge",
      "Problem-solving skills"
    ],
    tips: [
      "Build projects",
      "Learn APIs",
      "Practice coding"
    ],
    perks: [
      { label: "Work", value: "Developer role" },
      { label: "Growth", value: "Backend career" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via LinkedIn" },
      { title: "Interview", desc: "Technical rounds" }
    ],
    notes: ["Python role"],
    aboutCompany: "Shared via LinkedIn hiring post.",
    urgencyMessage: "🔥 Python devs apply now!",
    applyLink: "https://www.linkedin.com/posts/vaishnavi-anand97_hiring-chennaijobs-pythondeveloper-share-7443273596413788160-vnEf"
  },

  {
    id: "amdocs-software-engineer-2026-0417",
    title: "Software Engineer",
    company: "Amdocs",
    location: "India",
    jobType: "Full-time",
    experience: "1+ Years",
    postedDate: "2026-04-17",
    skills: ["Software Development", "Programming", "Problem Solving"],
    responsibilities: [
      "Develop software solutions",
      "Work with teams",
      "Maintain code quality"
    ],
    requirements: [
      "1+ years experience",
      "Programming knowledge",
      "Analytical skills"
    ],
    tips: [
      "Prepare DSA",
      "Revise core concepts",
      "Practice coding"
    ],
    perks: [
      { label: "Salary", value: "9–11 LPA" },
      { label: "Growth", value: "MNC exposure" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via official link" },
      { title: "Interview", desc: "Coding + HR rounds" }
    ],
    notes: ["Good package"],
    aboutCompany: "Amdocs is a global software and services provider.",
    urgencyMessage: "🚀 High paying role – apply fast!",
    applyLink: "https://jobs.amdocs.com/careers/job/563431012628691"
  },

//16-04-26end
  {
    id: "phonepe-sdet-bangalore-2026-0416-h1a1",
    title: "Software Engineer - Test",
    company: "PhonePe",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "5+ Years",
    postedDate: "2026-04-16",
    skills: [
      "Automation Testing",
      "Selenium",
      "Appium",
      "Java/Python",
      "API Testing",
      "CI/CD"
    ],
    responsibilities: [
      "Own product quality",
      "Build automation frameworks",
      "Test web/mobile/API",
      "Handle performance testing"
    ],
    requirements: [
      "BTech/MTech",
      "5+ years testing experience",
      "Strong coding skills",
      "Automation tools experience"
    ],
    tips: [
      "Practice automation tools",
      "Learn API testing",
      "Understand CI/CD pipelines"
    ],
    perks: [
      { label: "Salary", value: "Up to 6 LPA" },
      { label: "Company", value: "Top fintech" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Greenhouse link" }
    ],
    notes: ["Strong testing + coding required"],
    aboutCompany: "PhonePe is a leading fintech platform in India.",
    urgencyMessage: "🔥 High demand role!",
    applyLink: "https://boards.greenhouse.io/embed/job_app?token=7546288003&gh_src=961e65dc3us"
  },
{
  id: "edi-lead-supply-chain-bangalore-2026-0416-a8k3",
  title: "EDI Lead – Supply Chain",
  company: "Confidential / Saptix Hiring",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "5+ Years",
  postedDate: "2026-04-16",
  salary: "₹20 – 25 LPA",
  shift: "US Shift",
  skills: [
    "EDI Standards (ANSI X12, EDIFACT)",
    "XML, JSON, APIs",
    "SAP / Oracle / MS Dynamics",
    "WMS / TMS / SCM",
    "AS2, SFTP, FTP",
    "Seeburger / IBM Sterling / Boomi / Mulesoft",
    "Supply Chain Systems"
  ],
  responsibilities: [
    "Design and implement EDI architecture",
    "Manage integrations across ERP, WMS, TMS",
    "Monitor EDI transactions and resolve issues",
    "Onboard suppliers and partners",
    "Ensure compliance and data security",
    "Lead EDI team and vendor coordination"
  ],
  requirements: [
    "Strong EDI experience",
    "Hands-on with integration tools",
    "Knowledge of supply chain workflows",
    "Experience in communication protocols",
    "Leadership and problem-solving skills"
  ],
  tips: [
    "Revise EDI standards and formats",
    "Highlight ERP integration experience",
    "Prepare real-time troubleshooting examples"
  ],
  perks: [
    { label: "Salary", value: "20-25 LPA" },
    { label: "Shift", value: "US Shift Exposure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Submit resume via link" },
    { title: "Interview", desc: "Technical + Manager rounds" }
  ],
  notes: ["High responsibility leadership role"],
  aboutCompany: "Enterprise supply chain solutions hiring via Saptix platform.",
  urgencyMessage: "🔥 High-paying EDI role – Apply fast!",
  applyLink: "https://my.saptix.com/jobs/edi-lead-supply-chain-862?"
},
{
  id: "fullstack-php-wordpress-remote-2026-0416-b7m2",
  title: "Full Stack Developer (PHP & HTML)",
  company: "91HR",
  location: "Remote (Work From Home)",
  jobType: "Full-time",
  experience: "2 – 5 Years",
  postedDate: "2026-04-16",
  salary: "₹40,000 – ₹80,000 / month",
  shift: "Australian Time (4:00 AM – 1:00 PM IST)",
  skills: [
    "PHP",
    "WordPress",
    "WooCommerce",
    "HTML, CSS",
    "JavaScript",
    "WPML",
    "HubSpot",
    "Google Analytics"
  ],
  responsibilities: [
    "Develop WordPress-based applications",
    "Optimize website performance",
    "Manage multiple projects",
    "Integrate plugins and tools",
    "Ensure accessibility and standards"
  ],
  requirements: [
    "3–5 years WordPress experience",
    "Strong PHP and frontend skills",
    "Knowledge of Agile & SDLC",
    "Good communication skills",
    "Ability to work independently"
  ],
  tips: [
    "Show WordPress projects",
    "Highlight plugin experience",
    "Prepare for client communication questions"
  ],
  perks: [
    { label: "Work Mode", value: "Remote" },
    { label: "Salary", value: "Up to ₹80K/month" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send CV via email" },
    { title: "Contact", desc: "Call/WhatsApp for follow-up" }
  ],
  notes: ["Early morning shift required"],
  aboutCompany: "Recruitment firm hiring for remote WordPress projects.",
  urgencyMessage: "⚡ Remote job – Immediate hiring!",
  applyLink: "mailto:suzanne@91hr.in"
},

  {
    id: "techmahindra-multiple-dev-2026-0416-i2b2",
    title: "Multiple Developer Roles",
    company: "Tech Mahindra",
    location: "Hyderabad / Chennai / Bangalore",
    jobType: "Full-time",
    experience: "5+ Years",
    postedDate: "2026-04-16",
    skills: [
      "Java",
      "Spring Boot",
      "Angular",
      "Kafka",
      "ServiceNow",
      "API Testing"
    ],
    responsibilities: [
      "Develop enterprise applications",
      "Work on backend/frontend",
      "Handle APIs & integrations"
    ],
    requirements: [
      "5+ years experience",
      "Strong coding skills",
      "Relevant tech stack knowledge"
    ],
    tips: [
      "Revise Java + Spring",
      "Practice system design",
      "Prepare project explanations"
    ],
    perks: [
      { label: "Locations", value: "Multiple cities" },
      { label: "Growth", value: "Enterprise projects" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Send resume via email" }
    ],
    notes: ["Multiple roles available"],
    aboutCompany: "Tech Mahindra is a global IT services company.",
    urgencyMessage: "🚀 Bulk hiring!",
    applyLink: "mailto:ss001066799@techmahindra.com"
  },

  {
    id: "eaton-career-opportunity-2026-0416-j3c3",
    title: "Career Opportunity",
    company: "Eaton",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher / Experienced",
    postedDate: "2026-04-16",
    skills: [
      "Engineering Operations",
      "MS Office",
      "Problem Solving",
      "Analytical Thinking"
    ],
    responsibilities: [
      "Support engineering operations",
      "Analyze technical data"
    ],
    requirements: [
      "Engineering background",
      "Basic technical skills"
    ],
    tips: [
      "Prepare core subjects",
      "Improve analytical skills"
    ],
    perks: [
      { label: "Company", value: "Global brand" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via career portal" }
    ],
    notes: ["General role"],
    aboutCompany: "Eaton is a global power management company.",
    urgencyMessage: "🔥 Apply soon!",
    applyLink: "https://app.eightfold.ai/careers/job/687236211462?domain=eaton.com"
  },

  {
    id: "ptc-career-2026-0416-k4d4",
    title: "Career Opportunity",
    company: "PTC",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-16",
    skills: [
      "Software Engineering",
      "CAD/PLM",
      "Logic Building"
    ],
    responsibilities: [
      "Support engineering tools",
      "Assist in technical solutions"
    ],
    requirements: [
      "Basic programming knowledge"
    ],
    tips: [
      "Learn CAD basics",
      "Practice coding"
    ],
    perks: [
      { label: "Learning", value: "Tech exposure" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply online" }
    ],
    notes: ["Entry level role"],
    aboutCompany: "PTC develops CAD and PLM software.",
    urgencyMessage: "🚀 Freshers apply!",
    applyLink: "https://ptc.eightfold.ai/careers/job/137480387477"
  },

  {
    id: "cai-freshgrad-2026-0416-l5e5",
    title: "Fresh Grad",
    company: "CAI",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-16",
    skills: [
      "IT Consulting",
      "Software Development",
      "Communication"
    ],
    responsibilities: [
      "Work on IT consulting projects",
      "Assist development tasks"
    ],
    requirements: [
      "Graduate",
      "Basic IT knowledge"
    ],
    tips: [
      "Practice fundamentals",
      "Improve communication"
    ],
    perks: [
      { label: "Entry", value: "Graduate role" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply online" }
    ],
    notes: ["Good for freshers"],
    aboutCompany: "CAI provides IT consulting services.",
    urgencyMessage: "🔥 Hiring fresh grads!",
    applyLink: "https://careers.cai.io/us/en/job/R7514/Fresh-Grad"
  },

  {
    id: "deutschebank-qa-pune-2026-0416-m6f6",
    title: "Quality and Testing Engineer",
    company: "Deutsche Bank",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "Fresher / Experienced",
    postedDate: "2026-04-16",
    skills: [
      "Software Testing",
      "Automation",
      "QA",
      "Bug Tracking"
    ],
    responsibilities: [
      "Test applications",
      "Write test cases",
      "Report bugs"
    ],
    requirements: [
      "QA knowledge",
      "Basic programming"
    ],
    tips: [
      "Learn testing tools",
      "Practice automation"
    ],
    perks: [
      { label: "Company", value: "Top bank" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply online" }
    ],
    notes: ["Fintech role"],
    aboutCompany: "Deutsche Bank is a global financial institution.",
    urgencyMessage: "🚀 QA hiring!",
    applyLink: "https://db.wd3.myworkdayjobs.com/en-US/DBWebsite/job/Pune---Margarpatta/Quality-and-Testing-Engineer--Associate_R0427154-1"
  },

//16-0426
  {
    id: "dravido-frontend-kolkata-2026-0416-a1x2",
    title: "Frontend Developer (React.js)",
    company: "Drivado Transfers Pvt. Ltd.",
    location: "Kolkata, India",
    jobType: "Full-time",
    experience: "3–10 Years",
    postedDate: "2026-04-16",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "React Query",
      "Redux/Zustand"
    ],
    responsibilities: [
      "Build scalable UI components",
      "Convert Figma to responsive UI",
      "Integrate APIs",
      "Optimize performance"
    ],
    requirements: [
      "Strong React & Next.js knowledge",
      "Experience with modern frontend tools",
      "Good understanding of architecture"
    ],
    tips: [
      "Practice React projects",
      "Learn state management deeply",
      "Build portfolio with UI work"
    ],
    perks: [
      { label: "Salary", value: "₹25K–₹30K/month" },
      { label: "Work", value: "Product-based UI development" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Submit via Unstop link" }
    ],
    notes: ["Strong UI skills required"],
    aboutCompany: "Drivado is a transport-tech platform.",
    urgencyMessage: "🔥 Immediate hiring!",
    applyLink: "https://unstop.com/o/JZ4m6KE"
  },

  {
    id: "oracle-incident-manager-noida-2026-0416-b2y3",
    title: "Major Incident Manager",
    company: "Oracle",
    location: "Noida, India",
    jobType: "Full-time",
    experience: "8+ Years",
    postedDate: "2026-04-16",
    skills: [
      "ITIL",
      "Incident Management",
      "Stakeholder Communication",
      "IT Service Management"
    ],
    responsibilities: [
      "Manage critical incidents",
      "Coordinate teams",
      "Communicate updates",
      "Drive RCA analysis"
    ],
    requirements: [
      "Experience in IT service management",
      "Strong communication",
      "Ability to handle pressure"
    ],
    tips: [
      "Learn ITIL concepts",
      "Practice incident scenarios",
      "Improve communication"
    ],
    perks: [
      { label: "Role", value: "Leadership role" },
      { label: "Exposure", value: "Enterprise systems" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Send resume via email" }
    ],
    notes: ["High-pressure role"],
    aboutCompany: "Oracle is a global leader in cloud and enterprise software.",
    urgencyMessage: "🚨 Urgent hiring!",
    applyLink: "mailto:varun.v.goswami@gmail.com"
  },

  {
    id: "wikasta-python-remote-2026-0416-c3z4",
    title: "Python Developer Intern",
    company: "Wikasta Business & Technical Solutions",
    location: "Remote",
    jobType: "Internship",
    experience: "Fresher",
    postedDate: "2026-04-16",
    skills: [
      "Python",
      "Django",
      "Flask",
      "AWS",
      "PostgreSQL"
    ],
    responsibilities: [
      "Develop Python applications",
      "Integrate APIs",
      "Work on backend systems"
    ],
    requirements: [
      "Basic Python knowledge",
      "Familiarity with frameworks",
      "Good problem solving"
    ],
    tips: [
      "Build Python projects",
      "Learn Django basics",
      "Practice APIs"
    ],
    perks: [
      { label: "Mode", value: "Remote" },
      { label: "Learning", value: "Hands-on experience" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via job portal" }
    ],
    notes: ["Good for beginners"],
    aboutCompany: "Wikasta builds tech hiring solutions.",
    urgencyMessage: "🔥 Internship open now!",
    applyLink: "https://abekus.ai/public-job-search/python-developer-11?referral_hash=IIHT.VIMANNAGAR0138"
  },

  {
    id: "pwc-project-manager-mumbai-2026-0416-d4k5",
    title: "Senior Consultant - Technical Project Manager",
    company: "PwC",
    location: "Mumbai / Navi Mumbai, India",
    jobType: "Full-time",
    experience: "8–9 Years",
    postedDate: "2026-04-16",
    skills: [
      "Project Management",
      "IT Infrastructure",
      "SDLC",
      "Leadership"
    ],
    responsibilities: [
      "Manage SDLC lifecycle",
      "Lead teams",
      "Coordinate infra setup",
      "Ensure project delivery"
    ],
    requirements: [
      "8+ years experience",
      "Strong leadership",
      "Infra + dev knowledge"
    ],
    tips: [
      "Prepare project case studies",
      "Understand SDLC deeply",
      "Learn stakeholder handling"
    ],
    perks: [
      { label: "Brand", value: "Top consulting firm" },
      { label: "Growth", value: "Leadership exposure" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Email resume" }
    ],
    notes: ["Client-facing role"],
    aboutCompany: "PwC is a global consulting and auditing firm.",
    urgencyMessage: "🚀 High-level role!",
    applyLink: "mailto:prashant.m.more@pwc.com"
  },

  {
    id: "nec-fresher-panindia-2026-0416-e5m6",
    title: "GET / Fresher Talent Pool",
    company: "NEC Corporation",
    location: "PAN India",
    jobType: "Full-time",
    experience: "Fresher",
    postedDate: "2026-04-16",
    skills: [
      "IT Basics",
      "Communication",
      "Problem Solving"
    ],
    responsibilities: [
      "Work on IT systems",
      "Support development",
      "Assist teams"
    ],
    requirements: [
      "Graduate in IT field",
      "Willing to learn",
      "Good communication"
    ],
    tips: [
      "Prepare basics",
      "Revise core subjects",
      "Practice aptitude"
    ],
    perks: [
      { label: "Locations", value: "Multiple cities" },
      { label: "Growth", value: "Entry-level opportunity" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via career portal" }
    ],
    notes: ["Generic hiring pool"],
    aboutCompany: "NEC is a global IT and networking company.",
    urgencyMessage: "🔥 Freshers hiring!",
    applyLink: "https://careers.nec.com/job/Viman-Nagar-Talent-Pool-GET-Fresher-MH-411014/770114502/"
  },

  {
    id: "amazon-remote-support-2026-0416-f6n7",
    title: "Virtual Customer Support Associate",
    company: "Amazon",
    location: "Remote",
    jobType: "Full-time",
    experience: "Fresher / Experienced",
    postedDate: "2026-04-16",
    skills: [
      "Communication",
      "Customer Support",
      "Problem Solving"
    ],
    responsibilities: [
      "Handle customer queries",
      "Resolve issues",
      "Provide support"
    ],
    requirements: [
      "Good communication",
      "Basic computer knowledge"
    ],
    tips: [
      "Improve communication",
      "Practice customer scenarios",
      "Stay calm under pressure"
    ],
    perks: [
      { label: "Mode", value: "Work from home" },
      { label: "Flexibility", value: "Remote job" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply via Amazon careers" }
    ],
    notes: ["Great for freshers"],
    aboutCompany: "Amazon is a global e-commerce and tech giant.",
    urgencyMessage: "🔥 Remote job!",
    applyLink: "https://www.amazon.jobs/en/jobs/SF260122788/virtual-customer-support-associate-mh-india"
  },

  {
    id: "kornferry-analytics-intern-2026-0416-g7p8",
    title: "Analytics Intern",
    company: "Korn Ferry",
    location: "Gurgaon, India",
    jobType: "Internship",
    experience: "0–1 Year",
    postedDate: "2026-04-16",
    skills: [
      "Analytics",
      "Excel",
      "Data Analysis"
    ],
    responsibilities: [
      "Analyze data",
      "Create reports",
      "Support analytics team"
    ],
    requirements: [
      "Basic analytics knowledge",
      "Good communication"
    ],
    tips: [
      "Learn Excel",
      "Practice data analysis",
      "Build mini projects"
    ],
    perks: [
      { label: "Learning", value: "Analytics exposure" },
      { label: "Brand", value: "Global company" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Apply online" }
    ],
    notes: ["Entry-level role"],
    aboutCompany: "Korn Ferry is a global consulting firm.",
    urgencyMessage: "🚀 Internship open!",
    applyLink: "https://kornferry.tal.net/vx/mobile-0/appcentre-ext/brand-4/candidate/so/pm/1/pl/3/opp/26004-Analyst/en-GB"
  },
//

{
  id: "cybersecurity-engineer-jaipur-2to5exp-linkedin-post-cs1",
  title: "Security Engineer",
  company: "Confidential (LinkedIn Hiring)",
  location: "Jaipur, India",
  jobType: "Full-time",
  experience: "2–5 Years",
  postedDate: "2026-04-16",
  skills: [
    "Cybersecurity",
    "Network Security",
    "SIEM",
    "Vulnerability Assessment"
  ],
  responsibilities: [
    "Monitor systems for threats",
    "Identify vulnerabilities",
    "Implement security controls",
    "Handle incident response"
  ],
  requirements: [
    "Experience in cybersecurity",
    "Knowledge of security tools",
    "Strong fundamentals"
  ],
  tips: [
    "Learn networking basics",
    "Practice security tools",
    "Prepare real-world scenarios"
  ],
  perks: [
    { label: "Domain", value: "Cybersecurity" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn post" }
  ],
  notes: [],
  aboutCompany: "Hiring for cybersecurity role via LinkedIn.",
  urgencyMessage: "🚨 High demand role!",
  applyLink: "https://www.linkedin.com/posts/simran-bhinda-a4808b209_hiringfreshers-cybersecuritycareers-techjobs-share-7450110834934202368"
},

{
  id: "hr-intern-chennai-freshers-linkedin-hiring-hr2",
  title: "HR Intern",
  company: "Confidential",
  location: "Chennai, India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-16",
  skills: [
    "Recruitment",
    "Communication",
    "HR Basics"
  ],
  responsibilities: [
    "Assist in recruitment",
    "Screen candidates",
    "Coordinate interviews"
  ],
  requirements: [
    "Good communication",
    "Interest in HR"
  ],
  tips: [
    "Prepare HR basics",
    "Practice communication"
  ],
  perks: [
    { label: "Type", value: "Internship" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn post" }
  ],
  notes: [],
  aboutCompany: "Hiring HR interns via LinkedIn.",
  urgencyMessage: "⚡ Freshers apply!",
  applyLink: "https://www.linkedin.com/posts/iramyakrishnaraj_hrintern-chennaijobs-itrecruitment-share-7450128073464676352"
},

{
  id: "joveo-ai-intern-ml-ai-role-2026-joveo3",
  title: "AI / ML Intern",
  company: "Joveo AI",
  location: "India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-16",
  skills: [
    "Machine Learning",
    "Python",
    "AI Basics"
  ],
  responsibilities: [
    "Work on AI models",
    "Support ML projects"
  ],
  requirements: [
    "Basic ML knowledge",
    "Python skills"
  ],
  tips: [
    "Revise ML basics",
    "Practice Python"
  ],
  perks: [
    { label: "Domain", value: "AI" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn job" }
  ],
  notes: [],
  aboutCompany: "Joveo AI works in recruitment AI solutions.",
  urgencyMessage: "🚀 Apply now!",
  applyLink: "https://www.linkedin.com/jobs/view/4399750741"
},

{
  id: "pwc-intern-trainee-global-2026-consulting-pwc4",
  title: "Intern / Trainee",
  company: "PwC",
  location: "India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-16",
  skills: [
    "Consulting",
    "Analysis",
    "Communication"
  ],
  responsibilities: [
    "Support consulting projects",
    "Work with teams",
    "Analyze data"
  ],
  requirements: [
    "Graduate",
    "Strong communication"
  ],
  tips: [
    "Prepare aptitude",
    "Revise basics"
  ],
  perks: [
    { label: "Company", value: "Big4" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Company portal" }
  ],
  notes: [],
  aboutCompany: "PwC is a Big4 consulting firm.",
  urgencyMessage: "🔥 Big4 opportunity!",
  applyLink: "https://pwc.wd3.myworkdayjobs.com/en-US/Global_Experienced_Careers/job/Intern--Trainee_442620WD-1"
},

{
  id: "gamehok-developer-role-2026-linkedin-job-gh5",
  title: "Developer Role",
  company: "Gamehok",
  location: "India",
  jobType: "Full-time",
  experience: "Entry Level",
  postedDate: "2026-04-16",
  skills: [
    "Development",
    "JavaScript",
    "Web Tech"
  ],
  responsibilities: [
    "Develop applications",
    "Work on projects"
  ],
  requirements: [
    "Basic coding skills"
  ],
  tips: [
    "Build projects",
    "Practice coding"
  ],
  perks: [
    { label: "Type", value: "Entry Level" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn job" }
  ],
  notes: [],
  aboutCompany: "Gamehok is a tech company.",
  urgencyMessage: "🚀 Apply fast!",
  applyLink: "https://www.linkedin.com/jobs/view/4399100180"
},
//15-04-2026wnd

{
  id: "hcltech-infra-l2-l3-nagpur-2026-multi-skills-hcl1",
  title: "IT Infra Engineer (L2 / L3)",
  company: "HCLTech",
  location: "Nagpur, India",
  jobType: "Full-time",
  experience: "3–10 Years",
  postedDate: "2026-04-15",
  skills: [
    "Zscaler (ZIA, ZPA, ZDX, ZCC)",
    "VMS",
    "Linux Administration",
    "F5 Load Balancer",
    "ServiceNow",
    "VMware",
    "Intune (MDM)",
    "BMC Control-M"
  ],
  responsibilities: [
    "Manage IT infrastructure systems",
    "Handle network security and administration",
    "Work on cloud & virtualization tools",
    "Maintain enterprise IT operations"
  ],
  requirements: [
    "3–10 years relevant experience",
    "Immediate to 30 days joiners preferred",
    "Willing to work in shifts"
  ],
  tips: [
    "Revise Linux & networking",
    "Prepare ServiceNow basics",
    "Understand cloud infra tools"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Location", value: "MIHAN SEZ" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume via email" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: [
    "Subject: CV for Skill Name - Candidate Name",
    "100% Work From Office"
  ],
  aboutCompany: "HCLTech is a leading global IT services company.",
  urgencyMessage: "⚡ Immediate joiners preferred!",
  applyLink: "mailto:abhishek.chatterjee@hcltech.com"
},

{
  id: "dhl-associate-software-engineer-analyst-chennai-2026-it-dhl2",
  title: "Associate Software Engineering Analyst",
  company: "DHL",
  location: "Chennai, India",
  jobType: "Full-time",
  experience: "Freshers / Early Career",
  postedDate: "2026-04-15",
  skills: ["IBM WTX", "ITX 10", "Software Development"],
  responsibilities: [
    "Develop software solutions",
    "Work on logistics tech systems",
    "Support IT transformation"
  ],
  requirements: [
    "Technical background",
    "Basic programming knowledge"
  ],
  tips: [
    "Revise programming basics",
    "Understand integration tools",
    "Prepare for interviews"
  ],
  perks: [
    { label: "Company", value: "Global Logistics Leader" },
    { label: "Environment", value: "Innovation Driven" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Company portal" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: [],
  aboutCompany: "DHL IT Services drives global logistics innovation.",
  urgencyMessage: "🚀 Apply now!",
  applyLink: "https://www.dhl.com/global-en/home/careers.html"
},

{
  id: "heyhomie-growth-marketing-automation-lead-bangalore-2026-3to5exp-hh3",
  title: "Growth Marketing & Automation Lead",
  company: "HeyHomie (Homepreneur Solutions Pvt. Ltd.)",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "3–5 Years",
  postedDate: "2026-04-15",
  skills: [
    "Performance Marketing",
    "Automation Tools (Zapier, Make, n8n)",
    "Data Scraping",
    "CRM (HubSpot, Zoho)",
    "Google Ads",
    "Meta Ads",
    "Analytics",
    "Python / Node.js"
  ],
  responsibilities: [
    "Build growth engine from scratch",
    "Run paid campaigns (Meta, Google, LinkedIn)",
    "Design automation workflows",
    "Create lead generation systems",
    "Optimize funnels and conversions"
  ],
  requirements: [
    "3–5 years experience in marketing automation",
    "Hands-on campaign execution",
    "Strong analytical mindset",
    "Startup experience preferred"
  ],
  tips: [
    "Prepare marketing metrics (ROAS, CPL, CPA)",
    "Revise automation tools",
    "Understand funnels deeply"
  ],
  perks: [
    { label: "Role", value: "High Ownership" },
    { label: "Growth", value: "Startup Scaling Role" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume + 200 word note" },
    { title: "Interview", desc: "Founder discussion" }
  ],
  notes: [
    "Send resume + answer (max 200 words)",
    "Email: careers@heyhomie.me"
  ],
  aboutCompany: "HeyHomie is a WhatsApp commerce platform for SMBs.",
  urgencyMessage: "🔥 High impact role!",
  applyLink: "mailto:careers@heyhomie.me"
},

{
  id: "ibm-multiple-roles-pan-india-2026-0to2exp-ibm1",
  title: "Multiple Roles",
  company: "IBM",
  location: "PAN India",
  jobType: "Full-time",
  experience: "0–2 Years",
  postedDate: "2026-04-15",
  skills: ["Programming", "Communication", "Problem Solving"],
  responsibilities: [
    "Work on assigned technical roles",
    "Collaborate with teams",
    "Support project delivery"
  ],
  requirements: [
    "Graduate / Post Graduate",
    "0-2 years experience",
    "Good communication skills"
  ],
  tips: [
    "Prepare aptitude",
    "Revise basics",
    "Practice coding"
  ],
  perks: [
    { label: "Salary", value: "10–28 LPA (Expected)" },
    { label: "Company", value: "Top MNC" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Register and select company" },
    { title: "Assessment", desc: "Online test" }
  ],
  notes: ["Select 'Tech Mahindra' during registration"],
  aboutCompany: "IBM is a global technology and consulting company.",
  urgencyMessage: "🔥 Apply now!",
  applyLink: "https://tinyurl.com/svu75s85"
},

{
  id: "hackerearth-technical-engineer-intern-2026-batch-he2",
  title: "Technical Engineer / Problem Setter (Internship)",
  company: "HackerEarth",
  location: "India",
  jobType: "Internship",
  experience: "Freshers (2025–2026)",
  postedDate: "2026-04-15",
  skills: ["Programming", "Problem Solving", "DSA"],
  responsibilities: [
    "Create coding problems",
    "Test solutions",
    "Work on platform tasks"
  ],
  requirements: [
    "Strong coding skills",
    "Good problem solving"
  ],
  tips: [
    "Practice DSA",
    "Solve coding problems",
    "Revise algorithms"
  ],
  perks: [
    { label: "Type", value: "Internship" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" }
  ],
  notes: [],
  aboutCompany: "HackerEarth is a coding platform.",
  urgencyMessage: "⚡ Apply fast!",
  applyLink: "https://hackerearth.applytojob.com/apply/TD1LYRto09/Technical-Engineer-Problem-Setter-Programming--Internship"
},

{
  id: "mahindra-campus-hiring-2026-freshers-mr3",
  title: "Campus Hiring 2026",
  company: "Mahindra Rise",
  location: "India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-15",
  skills: ["Engineering Basics", "Communication"],
  responsibilities: [
    "Work on assigned roles",
    "Support projects"
  ],
  requirements: [
    "2026 Batch",
    "Graduate"
  ],
  tips: [
    "Prepare aptitude",
    "Revise basics"
  ],
  perks: [
    { label: "Company", value: "Top Brand" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" }
  ],
  notes: [],
  aboutCompany: "Mahindra is a leading global enterprise.",
  urgencyMessage: "🔥 Apply now!",
  applyLink: "https://mycareernet.co/events/mahindra-campus-hiring-2026/"
},

{
  id: "amazon-remote-customer-support-2026-freshers-amz4",
  title: "Customer Service Associate (Remote)",
  company: "Amazon",
  location: "Remote",
  jobType: "Full-time",
  experience: "Freshers (2025–2026)",
  postedDate: "2026-04-15",
  skills: ["Communication", "Customer Support"],
  responsibilities: [
    "Handle customer queries",
    "Resolve issues",
    "Maintain satisfaction"
  ],
  requirements: [
    "Good communication skills",
    "Basic computer knowledge"
  ],
  tips: [
    "Practice communication",
    "Be clear and confident"
  ],
  perks: [
    { label: "Mode", value: "Work From Home" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" }
  ],
  notes: [],
  aboutCompany: "Amazon is a global e-commerce leader.",
  urgencyMessage: "🚀 Remote job!",
  applyLink: "https://jobs.amazon.in/jobDetail/en-IN/Remote-Customer-Service-Associate/a0Rar0000023JrNEAU"
},

{
  id: "mthree-graduate-role-2026-freshers-mth5",
  title: "Graduate Program",
  company: "Mthree",
  location: "India",
  jobType: "Full-time",
  experience: "Freshers (2024–2026)",
  postedDate: "2026-04-15",
  skills: ["Programming", "Communication"],
  responsibilities: [
    "Training + placement",
    "Work with clients"
  ],
  requirements: [
    "Graduate",
    "Basic coding skills"
  ],
  tips: [
    "Revise basics",
    "Prepare interviews"
  ],
  perks: [
    { label: "Program", value: "Training + Job" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" }
  ],
  notes: [],
  aboutCompany: "Mthree provides graduate hiring programs.",
  urgencyMessage: "🔥 Apply soon!",
  applyLink: "https://job-boards.greenhouse.io/mthreerecruitingportal/jobs/4660233006"
},

{
  id: "iqvia-freshers-role-2026-life-science-iq6",
  title: "Associate Role",
  company: "IQVIA",
  location: "India",
  jobType: "Full-time",
  experience: "Freshers (2025–2026)",
  postedDate: "2026-04-15",
  skills: ["Data Analysis", "Communication"],
  responsibilities: [
    "Support projects",
    "Analyze data"
  ],
  requirements: [
    "Graduate",
    "Basic domain knowledge"
  ],
  tips: [
    "Revise basics",
    "Prepare communication"
  ],
  perks: [
    { label: "Domain", value: "Healthcare" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" }
  ],
  notes: [],
  aboutCompany: "IQVIA works in healthcare analytics.",
  urgencyMessage: "⚡ Apply now!",
  applyLink: "https://jobs.iqvia.com/en/jobs/R1536744-0"
},

{
  id: "mantracare-fullstack-intern-delhi-2026-fs7",
  title: "Full Stack Developer Intern",
  company: "MantraCare",
  location: "Delhi, India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-15",
  skills: ["React", "Node.js", "JavaScript"],
  responsibilities: [
    "Develop web apps",
    "Work on frontend & backend"
  ],
  requirements: [
    "Basic full stack knowledge"
  ],
  tips: [
    "Build projects",
    "Practice coding"
  ],
  perks: [
    { label: "Type", value: "Internship" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" }
  ],
  notes: [],
  aboutCompany: "MantraCare is a healthcare platform.",
  urgencyMessage: "🚀 Apply fast!",
  applyLink: "https://mantra.care/careers/full-stack-developer-intern-delhi/"
},


{
  id: "mercor-machine-learning-engineer-remote-2026-ai-network-ml1",
  title: "Machine Learning Engineer (Expert Network)",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "Experienced",
  postedDate: "2026-04-15",
  skills: [
    "Python",
    "Machine Learning",
    "PyTorch",
    "TensorFlow",
    "MLOps",
    "Model Deployment"
  ],
  responsibilities: [
    "Train and evaluate ML models",
    "Work on real-world AI tasks",
    "Provide feedback for AI research",
    "Contribute to ML engineering projects"
  ],
  requirements: [
    "Experience in ML model development",
    "Strong Python and ML frameworks knowledge",
    "Ability to work independently",
    "Good communication skills"
  ],
  tips: [
    "Revise ML fundamentals",
    "Practice PyTorch/TensorFlow",
    "Understand MLOps",
    "Prepare real-world ML use cases"
  ],
  perks: [
    { label: "Salary", value: "$60–$130/hour" },
    { label: "Mode", value: "Fully Remote" },
    { label: "Payment", value: "Weekly (Stripe/Wise)" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Submit profile and resume" },
    { title: "Verification", desc: "AI interview + profile review" },
    { title: "Projects", desc: "Matched with relevant opportunities" }
  ],
  notes: [
    "Not a single job – talent network",
    "15–30 hours/week typical workload",
    "No H1-B or STEM OPT support"
  ],
  aboutCompany: "Mercor connects experts with AI companies and research labs.",
  urgencyMessage: "🚀 High paying remote opportunity!",
  applyLink: "https://t.mercor.com/FhTqM"
},
{
  id: "genpact-sourcing-specialist-noida-2026-hr-fresher-gp1",
  title: "Sourcing Specialist (Non-IT)",
  company: "Genpact",
  location: "Noida, India",
  jobType: "Contract-to-Hire",
  experience: "Freshers / 1+ Year",
  postedDate: "2026-04-15",
  skills: [
    "Talent Sourcing",
    "Recruitment",
    "Communication",
    "Stakeholder Management"
  ],
  responsibilities: [
    "Source candidates",
    "Screen profiles",
    "Manage end-to-end recruitment lifecycle",
    "Coordinate with stakeholders"
  ],
  requirements: [
    "MBA (HR) Freshers",
    "1+ year Non-IT hiring experience (optional)",
    "Strong communication skills"
  ],
  tips: [
    "Revise HR basics",
    "Practice communication",
    "Understand recruitment lifecycle"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Role", value: "HR Domain" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume via email" },
    { title: "Interview", desc: "HR rounds" }
  ],
  notes: ["Subject: Genpact - HR sourcer"],
  aboutCompany: "Genpact is a global professional services firm.",
  urgencyMessage: "⚡ Hiring now!",
  applyLink: "mailto:ruchika.joshi1@genpact.com"
},

{
  id: "dexian-senior-data-analyst-pune-2026-6plus-exp-da2",
  title: "Senior Data Analyst",
  company: "Dexian",
  location: "Pune, India",
  jobType: "Full-time",
  experience: "6+ Years",
  postedDate: "2026-04-15",
  skills: [
    "Python",
    "JavaScript",
    "Data Modeling",
    "Snowflake",
    "API Integration",
    "Workflow Automation"
  ],
  responsibilities: [
    "Design scalable data solutions",
    "Work on data modeling",
    "Automate workflows",
    "Integrate APIs"
  ],
  requirements: [
    "6+ years experience",
    "Strong Python & JavaScript",
    "Hands-on Snowflake or similar",
    "Experience in workflow tools"
  ],
  tips: [
    "Revise data modeling",
    "Practice Python",
    "Understand APIs",
    "Learn Snowflake basics"
  ],
  perks: [
    { label: "Work Mode", value: "Hybrid (4 WFO + 1 WFH)" },
    { label: "Role", value: "Senior Level" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume via email" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: [
    "Send Current CTC, Expected CTC, Notice Period",
    "Good to have: Camunda, BPMN, Finance domain"
  ],
  aboutCompany: "Dexian provides IT staffing and consulting services.",
  urgencyMessage: "🔥 Immediate hiring!",
  applyLink: "mailto:arkadeep.sen@dexian.com"
},

{
  id: "wipro-ptp-procurement-walkin-pune-2026-drive-april16-wp3",
  title: "PTP & Procurement Roles (Walk-in Drive)",
  company: "Wipro",
  location: "Pune, India",
  jobType: "Walk-in",
  experience: "0.6–6 Years",
  postedDate: "2026-04-15",
  skills: [
    "Accounts Payable",
    "Procurement",
    "Finance Operations",
    "Communication"
  ],
  responsibilities: [
    "Handle PTP processes",
    "Manage procurement operations",
    "Work in finance domain",
    "Coordinate with teams"
  ],
  requirements: [
    "0.6–6 years experience",
    "Immediate joiners (0–15 days)",
    "Willing to work US shifts"
  ],
  tips: [
    "Revise finance basics",
    "Prepare for walk-in",
    "Carry updated resume"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Facility", value: "Cab (One Way)" }
  ],
  applicationProcess: [
    { title: "Walk-in", desc: "16th April 2026, 10:30 AM – 12 PM" },
    { title: "Interview", desc: "On-site rounds" }
  ],
  notes: [
    "Venue: Hinjewadi Phase 2, Pune",
    "Contact: Harsha Manglani"
  ],
  aboutCompany: "Wipro is a global IT consulting company.",
  urgencyMessage: "⚡ Walk-in on April 16!",
  applyLink: "https://www.wipro.com/careers/"
},





      //14-04-26end

{
  id: "hdfc-life-fullstack-java-react-mumbai-2026-6to8exp-hdfc1",
  title: "Full Stack Developer (Java SpringBoot + React)",
  company: "HDFC Life",
  location: "Mumbai, India",
  jobType: "Full-time",
  experience: "6–8 Years",
  postedDate: "2026-04-14",
  skills: [
    "Java", "Spring Boot", "React", "Next.js", "React Native",
    "API Integration", "OAuth2.0", "Kafka", "Camel",
    "MongoDB", "PostgreSQL", "MySQL"
  ],
  responsibilities: [
    "Develop full stack applications",
    "Design and integrate APIs",
    "Implement secure authentication systems",
    "Build responsive frontend UI",
    "Work with databases and backend services"
  ],
  requirements: [
    "6-8 years experience in full stack development",
    "Strong knowledge of Java Spring Boot",
    "Strong React or Next.js experience",
    "Knowledge of API gateway and security"
  ],
  tips: [
    "Revise Spring Boot concepts",
    "Practice React projects",
    "Understand API security",
    "Prepare system design basics"
  ],
  perks: [
    { label: "Company", value: "Top Financial MNC" },
    { label: "Role", value: "Senior Level" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume via email" },
    { title: "Interview", desc: "Technical + HR rounds" }
  ],
  notes: ["Use subject: Expertise [BE] and Experience Year"],
  aboutCompany: "HDFC Life is a leading life insurance company in India.",
  urgencyMessage: "🔥 Immediate hiring!",
  applyLink: "mailto:devendra.sawant@hdfclife.com"
},

{
  id: "pragma-edge-associate-trainee-hyderabad-2026-fresher-java-python-pe2",
  title: "Associate Trainee",
  company: "Pragma Edge",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "Freshers (2026 Pass-outs)",
  postedDate: "2026-04-14",
  skills: ["Java", "Python", "Communication"],
  responsibilities: [
    "Assist in development tasks",
    "Work with senior developers",
    "Learn and contribute to projects"
  ],
  requirements: [
    "B.Tech / MCA (2026 pass-outs)",
    "Basic Java or Python knowledge",
    "Good communication skills",
    "Immediate joiners (15 days)"
  ],
  tips: [
    "Revise Java/Python basics",
    "Practice coding problems",
    "Prepare for technical interviews"
  ],
  perks: [
    { label: "Role", value: "Fresher Entry" },
    { label: "Growth", value: "Learning opportunity" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send CV via email" },
    { title: "Interview", desc: "Technical screening" }
  ],
  notes: ["Subject: Associate Trainee"],
  aboutCompany: "Pragma Edge provides digital transformation solutions.",
  urgencyMessage: "⚡ Immediate joiners required!",
  applyLink: "mailto:divya.vullamparthi@pragmaedge.com"
},

{
  id: "gocomet-associate-trainee-hyderabad-2026-fresher-drive-gc3",
  title: "Associate Trainee",
  company: "GoComet",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "Freshers (2026 Pass-outs)",
  postedDate: "2026-04-14",
  skills: ["Java", "Python", "Communication"],
  responsibilities: [
    "Work on development tasks",
    "Assist in project implementation",
    "Collaborate with team members"
  ],
  requirements: [
    "B.Tech / MCA (2026 pass-outs)",
    "Basic programming knowledge",
    "Good communication skills"
  ],
  tips: [
    "Revise programming basics",
    "Practice coding",
    "Prepare aptitude"
  ],
  perks: [
    { label: "Role", value: "Entry Level" },
    { label: "Company", value: "Logistics Tech" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online job drive" },
    { title: "Interview", desc: "Drive-based selection" }
  ],
  notes: [],
  aboutCompany: "GoComet is a logistics technology company.",
  urgencyMessage: "🚀 Apply now!",
  applyLink: "https://placement.acciojob.com/job-drive-details/?jobDriveId=19e91b1e-2830-4a70-b6fb-8dbfaffb9fb6"
},
{
  id: "embark-system-admin-intern-bangalore-2026-zoho-emb1",
  title: "System Administrator Intern",
  company: "EMBARK Services Pvt Ltd",
  location: "Bangalore, India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["System Administration", "Networking", "IT Support"],
  responsibilities: [
    "Assist in system maintenance",
    "Monitor servers and systems",
    "Provide technical support"
  ],
  requirements: [
    "BSc IT / BCA / BE / BTech",
    "Basic networking knowledge",
    "Good communication skills"
  ],
  tips: [
    "Revise networking basics",
    "Learn Linux basics",
    "Understand system tools"
  ],
  perks: [
    { label: "Type", value: "Internship" },
    { label: "Learning", value: "IT Infrastructure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" },
    { title: "Interview", desc: "Technical round" }
  ],
  notes: [],
  aboutCompany: "EMBARK Services provides IT and business solutions.",
  urgencyMessage: "⚡ Apply fast!",
  applyLink: "https://embarkgcc.zohorecruit.in/jobs/Careers/186972000024954661/System-Administrator-Intern"
},

{
  id: "amenify-software-engineer-intern-gurgaon-2026-swe-amn2",
  title: "Software Engineering Intern (Summer 2026)",
  company: "Amenify",
  location: "Gurugram, India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["JavaScript", "React", "Node.js"],
  responsibilities: [
    "Develop web applications",
    "Collaborate with engineering team",
    "Write clean and efficient code"
  ],
  requirements: [
    "Basic programming knowledge",
    "Understanding of web development",
    "Passion to learn"
  ],
  tips: [
    "Build projects",
    "Practice coding",
    "Learn full stack basics"
  ],
  perks: [
    { label: "Type", value: "Internship" },
    { label: "Company", value: "US Startup" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: ["Summer internship"],
  aboutCompany: "Amenify is a US-based tech startup providing lifestyle services.",
  urgencyMessage: "🚀 Apply now!",
  applyLink: "https://www.linkedin.com/jobs/view/4395975299"
},

{
  id: "sap-trainee-freshers-hyderabad-2026-abap-sap3",
  title: "SAP Trainee / ABAP Consultant",
  company: "Confidential",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["SAP", "ABAP", "SD", "FICO"],
  responsibilities: [
    "Work on SAP modules",
    "Support SAP implementation",
    "Assist in ABAP development"
  ],
  requirements: [
    "Any graduate",
    "Interest in SAP",
    "Basic technical knowledge"
  ],
  tips: [
    "Learn SAP basics",
    "Understand ERP concepts",
    "Practice ABAP basics"
  ],
  perks: [
    { label: "Role", value: "Entry Level" },
    { label: "Domain", value: "ERP" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn post" },
    { title: "Interview", desc: "Basic screening" }
  ],
  notes: [],
  aboutCompany: "SAP hiring drive for freshers in Hyderabad.",
  urgencyMessage: "🔥 Hiring now!",
  applyLink: "https://www.linkedin.com/posts/naresh-bulle-818674200_hyderabdjobs-freshershiring-fresherjobs-share-7449712984035209216-HNS5"
},

{
  id: "dexian-data-process-remote-2026-freshers-dex4",
  title: "Process / Data Analyst (Remote)",
  company: "Dexian India",
  location: "Remote",
  jobType: "Full-time",
  experience: "Freshers / Early Career",
  postedDate: "2026-04-14",
  skills: ["Data Analysis", "Process Improvement", "Excel"],
  responsibilities: [
    "Analyze business data",
    "Improve processes",
    "Work with teams remotely"
  ],
  requirements: [
    "Basic data knowledge",
    "Good communication skills"
  ],
  tips: [
    "Learn Excel",
    "Understand data basics",
    "Improve analytical thinking"
  ],
  perks: [
    { label: "Mode", value: "Remote" },
    { label: "Company", value: "MNC Client" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn" },
    { title: "Interview", desc: "Screening + rounds" }
  ],
  notes: [],
  aboutCompany: "Dexian provides IT staffing and consulting services.",
  urgencyMessage: "⚡ Remote job!",
  applyLink: "https://www.linkedin.com/posts/banideepabarman_were-hiring-at-dexian-india-for-a-remote-share-7449322179219046400-yySi"
},

{
  id: "codingal-operations-associate-bangalore-2026-ops5",
  title: "Operations Associate (US Shift)",
  company: "Codingal",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["Operations", "Communication", "Support"],
  responsibilities: [
    "Handle operations tasks",
    "Support business processes",
    "Work in US shift"
  ],
  requirements: [
    "Good communication",
    "Flexible for night shifts"
  ],
  tips: [
    "Prepare communication",
    "Be flexible",
    "Understand operations role"
  ],
  perks: [
    { label: "Shift", value: "US Shift" },
    { label: "Company", value: "EdTech" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "LinkedIn" },
    { title: "Interview", desc: "HR + Ops round" }
  ],
  notes: [],
  aboutCompany: "Codingal is a global coding education platform.",
  urgencyMessage: "🔥 Apply now!",
  applyLink: "https://www.linkedin.com/jobs/view/4397219652"
},

{
  id: "php-developer-wps-navi-mumbai-2026-laravel-php6",
  title: "PHP Developer",
  company: "WP Translation & Testing Services",
  location: "Navi Mumbai, India",
  jobType: "Full-time",
  experience: "1–2 Years",
  postedDate: "2026-04-14",
  skills: ["PHP", "Laravel", "HTML", "CSS", "JavaScript"],
  responsibilities: [
    "Develop web applications",
    "Work on Laravel framework",
    "Maintain backend systems"
  ],
  requirements: [
    "1-2 years experience",
    "Knowledge of Laravel",
    "Frontend basics required"
  ],
  tips: [
    "Revise Laravel",
    "Practice PHP",
    "Build small apps"
  ],
  perks: [
    { label: "Salary", value: "Up to 4 LPA" },
    { label: "Industry", value: "IT" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Send resume via email" },
    { title: "Interview", desc: "Technical round" }
  ],
  notes: ["Email: mayury.more@wpsgp.com"],
  aboutCompany: "Provides translation and IT services.",
  urgencyMessage: "⚡ Immediate hiring!",
  applyLink: "mailto:mayury.more@wpsgp.com"
},

{
  id: "diebold-service-desk-hyderabad-2026-support-it7",
  title: "Associate Service Desk Representative",
  company: "Diebold Nixdorf",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "0–2 Years",
  postedDate: "2026-04-14",
  skills: ["IT Support", "Troubleshooting", "Customer Service"],
  responsibilities: [
    "Handle customer queries",
    "Resolve technical issues",
    "Manage support tickets"
  ],
  requirements: [
    "0-2 years experience",
    "Good English communication",
    "IT support knowledge"
  ],
  tips: [
    "Prepare troubleshooting basics",
    "Practice communication",
    "Understand ticketing systems"
  ],
  perks: [
    { label: "Role", value: "Support" },
    { label: "Company", value: "Global MNC" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" },
    { title: "Interview", desc: "Technical + HR" }
  ],
  notes: [],
  aboutCompany: "Diebold Nixdorf is a global leader in banking and retail tech.",
  urgencyMessage: "🔥 Hiring now!",
  applyLink: "https://eeug.fa.us6.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX/job/18466"
},
{
  id: "service-desk-analyst-walkin-hyderabad-2026-0415-freshers-x1a9",
  title: "Service Desk Analyst (Walk-In)",
  company: "Confidential",
  location: "Hyderabad, India",
  jobType: "Walk-in",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["IT Support", "Communication", "Troubleshooting"],
  responsibilities: [
    "Handle user queries and issues",
    "Provide IT support assistance",
    "Resolve technical problems"
  ],
  requirements: [
    "Good communication skills",
    "Basic IT knowledge",
    "Willing to work in shifts"
  ],
  tips: [
    "Prepare IT support basics",
    "Practice communication skills",
    "Be confident in walk-in"
  ],
  perks: [
    { label: "Type", value: "Walk-in Drive" },
    { label: "Opportunity", value: "Freshers Entry" }
  ],
  applicationProcess: [
    { title: "Walk-in", desc: "Attend on 15th, 16th, 17th April" },
    { title: "Interview", desc: "Face-to-face rounds" }
  ],
  notes: ["Only freshers eligible"],
  aboutCompany: "IT support hiring drive conducted in Hyderabad.",
  urgencyMessage: "⚡ Walk-in this week!",
  applyLink: "https://www.linkedin.com/posts/srilatha-cheguri-68b3a615_we-are-conducting-awalkin-drive-for-the-activity-7449348235191820288-Qw3L"
},

{
  id: "wysele-digital-marketing-freshers-hyderabad-2026-0414-dm3k",
  title: "Digital Marketing Executive",
  company: "Wysele Technologies",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["SEO", "Social Media Marketing", "Content Marketing"],
  responsibilities: [
    "Manage social media platforms",
    "Work on SEO optimization",
    "Create marketing content"
  ],
  requirements: [
    "Interest in digital marketing",
    "Basic knowledge of social media"
  ],
  tips: [
    "Learn SEO basics",
    "Build small projects",
    "Understand social media trends"
  ],
  perks: [
    { label: "Role", value: "Entry Level" },
    { label: "Growth", value: "Marketing exposure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online application" },
    { title: "Interview", desc: "Basic HR round" }
  ],
  notes: ["Freshers welcome"],
  aboutCompany: "Wysele Technologies focuses on digital marketing and IT services.",
  urgencyMessage: "🔥 Hiring now!",
  applyLink: "https://www.linkedin.com/posts/wysele-62679021b_hiring-digitalmarketing-freshersjobs-share-7449422748549951489-UAly"
},

{
  id: "atlys-machine-learning-intern-remote-2026-ml9p",
  title: "Machine Learning Intern",
  company: "Atlys",
  location: "Remote",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["Python", "Machine Learning", "Data Analysis"],
  responsibilities: [
    "Assist in ML model development",
    "Analyze datasets",
    "Support engineering team"
  ],
  requirements: [
    "Basic ML knowledge",
    "Python programming skills"
  ],
  tips: [
    "Revise ML concepts",
    "Practice Python coding",
    "Work on mini ML projects"
  ],
  perks: [
    { label: "Type", value: "Internship" },
    { label: "Mode", value: "Remote" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" },
    { title: "Interview", desc: "Technical discussion" }
  ],
  notes: ["Great for beginners"],
  aboutCompany: "Atlys is a travel-tech startup simplifying visa processes.",
  urgencyMessage: "🚀 Apply fast!",
  applyLink: "https://careers.atlys.com/o/machine-learning-intern"
},

{
  id: "hexa-frontend-developer-intern-2026-react-ui-x7b2",
  title: "Frontend Developer",
  company: "Hexa Solutions",
  location: "India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["React", "HTML", "CSS", "JavaScript"],
  responsibilities: [
    "Build UI components",
    "Work on frontend features",
    "Improve user experience"
  ],
  requirements: [
    "Basic React knowledge",
    "Understanding of frontend development"
  ],
  tips: [
    "Practice React projects",
    "Build portfolio",
    "Learn UI design basics"
  ],
  perks: [
    { label: "Type", value: "Internship" },
    { label: "Learning", value: "Frontend exposure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online application" },
    { title: "Interview", desc: "Technical round" }
  ],
  notes: [],
  aboutCompany: "Hexa Solutions is a growing software company.",
  urgencyMessage: "⚡ Apply now!",
  applyLink: "https://jobs.pyjamahr.com/hexa-solutions/frontend-development-2"
},

{
  id: "opteamix-trainee-software-engineer-bangalore-2026-tns4",
  title: "Trainee Software Engineer",
  company: "Opteamix",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-14",
  skills: ["Programming", "Problem Solving", "Basics of Development"],
  responsibilities: [
    "Assist in software development",
    "Work with senior developers",
    "Debug and test code"
  ],
  requirements: [
    "Basic coding knowledge",
    "Willingness to learn"
  ],
  tips: [
    "Practice coding problems",
    "Revise basics",
    "Be confident"
  ],
  perks: [
    { label: "Role", value: "Entry Level" },
    { label: "Growth", value: "Learning opportunity" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" },
    { title: "Interview", desc: "Technical + HR" }
  ],
  notes: [],
  aboutCompany: "Opteamix is an IT services and consulting company.",
  urgencyMessage: "🔥 Apply soon!",
  applyLink: "https://opteamix.darwinbox.in/ms/candidatev2/main/careers/jobDetails/a6932bbc8c7323"
},

{
  id: "node-react-developer-freshers-gurgaon-2026-fullstack-nr5",
  title: "Node.js / React Developer",
  company: "Startup",
  location: "Gurgaon, India",
  jobType: "Full-time",
  experience: "0–3 Years",
  postedDate: "2026-04-14",
  skills: ["Node.js", "React", "JavaScript"],
  responsibilities: [
    "Develop full stack applications",
    "Build APIs and UI",
    "Collaborate with team"
  ],
  requirements: [
    "Basic MERN stack knowledge",
    "Passion for development"
  ],
  tips: [
    "Build projects",
    "Practice coding",
    "Learn APIs"
  ],
  perks: [
    { label: "Type", value: "Startup" },
    { label: "Growth", value: "Fast learning" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: [],
  aboutCompany: "Growing startup hiring developers.",
  urgencyMessage: "🚀 Hiring now!",
  applyLink: "https://www.linkedin.com/posts/shivani-chauhan0931_hiring-nodejs-reactjs-share-7449325378751447040-U8sL"
},
      {
  id: "tcs-nodejs-developer-pune-2026-0414-183355-z3p8",
  title: "Node.js Developer",
  company: "TCS",
  location: "Pune, India",
  jobType: "Full-time",
  experience: "2–4 Years",
  postedDate: "2026-04-14",
  skills: ["Node.js", "Express.js", "MongoDB", "REST APIs"],
  responsibilities: [
    "Build backend APIs",
    "Handle database operations",
    "Ensure security and performance"
  ],
  requirements: [
    "2+ years Node.js experience",
    "Knowledge of databases",
    "Understanding of REST APIs"
  ],
  tips: [
    "Revise Express.js",
    "Practice API building",
    "Learn JWT authentication"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Work", value: "Stable job" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online portal" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: ["Good communication required"],
  aboutCompany: "TCS is one of India's largest IT companies.",
  urgencyMessage: "🔥 Hiring now!",
  applyLink: "https://www.tcs.com/careers"
},
      {
  id: "infosys-react-developer-hyderabad-2026-0414-183210-a7m4",
  title: "React Developer",
  company: "Infosys",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "1–3 Years",
  postedDate: "2026-04-14",
  skills: ["React JS", "JavaScript", "HTML", "CSS", "REST APIs"],
  responsibilities: [
    "Develop responsive UI components",
    "Integrate APIs",
    "Optimize performance"
  ],
  requirements: [
    "1+ years experience in React",
    "Strong JavaScript fundamentals",
    "Basic Git knowledge"
  ],
  tips: [
    "Practice React hooks",
    "Revise JS fundamentals",
    "Build small projects"
  ],
  perks: [
    { label: "Company", value: "Top IT Company" },
    { label: "Growth", value: "Fast career growth" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online application" },
    { title: "Interview", desc: "Technical + HR rounds" }
  ],
  notes: ["Freshers with projects can apply"],
  aboutCompany: "Infosys is a global leader in IT services.",
  urgencyMessage: "⚡ Apply fast!",
  applyLink: "https://careers.infosys.com"
},
      {
  id: "wipro-cloud-engineer-bangalore-2026-0414-183045-x9k2",
  title: "Cloud Engineer",
  company: "Wipro",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "3–6 Years",
  postedDate: "2026-04-14",
  skills: ["AWS", "Azure", "Cloud Architecture", "Linux", "Networking"],
  responsibilities: [
    "Design and manage cloud infrastructure",
    "Monitor cloud environments",
    "Implement security best practices"
  ],
  requirements: [
    "3+ years experience in cloud",
    "Knowledge of AWS or Azure",
    "Strong networking basics"
  ],
  tips: [
    "Revise cloud services",
    "Prepare networking basics",
    "Understand IAM concepts"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Learning", value: "Cloud exposure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online application" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: ["Cloud certification preferred"],
  aboutCompany: "Wipro is a leading global IT consulting company.",
  urgencyMessage: "⚡ Apply soon!",
  applyLink: "https://careers.wipro.com"
},
      {
  id: "wipro-cloud-engineer-bangalore",
  title: "Cloud Engineer",
  company: "Wipro",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "3–6 Years",
  postedDate: "2026-04-14",
  skills: [
    "AWS",
    "Azure",
    "Cloud Architecture",
    "Linux",
    "Networking"
  ],
  responsibilities: [
    "Design and manage cloud infrastructure",
    "Monitor cloud environments",
    "Implement security best practices"
  ],
  requirements: [
    "3+ years experience in cloud",
    "Knowledge of AWS or Azure",
    "Strong networking basics"
  ],
  tips: [
    "Revise cloud services",
    "Prepare networking basics",
    "Understand IAM concepts"
  ],
  perks: [
    { label: "Company", value: "Top MNC" },
    { label: "Learning", value: "Cloud exposure" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online application" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: ["Cloud certification preferred"],
  aboutCompany: "Wipro is a leading global IT consulting company.",
  urgencyMessage: "⚡ Apply soon!",
  applyLink: "https://careers.wipro.com"
},
{
  id: "tcs-java-developer-chennai",
  title: "Java Developer",
  company: "TCS",
  location: "Chennai, India",
  jobType: "Full-time",
  experience: "2–5 Years",
  postedDate: "2026-04-14",
  skills: [
    "Java",
    "Spring Boot",
    "Microservices",
    "SQL"
  ],
  responsibilities: [
    "Develop backend applications",
    "Work on APIs",
    "Maintain code quality"
  ],
  requirements: [
    "2+ years Java experience",
    "Knowledge of Spring Boot",
    "Database skills"
  ],
  tips: [
    "Revise Java basics",
    "Practice API development",
    "Prepare SQL queries"
  ],
  perks: [
    { label: "Stability", value: "Long-term career" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Through portal" },
    { title: "Interview", desc: "Tech + HR" }
  ],
  notes: ["Service-based company role"],
  aboutCompany: "TCS is a global IT services leader.",
  urgencyMessage: "⚡ Hiring ongoing!",
  applyLink: "https://www.tcs.com/careers"
},
{
  id: "zoho-frontend-developer-chennai",
  title: "Frontend Developer",
  company: "Zoho",
  location: "Chennai, India",
  jobType: "Full-time",
  experience: "Freshers / 1 Year",
  postedDate: "2026-04-14",
  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "React"
  ],
  responsibilities: [
    "Develop UI components",
    "Optimize web performance",
    "Work with backend teams"
  ],
  requirements: [
    "Strong frontend basics",
    "Good problem-solving skills"
  ],
  tips: [
    "Build projects",
    "Practice JS concepts"
  ],
  perks: [
    { label: "Culture", value: "Product-based company" }
  ],
  applicationProcess: [
    { title: "Test", desc: "Online assessment" },
    { title: "Interview", desc: "Technical rounds" }
  ],
  notes: ["Freshers welcome"],
  aboutCompany: "Zoho builds cloud-based business software.",
  urgencyMessage: "⚡ Apply now!",
  applyLink: "https://careers.zoho.com"
},
{
  id: "accenture-data-analyst-hyderabad",
  title: "Data Analyst",
  company: "Accenture",
  location: "Hyderabad, India",
  jobType: "Full-time",
  experience: "1–4 Years",
  postedDate: "2026-04-14",
  skills: [
    "SQL",
    "Excel",
    "Power BI",
    "Data Analysis"
  ],
  responsibilities: [
    "Analyze business data",
    "Create dashboards",
    "Generate reports"
  ],
  requirements: [
    "1+ years experience",
    "Strong SQL knowledge"
  ],
  tips: [
    "Practice SQL queries",
    "Learn visualization tools"
  ],
  perks: [
    { label: "Brand", value: "Global MNC" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" },
    { title: "Interview", desc: "Assessment + HR" }
  ],
  notes: ["Good communication required"],
  aboutCompany: "Accenture is a global professional services company.",
  urgencyMessage: "⚡ Limited openings!",
  applyLink: "https://www.accenture.com/in-en/careers"
},
{
  id: "flipkart-software-engineer-bangalore",
  title: "Software Engineer",
  company: "Flipkart",
  location: "Bangalore, India",
  jobType: "Full-time",
  experience: "2–5 Years",
  postedDate: "2026-04-14",
  skills: [
    "Java",
    "System Design",
    "Microservices",
    "DSA"
  ],
  responsibilities: [
    "Build scalable systems",
    "Work on backend services",
    "Optimize performance"
  ],
  requirements: [
    "2+ years experience",
    "Strong DSA skills"
  ],
  tips: [
    "Prepare system design",
    "Practice coding problems"
  ],
  perks: [
    { label: "Salary", value: "High package" }
  ],
  applicationProcess: [
    { title: "Apply", desc: "Online" },
    { title: "Interview", desc: "Multiple rounds" }
  ],
  notes: ["Product-based role"],
  aboutCompany: "Flipkart is India’s leading e-commerce platform.",
  urgencyMessage: "⚡ Apply fast!",
  applyLink: "https://www.flipkartcareers.com"
},
      
  {
    id: "amd-software-development-engineer-hyderabad",
    title: "Software Development Engineer",
    company: "AMD",
    location: "Hyderabad, India",
    jobType: "Full-time",
    experience: "Freshers / Relevant Experience",
    postedDate: "2026-04-13",
    skills: ["C","C++","Python","Programming","Systems Engineering"],
    responsibilities: [
      "Develop high-performance software",
      "Work on system-level optimizations",
      "Collaborate with teams"
    ],
    requirements: [
      "B.E / B.Tech / M.E / M.Tech",
      "Strong programming skills",
      "Problem-solving ability"
    ],
    tips: ["Practice coding","Revise C/C++","Prepare basics"],
    perks: [
      { label: "Salary", value: "Competitive" },
      { label: "Growth", value: "High learning" }
    ],
    applicationProcess: [
      { title: "Apply", desc: "Submit application" },
      { title: "Interview", desc: "Technical rounds" }
    ],
    notes: ["Apply early"],
    aboutCompany: "AMD is a global semiconductor company.",
    urgencyMessage: "⚡ Apply soon!",
    applyLink: "https://careers.amd.com/careers-home/jobs/67021?lang=en-us"
  },

  {
    id: "salesforce-software-engineering-amts-india",
    title: "Software Engineering AMTS",
    company: "Salesforce",
    location: "Hyderabad / Bangalore",
    jobType: "Full-time",
    experience: "Freshers",
    postedDate: "2026-04-13",
    skills: ["DSA","Programming","Algorithms"],
    responsibilities: [
      "Build scalable apps",
      "Work on cloud systems"
    ],
    requirements: [
      "2026 batch",
      "7.5+ CGPA",
      "No backlogs"
    ],
    tips: ["Practice DSA","Prepare coding"],
    perks: [
      { label: "Salary", value: "High package" }
    ],
    applicationProcess: [
      { title: "Test", desc: "Online coding" },
      { title: "Interview", desc: "Tech rounds" }
    ],
    notes: ["Strict eligibility"],
    aboutCompany: "Salesforce is a leading CRM company.",
    urgencyMessage: "⚡ Don’t miss!",
    applyLink: "https://careers.salesforce.com/en/jobs/jr334858/software-engineering-amts/"
  },

  {
    id: "qualcomm-software-engineer-hyderabad",
    title: "Software Engineer",
    company: "Qualcomm",
    location: "Hyderabad",
    jobType: "Full-time",
    experience: "0–2 Years",
    postedDate: "2026-04-13",
    skills: ["C++","Embedded","Testing"],
    responsibilities: ["Develop software","Testing systems"],
    requirements: ["B.Tech","Programming knowledge"],
    tips: ["Revise C++","Prepare basics"],
    perks: [{ label: "Growth", value: "Global exposure" }],
    applicationProcess: [{ title: "Apply", desc: "Online" }],
    notes: ["Role varies"],
    aboutCompany: "Qualcomm is a global telecom company.",
    urgencyMessage: "⚡ Apply fast!",
    applyLink: "https://careers.qualcomm.com/careers/job/446717850422"
  },

  {
    id: "sapl-hr-executive",
    title: "HR Executive",
    company: "Srinivasan Associates Pvt Ltd",
    location: "Coimbatore / Chennai / Bangalore",
    jobType: "Full-time",
    experience: "5+ Years",
    postedDate: "2026-04-13",
    skills: ["Recruitment","HR Ops"],
    responsibilities: ["Handle HR tasks","Manage employees"],
    requirements: ["MBA/MSW","5+ years"],
    tips: ["Prepare HR basics"],
    perks: [{ label: "Career", value: "Stable role" }],
    applicationProcess: [{ title: "Apply", desc: "Email resume" }],
    notes: ["Construction exp preferred"],
    aboutCompany: "Construction services company.",
    urgencyMessage: "⚡ Hiring now!",
    applyLink: "mailto:ranganathan.sk@sapl.in"
  },

  {
    id: "arcitech-ai-it-operations",
    title: "IT Operations Engineer",
    company: "Arcitech AI",
    location: "Navi Mumbai",
    jobType: "Full-time",
    experience: "2–5 Years",
    postedDate: "2026-04-13",
    skills: ["Windows","Linux","AWS","Networking"],
    responsibilities: ["Manage infra","Support systems"],
    requirements: ["2–5 years exp"],
    tips: ["Revise networking"],
    perks: [{ label: "Learning", value: "Cloud exposure" }],
    applicationProcess: [{ title: "Apply", desc: "Email" }],
    notes: ["Hands-on needed"],
    aboutCompany: "IT operations company.",
    urgencyMessage: "⚡ Immediate hiring!",
    applyLink: "mailto:pamela@arcotgroup.com"
  },

  {
    id: "agoda-staff-engineer",
    title: "Staff Software Engineer",
    company: "Agoda",
    location: "Gurugram",
    jobType: "Full-time",
    experience: "8+ Years",
    postedDate: "2026-04-13",
    skills: ["Java","React","Node.js"],
    responsibilities: ["Lead architecture","Mentor teams"],
    requirements: ["8+ years exp"],
    tips: ["Prepare system design"],
    perks: [{ label: "Role", value: "Leadership" }],
    applicationProcess: [{ title: "Apply", desc: "Online" }],
    notes: ["Senior role"],
    aboutCompany: "Travel tech platform.",
    urgencyMessage: "⚡ Apply soon!",
    applyLink: "https://job-boards.greenhouse.io/agoda/jobs/6792246"
  },

  {
    id: "network-admin-goa",
    title: "Network Administrator",
    company: "IT Company",
    location: "Goa",
    jobType: "Full-time",
    experience: "Relevant",
    postedDate: "2026-04-13",
    skills: ["Networking","DNS","Cisco"],
    responsibilities: ["Manage network","Troubleshoot"],
    requirements: ["Experience needed"],
    tips: ["Revise networking"],
    perks: [{ label: "Salary", value: "₹40K" }],
    applicationProcess: [{ title: "Apply", desc: "Email" }],
    notes: ["Goa candidates only"],
    aboutCompany: "IT services firm.",
    urgencyMessage: "⚡ Immediate joiners!",
    applyLink: "mailto:vignesh@91hr.in"
  },

  {
    id: "infosys-fullstack",
    title: "Full Stack Developer",
    company: "Infosys",
    location: "India",
    jobType: "Full-time",
    experience: "Freshers",
    postedDate: "2026-04-13",
    skills: ["Full Stack","Programming"],
    responsibilities: ["Develop apps"],
    requirements: ["Graduates"],
    tips: ["Practice coding"],
    perks: [{ label: "Salary", value: "₹21 LPA" }],
    applicationProcess: [{ title: "Apply", desc: "Online" }],
    notes: ["Apply fast"],
    aboutCompany: "IT services company.",
    urgencyMessage: "⚡ High package!",
    applyLink: "https://surveys.infosysapps.com/r/a/InfosysDSESPoffcampus"
  },

  {
    id: "data-engineer-genai",
    title: "Data Engineer",
    company: "Confidential",
    location: "Multiple Cities",
    jobType: "Full-time",
    experience: "8+ Years",
    postedDate: "2026-04-13",
    skills: ["Python","Azure","GenAI"],
    responsibilities: ["Build pipelines"],
    requirements: ["8+ years"],
    tips: ["Revise Python"],
    perks: [{ label: "Field", value: "AI/GenAI" }],
    applicationProcess: [{ title: "Apply", desc: "Email" }],
    notes: ["Senior role"],
    aboutCompany: "AI company.",
    urgencyMessage: "⚡ High demand!",
    applyLink: "mailto:rect.rajatg@gmail.com"
  },

  {
    id: "natwest-react-fullstack",
    title: "React FullStack Engineer",
    company: "NatWest",
    location: "Gurugram",
    jobType: "Full-time",
    experience: "5+ Years",
    postedDate: "2026-04-13",
    skills: ["React","JS","HTML","CSS"],
    responsibilities: ["Build UI","Maintain apps"],
    requirements: ["5+ years"],
    tips: ["Revise React"],
    perks: [{ label: "Company", value: "Banking MNC" }],
    applicationProcess: [{ title: "Apply", desc: "Online" }],
    notes: ["Experienced only"],
    aboutCompany: "Banking company.",
    urgencyMessage: "⚡ Apply now!",
    applyLink: "https://jobs.natwestgroup.com/jobs/17596387-react-fullstack-software-engineer"
  },
      {
  id: "virtusa-java-fullstack-developer-pune",
  title: "Java Full Stack Developer",
  company: "Virtusa",
  location: "Pune, India",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-11",
  skills: [
    "Java",
    "Full Stack Development",
    "Spring Boot",
    "React",
    "SQL"
  ],
  requirements: [
    "Bachelor’s or Master’s Degree",
    "Basic knowledge of Java and web development",
    "Understanding of frontend and backend concepts",
    "Willingness to learn and grow"
  ],
  applyLink: "https://www.virtusa.com/careers/job-search/in/pune/core-tech-java/java-full-stack-developer/creq252194"
},
{
  id: "mercor-devops-platform-engineer-remote",
  title: "DevOps / Platform Engineer",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "Experienced Professionals",
  postedDate: "2026-04-11",
  skills: [
    "CI/CD",
    "AWS",
    "GCP",
    "Azure",
    "Docker",
    "Kubernetes"
  ],
  requirements: [
    "Experience with cloud infrastructure",
    "Strong knowledge of CI/CD pipelines",
    "Experience with containerization tools",
    "Ability to work independently",
    "Strong communication skills"
  ],
  applyLink: "https://t.mercor.com/cLiEV"
},
      // 9-4-26
      {
  id: "juspay-sde-backend-bangalore",
  title: "Software Development Engineer (Backend)",
  company: "Juspay",
  location: "Bengaluru, India",
  jobType: "Full-time",
  experience: "Relevant Experience",
  postedDate: "2026-04-09",
  skills: [
    "Backend Development",
    "API Integrations",
    "Functional Programming",
    "UPI Payments",
    "Authentication Systems"
  ],
  requirements: [
    "Interest in large-scale system design",
    "Knowledge of backend and payment systems",
    "Strong problem-solving skills",
    "Passion for performance and reliability",
    "Interest in functional programming"
  ],
  applyLink: "https://juspay.io/careers/DEV-BE01"
},
{
  id: "cornerstone-junior-engineer-intern-pune",
  title: "Junior Engineer - Intern",
  company: "Cornerstone",
  location: "Pune, India",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-09",
  skills: [
    "Programming",
    "Software Development",
    "Problem Solving"
  ],
  requirements: [
    "Bachelor’s Degree",
    "Basic programming knowledge",
    "Willingness to learn",
    "Good communication skills"
  ],
  applyLink: "https://cornerstone.csod.com/ux/ats/careersite/2/home/requisition/11139?c=cornerstone&sq=Junior%20Engineer-%20Intern&country=in"
},
      // end
      {
  id: "fullstack-developer-wfh-python-react-azure",
  title: "Full Stack Software Developer",
  company: "One Degree North",
  location: "Remote (Work From Home)",
  jobType: "Full-time",
  experience: "3+ Years",
  postedDate: "2026-04-08",
  skills: ["Python", "Django", "React", "Microsoft Azure"],
  requirements: [
    "3+ years of experience",
    "Strong knowledge of Python & Django",
    "Experience with React",
    "Cloud experience with Microsoft Azure"
  ],
  applyLink: "mailto:mansuri@onedegreenorth.in"
},
{
  id: "hr-recruiter-intern-chennai-freshers",
  title: "HR Recruiter Intern",
  company: "Tecvesten",
  location: "Madipakkam, Chennai",
  jobType: "Internship",
  experience: "Freshers",
  postedDate: "2026-04-08",
  skills: ["Recruitment", "Sourcing", "Screening"],
  requirements: [
    "Freshers or currently pursuing",
    "Interest in recruitment",
    "Good communication skills"
  ],
  applyLink: "mailto:preethi@tecvesten.com"
},
{
  id: "canonical-graduate-software-engineer-remote",
  title: "Graduate Software Engineer",
  company: "Canonical (Ubuntu)",
  location: "Remote (Worldwide)",
  jobType: "Full-time",
  experience: "Freshers",
  postedDate: "2026-04-08",
  skills: ["Programming", "Linux", "Software Development"],
  requirements: [
    "Graduate in relevant field",
    "Strong programming fundamentals",
    "Interest in open-source"
  ],
  applyLink: "https://job-boards.greenhouse.io/canonical/jobs/7679138"
},
{
  id: "qualcomm-frontend-engineer-genai",
  title: "Front-End Engineer (Gen-AI)",
  company: "Qualcomm",
  location: "India",
  jobType: "Full-time",
  experience: "Relevant Experience",
  postedDate: "2026-04-09",
  skills: ["Frontend", "React", "JavaScript", "AI"],
  requirements: [
    "Strong frontend skills",
    "Experience with React",
    "Interest in AI technologies"
  ],
  applyLink: "https://hiringhustle.com/qualcomm-hiring-frontend-engineer/"
},
{
  id: "off-campus-hiring-multiple-companies-2026",
  title: "Off-Campus Hiring (Multiple Roles)",
  company: "Multiple Companies",
  location: "India",
  jobType: "Full-time",
  experience: "Freshers / Experienced",
  postedDate: "2026-04-09",
  skills: ["Software", "DevOps", "Engineering"],
  requirements: [
    "Open to freshers",
    "Basic technical knowledge",
    "Willingness to learn"
  ],
  applyLink: "https://hiringhustle.com/off-campus-hiring/"
},
{
  id: "cleartrip-frontend-developer",
  title: "Frontend Developer",
  company: "Cleartrip",
  location: "India",
  jobType: "Full-time",
  experience: "Relevant Experience",
  postedDate: "2026-04-08",
  skills: ["HTML", "CSS", "JavaScript", "React"],
  requirements: [
    "Strong frontend experience",
    "Knowledge of React",
    "Good problem-solving skills"
  ],
  applyLink: "https://hiringhustle.com/cleartrip-is-hiring-a-frontend-developer/"
},
  {
    id: "infosys-bpm-pune-walkin-10-apr-2026",
    title: "PTP / RTR / OTC",
    company: "Infosys BPM",
    location: "Pune, India",
    jobType: "Walk-in",
    experience: "1–6 Years",
    vacancies: 10,
    postedDate: "2026-04-08",
    walkInDate: "2026-04-10",
    time: "10:00 AM – 1:00 PM",
    venue: "Infosys BPM Limited, International Tech Park, Hinjewadi, Pune",
    skills: [
      "Finance & Accounts",
      "PTP",
      "RTR",
      "OTC",
      "General Ledger",
      "Accounts Payable"
    ],
    requirements: [
      "1–6 years of experience in Finance & Accounts",
      "Knowledge in PTP, RTR, or OTC",
      "Good communication skills"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-drive-for-ptp-rtr-otc-on-10th-apr-26-at-pune-location-infosys-bpm-pune-1-to-6-years-080426009122"
  },

  {
    id: "infosys-bpm-nagpur-walkin-18-apr-2026",
    title: "PTP / RTR / OTC",
    company: "Infosys BPM",
    location: "Nagpur, India",
    jobType: "Walk-in",
    experience: "1–6 Years",
    vacancies: 10,
    postedDate: "2026-04-08",
    walkInDate: "2026-04-18",
    time: "10:00 AM – 1:00 PM",
    venue: "Infosys Limited SEZ, MIHAN, Nagpur",
    skills: [
      "Finance & Accounts",
      "R2R",
      "P2P",
      "OTC",
      "Accounts Payable",
      "General Ledger"
    ],
    requirements: [
      "1–6 years of experience in accounting roles",
      "Understanding of R2R, P2P, OTC processes",
      "Basic Excel skills"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-drive-for-ptp-rtr-otc-on-18th-apr-26-at-nagpur-location-infosys-bpm-pune-1-to-6-years-030426010180"
  },

  {
    id: "sai-life-sciences-process-engineering-mumbai",
    title: "Process Engineering",
    company: "SAI Life Sciences",
    location: "Mumbai (Interview) / Hyderabad (Job)",
    jobType: "Walk-in",
    experience: "4–9 Years",
    vacancies: 10,
    postedDate: "2026-04-08",
    walkInDate: "2026-04-11",
    time: "9:00 AM – 4:30 PM",
    venue: "Le Meridien, Navi Mumbai",
    skills: ["Scale Up", "Technology Transfer"],
    requirements: [
      "4–9 years experience in process engineering",
      "Experience in scale-up and tech transfer",
      "Strong domain knowledge"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-interview-at-mumbai-process-engineering-sai-life-sciences-hyderabad-4-to-9-years-080426013244"
  },

  {
    id: "sai-life-sciences-analytical-rnd-mumbai",
    title: "Analytical R&D - Med Chem",
    company: "SAI Life Sciences",
    location: "Mumbai (Interview) / Hyderabad (Job)",
    jobType: "Walk-in",
    experience: "5–10 Years",
    vacancies: 10,
    postedDate: "2026-04-08",
    walkInDate: "2026-04-11",
    time: "9:00 AM – 4:30 PM",
    venue: "Le Meridien, Navi Mumbai",
    skills: ["Prep HPLC", "SFC"],
    requirements: [
      "5–10 years in Analytical R&D",
      "Experience with HPLC and SFC",
      "Strong chemistry background"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-interview-at-mumbai-analytical-r-d-med-chem-sai-life-sciences-hyderabad-5-to-10-years-080426013602"
  },

  {
    id: "tmf-group-payroll-pune-walkin",
    title: "Global Payroll Associate",
    company: "TMF Group",
    location: "Pune, India",
    jobType: "Walk-in",
    experience: "1–6 Years",
    vacancies: 11,
    salary: "₹4.25–7 LPA",
    postedDate: "2026-04-08",
    walkInDate: "2026-04-11",
    time: "10:30 AM – 2:00 PM",
    venue: "ICC Trade Tower, Pune",
    skills: [
      "Global Payroll",
      "Excel",
      "Payroll Accounting",
      "English Communication"
    ],
    requirements: [
      "Experience in payroll processing",
      "Good Excel knowledge",
      "Strong communication skills"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-interview-for-global-payroll-associate-11th-april-pune-tmf-group-pune-1-to-6-years-260925030158"
  },

  {
    id: "tcs-sap-grc-hyderabad-walkin",
    title: "SAP GRC & Security",
    company: "TCS",
    location: "Hyderabad, India",
    jobType: "Walk-in",
    experience: "4–9 Years",
    vacancies: 1,
    postedDate: "2026-04-08",
    walkInDate: "2026-04-11",
    time: "9:00 AM – 2:00 PM",
    venue: "TCS Deccan Park, Hitech City, Hyderabad",
    skills: [
      "SAP GRC",
      "SAP Security",
      "Access Control",
      "Audit Compliance"
    ],
    requirements: [
      "Experience in SAP GRC & Security",
      "Knowledge of audit compliance",
      "Relevant SAP experience"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-tcs-walk-in-drive-in-hyderabad-for-sap-grc-security-on-11-april-26-tata-consultancy-services-hyderabad-4-to-9-years-080426026684"
  },

  {
    id: "xl-dynamics-financial-analyst-mumbai",
    title: "Financial Analyst",
    company: "XL Dynamics",
    location: "Mumbai / Navi Mumbai",
    jobType: "Walk-in",
    experience: "0–5 Years",
    vacancies: 100,
    salary: "₹3.5–6 LPA",
    postedDate: "2026-04-08",
    walkInDate: "2026-04-18",
    time: "11:00 AM – 3:00 PM",
    venue: "Mumbai & Powai (Check JD)",
    skills: ["Finance", "Excel", "Accounting", "MIS", "Reporting"],
    requirements: [
      "0–5 years experience",
      "Basic finance and accounting knowledge",
      "Good Excel skills"
    ],
    applyLink:
      "https://www.naukri.com/job-listings-walk-in-drive-for-the-financial-analyst-position-navi-mumbai-and-powai-xl-dynamics-mumbai-navi-mumbai-mumbai-all-areas-0-to-5-years-070426029129"
  },
      
      
      // end
  {
    id: "incident-manager-l2-apideltech-2026",
    title: "Incident Manager (L2)",
    company: "Apidel Technologies",
    location: "Bangalore, India",
    postedDate:'2026-04-08',
    jobType: "Full-time",
    experience: "5+ Years",
    shift: "6 AM – 3 PM IST (Flexible)",
    skills: [
      "Incident Management",
      "ITIL",
      "ServiceNow",
      "ITSM Tools",
      "Infrastructure",
      "Networking",
      "Communication"
    ],
    requirements: [
      "5+ years in IT",
      "2+ years in Incident Management",
      "ITIL Certification (Mandatory)",
      "Experience with ServiceNow or ITSM tools",
      "Strong communication skills"
    ],
    applyLink: "mailto:hemanshi.b@apideltech.com"
  },

  {
    id: "revolut-support-specialist-2026",
    title: "Support Specialist",
    company: "Revolut",
    postedDate: "2026-04-08",
    location: "Remote",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s Degree",
    skills: [
      "Customer Support",
      "Communication",
      "Problem Solving",
      "FinTech Knowledge"
    ],
    applyLink:
      "https://www.revolut.com/en-IN/careers/position/support-specialist-retail-54262181-ce49-4fc7-8ea6-745c3073e6f6/"
  },

  {
    id: "microsoft-internship-2026",
    title: "Software Developer Intern",
    company: "Microsoft",
    postedDate: "2026-04-08",
    location: "Pan India (In Office)",
    jobType: "Internship",
    experience: "Fresher",
    eligibility: [
      "Engineering Students",
      "Graduates"
    ],
    skills: [
      "Programming",
      "Data Structures",
      "Algorithms",
      "Problem Solving"
    ],
    applyLink:
      "https://unstop.gotrackier.io/click?campaign_id=2625&pub_id=114"
  },

  {
    id: "hp-field-technical-support-associate-2026",
    title: "Field Technical Support Associate",
    company: "HP Inc.",
    postedDate: "2026-04-06",
    location: "Hyderabad, India",
    jobType: "Full-time",
    experience: "0–2 Years",
    skills: [
      "Technical Support",
      "Networking",
      "Operating Systems",
      "Hardware Troubleshooting",
      "Customer Support",
      "IT Infrastructure"
    ],
    responsibilities: [
      "Install, maintain and repair customer equipment",
      "Troubleshoot IT infrastructure issues",
      "Provide on-site technical support",
      "Maintain documentation and reports",
      "Assist customers and service providers"
    ],
    requirements: [
      "0–2 years of experience",
      "Basic IT and hardware knowledge",
      "Good communication skills",
      "Willingness to work in field support roles"
    ],
    applyLink:
      "https://hp.wd5.myworkdayjobs.com/en-US/ExternalCareerSite/job/Hyderabad-Telangana-India/Field-Technical-Support-Associate_3159283"
  },
      //6-04-26
  {
    id: "hp-field-technical-support-associate-2026",
    title: "Field Technical Support Associate",
    company: "HP Inc.",
    postedDate: "2026-04-06",
    location: "Hyderabad, India",
    jobType: "Full-time",
    experience: "0–2 Years",
    skills: [
      "Technical Support",
      "Networking",
      "Operating Systems",
      "Hardware Troubleshooting",
      "Customer Support",
      "IT Infrastructure"
    ],
    description:
      "HP Inc. is hiring Field Technical Support Associates to install, maintain, and troubleshoot customer systems while ensuring high service quality and customer satisfaction.",
    responsibilities: [
      "Install, maintain and repair customer equipment",
      "Troubleshoot IT infrastructure issues",
      "Provide on-site technical support",
      "Maintain documentation and reports",
      "Assist customers and service providers"
    ],
    requirements: [
      "0–2 years of experience",
      "Basic IT and hardware knowledge",
      "Good communication skills",
      "Willingness to work in field support roles"
    ],
    applyLink: "https://hp.wd5.myworkdayjobs.com/en-US/ExternalCareerSite/job/Hyderabad-Telangana-India/Field-Technical-Support-Associate_3159283",
    
  },

  {
    id: "microsoft-research-sciences-intern-2026",
    title: "Research Sciences Intern",
    company: "Microsoft",
    postedDate: "2026-04-06",
    location: "Bangalore, India",
    jobType: "Internship",
    experience: "Freshers",
    skills: [
      "Machine Learning",
      "Data Science",
      "Research",
      "Python",
      "AI"
    ],
    description:
      "Microsoft is hiring Research Sciences Interns to work on advanced AI/ML research projects and cutting-edge technologies.",
    requirements: [
      "Bachelor’s or Master’s degree",
      "Strong problem-solving skills",
      "Interest in AI/ML and research",
      "Basic programming knowledge"
    ],
    perks: [
      "Work with top engineers",
      "Exposure to real-world AI projects",
      "Brand value experience"
    ],
    applyLink: "https://apply.careers.microsoft.com/careers/job/1970393556638637",
  },
  {
    id: "wns-r2r-pune-2026",
    title: "Record to Report (R2R)",
    company: "WNS (Capgemini)",
    postedDate: "2026-04-06",
    location: "Pune (Magarpatta), India",
    jobType: "Full-time",
    experience: "2–-3 Years",
    skills: [
      "Balance Sheet Reconciliation",
      "Fixed Assets",
      "Journal Entries",
      "Accruals",
      "Intercompany",
      "Month-End Closing"
    ],
    description:
      "WNS (a part of Capgemini) is hiring R2R professionals with hands-on experience in accounting processes like reconciliation, journal entries, and month-end activities.",
    requirements: [
      "2–3 years of relevant R2R experience",
      "Strong accounting knowledge",
      "Immediate joiner preferred",
      "Willing to work night shifts"
    ],
    shift: "Night Shift (8PM–5AM / 10PM–7AM)",
    applyLink: "mailto:Bandish.Pathak@wns.com"
  },

  {
    id: "mis-executive-pune-2026",
    title: "MIS Executive / Sr. Executive",
    company: "Reva HR",
    postedDate: "2026-04-06",
    location: "Pune (Magarpatta), India",
    jobType: "Full-time",
    experience: "3–6 Years",
    skills: [
      "Advanced Excel",
      "VBA",
      "SQL",
      "Power BI",
      "MIS Reporting",
      "Dashboarding",
      "Data Analysis"
    ],
    description:
      "Hiring MIS professionals to develop reports, automate dashboards, and generate business insights using Excel, SQL, and Power BI.",
    responsibilities: [
      "Develop and automate MIS reports",
      "Analyze large datasets",
      "Build dashboards for decision-making"
    ],
    requirements: [
      "3–6 years of MIS/Data Analysis experience",
      "Strong Excel and SQL skills",
      "Immediate/15 days joiners preferred"
    ],
    applyLink: "mailto:vaishnavi@revahr.com"
  },

  {
    id: "nodejs-developer-remote-us-2026",
    title: "Node.js Developer",
    company: "Pioneer IT Systems",
    postedDate: "2026-04-06",
    location: "Remote (US - CST)",
    jobType: "Contract (W2)",
    experience: "10–15 Years",
    skills: ["Node.js", "Kafka", "Docker", "Kubernetes"],
    description:
      "Looking for a senior Node.js developer with strong backend coding experience and expertise in distributed systems and containerization.",
    requirements: [
      "10+ years of experience",
      "Strong coding skills",
      "Experience with Kafka and Kubernetes"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com"
  },

  {
    id: "lead-java-ai-developer-2026",
    title: "Lead Java Backend Developer (AI)",
    company: "Pioneer IT Systems",
    postedDate: "2026-04-06",
    location: "Plano, Texas (Hybrid)",
    jobType: "Full-time",
    experience: "10–15 Years",
    skills: ["Java", "Gen AI", "AI Tools", "Copilot"],
    description:
      "Lead backend role focusing on AI integration, GenAI tools, and enterprise-level Java systems.",
    requirements: [
      "Strong Java backend experience",
      "Experience with AI tools like Copilot, Codex, Claude",
      "Leadership experience required"
    ],
    salary: "$170K + Benefits",
    applyLink: "mailto:manu@pioneeritsystems.com"
  },

  {
    id: "lead-java-fullstack-2026",
    title: "Lead Java Full Stack Developer",
    company: "Pioneer IT Systems",
    postedDate: "2026-04-06",
    location: "Plano, Texas (Hybrid)",
    jobType: "Full-time",
    experience: "12–17 Years",
    skills: ["Java", "Angular", "AWS", "Full Stack"],
    description:
      "Full stack leadership role with equal focus on frontend (Angular) and backend (Java + AWS).",
    requirements: [
      "Strong full-stack experience",
      "Hands-on coding",
      "Excellent communication skills"
    ],
    salary: "$170K + Benefits",
    applyLink: "mailto:manu@pioneeritsystems.com"
  },

  {
    id: "java-fullstack-developer-us-2026",
    title: "Java Full Stack Developer",
    company: "Pioneer IT Systems",
    postedDate: "2026-04-06",
    location: "US (Hybrid)",
    jobType: "Full-time",
    experience: "9–12 Years",
    skills: ["Java", "Spring Boot", "Frontend"],
    description:
      "Mid to senior level full stack developer role working on enterprise applications.",
    requirements: [
      "Strong Java experience",
      "Full stack development knowledge",
      "Good communication skills"
    ],
    salary: "$115K + Benefits",
    applyLink: "mailto:manu@pioneeritsystems.com"
  },

  {
    id: "bluecat-network-dns-engineer-2026",
    title: "Senior Network & DNS Engineer",
    company: "Pioneer IT Systems",
    postedDate: "2026-04-06",
    location: "New York / Hybrid",
    jobType: "Contract",
    experience: "10+ Years",
    skills: ["DNS", "Networking", "Infrastructure"],
    description:
      "Senior infrastructure role focusing on network and DNS systems with enterprise-level experience.",
    requirements: [
      "Strong networking fundamentals",
      "Experience in DNS systems",
      "Infrastructure experience"
    ],
    applyLink: "mailto:manu@pioneeritsystems.com"
  },
      // below 5-4-26
  {
    id: "us-non-it-recruiter-remote-ambiraj-2026",
    title: "US Non-IT Recruiter",
    company: "Ambiraj Consulting",
    postedDate: "2026-04-05",
    location: "Remote (India)",
    jobType: "Full-time",
    experience: "2+ Years",
    workHours: "1:00 PM – 10:00 PM IST",
    skills: [
      "US Recruitment",
      "ZipRecruiter",
      "Candidate Sourcing",
      "Screening",
      "Interview Coordination",
      "Communication"
    ],
    description:
      "We are hiring an experienced US Non-IT Recruiter to handle end-to-end recruitment for roles like Admin, Healthcare, Retail, and Customer Support. The candidate should have strong experience using ZipRecruiter and other hiring tools.",
    responsibilities: [
      "Handle end-to-end US Non-IT recruitment",
      "Source candidates via ZipRecruiter and job portals",
      "Screen and shortlist candidates",
      "Coordinate interviews with clients",
      "Maintain candidate pipeline",
      "Ensure quick turnaround time"
    ],
    qualifications: [
      "Minimum 2+ years experience in US recruitment",
      "Hands-on experience with ZipRecruiter (mandatory)",
      "Strong understanding of US job market",
      "Excellent communication skills",
      "Ability to work remotely"
    ],
    perksBenefits: [
      "100% Remote Work",
      "International client exposure",
      "Performance incentives",
      "Growth opportunities"
    ],
    applyLink: "mailto:info@ambirajconsulting.com",
  },

  {
    id: "hr-business-partner-hdbfs-andhra-2026",
    title: "HR Business Partner (HRBP)",
    company: "HDB Financial Services",
    postedDate: "2026-04-05",
    location: "Andhra Pradesh, India",
    jobType: "Full-time",
    experience: "5+ Years",
    skills: [
      "HR Strategy",
      "Stakeholder Management",
      "Talent Management",
      "HR Operations",
      "Process Management"
    ],
    description:
      "We are looking for a strategic HR Business Partner to align people strategy with business goals and work closely with leadership on performance and culture.",
    responsibilities: [
      "Align HR strategy with business goals",
      "Work with leadership on talent development",
      "Drive employee engagement and performance",
      "Manage HR processes and operations",
      "Visit branches monthly for HR activities"
    ],
    qualifications: [
      "5+ years HR experience",
      "MBA or MSW mandatory",
      "Strong stakeholder management",
      "Process-oriented mindset",
      "Telugu-speaking candidate preferred"
    ],
    additionalRequirements: [
      "Must be local to Andhra Pradesh",
      "Willing to travel to branches"
    ],
    applyLink: "mailto:saranraj.s@hdbfs.com",
  },
  {
    id: "sigmat-multiple-roles-jaipur-2026",
    title: "Multiple Roles (Power BI, AI, SharePoint)",
    company: "SigmaT",
    postedDate: "2026-04-05",
    location: "Jaipur, India",
    jobType: "Full-time",
    experience: "Various",
    skills: ["Power BI", "Microsoft Fabric", "AI", "SharePoint", "UI/UX"],
    description: "SigmaT is hiring for multiple roles including Power BI Developers, AI Engineers, and Architects.",
    applyLink: "mailto:info@sigmat.in",
  },
  {
    id: "deloitte-analyst-p2p-2026",
    title: "Finance Operations Analyst (P2P)",
    company: "Deloitte",
    postedDate: "2026-04-05",
    location: "Bengaluru, India",
    jobType: "Full-time",
    experience: "2–4 Years",
    skills: ["Databricks", "Invoicing", "Collections"],
    description: "Deloitte is hiring Finance Operations Analysts for P2P domain.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=145303479",
  },
  {
    id: "staples-associate-software-engineer-2026",
    title: "Associate Software Engineer",
    company: "Staples",
    postedDate: "2026-04-05",
    location: "Chennai, India",
    jobType: "Full-time",
    experience: "Freshers",
    skills: ["Programming", "Software Development"],
    description: "Staples is hiring freshers for Software Engineer role.",
    applyLink: "https://www.linkedin.com/jobs/view/4392163488/",
  },
  {
    id: "verint-cloudops-engineer-2026",
    title: "CloudOps Engineer",
    company: "Verint",
    postedDate: "2026-04-05",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "2021–2024 Batch",
    skills: ["Cloud", "DevOps"],
    description: "Verint is hiring CloudOps Engineers for multiple batches.",
    applyLink: "https://fa-epcb-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX/job/3798",
  },
  {
    id: "siemens-software-engineer-cpp-2026",
    title: "Software Engineer (C++)",
    company: "Siemens",
    postedDate: "2026-04-05",
    location: "New Delhi, India",
    jobType: "Full-time",
    experience: "0–3 Years",
    skills: ["C++", "Software Development"],
    description: "Siemens is hiring C++ developers.",
    applyLink: "https://jobs.siemens.com/en_US/externaljobs/JobDetail/499631",
  },
  {
    id: "emerson-applications-engineer-2026",
    title: "Applications & Systems Engineer",
    company: "Emerson",
    postedDate: "2026-04-05",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "Freshers",
    skills: ["Engineering", "Systems"],
    description: "Emerson is hiring engineers for application/system roles.",
    applyLink: "https://hdjq.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/job/25029880",
  },
  {
    id: "wipro-intern-2026",
    title: "Intern",
    company: "Wipro",
    postedDate: "2026-04-05",
    location: "Bengaluru, India",
    jobType: "Internship",
    experience: "Freshers",
    skills: ["Basic Tech Skills"],
    description: "Wipro internship opportunity for students.",
    applyLink: "https://careers.wipro.com/job/Intern-L0-1/156375-en_US",
  },
  {
    id: "iqvia-devops-engineer-2026",
    title: "DevOps Engineer",
    company: "IQVIA",
    postedDate: "2026-04-05",
    location: "Bengaluru, India",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    skills: ["DevOps", "Cloud"],
    description: "IQVIA is hiring DevOps Engineers.",
    applyLink: "https://jobs.iqvia.com/en/jobs/R1531844-0",
  },
  {
    id: "junauto-hr-admin-manager-2026",
    title: "HR & Admin Assistant Manager",
    company: "JUN Automotive",
    postedDate: "2026-04-05",
    location: "Chennai, India",
    jobType: "Full-time",
    experience: "6–10 Years",
    salary: "₹40K–₹45K",
    skills: ["HR", "Payroll", "Compliance"],
    description: "Hiring HR Admin Assistant Manager with strong HR operations experience.",
    applyLink: "mailto:hrm.admin@junauto.in",
  },
  // above 5-4-26
  {
    id: "euromonitor-associate-data-analyst-2026",
    title: "Associate Data Analyst",
    company: "Euromonitor International",
    postedDate: "2026-04-03",
    location: "India / Global",
    jobType: "Full-time",
    experience: "Freshers",
    skills: ["Data Analysis", "Excel", "Research"],
    description: "Euromonitor is hiring Associate Data Analysts with strong analytical and research skills.",
    applyLink: "https://apply.workable.com/euromonitor/j/AEE001C58A/",
  },
  {
    id: "hcltech-data-analytics-azure-freshers-2026",
    title: "Data Analytics (Azure Freshers Academy)",
    company: "HCLTech",
    postedDate: "2026-04-03",
    location: "India",
    jobType: "Full-time",
    experience: "Freshers",
    skills: ["SQL", "Azure", "ETL", "Data Analytics"],
    description: "HCLTech is hiring freshers for Azure Data Analytics Academy program.",
    applyLink: "https://forms.cloud.microsoft/pages/responsepage.aspx?id=iFbzpwCcXk26QSnxRjd6sHuOusYa6pxEhQTBJ2wNU81URDE0R1ZSQTNKMURNTjVRRUNMSFJDRDhSTy4u&route=shorturl",
    
  },
  {
    id: "bt-group-trainee-associate-chat-2026",
    title: "Trainee Associate (Chat)",
    company: "BT Group",
    postedDate: "2026-04-03",
    location: "Gurugram, India",
    jobType: "Full-time",
    experience: "Freshers",
    skills: ["Communication", "Customer Support"],
    description: "BT Group is hiring Trainee Associates for chat support roles.",
    applyLink: "https://www.hcltech.com/careers/freshers-academy-data-analytics-azure",
  },
  {
    id: "rebco-business-development-manager-2026",
    title: "Business Development Manager",
    company: "Rebco Ventures",
    postedDate: "2026-04-03",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "1+ Years",
    salary: "₹4–7 LPA + Incentives",
    skills: ["Sales", "Communication", "Business Development"],
    description: "Rebco Ventures is hiring BDMs to drive revenue and client relationships.",
    applyLink: "mailto:careers@rebcoindia.com",
  },
  {
    id: "aalfa-network-engineer-2026",
    title: "Network Consultant / Network Engineer",
    company: "Aalfa eNetwork Pvt Ltd",
    postedDate: "2026-04-03",
    location: "Delhi (Hybrid)",
    jobType: "Full-time",
    experience: "2–10 Years",
    salary: "₹2–6 LPA",
    skills: ["CCNA", "CCNP", "Networking", "TCP/IP", "Network Security"],
    description: "Hiring network engineers with strong experience in infrastructure and security.",
    applyLink: "https://abekus.ai/public-job-search/network-consultant---network-engineer-1",
  },
  {
    id: "citi-business-analytics-analyst-2026",
    title: "Business Analytics Analyst",
    company: "Citi",
    postedDate: "2026-04-03",
    location: "Bengaluru, India (Hybrid)",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    skills: ["Data Analysis", "Business Analytics"],
    description: "Citi is hiring Business Analytics Analysts for hybrid roles.",
    applyLink: "https://jobs.citi.com/job/bengaluru/business-analytics-analyst/287/93452186352",
  },
      //2-4-26
  {
    id: "teradata-senior-cloud-engineer-2026",
    title: "Senior Cloud Engineer",
    company: "Teradata",
    postedDate: "2026-04-02",
    location: "Hyderabad / Pune (Hybrid)",
    jobType: "Full-time",
    experience: "6+ Years",
    skills: [
      "AWS",
      "Azure",
      "GCP",
      "Kubernetes",
      "Terraform",
      "Ansible",
      "Microservices",
      "Docker"
    ],
    description: "Teradata is hiring Senior Cloud Engineers with strong experience in cloud platforms, DevOps, and distributed systems.",
    applyLink: "https://careers.teradata.com/jobs/220085/senior-cloud-engineer",
  },
  {
    id: "microsoft-data-scientist-2026",
    title: "Data Scientist",
    company: "Microsoft",
    postedDate: "2026-04-02",
    location: "India",
    jobType: "Full-time",
    experience: "1+ Year",
    skills: [
      "Python",
      "Machine Learning",
      "Data Science",
      "Statistics"
    ],
    description: "Microsoft is hiring Data Scientists with strong ML, Python, and analytical skills.",
    applyLink: "http://apply.careers.microsoft.com/careers/job/1970393556855741",
  },
  {
    id: "hr-executive-fmcg-coimbatore-2026",
    title: "HR Executive / Manager",
    company: "FMCG Company",
    postedDate: "2026-04-02",
    location: "Coimbatore, India",
    jobType: "Full-time",
    experience: "1–3 Years",
    skills: [
      "Payroll",
      "HR Operations",
      "Statutory Compliance",
      "HR Analytics"
    ],
    description: "Hiring HR professionals with experience in payroll, compliance, and HR operations.",
    applyLink: "mailto:hr@uvagro.com",
  },
  {
    id: "vb-net-developer-pune-2026",
    title: "VB.NET Developer",
    company: "Confidential",
    postedDate: "2026-04-02",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "4–6 Years",
    salary: "Up to ₹15 LPA",
    skills: [
      "VB.NET",
      "C#",
      "WPF",
      "MVVM",
      "Automation Testing"
    ],
    description: "Looking for experienced VB.NET developers with strong WPF and MVVM knowledge.",
    applyLink: "mailto:supriya.k@sasvatitsolutions.com",
  },
      // 01-04-26
  {
    id: "eaton-associate-engineer-chennai-2026",
    title: "Associate Engineer",
    company: "Eaton",
    postedDate: "2026-04-01",
    location: "Chennai, India",
    jobType: "Full-time",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    skills: [
      "Engineering Fundamentals",
      "Problem Solving",
      "Technical Skills"
    ],
    description: "Eaton is hiring Associate Engineers for freshers with strong engineering fundamentals and problem-solving skills.",
    applyLink: "https://eaton.eightfold.ai/careers/job/687235806080?domain=eaton.com&hl=en",
  },
  {
    id: "entropik-frontend-engineer-react-2026",
    title: "Frontend Software Engineer (React)",
    company: "Entropik",
    postedDate: "2026-04-01",
    location: "India",
    jobType: "Full-time",
    experience: "1–3 Years",
    salary: "₹8–12 LPA",
    skills: [
      "React.js",
      "JavaScript",
      "Frontend Development"
    ],
    description: "Entropik is hiring Frontend Software Engineers with React experience to build scalable UI applications.",
    applyLink: "https://entropik.keka.com/careers/jobdetails/124174",
  },
  {
    id: "qa-tester-evangelist-remote-2026",
    title: "Software Quality Assurance Tester",
    company: "Evangelist Apps",
    postedDate: "2026-04-01",
    location: "Remote",
    jobType: "Full-time",
    experience: "Freshers",
    salary: "₹15K/month",
    qualification: "Any Graduate (Preferably Technical)",
    skills: [
      "Software Testing",
      "Quality Assurance",
      "Bug Tracking",
      "Analytical Skills",
      "Agile Methodologies"
    ],
    description: "Evangelist Apps is hiring freshers for a remote QA Tester role. Responsibilities include test execution, bug identification, and ensuring software quality while collaborating with development teams.",
    requirements: [
      "Basic knowledge of software testing",
      "Strong analytical and problem-solving skills",
      "Attention to detail",
      "Good communication skills",
      "Ability to meet deadlines",
      "Laptop and stable internet connection required"
    ],
    applyLink: "mailto:sunetra@evangelistsoftware.com",
  },
  {
    id: "design-engineer-nx-pune-2026",
    title: "Design Engineer (NX)",
    company: "Confidential",
    postedDate: "2026-04-01",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "1–2 Years",
    noticePeriod: "Immediate Joiners Preferred",
    skills: [
      "NX Software",
      "Design Engineering",
      "Mechanical Design",
      "Engineering Concepts"
    ],
    description: "Hiring Design Engineer with hands-on experience in NX software and strong design fundamentals. Immediate joiners preferred for on-site Pune role.",
    applyLink: "mailto:promechhiringsolutions@gmail.com",
  },
  {
    id: "mykaarma-software-engineer-ai-ml-2026",
    title: "Software Engineer I (AI/ML)",
    company: "myKaarma",
    postedDate: "2026-04-01",
    location: "Noida, India",
    jobType: "Full-time",
    experience: "Freshers",
    batch: "2021, 2022, 2023, 2024",
    skills: ["Python", "Machine Learning", "AI"],
    applyLink: "https://ats.rippling.com/en-GB/mykaarma/jobs/f2e00d20-4347-4ba5-a54a-17f45421fca7",
  },
  {
    id: "bp-software-engineer-pune-2026",
    title: "Software Engineer",
    company: "bp",
    postedDate: "2026-04-01",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "0–3 Years",
    batch: "2022, 2023, 2024, 2025",
    applyLink: "https://careers.bp.com/job-description/RQ107707",
  },
  {
    id: "cloudsek-frontend-intern-2026",
    title: "SDE Intern - Frontend",
    company: "CloudSEK",
    postedDate: "2026-04-01",
    location: "Bangalore, India",
    jobType: "Internship",
    qualification: "Bachelor’s / Master’s Degree",
    skills: ["React", "Frontend"],
    applyLink: "https://job-boards.greenhouse.io/cloudsek/jobs/5831215004",
  },
  {
    id: "thomson-reuters-associate-software-engineer-2026",
    title: "Associate Software Engineer",
    company: "Thomson Reuters",
    postedDate: "2026-04-01",
    location: "Bengaluru, India",
    jobType: "Full-time",
    qualification: "Bachelor’s / Master’s Degree",
    applyLink: "https://thomsonreuters.wd5.myworkdayjobs.com/en-US/External_Career_Site/job/Associate-Software-Engineer_JREQ198083",
    
  },
  {
    id: "natwest-software-engineer-chennai-2026",
    title: "Software Engineer",
    company: "NatWest Group",
    postedDate: "2026-04-01",
    location: "Chennai, India (Hybrid)",
    jobType: "Full-time",
    qualification: "Bachelor’s / Master’s Degree",
    applyLink: "https://jobs.natwestgroup.com/jobs/17529132-software-engineer-iam-and-cloud",
  },
  {
    id: "swiggy-associate-sde-2026",
    title: "Associate Software Development Engineer",
    company: "Swiggy",
    postedDate: "2026-04-01",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "Freshers",
    qualification: "Bachelor’s Degree",
    applyLink: "https://careers.swiggy.com/",
  },
  {
    id: "heizen-sde-intern-2026",
    title: "SDE Intern",
    company: "Heizen",
    postedDate: "2026-04-01",
    location: "Remote / Hyderabad",
    jobType: "Internship",
    duration: "6 Months",
    stipend: "₹30K/month",
    ppo: "12 LPA + ESOP",
    skills: ["React Native", "Expo"],
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSfxTC_DgapUjE0c68CdUvij0vc_K5SqYs_XRcVo_Yn-jh1JUg/viewform",
  },
      // 31-12-26
  {
    id: "abhiyan-software-developer-intern-gurgaon-2026",
    title: "Software Developer Intern",
    company: "Abhiyan Capital",
    postedDate: "2026-03-30",
    location: "Gurgaon, India",
    jobType: "Internship",
    duration: "3–6 Months",
    experience: "Freshers / Students",
    skills: ["React", "Python", "APIs", "AI/ML"],
    description: "Work on fintech applications, AI tools, and automation systems.",
    applyLink: "mailto:sabrita.yadav@abhiyancapital.com",
  },
  {
    id: "cpp-embedded-engineer-spyrosoft-bangalore-2026",
    title: "C++ Software Engineer (Embedded Systems)",
    company: "Spyrosoft",
    postedDate: "2026-03-30",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "3–8 Years",
    skills: ["C++", "Linux", "Embedded Systems", "Multithreading", "CUDA"],
    description: "Work on robotics and high-performance embedded systems.",
    applyLink: "mailto:sinchana.sd@brigosha.com",
  },
  {
    id: "incident-manager-l2-bangalore-2026",
    title: "Incident Manager (L2)",
    company: "Confidential",
    postedDate: "2026-03-30",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "5+ Years",
    skills: ["ITIL", "ServiceNow", "ITSM", "Incident Management"],
    description: "Hiring Incident Manager with ITIL certification and ITSM tools experience.",
    applyLink: "mailto:hemanshi.b@apideltech.com",
  },
  {
    id: "honeywell-data-science-intern-bangalore-2026",
    title: "Data Science Intern",
    company: "Honeywell",
    postedDate: "2026-03-30",
    location: "Bengaluru, India",
    jobType: "Internship",
    experience: "Freshers",
    qualification: "Bachelor’s / Master’s Degree",
    skills: ["Python", "Machine Learning", "Data Science"],
    description: "Honeywell is hiring interns for data science roles.",
    applyLink: "https://careers.honeywell.com/en/sites/Honeywell/jobs/preview/144170/",
  },
  {
    id: "hsbc-data-analyst-hybrid-2026",
    title: "Data Analyst",
    company: "HSBC",
    postedDate: "2026-03-30",
    location: "Hyderabad / Bangalore (Hybrid)",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    skills: ["SQL", "Excel", "Data Analysis"],
    description: "HSBC is hiring Data Analysts for hybrid roles.",
    applyLink: "https://portal.careers.hsbc.com/careers/job/563774610369406",
  },
  {
    id: "accounts-executive-adi-corporate-delhi-2026",
    title: "Accounts Executive",
    company: "Adi Corporate Training",
    postedDate: "2026-03-30",
    location: "Dwarka, Delhi",
    jobType: "Walk-in ",
    experience: "2+ Years",
    salary: "Not Disclosed",
    skills: ["Tally", "GST", "TDS", "Accounting", "MS Office"],
    description: "Hiring Accounts Executive with strong experience in Tally, GST, and TDS compliance.",
    applyLink: "mailto:info@ambirajconsulting.com",
  },
  {
    id: "hindi-telecaller-noida-2026",
    title: "Customer Care Executive (Hindi Telecaller)",
    company: "Confidential",
    postedDate: "2026-03-30",
    location: "Noida, India",
    jobType: "Walk-in",
    experience: "Fresher / Experienced",
    salary: "₹16K–18K + OT",
    skills: ["Calling", "Customer Support", "Hindi Communication"],
    description: "Hiring Hindi Telecaller for customer care role. No sales, no targets.",
    applyLink: "7259736574",
  },
  {
    id: "hexaware-rta-walkin-mumbai-2026",
    title: "Real-Time Analyst",
    company: "Hexaware Technologies",
    postedDate: "2026-03-31",
    location: "Navi Mumbai, India",
    jobType: "Walk-in",
    experience: "2+ Years",
    skills: ["BPO", "Real-time Monitoring", "Team Handling"],
    description: "Hexaware is hiring Real-Time Analysts with BPO experience.",
    applyLink: "mailto:bhumikas@hexaware.com",
  },
  // end 30-12-26
  {
    id: "bp-software-engineer-pune-2026",
    title: "Software Engineer",
    company: "bp",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "0–3 Years",
    batch: "2022, 2023, 2024, 2025",
    skills: [
      "React.js",
      "JavaScript",
      "Node.js",
      "Python",
      "AWS",
      "REST APIs",
      "System Design",
      "Git"
    ],
    description: "bp is hiring Software Engineers to build scalable full-stack applications using React, Node.js/Python, and AWS cloud technologies.",
    applyLink: "https://careers.bp.com/job-description/RQ107707",
  },
  {
    id: "amazon-applied-scientist-core-search-2026",
    title: "Applied Scientist (Core Search)",
    company: "Amazon",
    postedDate: "2026-03-29",
    location: "India / Multiple Locations",
    jobType: "Full-time",
    experience: "Experienced",
    qualification: "Computer Science / Machine Learning / Data Science",
    skills: [
      "Python",
      "Java",
      "C++",
      "Machine Learning",
      "Algorithms",
      "Statistics",
      "Data Science"
    ],
    description: "Amazon is hiring Applied Scientists to work on core search and machine learning systems, building scalable AI solutions used by millions of users.",
    applyLink: "https://www.amazon.jobs/en/jobs/10377873/applied-scientist-central-machine-learning",
  },
  {
    id: "wordpress-developer-fresher-associative-trails-2026",
    title: "WordPress Developer (Fresher)",
    company: "Associative Trails",
    postedDate: "2026-03-29",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    skills: ["WordPress"],
    description: "Associative Trails is hiring WordPress Developers for freshers.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144968813",
  },
  {
    id: "marketing-executive-kabra-express-ahmedabad-2026",
    title: "Marketing Executive (Fresher)",
    company: "Kabra Express Logistics Pvt Ltd",
    postedDate: "2026-03-29",
    location: "Ahmedabad, India",
    jobType: "Full-time",
    experience: "Fresher",
    skills: ["Social Media", "Market Research", "Marketing Strategy"],
    description: "Hiring Marketing Executives for freshers with interest in marketing and strategy.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144967031",
  },
  {
    id: "management-associate-caliber-pune-2026",
    title: "Management Associate",
    company: "Caliber Organisation",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "0–2 Years",
    skills: ["MS Office", "Problem Solving", "Business Strategy"],
    description: "Caliber Organisation is hiring Management Associates for freshers.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=123849625",
  },
  {
    id: "ai-developer-fresher-associative-trails-2026",
    title: "AI Developer (Fresher)",
    company: "Associative Trails",
    postedDate: "2026-03-29",
    location: "India",
    jobType: "Full-time",
    experience: "Fresher",
    skills: ["Python", "TensorFlow", "PyTorch", "OpenCV", "Keras"],
    description: "Hiring AI Developers with basic ML and programming knowledge.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144968773",
  },
  {
    id: "data-analyst-scout-it-out-pune-2026",
    title: "Data Analyst",
    company: "Scout It Out",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "Fresher",
    skills: ["SQL", "Power BI", "Tableau", "Data Analysis"],
    description: "Hiring Data Analysts for freshers with analytics skills.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144964087",
  },
  {
    id: "data-analyst-scoutit-pune-2026",
    title: "Data Analyst",
    company: "Scoutit",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "Fresher",
    skills: ["SQL", "Python", "Power BI", "AWS", "Azure"],
    description: "Hiring Data Analysts with cloud and analytics skills.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144778103",
  },
  {
    id: "data-analyst-mopid-bangalore-2026",
    title: "Data Analyst I",
    company: "Mopid",
    postedDate: "2026-03-29",
    location: "Bangalore, India",
    jobType: "Walk-in",
    experience: "1–3 Years",
    skills: ["BigQuery", "Python", "SQL", "Power BI", "Tableau"],
    description: "Hiring Data Analyst I with experience in analytics tools.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144777615",
  },
  {
    id: "data-analyst-nestaway-bangalore-2026",
    title: "Data Analyst",
    company: "Nestaway",
    postedDate: "2026-03-29",
    location: "Bangalore, India",
    jobType: "Walk-in",
    experience: "2–4 Years",
    skills: ["SQL", "Python", "Power BI", "Tableau"],
    description: "Nestaway is hiring Data Analysts for experienced roles.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144860579",
  },
  {
    id: "agoda-associate-data-analyst-pune-2026",
    title: "Associate Data Analyst",
    company: "Agoda",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Walk-in",
    experience: "Fresher",
    skills: ["SAS", "Tableau", "Statistics"],
    description: "Agoda hiring freshers for data analyst roles.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144777867",
  },
  {
    id: "mphasis-nonvoice-backoffice-bangalore-2026",
    title: "Non-Voice Back Office",
    company: "Mphasis",
    postedDate: "2026-03-29",
    location: "Bangalore / Pune, India",
    jobType: "Walk-in",
    experience: "Freshers",
    qualification: "B.Com / BBA",
    description: "Mphasis hiring freshers for non-voice back office roles.",
    applyLink: "https://r.ripplehire.com/s/cPxpy",
  },
      {/* 29-03-26*/},
    {
      id: "mercor-csharp-ai-engineer-remote-2026",
      title: "Software Engineering / Data Science / Systems Design Expert (C#)",
      company: "Mercor",
      postedDate: "2026-03-29",
      location: "Remote",
      jobType: "Contract",
      experience: "5+ Years",
      salary: "$60–$100 per hour",
      qualification: "BS/MS/PhD in Computer Science or related field",
      skills: [
        "C#",
        "Software Engineering",
        "Data Science",
        "Systems Design",
        "Algorithms",
        "LLMs",
        "Code Review",
        "Problem Solving"
      ],
      description: "Mercor is hiring experienced engineers to evaluate and improve AI-generated code, reasoning, and system design using real-world engineering practices.",
      responsibilities: [
        "Evaluate AI-generated coding responses",
        "Perform fact-checking and validation",
        "Analyze code quality and algorithm efficiency",
        "Identify bugs and logical flaws",
        "Provide detailed feedback to improve AI systems"
      ],
      applyLink: "https://t.mercor.com/gLD5b",
    },
  {
    id: "agoda-associate-data-analyst-pune-2026",
    title: "Associate Data Analyst (New Graduate, Thai Speaking)",
    company: "Agoda",
    postedDate: "2026-03-29",
    location: "Pune, India",
    jobType: "Full-time",
    salary: "Not Disclosed",
    experience: "Fresher",
    skills: [
      "SAS",
      "VBA",
      "SPSS",
      "Tableau",
      "Statistics",
      "Marketing Analytics"
    ],
    description: "Agoda is hiring Associate Data Analysts for marketing analytics roles. Fresh graduates with analytics skills can apply.",
    applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144777867",
  },
  {
    id: "network-engineer-bangalore-2026",
    title: "Network Engineer",
    company: "Vays Infotech",
    postedDate: "2026-03-29",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "1–2 Years",
    salary: "Not Disclosed",
    qualification: "B.E / B.Tech",
    skills: [
      "LAN",
      "WAN",
      "VLAN",
      "Routing",
      "Switching",
      "Firewall Configuration"
    ],
    description: "Hiring Network Engineers with experience in LAN/WAN, routing, switching, and firewall configuration.",
    applyLink: "mailto:priya@vaysinfotech.com",
  },
  {/* 27-03-26*/},
  {
    id: "softworks-ta-vendor-executive-coimbatore-2026",
    title: "TA & Vendor Management Executive (IT)",
    company: "Softworks Technologies",
    postedDate: "2026-03-27",
    location: "Coimbatore, India",
    jobType: "Full-time",
    experience: "1–2 Years",
    salary: "Not Disclosed",
    skills: [
      "IT Recruitment",
      "Sourcing",
      "Vendor Management",
      "LinkedIn Hiring",
      "Boolean Search",
      "Stakeholder Management"
    ],
    description: "Hiring TA & Vendor Management Executive to handle IT hiring and vendor coordination.",
    applyLink: "mailto:deepa@sfwtechnologies.com",
  },
  {
    id: "quest-global-intern-bangalore-2026",
    title: "Intern",
    company: "Quest Global",
    postedDate: "2026-03-27",
    location: "Bengaluru, India",
    jobType: "Internship",
    experience: "Freshers",
    qualification: "Bachelor’s / Master’s Degree",
    description: "Quest Global is hiring interns for engineering and tech roles.",
    applyLink: "https://careers.quest-global.com/global/en/job/P-117019/Intern",
  },
  {
    id: "ntt-data-analyst-remote-2026",
    title: "Data Analyst / Business Analyst",
    company: "NTT DATA",
    postedDate: "2026-03-27",
    location: "Remote",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    qualification: "Bachelor’s / Master’s Degree",
    skills: ["SQL", "Excel", "Data Analysis"],
    description: "NTT DATA is hiring Data Analyst / Business Analyst roles.",
    applyLink: "https://careers.services.global.ntt/global/en/job/1076f1612a94770/Data-Analyst-Business-Analyst",
  },
  {
    id: "mercor-data-scientist-remote-2026",
    title: "Data Scientist",
    company: "Mercor",
    postedDate: "2026-03-27",
    location: "Remote",
    jobType: "Contract",
    experience: "Experienced",
    salary: "$100–$160 per hour",
    skills: [
      "Machine Learning",
      "Python",
      "Cloud (AWS/Azure)",
      "Databricks",
      "BigQuery",
      "Snowflake"
    ],
    description: "Mercor is hiring experienced Data Scientists for remote contract roles.",
    applyLink: "https://t.mercor.com/KGoEE",
  },
  {
    id: "fullstack-angular-node-goa-2026",
    title: "Full Stack Developer (Angular + Node.js)",
    company: "91HR",
    postedDate: "2026-03-27",
    location: "Goa, India",
    jobType: "Full-time",
    experience: "3–4 Years",
    salary: "₹7–9 LPA",
    skills: ["Angular", "Node.js", "MySQL", "PostgreSQL", "Git"],
    description: "Hiring Full Stack Developer with Angular and Node.js experience.",
    applyLink: "mailto:suzanne@91hr.in",
    jobUrl: "https://www.jobkickstart.online/job/fullstack-angular-node-goa-2026"
  },
  {
    id: "quality-lead-bangalore-2026",
    title: "Quality Lead (Manager)",
    company: "Confidential",
    postedDate: "2026-03-27",
    location: "Bengaluru, India",
    jobType: "Full-time",
    experience: "7–10 Years",
    salary: "₹10–12 LPA",
    skills: ["SQA", "SDLC", "JIRA", "SQL", "Testing"],
    description: "Hiring Quality Lead to manage QA teams and testing strategies.",
    applyLink: "https://optimhire.com/developers/jv/309598?ref_code=mukesh-agrawal",
  },
  {
    id: "plsql-developer-hyderabad-2026",
    title: "PL/SQL Developer",
    company: "Confidential",
    postedDate: "2026-03-27",
    location: "Hyderabad, India",
    jobType: "Full-time",
    experience: "Entry-level",
    salary: "₹20,000/month",
    skills: ["PL/SQL", "SQL", "Database"],
    description: "Hiring PL/SQL Developers with training in database development.",
    applyLink: "mailto:sarita.g@mentorstech.in",
  },
  {
    id: "it-infra-executive-kolkata-2026",
    title: "IT Infrastructure Services Executive",
    company: "Shivacha Technologies",
    postedDate: "2026-03-27",
    location: "Kolkata, India",
    jobType: "Full-time",
    experience: "Experienced",
    salary: "₹30K–80K/month",
    skills: ["System Administration", "Networking", "IT Operations"],
    description: "Manage IT infrastructure including servers and networks.",
    applyLink: "https://unstop.com/o/But2XYf?lb=Bnie7Jo",
  },
  {
    id: "tibco-developer-gurgaon-2026",
    title: "Software Developer – TIBCO BWCE/BW 6.x",
    company: "Confidential",
    postedDate: "2026-03-27",
    location: "Gurgaon, India",
    jobType: "Full-time",
    experience: "3–7 Years",
    skills: ["TIBCO", "Docker", "Kubernetes"],
    description: "Hiring TIBCO Developer for middleware and integration solutions.",
    applyLink: "mailto:priyanshi@suitable.ai",
  },
  {
    id: "quantum-data-analyst-bangalore-2026",
    title: "Data Analyst",
    company: "Quantum Leap Learning Solutions",
    postedDate: "2026-03-27",
    location: "Bengaluru, India",
    jobType: "Full-time",
    experience: "4–5 Years",
    salary: "₹60K–70K/month",
    skills: ["Excel", "Power BI", "SQL", "Python"],
    description: "Hiring Data Analyst for business insights and reporting.",
    applyLink: "https://abekus.ai/public-job-search/data-analyst-12?referral_hash=IIHT.VIMANNAGAR0138",
  },
  {
    id: "virtualheight-developers-ahmedabad-2026",
    title: "WordPress / MERN Developer",
    company: "Virtual Height IT Services",
    postedDate: "2026-03-27",
    location: "Ahmedabad, India",
    jobType: "Full-time",
    experience: "2–4 Years",
    description: "Hiring WordPress and MERN stack developers.",
    applyLink: "mailto:hr@virtualheight.com",
  },
  {
    id: "angelone-sde-intern-bangalore-2026",
    title: "SDE Intern",
    company: "Angel One",
    postedDate: "2026-03-27",
    location: "Bangalore, India",
    jobType: "Internship",
    experience: "0–1 Years",
    description: "Work on real-time financial systems and scalable applications.",
    applyLink: "https://angelone.mynexthire.com/employer/jobs",
  },
  {
    id: "lowes-software-engineer-intern-bangalore-2026",
    title: "Software Engineer Intern",
    company: "Lowe's",
    postedDate: "2026-03-27",
    location: "Bengaluru, India",
    jobType: "Internship",
    batch: "2025, 2026",
    skills: ["Java", "Python", "React", "Node.js"],
    description: "Lowe’s is hiring interns for software engineering roles.",
    applyLink: "https://talent.lowes.com/in/en/job/JR-02370131/DIH-Intern-Software-Engineering",
  },
  {/* last 27-03-26 */},
  {
    id: "ge-aerospace-btech-intern-bangalore-2026",
    title: "B.Tech Intern",
    company: "GE Aerospace",
    postedDate: "2026-03-26",
    location: "Bangalore, India",
    jobType: "Internship",
    batch: "2025, 2026",
    experience: "Freshers",
    salary: "Not Disclosed",
    qualification: "B.Tech Students",
    skills: [
      "Engineering Fundamentals",
      "Problem Solving",
      "Technical Skills",
      "Communication"
    ],
    description: "GE Aerospace is hiring B.Tech Interns for 2025 and 2026 graduates to work on innovative aerospace projects.",
    applyLink: "https://careers.geaerospace.com/global/en/job/R5031124/B-Tech-Intern",
  },
  {
    id: "ntt-data-analyst-remote-2026",
    title: "Data Analyst / Business Analyst",
    company: "NTT DATA",
    postedDate: "2026-03-26",
    location: "Remote",
    jobType: "Full-time",
    experience: "Freshers / Experienced",
    salary: "Not Disclosed",
    qualification: "Bachelor’s / Master’s Degree",
    skills: [
      "Data Analysis",
      "Business Analysis",
      "SQL",
      "Excel",
      "Reporting",
      "Communication"
    ],
    description: "NTT DATA is hiring Data Analyst / Business Analyst for remote roles. Suitable for both freshers and experienced candidates.",
    applyLink: "https://careers.services.global.ntt/global/en/job/1076f1612a94770/Data-Analyst-Business-Analyst",
  },
  {
    id: "databricks-engineer-pharma-bangalore-2026",
    title: "Databricks Engineer (Pharma Domain)",
    company: "Confidential",
    postedDate: "2026-03-26",
    location: "Bangalore, India (Hybrid)",
    jobType: "Full-time",
    experience: "5+ Years",
    salary: "₹20 LPA",
    qualification: "Bachelor’s Degree in Computer Science or related field",
    skills: [
      "Databricks",
      "Azure",
      "SQL",
      "Snowflake",
      "Spark SQL",
      "Airflow",
      "ADF",
      "Python",
      "Pandas",
      "PySpark",
      "Data Engineering",
      "Data Pipelines",
      "Pharma Domain"
    ],
    description: "Looking for an experienced Databricks Engineer with strong Pharma domain knowledge to build and optimize scalable data pipelines.",
    responsibilities: [
      "Design and develop data pipelines",
      "Work on Databricks and Azure ecosystem",
      "Analyze and optimize large datasets",
      "Implement ETL workflows using Airflow/ADF",
      "Collaborate with cross-functional teams"
    ],
    interviewProcess: "2 Rounds (Virtual)",
    contactNumber: "9980934072",
    applyLink: "mailto:newjobskrishna@yahoo.com",
  },
  {
    id: "hp-software-engineer-entry-2026",
    title: "Systems Software Engineer I (Entry Level)",
    company: "HP (Hewlett Packard Enterprise)",
    postedDate: "2026-03-23",
    location: "India",
    jobType: "Full-time",
    experience: "0–2 Years",
    salary: "Not Disclosed",
    qualification: "Bachelor’s Degree in Computer Science or related field",
    skills: [
      "Software Development",
      "Programming (Java/Python/C++)",
      "Data Structures",
      "Algorithms",
      "Problem Solving"
    ],
    description: "HP is hiring entry-level Software Engineers to build and maintain scalable software systems.",
    applyLink: "https://careers.hpe.com/us/en/job/1204760/Systems-Software-Engineer-I-Entry-Level",
  },
  {
    id: "hp-finance-analyst-2026",
    title: "Finance Analyst",
    company: "HP (Hewlett Packard Enterprise)",
    postedDate: "2026-03-23",
    location: "India",
    jobType: "Full-time",
    experience: "2+ Years",
    salary: "Not Disclosed",
    qualification: "Bachelor’s Degree in Finance, Accounting, or related field",
    skills: [
      "Financial Analysis",
      "Accounting",
      "Excel",
      "Reporting",
      "Data Analysis"
    ],
    description: "HP is hiring Finance Analysts to support financial planning, reporting, and business decision-making.",
    applyLink: "https://careers.hpe.com/us/en/job/1204049/Finance-Analyst",
  },
  {
    id: "comcast-software-engineer-chennai-2026",
    title: "Software Engineer I",
    company: "Comcast",
    postedDate: "2026-03-23",
    location: "Chennai, India",
    jobType: "Full-time",
    batch: "2024, 2025",
    experience: "Freshers / Entry-level",
    salary: "Not Disclosed",
    qualification: "Bachelor’s Degree in Computer Science or related field",
    skills: [
      "Java / Python",
      "Data Structures",
      "Algorithms",
      "Software Development",
      "Problem Solving"
    ],
    description: "Comcast is hiring Software Engineer I for fresh graduates to work on scalable software solutions.",
    applyLink: "https://jobs.comcast.com/job/chennai/engineer-1-software-development-and-engineering/45483/93005912000"
  },
  {
    id: "exl-developer-2026",
    title: "Developer",
    company: "EXL",
    postedDate: "2026-03-23",
    location: "India",
    jobType: "Full-time",
    experience: "0-2 Years",
    salary: "4-8 LPA",
    qualification: "Bachelor’s Degree",
    skills: [
      "Programming",
      "Problem Solving",
      "Software Development",
      "SQL (Preferred)"
    ],
    description: "EXL is hiring Developers with 0-2 years experience. Great opportunity for freshers and early professionals.",
    applyLink: "https://fa-ewjt-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_2/job/7483"
  },
  {
    id: "ey-ui-ux-intern-bangalore-2026",
    title: "UI/UX Intern",
    company: "EY",
    postedDate: "2026-03-23",
    location: "Bengaluru, India",
    jobType: "Internship",
    experience: "Freshers",
    salary: "Not Disclosed",
    qualification: "Bachelor’s Degree",
    skills: [
      "UI Design",
      "UX Research",
      "Figma",
      "Wireframing",
      "Prototyping"
    ],
    description: "EY is offering UI/UX Internship for freshers to work on user-centric design and product experiences.",
    applyLink: "https://eyglobal.yello.co/jobs/3_TgQ8Fs5alVlRS_HO4L9w?job_board_id=c1riT--B2O-KySgYWsZO1Q"
  },
  {
    id: "signzy-data-analyst-intern-2026",
    title: "Data Analyst Intern",
    company: "Signzy",
    postedDate: "2026-03-23",
    location: "India",
    jobType: "Internship",
    duration: "6 Months",
    experience: "Freshers",
    salary: "Not Disclosed",
    qualification: "Bachelor’s Degree in CS / Statistics / Mathematics",
    skills: [
      "SQL",
      "Excel",
      "Python",
      "R",
      "Data Analysis",
      "Power BI / Tableau"
    ],
    description: "Signzy is hiring Data Analyst Interns to work on data extraction, analysis, and building predictive models.",
    responsibilities: [
      "Extract and transform datasets using SQL",
      "Perform statistical analysis using Python/R",
      "Create dashboards and reports",
      "Ensure data quality and validation",
      "Work on real-world business insights"
    ],
    applyLink: "https://signzy.keka.com/careers/jobdetails/83267"
  },
  {
    id: "dzylo-software-developer-intern-2026",
    title: "Software Developer Intern",
    company: "Dzylo",
    postedDate: "2026-03-23",
    location: "Gurgaon, India",
    jobType: "Internship",
    batch: "2026",
    experience: "Freshers",
    salary: "Not Disclosed",
    qualification: "Final Year Students",
    skills: [
      "JavaScript",
      "React",
      "Node.js",
      "Problem Solving",
      "Software Development"
    ],
    description: "Dzylo is hiring Software Developer Interns for 2026 batch to build real-world products and gain hands-on experience.",
    applyEmail: "mailto:ayushman@dzylo.com"
  },
  {
    id: "flipkart-data-scientist-bangalore-2026",
    title: "Data Scientist",
    company: "Flipkart",
    postedDate: "2026-03-22",
    location: "Bangalore, India",
    jobType: "Full-time",
    experience: "Not specified",
    salary: "Not Disclosed",
    qualification: "Bachelor’s / Master’s in Computer Science, Data Science, or related field",
    skills: [
      "Machine Learning",
      "Python",
      "SQL",
      "Data Analysis",
      "Statistics",
      "Deep Learning (Preferred)",
      "Big Data Tools"
    ],
    description: "Flipkart is hiring Data Scientists to work on large-scale data problems, build predictive models, and drive business insights using advanced analytics.",
    responsibilities: [
      "Develop and deploy machine learning models",
      "Analyze large datasets to extract insights",
      "Work with cross-functional teams",
      "Improve product and business decisions using data"
    ],
    applyLink: "https://www.linkedin.com/jobs/view/4387960445/"
  },
  {
    id: "tcs-accounts-payable-walkin-pune-2026",
    title: "Accounts Payable (Walk-In Drive)",
    company: "Tata Consultancy Services (TCS)",
    postedDate: "2026-03-22",
    location: "Pune, India",
    jobType: "Walk-in",
    experience: "1–6 Years",
    vacancies: "8–10 Openings",
    salary: "Not Disclosed",
    qualification: "Minimum 15 years of full-time education (10+2+3)",
    skills: [
      "Accounts Payable",
      "Invoice Processing",
      "Finance & Accounting",
      "ERP/SAP (Preferred)"
    ],
    description: "TCS is conducting a mega walk-in drive for Accounts Payable roles in Pune. Candidates with experience in invoice processing and finance operations are encouraged to apply.",
    responsibilities: [
      "Process vendor invoices accurately",
      "Handle accounts payable operations",
      "Ensure timely payments and reconciliations",
      "Work with finance teams for reporting"
    ],
    walkinDetails: {
      date: "15th March 2026",
      time: "10:00 AM – 12:30 PM",
      venue: "TCS, Sahyadri Park, Phase 3, Hinjawadi, Pune"
    },
    applyLink: "https://www.naukri.com/job-listings-mega-walk-in-at-tcs-pune-hiring-accounts-payable-tata-consultancy-services-pune-1-to-6-years-100326022136"
  },
  {
    id: "fullstack-node-react-remote-2026",
    title: "Full Stack Developer / Sr. Full Stack Developer",
    company: "91HR",
    postedDate: "2026-03-22",
    location: "Remote",
    jobType: "Full-time",
    experience: "2.5+ Years / 4+ Years",
    salary: "Up to 6 LPA / 10 LPA",
    qualification: "Relevant degree or equivalent experience",
    skills: [
      "Node.js",
      "Express.js",
      "NestJS",
      "React.js",
      "React Hooks",
      "PostgreSQL",
      "MySQL",
      "MariaDB",
      "REST API",
      "Git",
      "AWS",
      "MongoDB"
    ],
    description: "Hiring Full Stack Developers to build scalable applications using Node.js and React.js. Strong backend and frontend integration skills required.",
    responsibilities: [
      "Build and maintain full-stack applications",
      "Develop and integrate RESTful APIs",
      "Translate business requirements into scalable solutions",
      "Maintain clean and production-ready code",
      "Collaborate with cross-functional teams"
    ],
    applyEmail: "mailto:mihir@91hr.in"
  },
  {
    id: "data-scientist-ml-engineer-pune-2026",
    title: "Data Scientist / Senior Machine Learning Engineer",
    company: "OptimHire",
    postedDate: "2026-03-22",
    location: "Pune (Work from Office)",
    jobType: "Full-time",
    experience: "6–7 Years",
    salary: "₹7 - 9 LPA",
    qualification: "Bachelor’s Degree in Computer Science / Information Systems or equivalent",
    skills: [
      "Machine Learning",
      "Python",
      "SQL",
      "ETL",
      "Azure",
      "AWS",
      "Databricks",
      "SageMaker",
      "Azure ML"
    ],
    description: "Looking for experienced Data Scientists / ML Engineers with strong expertise in model development, data pipelines, and cloud-based ML deployment.",
    responsibilities: [
      "Develop machine learning models",
      "Build scalable ETL/ELT data pipelines",
      "Deploy ML models using cloud platforms",
      "Work with large datasets and optimize performance"
    ],
    applyLink: "https://optimhire.com/developers/jv/309514?ref_code=mukesh-agrawal",
    Requirements: [
      "Current CTC",
      "Expected CTC",
      "Notice Period",
      "Current Location",
      "Willingness to work from Pune office"
    ]
  },
    {
  id: "virtusa-ui-react-developer-2026",
  title: "UI React Developer",
  postedDate: "2026-03-15",
  company: "Virtusa",
  location: "Bangalore, India",
  jobType: "Full-time",
  workMode: "Hybrid",
  experience: "5+ Years",
  skills: [
    "React.js",
    "Angular",
    "Java",
    "J2EE",
    "REST APIs",
    "Docker",
    "Kubernetes",
    "Terraform",
    "CI/CD"
  ],
  description: "Virtusa is hiring experienced UI React Developers to build scalable enterprise applications and modern frontend platforms.",
  applyLink: "https://www.linkedin.com/jobs/view/4344738580/"
},
{
  id: "goodscore-frontend-developer-2026",
  title: "Frontend Developer",
  company: "GoodScore",
  postedDate: "2026-03-15",
  location: "Bengaluru, India",
  jobType: "Full-time",
  workMode: "On-site",
  experience: "2-6 Years",
  qualification: "B.Tech in Computer Science or related field",
  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "React.js",
    "Git",
    "Responsive Web Design"
  ],
  description: "GoodScore is hiring Frontend Developers to build responsive web applications and improve user experience for their credit management platform.",
  applyLink: "https://www.linkedin.com/jobs/view/4383647350/"
},
{
  id: "nvent-software-engineer-frontend-2026",
  title: "Software Engineer – Frontend Applications",
  company: "nVent",
  postedDate: "2026-03-15",
  location: "Bengaluru, India",
  jobType: "Full-time",
  experience: "3+ Years",
  qualification: "Bachelor’s Degree in Computer Science or Software Engineering",
  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "TypeScript",
    "Node.js",
    "JSON"
  ],
  description: "nVent is hiring Frontend Software Engineers to build scalable web applications and high-performance UI systems.",
  applyLink: "https://www.linkedin.com/jobs/view/4367462821/"
},
{
  id: "valiance-full-stack-engineer-2026",
  title: "Full Stack Engineer",
  company: "Valiance Solutions",
  location: "Bangalore, India",
  postedDate: "2026-03-15",
  jobType: "Full-time",
  workMode: "On-site",
  experience: "3-6 Years",
  skills: [
    "React.js",
    "Vue.js",
    "Python",
    "FastAPI",
    "Node.js",
    "REST APIs",
    "SQL",
    "MongoDB",
    "Docker"
  ],
  description: "Valiance Solutions is hiring Full Stack Engineers to build scalable AI-driven enterprise applications using modern web technologies.",
  applyLink: "https://www.linkedin.com/jobs/view/4386019683/"
},
{
  id: "accenture-full-stack-engineer-2026",
  title: "Full Stack Engineer",
  company: "Accenture",
  location: "Bengaluru, India",
  jobType: "Full-time",
  postedDate: "2026-03-15",
  experience: "3+ Years",
  skills: [
    "React.js",
    "JavaScript",
    "REST APIs",
    "Git",
    "SQL"
  ],
  description: "Accenture is hiring Full Stack Engineers with strong experience in React.js and modern web technologies to build scalable enterprise solutions.",
  applyLink: "https://www.linkedin.com/jobs/view/4373716063/"
},
    {
  id: "tcs-accounts-payable-walkin-pune-2026",
  title: "Accounts Payable (Walk-In Drive)",
  company: "Tata Consultancy Services (TCS)",
  location: "Pune, Maharashtra, India",
  jobType: "Walk-In",
  postedDate: "2026-03-15",
  experience: "1-6 Years",
  qualification: "Bachelor’s Degree in Commerce / Finance or Related Field",
  vacancies: "8-10",
  skills: [
    "Accounts Payable",
    "Invoice Processing",
    "Finance Operations",
    "Accounting"
  ],
  walkInDetails: {
    date: "15 March 2026",
    time: "10:00 AM – 12:30 PM",
    venue: "TCS, Sahyadri Park, Plot No. 2 & 3, Phase 3, Rajiv Gandhi Infotech Park, Maan, Hinjawadi, Pune, Maharashtra 411057"
  },
  description: "Tata Consultancy Services (TCS) is conducting a Mega Walk-In Drive in Pune for Accounts Payable professionals. Candidates with experience in invoice processing and finance operations are encouraged to attend the walk-in interview.",
  applyLink: "https://www.naukri.com/job-listings-mega-walk-in-at-tcs-pune-hiring-accounts-payable-tata-consultancy-services-pune-1-to-6-years-100326022136"
},
{
  id: "ibm-software-engineer-intern-2026",
  title: "Software Engineer Intern",
  company: "IBM",
  location: "Bangalore, India",
  jobType: "Internship",
  postedDate: "2026-03-15",
  experience: "Freshers (0-1 Years)",
  qualification: "Bachelor’s Degree",
  skills: [
    "Programming",
    "Software Development",
    "Problem Solving",
    "Debugging"
  ],
  description: "IBM is hiring Software Engineer Interns for its Bangalore office. This internship offers an opportunity to work with experienced engineers and gain hands-on experience in software development and enterprise technology solutions.",
  applyLink: "https://careers.ibm.com/en_US/careers/JobDetail?jobId=101188&source=WEB_Search_INDIA"
},
{
  id: "finacplus-qa-automation-intern-2026",
  title: "QA Automation Intern",
  company: "FinacPlus",
  location: "Bangalore, India",
  jobType: "Internship",
  postedDate: "2026-03-15",
  experience: "Internship",
  qualification: "Bachelor’s Degree in Computer Science / Related Field",
  stipend: "₹50,000 per month",
  workMode: "On-site",
  shift: "11:00 AM – 8:00 PM IST",
  skills: [
    "JavaScript",
    "TypeScript",
    "Playwright",
    "Selenium",
    "Rest Assured",
    "Postman",
    "Git",
    "Jenkins",
    "GitLab CI"
  ],
  description: "FinacPlus is hiring a QA Automation Intern to work on building and maintaining automation frameworks for API and UI testing. Interns will collaborate with developers and product teams to ensure high-quality software delivery.",
  responsibilities: [
    "Develop and maintain automated test scripts",
    "Perform API and UI testing using Playwright and Selenium",
    "Integrate automated tests with CI/CD pipelines",
    "Collaborate with cross-functional teams",
    "Report defects and analyze test results"
  ],
  applyLink: "mailto:SheetalZade@finacplus.com"
},
    {
  id: "senior-python-engineer-service-implementation-2026",
  title: "Senior Python Engineer – Service Implementation",
  company: "Confidential",
  location: "Remote",
  jobType: "Contract (C2H – 6 Months)",
  postedDate: "2026-03-14",
  experience: "5 Years",
  qualification: "Bachelor's Degree in Computer Science or Related Field",
  skills: [
    "Python",
    "API Development",
    "Test Driven Development (TDD)",
    "Database Design",
    "Microservices",
    "System Architecture",
    "Documentation"
  ],
  description: "Hiring Senior Python Engineers to design and implement modular APIs replicating real-world services such as Gmail and Jira. The role involves strict TDD practices, scalable database design, and collaboration across teams to build production-ready systems.",
  responsibilities: [
    "Design modular APIs replicating real-world services",
    "Follow Test-Driven Development (TDD)",
    "Architect scalable database schemas",
    "Maintain developer documentation",
    "Collaborate with cross-functional teams",
    "Manage full API lifecycle"
  ],
  applyLink: "mailto:rect.rajatg@gmail.com"
},
{
  id: "ey-internship-2026",
  title: "Intern",
  company: "EY",
  location: "Bengaluru, India",
  jobType: "Internship",
  postedDate: "2026-03-14",
  experience: "Freshers",
  qualification: "Bachelor’s Degree",
  skills: [
    "Business Analysis",
    "Communication",
    "Problem Solving",
    "Team Collaboration"
  ],
  description: "EY is offering internship opportunities for fresh graduates. This program allows interns to gain real-world experience by working with professional teams and learning industry practices.",
  applyLink: "https://eyglobal.yello.co/jobs/SjvHlKZm9JlbH93rhTrC4w?job_board_id=c1riT--B2O-KySgYWsZO1Q"
},
{
  id: "coincent-android-developer-internship-2026",
  title: "Android Developer Internship",
  company: "Coincent",
  location: "Pan India (Hybrid)",
  jobType: "Internship",
  postedDate: "2026-03-14",
  experience: "Students / Freshers",
  qualification: "Engineering Students",
  openings: "50",
  skills: [
    "Android Development",
    "Java",
    "Kotlin",
    "Mobile App Development",
    "UI Development"
  ],
  description: "Coincent is hiring Android Developer Interns across India. This internship offers hands-on experience in mobile app development and working with Android technologies.",
  applyLink: "https://unstop.gotrackier.io/click?campaign_id=2237&pub_id=114"
},
    {
  id: "kukbit-vlsi-design-intern-2026",
  title: "VLSI Design Intern",
  company: "Kukbit SL",
  location: "Remote / Work From Home",
  jobType: "Internship",
  postedDate: "2026-03-14",
  experience: "Students / Freshers",
  qualification: "Engineering Students, Undergraduate, Postgraduate, Management, Arts, Commerce, Sciences & Others",
  stipend: "₹20,000 – ₹25,000 / Month",
  skills: [
    "VLSI Design",
    "RTL Design",
    "EDA Tools",
    "Integrated Circuit Design",
    "Functional Verification",
    "Simulation & Debugging",
    "Physical Verification"
  ],
  description: "Kukbit SL is hiring VLSI Design Interns to work on integrated circuit design and verification. Interns will gain hands-on experience with industry-standard EDA tools, RTL development, testbench creation, and simulation analysis while collaborating with experienced engineers.",
  responsibilities: [
    "Assist in design and verification of integrated circuits",
    "Participate in RTL development",
    "Create and execute test benches for verification",
    "Support layout design and physical verification",
    "Analyze simulation results and debug design issues",
    "Document design specifications and verification plans",
    "Research emerging VLSI technologies",
    "Support project tasks and milestones"
  ],
  applyLink: "https://unstop.com/o/MPAjdCS?lb=Bnie7Jo"
},
    {
  id: "episode-six-software-engineer-backend-2026",
  title: "Software Engineer – Backend",
  company: "Episode Six",
  location: "Chennai, India",
  jobType: "Full-Time",
  postedDate: "2026-03-12",
  experience: "0-1 Years (Freshers & Early Career)",
  qualification: "B.Tech / B.E in Computer Science or Related Field",
  batchEligible: "2023, 2024, 2025, 2026",
  salary: "₹12 – 18 LPA (Estimated)",
  skills: [
    "Java",
    "Backend Development",
    "Software Development Life Cycle",
    "Debugging",
    "API Development",
    "Database Validation",
    "Testing",
    "Problem Solving"
  ],
  description: "Episode Six is hiring Software Engineer – Backend for fresh graduates and early career engineers. The role involves working on backend systems, debugging applications, developing test cases, supporting deployments, and collaborating with senior engineers in building scalable fintech payment solutions.",
  responsibilities: [
    "Participate in training sessions and workshops",
    "Understand and apply SDLC in project work",
    "Assist in testing and supporting software solutions",
    "Debug and troubleshoot software applications",
    "Develop documentation for systems and processes",
    "Monitor application logs and production alerts",
    "Analyze job execution errors and report issues",
    "Develop and execute detailed test cases",
    "Collaborate with engineering teams on project tasks"
  ],
  workShift: "APAC / UK / US Shifts",
  applyLink: "https://job-boards.greenhouse.io/episodesixlinkedin/jobs/5797687004"
},
    {
  id: "problem-manager-global-itsearch-2026",
  title: "Problem Manager",
  company: "Global IT Search",
  location: "Pan India",
  jobType: "Full-Time",
  workModel: "Hybrid (3 Days WFO)",
  postedDate: "2026-03-11",
  experience: "6-9+ Years",
  shift: "US Shift (CDT) & Weekends",
  qualification: "Bachelor's Degree in IT / Computer Science or Related Field",
  skills: [
    "ITIL",
    "Problem Management",
    "Root Cause Analysis",
    "Incident Management",
    "ServiceNow",
    "Power BI",
    "Change Management",
    "Knowledge Management"
  ],
  description: "Global IT Search is hiring an experienced Problem Manager with strong ITIL background to lead problem lifecycle management, perform root cause analysis, and prevent recurring incidents. The role involves collaborating with technical teams and driving continuous improvement in IT Service Management processes.",
  applyEmail: "mailto:sripan@globalitsearch.com"
},
    {
  id: "yuvolt-investment-banking-associate-2026",
  title: "Investment Banking Associate",
  company: "Yuvolt Financial Services",
  location: "India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree (Finance / Related Field)",
  skills: [
    "Financial Analysis",
    "Market Research",
    "Financial Modeling",
    "Due Diligence"
  ],
  description: "Yuvolt Financial Services is hiring freshers for the role of Investment Banking Associate. Candidates will work on financial analysis, market research, financial modeling, and due diligence activities.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144048995"
},
{
  id: "ghc-growthlab-chartered-accountant-2026",
  title: "Chartered Accountant - Investment Banking Division",
  company: "GHC Growth Lab",
  location: "Cochin / Kochi / Ernakulam, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Chartered Accountant",
  skills: [
    "Accounting Principles",
    "Journal Entries",
    "Financial Reporting",
    "Financial Statements",
    "Analytical Skills"
  ],
  description: "GHC Growth Lab is hiring Chartered Accountants for its Investment Banking Division to work on accounting, financial reporting, and financial statement analysis.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144010055"
},
{
  id: "kpmg-assistant-manager-investment-banking-2026",
  title: "Assistant Manager - Investment Banking",
  company: "KPMG",
  location: "Gurgaon / Gurugram, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree",
  skills: [
    "Financial Analysis",
    "Investment Banking",
    "Excel",
    "Business Analysis"
  ],
  description: "KPMG is hiring fresh graduates for the Assistant Manager role in the Investment Banking division.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=143406987"
},
{
  id: "midascap-investment-banking-analyst-2026",
  title: "Investment Banking Analyst",
  company: "MidasCap",
  location: "Delhi, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "1-3 Years",
  qualification: "Bachelor's Degree",
  skills: [
    "MS Excel",
    "Financial Modeling",
    "Due Diligence",
    "Investment Banking"
  ],
  description: "MidasCap is hiring Investment Banking Analysts with experience in financial modeling, due diligence, and Excel analysis.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=142680291"
},
{
  id: "amplify-investment-banking-analyst-2026",
  title: "Investment Banking Analyst",
  company: "Amplify",
  location: "Bengaluru / Bangalore, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree",
  skills: [
    "Research",
    "Valuation",
    "Financial Statement Analysis",
    "Financial Modeling",
    "Presentation",
    "Communication",
    "Report Writing"
  ],
  description: "Amplify is hiring freshers for Investment Banking Analyst roles involving financial research, valuation, and report preparation.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=143783325"
},
{
  id: "barclays-senior-analyst-2026",
  title: "Senior Analyst",
  company: "Barclays",
  location: "Pune, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree",
  skills: [
    "Mutual Funds",
    "Capital Markets",
    "Investment Banking",
    "Derivatives",
    "Fixed Income"
  ],
  description: "Barclays is hiring Senior Analysts to work on capital markets, mutual funds, derivatives, and investment banking operations.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=144011455"
},
{
  id: "altamount-investment-banking-associate-2026",
  title: "Investment Banking Associate",
  company: "Altamount Capital Management",
  location: "Mumbai, India",
  jobType: "Full-Time",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree",
  skills: [
    "Financial Analysis",
    "Financial Modeling",
    "Due Diligence",
    "Valuations"
  ],
  description: "Altamount Capital Management is hiring freshers for Investment Banking Associate roles focusing on financial modeling and valuations.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=143784227"
},
{
  id: "abovealpha-finance-intern-2026",
  title: "Finance and Investment Banking Intern",
  company: "Above Alpha Solutions",
  location: "Kolkata, India",
  jobType: "Internship",
  postedDate: "2026-03-11",
  experience: "Fresher",
  qualification: "Bachelor's Degree",
  skills: [
    "Accounting",
    "Finance",
    "Financial Statements",
    "Financial Modeling"
  ],
  description: "Above Alpha Solutions is offering internship opportunities in Finance and Investment Banking for fresh graduates.",
  applyLink: "https://www.foundit.in/seeker/single-page-registration?jobId=143114641"
},
  {
    id: "academian-inc-trainee-software-engineer-2026",
    title: "Trainee Software Engineer",
    company: "Academian Inc",
    location: "Pune, Maharashtra",
    jobType: "Full-Time",
    experience: "0-1 Year",
    postedDate:'2026-03-12',
    qualification: "B.Tech / MCA",
    skills: ["Java", "React", "Automation", "Cloud", "AI"],
    description: "Work on Java, React, and AI to develop high-quality software solutions. Part of the full SDLC from requirement gathering to deployment.",
    applyLink: "mailto:careers@academian.com"
  },
  {
    id: "uipath-senior-principal-software-engineer-2026",
    title: "Senior Principal Software Engineer",
    company: "UiPath",
    location: "Bangalore (On-site)",
    jobType: "Full-Time",
    postedDate: "2026-03-12",
    experience: "15+ Years",
    qualification: "Bachelor's / Master's Degree",
    skills: ["System Architecture", "Distributed Systems", "Azure/AWS", "Kubernetes"],
    description: "Lead the future of agentic automation. Architect and design large-scale distributed enterprise applications.",
    applyLink: "https://jobs.ashbyhq.com/uipath/01e40868-d6ef-429f-98c7-a63ea649d41d?locationId=0d1450d9-c9e6-4015-bee9-f74f5dc93c73 "
  },
    {
  id: "wipro-trainee-hiring-2026",
  title: "Trainee",
  company: "Wipro",
  location: "Chennai, Tamil Nadu",
  jobType: "Full-Time",
  postedDate: "2026-03-12",
  experience: "Freshers",
  qualification: "Bachelor's / Master's Degree",
  skills: [
    "Communication Skills",
    "Analytical Thinking",
    "Problem Solving",
    "Basic IT Knowledge",
    "Adaptability"
  ],
  description: "Wipro is hiring motivated Freshers for the Trainee position. Candidates will be responsible for supporting project delivery and learning corporate workflows in a global tech environment.",
  applyLink: "https://careers.wipro.com/job/Trainee/145301-en_US"
},
    {
  id: "mercor-senior-generalist-rubrics-expert-remote-2026",
  title: "Senior Generalist Rubrics Expert",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "Experienced",
  salary: "$65 per hour",
  postedDate:"2026-03-11",
  engagement: {
    payPerTask: "$130",
    timePerTask: "1.5 hours",
    initialCommitment: "3-week sprint",
    continuation: "Possible extension based on performance"
  },
  skills: [
    "Rubrics Evaluation",
    "Quality Assessment",
    "Analytical Thinking",
    "AI Task Evaluation",
    "Shopping Domain Knowledge"
  ],
  description: "Mercor is hiring Senior Generalist Rubrics Experts to work on a new shopping domain project. The role involves evaluating outputs using rubrics and helping define high-quality standards for scalable tasks.",
  workMode: "Remote",
  paymentMethod: ["Stripe", "Wise"],
  applyLink: "https://t.mercor.com/tY9IL"
},
    {
  id: "react-js-developer-walkin-2026",
  title: "React JS Developer",
  company: "RohitXI",
  location: "Pimpri-Chinchwad, Maharashtra",
  jobType: "Walk-In",
  postedDate:'2026-03-11',
  experience: "0-1 Year",
  qualification: "Bachelor's Degree",
  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "React JS",
    "API Integration",
    "Git"
  ],
  description: "Walk-in hiring for React JS Developers to build web applications and UI components using modern JavaScript frameworks.",
  applyEmail: "mailto:dhanvesh@rohitxi.com"
},
    {
  id: "autodesk-software-engineer-cpp-etl-2026",
  title: "Software Engineer (C++ / ETL)",
  company: "Autodesk",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "Experienced",
  postedDate:'2026-03-11',
  qualification: "Bachelor’s Degree",
  skills: [
    "C++",
    "ETL",
    "Software Development",
    "Data Processing",
    "Algorithms"
  ],
  description: "Autodesk is hiring Software Engineers with C++ and ETL experience to build scalable engineering software systems.",
  applyLink: "https://autodesk.wd1.myworkdayjobs.com/en-US/Ext/job/Software-Engineer--C----ETL-_26WD95489-1"
},
    {
  id: "android-developer-walkin-2026",
  title: "Android Developer",
  company: "RohitXI",
  location: "Pimpri-Chinchwad, Maharashtra",
  jobType: "Walk-In",
  postedDate:'2026-03-11',
  experience: "0-1 Year",
  qualification: "Bachelor's Degree",
  skills: [
    "Android SDK",
    "Kotlin",
    "Java",
    "XML",
    "REST APIs",
    "Android Studio",
    "Git"
  ],
  description: "Walk-in opportunity for Android Developers to build and maintain mobile applications using Kotlin/Java.",
  applyEmail: "mailto:dhanvesh@rohitxi.com"
},
    {
  id: "academian-trainee-software-engineer-2026",
  title: "Trainee Software Engineer",
  company: "Academian Inc",
  location: "Pune, India",
  jobType: "Full-Time",
  experience: "0-1 Year",
  postedDate:'2026-03-11',
  qualification: "B.Tech / MCA",
  skills: [
    "Java",
    "React",
    "Automation",
    "AI",
    "Cloud Computing",
    "Software Development"
  ],
  description: "Academian Inc is hiring Trainee Software Engineers to work on software development, automation, and cloud-based applications.",
  applyEmail: "mailto:careers@academian.com"
},
    {
  id: "lumel-product-developer-trainee-2026",
  title: "Product Developer Trainee",
  company: "Lumel",
  location: "Chennai, Tamil Nadu",
  jobType: "Full-Time",
  experience: "Fresher (2026 Batch)",
  qualification: "BE Computer Science / IT (2026 Batch)",
  skills: [
    "Rust",
    "Data Structures",
    "Algorithms",
    "Systems Programming",
    "Problem Solving",
    "GitHub"
  ],
  description: "Lumel is hiring Product Developer Trainees from the 2026 BE Computer Science/IT batch to build scalable product features and work with Rust-based systems programming.",
  applyLink: "https://lumel.keka.com/careers/jobdetails/121545"
},
    {
  id: "niwas-hfc-hrbp-2026",
  title: "HR Business Partner (HRBP)",
  company: "Niwas Housing Finance",
  location: "Bangalore / Coimbatore, India",
  jobType: "Full-Time",
  experience: "5+ Years",
  salary: "Up to ₹8 LPA",
  postedDate:'2026-03-09',
  qualification: "Bachelor’s or Master’s Degree in HR / Management",
  skills: [
    "HR Business Partnering",
    "Employee Lifecycle Management",
    "Talent Management",
    "Performance Management",
    "HR Compliance",
    "Stakeholder Management"
  ],
  description: "Niwas Housing Finance is hiring HR Business Partners to drive HR strategy, manage employee lifecycle processes, and support business operations across multiple locations.",
  applyEmail: "mailto:gureddy.reddy@niwashfc.com"
},
    {
  id: "vapt-engineer-mumbai-2026",
  title: "VAPT Engineer",
  company: "TechFlex",
  location: "Worli, Mumbai",
  jobType: "Full-Time",
  experience: "1-2 Years",
  postedDate:'2026-03-09',
  qualification: "Bachelor's Degree in Cybersecurity / IT",
  skills: [
    "VAPT",
    "Burp Suite",
    "Nessus",
    "Metasploit",
    "Nmap",
    "OWASP Top 10",
    "Network Security"
  ],
  description: "Hiring VAPT Engineers with experience in vulnerability assessment, penetration testing, and web application security.",
  applyEmail: "mailto:anishad@techflex.co.in"
},
    {
  id: "fusion-analyst-cyber-fraud-2026",
  title: "Fusion Analyst",
  company: "Confidential",
  location: "Bengaluru, India",
  jobType: "Full-Time",
  salary: "₹10 - ₹12 LPA",
  postedDate:'2026-03-09',
  qualification: "Bachelor’s Degree in Computer Science or Information Systems",
  skills: [
    "Splunk",
    "Databricks",
    "Fraud Detection",
    "Financial Crime Surveillance",
    "Data Correlation",
    "Cybersecurity Analytics"
  ],
  description: "Fusion Analyst role focused on cyber-fraud detection, threat intelligence analysis, and cross-domain security analytics.",
  applyLink: "https://optimhire.com/developers/jv/309524?ref_code=mukesh-agrawal"
},
    {
  id: "senior-apigee-api-engineer-2026",
  title: "Senior API / Apigee Engineer",
  company: "Confidential",
  location: "Remote / Hybrid",
  jobType: "Full-Time",
  experience: "8-10 Years",
  postedDate: "2026-03-09",
  qualification: "Bachelor's Degree in Computer Science or related field",
  skills: [
    "Apigee",
    "API Development",
    "Google Cloud Platform",
    "Kubernetes",
    "OAuth2",
    "JWT",
    "CI/CD"
  ],
  description: "Hiring Senior API / Apigee Engineers to support enterprise API migration and modernization projects using Google Cloud Platform and Apigee.",
  applyEmail: "mailto:idealhrsol.it@gmail.com"
},
    {
  id: "mercor-devops-engineer-remote-2026",
  title: "DevOps / Platform Engineer",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  experience: "Experienced",
  postedDate: "2026-03-09",
  salary: "$70 - $250 per hour",
  qualification: "Professional experience in DevOps / Cloud",
  skills: [
    "CI/CD",
    "AWS",
    "GCP",
    "Azure",
    "Docker",
    "Kubernetes",
    "Cloud Infrastructure"
  ],
  description: "Mercor is hiring DevOps / Platform Engineers to join its expert talent network and work on AI-related projects including model training, evaluation, and infrastructure tasks.",
  applyLink: "https://t.mercor.com/E4ov3"
},
    {
  id: "WNS-Assistant-Manager-Risk-Management-2026",
  title: "Assistant Manager – Risk Management",
  company: "WNS (Capgemini)",
  location: "Pune / Mumbai",
  jobType: "Full-Time",
  experience: "Freshers / 3-6 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-09",
  qualification: "CA Freshers / MBA",
  skills: [
    "Risk Management",
    "Process Audit",
    "Internal Audit",
    "Compliance",
    "Financial Analysis"
  ],
  description: "WNS is hiring Assistant Manager for Risk Management with exposure to process-related audits and compliance processes.",
  applyLink: "mailto:samarth.gandhi@wns.com"
},
    {
  id: "ZapTech-Junior-Accounts-Receivable-2026",
  title: "Junior Accounts Receivables Associate",
  company: "ZapTech Pvt Ltd",
  location: "Pune",
  jobType: "Full-Time",
  experience: "0-1 Year",
  salary: "14K-16K per month + incentives",
  postedDate: "2026-03-09",
  qualification: "BBA / B.Com",
  skills: [
    "Accounts Receivable",
    "MS Office",
    "Communication Skills",
    "Negotiation",
    "Account Reconciliation"
  ],
  description: "Entry-level international voice process role focused on accounts receivable management and client communication.",
  applyLink: "mailto:vaishnavipandit@zaptech.co.in"
},
    {
  id: "VarshaKrishi-Hardware-Embedded-Intern-2026",
  title: "Hardware & Embedded Systems Intern",
  company: "VarshaKrishi Udhyog Pvt Ltd",
  location: "Kanpur",
  jobType: "Internship",
  experience: "0 Years",
  salary: "5K-8K per month",
  postedDate: "2026-03-09",
  qualification: "Engineering Students / Graduates",
  skills: [
    "Arduino",
    "ESP32",
    "IoT",
    "Sensors",
    "Embedded Systems",
    "LoRa Communication",
    "Electronics"
  ],
  description: "Internship to build IoT-based smart agriculture systems using sensors, ESP32 microcontrollers, and LoRa communication.",
  applyLink: "https://unstop.com/o/ZrjvM8k?lb=Bnie7Jo"
},
    {
  id: "Tech2Globe-FullStack-Developer-Fresher-2026",
  title: "Full Stack Developer (Fresher)",
  company: "Tech2Globe",
  location: "North West Delhi",
  jobType: "Full-Time",
  experience: "3-6 Months Internship",
  salary: "Not Mentioned",
  postedDate: "2026-03-09",
  qualification: "Bachelor's Degree in Computer Science or related field",
  skills: [
    "Full Stack Development",
    "Backend Development",
    "PHP",
    "Laravel",
    "Databases",
    "Web Development"
  ],
  description: "Tech2Globe is hiring Full Stack Developer Freshers with internship experience. Candidates with knowledge of PHP, Laravel, backend development, and web application development are encouraged to apply.",
  applyLink: "mailto:monika.sharma@tech2globe.com"
},
    {
  id: "PwC-Business-Analyst-Associate-2026",
  title: "Business Analyst - Associate",
  company: "PwC",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not Mentioned",
  postedDate: "2026-03-09",
  qualification: "Bachelor’s / Master’s Degree",
  skills: [
    "Business Analysis",
    "Data Analysis",
    "Problem Solving",
    "Stakeholder Communication",
    "Reporting"
  ],
  description: "PwC is hiring Business Analyst Associates in Bangalore. Candidates will work on business analysis, data insights, and stakeholder collaboration to support strategic decisions.",
  applyLink: "https://jobs-ta.pwc.com/global/en/job/695817WD/Associate-Deals-Data-Science-Bangalore"
},
    {
  id: "Citi-Junior-Python-Developer-2026",
  title: "Junior Python Developer",
  company: "Citi",
  location: "Pune, India",
  jobType: "Hybrid",
  experience: "0-3 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-08",
  qualification: "Bachelor’s Degree",
  skills: [
    "Python",
    "Data Structures",
    "Algorithms",
    "Software Development",
    "Problem Solving"
  ],
  description: "Citi is hiring Junior Python Developers to build and maintain financial technology applications and systems.",
  applyLink: "https://jobs.citi.com/job/pune/junior-python-developer/287/92459979968"
},
    {
  id: "NTT-DATA-AI-Developer-2026",
  title: "AI Developer",
  company: "NTT DATA",
  location: "Hyderabad, India",
  jobType: "Hybrid",
  experience: "Freshers / Experienced",
  salary: "Not Mentioned",
  postedDate: "2026-03-08",
  qualification: "Bachelor’s Degree",
  skills: [
    "Artificial Intelligence",
    "Machine Learning",
    "Python",
    "Data Analysis",
    "Software Development"
  ],
  description: "NTT DATA is hiring AI Developers to work on AI-driven solutions and intelligent systems. The role involves developing, testing, and deploying machine learning models and AI applications.",
  applyLink: "https://careers.services.global.ntt/global/en/job/R-140997/AI-Developer"
},
    {
  id: "Multiple-IT-Openings-2026",
  title: "Multiple IT Roles",
  company: "Confidential",
  location: "India",
  jobType: "Full-Time",
  experience: "0-5 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree",
  skills: [
    "Java",
    "Python",
    "React",
    "Software Testing",
    "DevOps"
  ],
  description: "Multiple IT openings for developers, testers, and DevOps engineers with 0-5 years experience.",
  applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSezcZQfJ6jo4SL7exyQ8p-HH0Huql-4GW_GSrsuM4sGtDs2zQ/viewform?usp=header"
},
    {
  id: "Intrics-Data-Mining-Intern-2026",
  title: "Data Mining Intern",
  company: "Intrics Solutions Pvt Ltd",
  location: "Noida",
  jobType: "Internship",
  experience: "0 Years",
  salary: "8000-10000 per month",
  postedDate: "2026-03-07",
  qualification: "Graduate / Student",
  skills: [
    "Advanced Excel",
    "SQL",
    "Data Analysis",
    "Data Mining"
  ],
  description: "Internship opportunity for candidates interested in data mining and analytics using Excel and SQL.",
  applyLink: "https://grow.almabetter.com/job-board/5aadc3b2-c690-4483-a147-4aa7d75c65ae"
},
    {
  id: "Infinity-Assurance-AI-Intern-2026",
  title: "Computer Vision & AI Intern",
  company: "Infinity Assurance Solutions Pvt. Ltd.",
  location: "South Delhi",
  jobType: "Internship",
  experience: "0 Years",
  salary: "5K-10K per month",
  postedDate: "2026-03-07",
  qualification: "Undergraduate / Postgraduate / Engineering Students",
  skills: [
    "Computer Vision",
    "Artificial Intelligence",
    "Machine Learning",
    "Python",
    "Deep Learning"
  ],
  description: "Internship opportunity to develop AI-based systems for document verification and fraud detection.",
  applyLink: "https://unstop.com/o/AY5vuBG?lb=Bnie7Jo"
},
    {
  id: "xcube-Labs-Software-Intern-2026",
  title: "Software Intern",
  company: "[x]cube LABS",
  location: "Hyderabad",
  jobType: "Internship",
  experience: "0 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "B.Tech / B.E in Computer Science",
  skills: [
    "JavaScript",
    "Java",
    "C",
    "C++",
    "OOPS",
    "DBMS",
    "Data Structures",
    "Algorithms",
    "React",
    "Redux",
    "Typescript"
  ],
  description: "Software internship opportunity to work on digital transformation projects including web and emerging technologies.",
  applyLink: "mailto:alphateam@xcubelabs.com"
},
    {
  id: "Senior-Analyst-Data-Scientist-2026",
  title: "Senior Analyst (Data Scientist)",
  company: "Confidential",
  location: "Bengaluru",
  jobType: "Full-Time",
  experience: "3-6 Years",
  salary: "14-16 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree / Diploma in Computer Science or related field",
  skills: [
    "Python",
    "SQL",
    "Hadoop",
    "Hive",
    "Scala",
    "Time Series Forecasting",
    "Feature Engineering",
    "Machine Learning"
  ],
  description: "Hiring Data Scientists to analyze business data, build predictive models, and support decision-making using advanced statistical techniques.",
  applyLink: "https://optimhire.com/developers/jv/309522?ref_code=mukesh-agrawal"
},

{
  id: "IBM-Associate-System-Engineer-2026",
  title: "Associate System Engineer",
  company: "IBM",
  location: "Multiple Locations",
  jobType: "Full-Time",
  experience: "0 Years",
  salary: "5-10 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree in Computer Science or related field",
  skills: ["Programming", "Problem Solving", "Software Development"],
  description: "IBM is hiring Associate System Engineers for multiple locations. Fresh graduates can start their career working on enterprise-level systems and innovative technology solutions.",
  applyLink: "https://devsunite.com/jobs/8UtSGObk0eSdhgYAHy0u"
},

{
  id: "Q2-Software-Engineer-2026",
  title: "Software Engineer",
  company: "Q2",
  location: "Bangalore",
  jobType: "Full-Time",
  experience: "1 Year",
  salary: "15-25 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree in Computer Science or related field",
  skills: ["Java", "Software Development", "Problem Solving"],
  description: "Q2 is hiring Software Engineers to build scalable financial technology solutions.",
  applyLink: "https://devsunite.com/jobs/wiUe5GLieC41PreIKInc"
},

{
  id: "Deepwatch-Software-Engineer-Intern-2026",
  title: "Software Engineer Intern",
  company: "Deepwatch",
  location: "Bangalore",
  jobType: "Internship",
  experience: "0 Years",
  salary: "4-6 LPA",
  postedDate: "2026-03-07",
  qualification: "Computer Science or related degree",
  skills: ["Programming", "Cybersecurity", "Software Development"],
  description: "Deepwatch is hiring Software Engineer Interns to work on cybersecurity and software development projects.",
  applyLink: "https://devsunite.com/job/69a7bc90001e4f991bc4?tag=norm"
},

{
  id: "Icertis-Intern-2026",
  title: "Intern",
  company: "Icertis",
  location: "Pune",
  jobType: "Internship",
  experience: "0 Years",
  salary: "4-6 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree",
  skills: ["Programming", "Problem Solving", "Software Development"],
  description: "Icertis is offering internship opportunities for students and fresh graduates to gain industry experience.",
  applyLink: "https://devsunite.com/jobs/tD1HvbbIKZAxXvZtHvq0"
},

{
  id: "Vymo-MTS-Intern-2026",
  title: "Intern - Member of Technical Staff",
  company: "Vymo",
  location: "Bangalore",
  jobType: "Internship",
  experience: "0 Years",
  salary: "4-7 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree",
  skills: ["Programming", "Software Development", "Problem Solving"],
  description: "Vymo is hiring technical interns to work on fintech products and engineering platforms.",
  applyLink: "https://devsunite.com/jobs/WhXcB32JKOsVdY72djK2"
},

{
  id: "Seceon-Software-Engineer-2026",
  title: "Software Engineer",
  company: "Seceon Inc",
  location: "Remote",
  jobType: "Full-Time",
  experience: "0 Years",
  salary: "4-7 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree in Computer Science",
  skills: ["Programming", "Cybersecurity", "Software Development"],
  description: "Seceon Inc is hiring Software Engineers for remote roles to work on cybersecurity platforms.",
  applyLink: "https://devsunite.com/job/69a9238e002844245eaa?tag=norm"
},

{
  id: "Uber-Software-Engineer-II-2026",
  title: "Software Engineer II",
  company: "Uber",
  location: "Bangalore",
  jobType: "Full-Time",
  experience: "2 Years",
  salary: "30-45 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree in Computer Science",
  skills: ["Backend Development", "Distributed Systems", "Programming"],
  description: "Uber is hiring Software Engineer II to build scalable global platforms used by millions of users.",
  applyLink: "https://devsunite.com/jobs/7xqsBUXqZU8P4Otkmj7b"
},

{
  id: "Cloudxtreme-DotNet-Developer-2026",
  title: ".NET Software Developer",
  company: "Cloudxtreme",
  location: "Multiple Locations",
  jobType: "Full-Time",
  experience: "3 Years",
  salary: "Competitive",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree",
  skills: [".NET", "C#", "SQL", "Web Development"],
  description: "Cloudxtreme is looking for experienced .NET developers to build enterprise applications.",
  applyLink: "https://devsunite.com/jobs/zztHPm3YP2aWxC9dpQFC"
},

{
  id: "Icon-Software-Test-Engineer-2026",
  title: "Software Test Engineer",
  company: "Icon",
  location: "Chennai",
  jobType: "Full-Time",
  experience: "0 Years",
  salary: "10-15 LPA",
  postedDate: "2026-03-07",
  qualification: "Bachelor's Degree",
  skills: ["Manual Testing", "Automation Testing", "QA"],
  description: "Icon is hiring Software Test Engineers for freshers interested in QA and testing roles.",
  applyLink: "https://devsunite.com/job/69a9238e002832b29bf1?tag=norm"
},
    {
  id: "Flex-Junior-Financial-Analyst-2026",
  title: "Junior Financial Analyst",
  company: "Flex",
  location: "Chennai, India",
  jobType: "Full-Time",
  experience: "0-2 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "B.Com / BBA / M.Com / MBA",
  skills: [
    "Financial Analysis",
    "Accounting",
    "Business Analysis",
    "Excel",
    "Financial Reporting"
  ],
  description: "Flex is hiring Junior Financial Analysts in Chennai. Freshers and candidates with up to 2 years of experience can apply. The role involves financial analysis, preparing reports, assisting finance teams, and supporting business decision-making processes.",
  applyLink: "https://flextronics.wd1.myworkdayjobs.com/en-US/Careers/job/Junior-Financial-Analyst---CAS_WD216531?source=Flex_Career_Site"
},
{
  id: "PwC-Business-Analyst-Associate-2026",
  title: "Business Analyst - Associate",
  company: "PwC",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s / Master’s Degree",
  skills: [
    "Business Analysis",
    "Data Analysis",
    "Problem Solving",
    "Stakeholder Communication",
    "Reporting"
  ],
  description: "PwC is hiring Business Analyst Associates in Bangalore. Both freshers and experienced professionals can apply. The role involves analyzing business processes, working with stakeholders, preparing reports, and supporting strategic business decisions.",
  applyLink: "https://jobs-ta.pwc.com/global/en/job/709161WD/Business-Analyst-Associate"
},
{
  id: "Uber-Software-Engineer-II-2026",
  title: "Software Engineer II",
  company: "Uber",
  location: "Bangalore, India",
  jobType: "Full-Time",
  experience: "0-3 Years",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree in Computer Science or related field",
  skills: [
    "Java",
    "Python",
    "Algorithms",
    "Data Structures",
    "System Design"
  ],
  description: "Uber is hiring Software Engineer II for its Bangalore location. Candidates from the 2021, 2022, and 2023 batches are eligible. The role involves developing scalable systems, solving complex engineering problems, and contributing to high-impact products used globally.",
  applyLink: "https://www.uber.com/global/en/careers/list/154725/"
},
    {
  id: "Deloitte-Application-Support-Analyst-2026",
  title: "Application Support Analyst",
  company: "Deloitte",
  location: "Hyderabad",
  jobType: "Full-Time",
  experience: "Freshers / Early Career",
  salary: "Not Mentioned",
  postedDate: "2026-03-07",
  qualification: "Bachelor’s Degree in IT / Computer Science or related field",
  skills: [
    "Application Support",
    "Ticket Handling",
    "Access Management",
    "Communication Skills"
  ],
  description: "Deloitte is hiring Application Support Analysts in Hyderabad. Freshers and early career candidates with strong communication and technical support skills can apply. The role involves handling support tickets, managing application access, and assisting in maintaining business applications.",
  applyLink: "https://usijobs.deloitte.com/en_US/careersUSI/JobDetail/USI-EH26-Application-support-Analyst-Hyderabad/324000"
},
    {
  id: "Full-Stack-Developer-Bengaluru-2026",
  title: "Full Stack Developer",
  company: "OptimHire",
  location: "Bengaluru",
  jobType: "Full-Time",
  experience: "12-14 Years",
  imageUrl:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAarXjXswXG8jHMfn5kx3cwrGjzsv33wG0hg&s',
  salary: "₹ 10 - 12 Lakh/Year",
  postedDate: "2026-03-06",
  qualification: "Bachelor’s Degree or College Diploma in Computer Science, Information Systems, or equivalent experience",
  skills: [
    "React",
    "React Native",
    ".NET Core",
    ".NET 8",
    "Redux",
    "Material UI",
    "Bootstrap",
    "Typescript",
    "SCSS",
    "Microservices",
    "EF",
    "LINQ",
    "SQL",
    "Azure",
    "AWS",
    "CI/CD",
    "Agile",
    "Agentic AI",
    "GitHub Copilot",
    "Azure DevOps",
    "Design System",
    "Micro Frontends",
    "Data Science",
    "Stakeholder Management",
    "Communication"
  ],
  description: `Responsible for establishing processes, SLAs, and escalation protocols for support & maintenance of web applications.
Lead development using React, React-Native, .NET Core, .NET 8, Azure/AWS, and Agentic AI.
Facilitate scrum ceremonies, manage stakeholders, and ensure adherence to best practices in CI/CD, Agile, and software design.
Handle technical and non-technical queries, maintain dashboards and metrics, and integrate internal/external product designs into cohesive user experiences.
Flexible to work rotational shifts.`,
  applyLink: "https://optimhire.com/developers/jv/309523?ref_code=mukesh-agrawal"
},
  {
    id: "Sakon-Associate-Software-Engineer-2026",
    title: "Associate Software Engineer",
    company: "Sakon",
    location: "PAN India",
    jobType: "Full-Time",
    experience: "0-1 Years",
    salary: "4-6 LPA",
    postedDate: "2026-03-06",
    qualification: "Graduate / Postgraduate",
    skills: ["Software Development", "Problem Solving", "Coding", "Basic Algorithms"],
    description: "Entry-level software engineering role, responsible for contributing to development projects, debugging, and collaborating with the engineering team.",
    applyLink: "https://www.linkedin.com/jobs/view/4377926286/"
  },
  {
    id: "NSF-Engineer-Front-End-2026",
    title: "Engineer – Front End",
    company: "NSF",
    location: "PAN India",
    jobType: "Full-Time",
    experience: "0-1 Years",
    imageUrl:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1OnHl5QHHtsU06rz4BlOz3TxxrKsEJ6G6Rw&s',
    salary: "4-6 LPA",
    postedDate: "2026-03-06",
    qualification: "Graduate / Postgraduate",
    skills: ["HTML", "CSS", "JavaScript", "React", "UI/UX"],
    description: "Front-end engineer role, responsible for developing user interfaces, implementing designs, and collaborating with backend teams for seamless integrations.",
    applyLink: "https://hcnz.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/NSFCareers/job/3722"
  },
  {
    id: "Mr-Cooper-Machine-Learning-Engineer-2026",
    title: "Machine Learning Engineer",
    company: "Mr. Cooper Group",
    location: "PAN India",
    jobType: "Full-Time",
    experience: "0-2 Years",
    imageUrl:'https://portal.financialmodelingprep.com/positions/68079414864b6d1a4dcc71d5.png',
    salary: "8-16 LPA",
    postedDate: "2026-03-06",
    qualification: "B.Tech / M.Tech / MCA",
    skills: ["Python", "Machine Learning", "Data Analysis", "AI", "Pandas", "Scikit-learn"],
    description: "Responsible for designing, implementing, and optimizing machine learning models, working with large datasets, and collaborating with product teams to build AI solutions.",
    applyLink: "https://careers.mrcooper.com/us/en/job/MRCOUS024298EXTERNALENUS/Machine-Learning-Engineer"
  },
  {
    id: "EA-Data-Scientist-I-2026",
    title: "Data Scientist I",
    company: "Electronic Arts (EA)",
    location: "Hyderabad",
    jobType: "Full-Time",
    experience: "Entry Level",
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "B.Tech / M.Tech / MCA",
    skills: ["Data Analysis", "Python", "R", "SQL", "Statistics", "Machine Learning"],
    description: "Work on game analytics and data-driven projects, supporting decision-making through insights and predictive modeling for EA's products.",
    applyLink: "https://jobs.ea.com/en_US/careers/JobDetail/Data-Scientist-I/212222"
  },
  {
    id: "SarvamAI-Frontend-Internship-2026",
    title: "Frontend Internship",
    company: "Sarvam AI",
    location: "Remote / WFH",
    jobType: "Internship",
    experience: "0 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "2026 / 2027 Passouts",
    skills: ["HTML", "CSS", "JavaScript", "React", "UI Development"],
    description: "Internship to support frontend development tasks, implement user interfaces, and assist in web application projects.",
    applyLink: "https://careers.kula.ai/sarvam-ai/24358"
  },
  {
    id: "Infineon-Trainee-Engineer-2026",
    title: "Trainee Engineer",
    company: "Infineon",
    location: "PAN India",
    jobType: "Full-Time",
    experience: "Freshers",
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "B.Tech / Diploma",
    skills: ["Electronics", "Embedded Systems", "Problem Solving", "Technical Analysis"],
    description: "Trainee engineer role for freshers to support projects, learn corporate processes, and gain hands-on experience in engineering solutions.",
    applyLink: "https://jobs.infineon.com/careers/job/563808969612057"
  },
  {
    id: "Synopsys-Software-Engineer-Apprenticeship-2026",
    title: "Software Engineer Apprenticeship",
    company: "Synopsys",
    location: "Bengaluru",
    jobType: "Apprenticeship",
    experience: "0 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "2025 Passouts",
    skills: ["Software Development", "Programming", "Problem Solving", "Team Collaboration"],
    description: "12-month apprenticeship program to train and develop software engineers, providing exposure to real projects and mentorship.",
    applyLink: "https://careers.synopsys.com/job/-/-/44408/92181995088"
  },
  {
    id: "SalientTech-ML-Intern-2026",
    title: "Machine Learning Intern",
    company: "Salient Technologies",
    location: "Remote (WFH)",
    jobType: "Internship",
    experience: "B.Tech/B.E. CS/IT, MCA, M.Tech (Preferred)",
    salary: "₹12,000 - ₹15,000/month",
    postedDate: "2026-03-05",
    skills: ["AI & Machine Learning", "Machine Learning", "PyTorch", "TensorFlow"],
    description: "Apply machine learning expertise to tackle challenges and drive development of cutting-edge solutions in a remote internship.",
    applyLink: "mailto:hr@salienttechnologies.com"
  },
  {
    id: "SmartMinds-DotNet-Developer-2026",
    title: ".NET Developer",
    company: "Smart Minds",
    location: "Kochi, Kerala",
    jobType: "Full-Time",
    experience: "4-6 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: [".NET (C#)", "ASP.NET", "SQL Server", "Git", "SDLC"],
    description: "Join the team as a .NET Developer with expertise in SQL and ASP.NET. Immediate joiners preferred.",
    applyLink: "mailto:hr@smart-minds.co.in"
  },
  {
    id: "RSC-Endpoint-Intune-2026",
    title: "Endpoint & Intune Specialist",
    company: "RSC",
    location: "Not specified",
    jobType: "Full-Time",
    experience: "Not specified",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: ["Endpoint Management", "Microsoft Intune"],
    description: "Opportunity to work on Endpoint & Intune solutions. Interested candidates can email Priyanka.Thakre@rsc.com",
    applyLink: "mailto:Priyanka.Thakre@rsc.com"
  },
  {
    id: "GlobalLogic-Zscaler-OneAPI-Backend-Engineer-2026",
    title: "Zscaler OneAPI Backend Engineer 1",
    company: "GlobalLogic",
    location: "Bangalore, Hyderabad, Noida, Pune (Hybrid)",
    jobType: "Full-Time",
    experience: "5-10 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: ["AWS", "Java", "Kubernetes", "Microservices", "Spring Frameworks", "SQL", "Git"],
    description: "Work as a backend engineer for Zscaler OneAPI. Experience in cloud computing, Java, containerization, and distributed systems required.",
    applyLink: "mailto:hr@globallogic.com"
  },
  {
    id: "EY-Azure-IAM-2026",
    title: "IAM Specialist",
    company: "EY Consulting",
    location: "Trivandrum/Bangalore/Pune/Chennai/Noida",
    jobType: "Full-Time",
    experience: "3-7 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: ["AWS IAM", "Azure Entra ID", "GCP IAM", "Okta", "SAML", "OAuth", "OpenID Connect", "Scripting"],
    description: "Work on identity and access management across cloud platforms. Email resume to Iflah.a@alpconsulting.in",
    applyLink: "mailto:Iflah.a@alpconsulting.in"
  },
  {
    id: "Environmental-Sector-Senior-PM-2026",
    title: "Senior Project Manager",
    company: "Environmental Sector Client",
    location: "Not specified",
    jobType: "Full-Time",
    experience: "7+ Years",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: ["Project Management", "Agile & Waterfall", "Stakeholder Engagement", "Business Writing"],
    description: "Lead complex projects with hybrid/waterfall methodologies. Send resume to tkvolek@recruitinginmotion.com",
    applyLink: "mailto:tkvolek@recruitinginmotion.com"
  },
  {
    id: "Mercor-Software-Engineering-Expert-2026",
    title: "Software Engineering Expert",
    company: "Mercor",
    location: "Remote",
    jobType: "Contract",
    experience: "Experienced Professionals",
    salary: "$50-$150 per hour",
    postedDate: "2026-03-05",
    skills: ["AI Systems", "Code Validation", "Prompt Refinement", "Algorithm Evaluation", "Model Benchmarking"],
    description: "Support AI research labs by improving AI systems through code validation and model evaluation.",
    applyLink: "mailto:hr@mercor.com"
  },
  {
    id: "TPM-Bangalore-Coimbatore-2026",
    title: "Technical Project Manager (TPM)",
    company: "Not specified",
    location: "Bangalore/Coimbatore",
    jobType: "Full-Time",
    experience: "6-10 Years",
    salary: "Not mentioned",
    postedDate: "2026-03-05",
    skills: ["Technical Project Management", "AI/ML Projects", "Software Development", "Metrics-driven Management", "PMP Certification (Desirable)"],
    description: "Lead AI/ML or Data projects, track and monitor project metrics. Send resume to rect.rajatg@gmail.com",
    applyLink: "mailto:rect.rajatg@gmail.com"
  },
    {
    id: "FTProTech-Python-Developer-2026",
    title: "Python Developer",
    company: "FT ProTech",
    location: "Hyderabad",
    jobType: "Full-Time",
    experience: "0-1 Years",
    imageUrl:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYqHYFvxEybwv_bFVw7D279IBdCTDIlSFuaA&s',
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "Freshers & Immediate Joiners Welcome",
    skills: [
      "Python",
      "Problem Solving",
      "OOP Concepts",
      "Databases (PostgreSQL/MySQL)",
      "Odoo Development (Preferred)"
    ],
    description: "Work on Python development tasks, apply OOP concepts, and gain experience with databases and Odoo development. Immediate joiners preferred.",
    applyLink: "mailto:saipriya.tulam@ftprotech.com"
  },
    {
    id: "Senior-Data-Analyst-Trading-Analytics-2026",
    title: "Senior Data Analyst – Trading Analytics",
    company: "Ancile Digital",
    location: "Bangalore (Hybrid)",
    jobType: "Full-Time",
    experience: "8 – 12+ Years",
    salary: "Not mentioned",
    postedDate: "2026-03-06",
    qualification: "Graduate / Postgraduate",
    skills: [
      "SQL",
      "Trading Analytics",
      "Product/Platform Teams",
      "BI / Reporting",
      "Analytical Storytelling",
      "Stakeholder Engagement",
      "Decision Making"
    ],
    description: "Translate complex data into meaningful insights, support product decisions, drive data-backed decision making, and collaborate across cross-functional teams.",
    applyLink: "mailto:bhavin.parekh@anciledigital.com"
  },

{
  id: "HPE-Software-Engineer-2026",
  title: "Software Engineer",
  company: "HPE (Hewlett Packard Enterprise)",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Java",
    "Python",
    "C++",
    "Data Structures",
    "Algorithms",
    "Problem Solving",
    "Operating Systems"
  ],
  description: "Work on software development projects, apply problem-solving skills, and contribute to enterprise solutions.",
  applyLink: "https://careers.hpe.com/us/en/job/HPE1US1199346EXTERNALENUS/Software-Engineer?utm_source=indeed&utm_medium=phenom-feeds"
},
{
  id: "Qualcomm-Engineer-446716366194",
  title: "Engineer",
  company: "Qualcomm",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Embedded Systems",
    "C/C++",
    "Wireless Communication",
    "RTOS",
    "Digital Design"
  ],
  description: "Develop embedded systems and work on wireless communication solutions with Qualcomm’s engineering teams.",
  applyLink: "https://app.eightfold.ai/careers/job/446716366194?domain=qualcomm.com"
},
{
  id: "Ecolab-Software-Engineer-2026",
  title: "Software Engineer",
  company: "Ecolab",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Software Development",
    "Coding",
    "Technical Analysis",
    "Documentation",
    "Problem Solving"
  ],
  description: "Develop software solutions, perform technical analysis, and contribute to Ecolab’s enterprise projects.",
  applyLink: "https://jobs.ecolab.com/global/en/job/EIYEIEUSR00286736EXTERNALENGLOBAL/Software-Engineer?utm_source=srm_indeed_org"
},
{
  id: "Qualcomm-Engineer-446716315281",
  title: "Engineer",
  company: "Qualcomm",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Programming (C/C++)",
    "Embedded Software",
    "Debugging",
    "Computer Architecture",
    "Linux"
  ],
  description: "Work on embedded software development and debugging, focusing on computer architecture and Linux systems.",
  applyLink: "https://app.eightfold.ai/careers/job/446716315281?domain=qualcomm.com"
},
{
  id: "Qualcomm-Engineer-446716366178",
  title: "Engineer",
  company: "Qualcomm",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Real-time Systems",
    "Microcontrollers",
    "Firmware Development",
    "Hardware-Software Integration"
  ],
  description: "Design and develop firmware, integrate hardware and software systems, and work on real-time applications.",
  applyLink: "https://app.eightfold.ai/careers/job/446716366178?domain=qualcomm.com"
},
{
  id: "NTT-DATA-Software-Applications-Development-Engineer-2026",
  title: "Software Applications Development Engineer",
  company: "NTT DATA",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Web Development",
    "SQL",
    "Java/Python",
    "Software Design",
    "Analytical Thinking"
  ],
  description: "Develop web applications, design software solutions, and perform analytical tasks to support enterprise projects.",
  applyLink: "https://careers.services.global.ntt/global/en/job/NTT1GLOBALR141003EXTERNALENGLOBAL/Software-Applications-Development-Engineer?utm_source=indeed&utm_medium=phenom-feeds"
},
{
  id: "Franklin-Templeton-Software-Engineer-2026",
  title: "Software Engineer",
  company: "Franklin Templeton",
  location: "Hyderabad",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Java/.NET",
    "Financial Systems Knowledge",
    "SQL",
    "Data Structures",
    "Communication"
  ],
  description: "Develop software solutions for financial systems, collaborate with teams, and optimize processes for Franklin Templeton.",
  applyLink: "https://franklintempleton.wd5.myworkdayjobs.com/en-US/Primary-External-1/job/Hyderabad-Telangana-India/Software-Engineer_866202"
},
{
  id: "KLA-Software-Engineer-2026",
  title: "Software Engineer",
  company: "KLA",
  location: "Chennai",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "C++/C#",
    "Software Architecture",
    "Technical Debugging",
    "Math/Physics Fundamentals"
  ],
  description: "Work on software engineering projects, technical debugging, and architecture design for KLA systems.",
  applyLink: "https://kla.wd1.myworkdayjobs.com/en-US/Search/job/Chennai-India/Software-Engineer_2634298"
},
{
  id: "BSH-Home-Appliances-DevOps-Engineer-2026",
  title: "DevOps Engineer",
  company: "BSH Home Appliances (Bosch)",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "CI/CD Pipelines",
    "Docker",
    "Kubernetes",
    "Cloud (AWS/Azure)",
    "Linux Administration"
  ],
  description: "Manage DevOps pipelines, cloud infrastructure, and deployment processes for BSH Home Appliances projects.",
  applyLink: "https://jobs.bsh-group.de/42664-devops-engineer/en/job.html?persisted_lang=en"
},
{
  id: "Cisco-Software-Engineer-2008714",
  title: "Software Engineer",
  company: "Cisco",
  location: "PAN India",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Networking Protocols",
    "C/C++",
    "Linux Internals",
    "System Programming",
    "Problem Solving"
  ],
  description: "Develop software for networking systems, work with Linux internals, and solve complex problems at Cisco.",
  applyLink: "https://careers.cisco.com/global/en/job/2008714"
},
{
  id: "RXO-Engineer-Software-Engineering-2026",
  title: "Engineer - Software Engineering",
  company: "RXO",
  location: "Mumbai",
  jobType: "Full-Time",
  experience: "Freshers / Experienced",
  salary: "Not mentioned",
  postedDate: "2026-03-05",
  qualification: "Graduate / Postgraduate",
  skills: [
    "Software Development Life Cycle (SDLC)",
    "Java",
    "SQL",
    "Database Management",
    "Testing"
  ],
  description: "Develop and maintain software, manage databases, and perform testing across the SDLC at RXO.",
  applyLink: "https://rxo.wd501.myworkdayjobs.com/en-US/rxojobs/job/Mumbai-India/Engineer--Software-Engineering_JR102290"
},
{
id: "Icertis-SDET-Intern-2026",
title: "SDET Intern",
company: "Icertis",
location: "Pune",
salary:'Not Mentioned',
batch: ["2025","2026"],
type: "Internship",
postedDate:'2026-03-05',
skills: [
"Software Testing",
"Automation Testing",
"Programming",
"Debugging"
],
applyLink: "https://iaaviz.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Jobs-at-Icertis/job/7337"
},

{
id: "Jabil-SE-Intern-2026",
title: "Software Engineer Intern",
company: "Jabil",
location: "Pune",
batch: ["2025","2026"],
type: "Internship",
postedDate:'2026-03-05',
salary:'Not mentioned',
skills: [
"Programming",
"Software Development",

"Problem Solving",
"Debugging"
],
applyLink: "https://jabil.wd5.myworkdayjobs.com/en-US/Jabil_Careers/job/Intern_J2440126"
},
{
id: "AI-Intern-BreakoutAI-2026",
title: "Artificial Intelligence Intern",
company: "BreakoutAI",
location: "Remote",
jobType: "Internship",
postedDate:'2026-03-05',
salary: "₹20,000 – ₹80,000 / month",
qualification: "Undergraduate / Postgraduate / Engineering Students / Freshers",
skills: [
"Programming",
"Artificial Intelligence",
"Problem Solving",
"AI Tools",
"Software Development"
],
description: "Work on real AI projects, build AI integrations, experiment with AI tools, and collaborate with developers to ship real products.",
applyLink: "https://unstop.com/o/jkdaviA?lb=Bnie7Jo"

},

{
id: "AI-RedTeamer-Mercor-2026",
title: "AI Red-Teamer – Adversarial AI Testing",

company: "Mercor",
location: "Remote",
jobType: "Contract",
salary: "$13.87 per hour",
postedDate:'2026-03-05',
languages: ["English", "Hindi"],
skills: [
"Adversarial AI Testing",
"Prompt Injection",
"Cybersecurity",
"AI Safety",
"Data Annotation",
"AI Evaluation"
],
description: "Test AI systems for vulnerabilities, identify bias and misuse risks, and generate datasets to improve AI safety.",
applyLink: "https://t.mercor.com/LoIjz"
},
    {
  id: "Senior-Software-Engineer-Flutter-GeekyAnts-2026",
  title: "Senior Software Engineer – I (Flutter Developer)",
  company: "GeekyAnts India Pvt Ltd",
  location: "Bengaluru (Onsite)",
  jobType: "Full-Time",
  experience: "4+ Years",
  salary:'Not mentioned',
  postedDate:'2026-03-05',
  qualification: "B.E / B.Tech (CS/IT)",
  skills: [
    "Flutter",
    "Dart",
    "Clean Architecture",
    "Bloc",
    "Riverpod",
    "REST",
    "GraphQL",
    "CI/CD",
    "Performance Optimization"
  ],
  description: "Lead architecture and development of scalable Flutter applications with production-grade standards.",
  applyLink: "https://topgeek.io/company/geekyants-india-pvt-ltd/openings/senior-software-engineer--i-flutter-developer-dc53?uid=316348"
},
    {
  id: "Full-Stack-Intern-Agentic-AI-Tecnod8AI-2026",
  title: "Intern – Full Stack (Agentic AI Applications)",
  company: "Tecnod8.AI",
  location: "Kolkata",
  jobType: "Internship",
  postedDate:'2026-03-05',
  salary: "₹20,000/month",
  skills: [
    "React",
    "Next.js",
    "Python",
    "FastAPI",
    "LLMs",
    "LangChain",
    "RAG",
    "REST APIs"
  ],
  description: "Build AI-powered full stack applications and agentic workflows using LLM frameworks.",
  applyLink: "https://grow.almabetter.com/job-board/0255403d-11bb-4724-ab42-8e21f5d05567"
},
    {
  id: "AR-Developer-Intern-Arishna-IoT-2026",
  title: "AR Developer Intern",
  company: "Arishna IoT Solutions",
  location: "Remote",
  postedDate:'2026-03-05',
  salary:'Not mentioned',
  jobType: "Internship",
  eligibility: "Undergraduate / Postgraduate / Any Discipline",
  skills: [
    "Unity",
    "ARCore",
    "ARKit",
    "AR Foundation",
    "Blender",
    "C#"
  ],
  description: "Develop and prototype AR applications using Unity and immersive technologies.",
  applyLink: "https://unstop.com/o/jiQJbvq?lb=Bnie7Jo"
},
    {
  id: "Frontend-Engineer-Talent-Network-Mercor-2026",
  title: "Frontend Engineer (Talent Network)",
  company: "Mercor",
  location: "Remote",
  jobType: "Contract",
  postedDate:'2026-03-05',
  salary: "$70–$150 per hour",
  skills: [
    "React",
    "Vue",
    "Angular",
    "HTML",
    "CSS",
    "State Management",
    "Performance Optimization"
  ],
  description: "Join Mercor’s expert network to contribute to AI model training and evaluation projects.",
  applyLink: "https://t.mercor.com/fkP4oA"
},
    {
  id: "Freshers-Ensuesoft-2026",
  title: "Software Trainee / Fresher",
  company: "Ensuesoft",
  location: "Mohali (Onsite)",
  jobType: "Full-Time",
  postedDate:'2026-03-05',
  eligibility: "Freshers",
  salary:'Not mentioned',
  skills: [
    "Basic Programming",
    "Communication Skills",
    "Learning Attitude"
  ],
  description: "Entry-level opportunity for freshers to work on real-time projects with growth and mentorship.",
  applyLink: "https://forms.gle/er1n4qYdEZDpRdpN9"
},
    {
  id: "Cloud-Architect-Shinebask-Technologies-2026",
  title: "Cloud Architect",
  company: "Shinebask Technologies",
  location: "Remote (WFH)",
  jobType: "Full-Time",
  salary: "₹1,00,000/month",
  postedDate:'2026-03-05',
  experience: "10–12 Years",
  skills: [
    "AWS",
    "Control Tower",
    "Landing Zone Accelerator",
    "VPC",
    "IAM",
    "KMS",
    "ECS",
    "RDS",
    "FinOps",
    "CI/CD"
  ],
  description: "Design and govern AWS multi-tenant architecture including landing zones, security frameworks, and modernization roadmap.",
  applyLink: "https://abekus.ai/public-job-search/cloud-architect-1?referral_hash=IIHT.VIMANNAGAR0138"
},
    {
  id: "Data-Science-Intern-Marsh-McLennan-2026",
  title: "Intern - Data Science",
  company: "Marsh McLennan",
  location: "Mumbai (Hybrid)",
  jobType: "Internship",
  salary:'Not mentioned',
  postedDate:'2026-03-05',
  skills: [
    "Data Cleaning",
    "Statistical Modeling",
    "Data Mining",
    "EDA",
    "Data Visualization"
  ],
  description: "Work with data science teams to collect, clean, analyze datasets and create insights for business stakeholders.",
  applyLink: "https://grow.almabetter.com/job-board/4c7e007c-1106-4d90-a64f-4d7e2ca2bdd4"
},
    {
  id: "AI-Intern-Digi-Technologies-2026",
  title: "AI Intern",
  company: "Digi Technologies",
  location: "Remote",
  jobType: "Internship",
  postedDate:'2026-03-05',
  stipend: "₹8,000/month",
  eligibility: "Undergraduate / Postgraduate / Engineering Students",
  skills: [
    "AI Tools",
    "Automation",
    "make.com",
    "n8n",
    "LinkedIn Automation",
    "Data Analysis Automation"
  ],
  description: "Build AI automation tools, automate outreach workflows, analyze chats, and create AI-powered applications.",
  applyLink: "https://unstop.com/o/6VeGn54?lb=Bnie7Jo"
},
    {
  id: 'SDET-Internship-Icertis-2026',
  title: 'SDET Intern',
  company: 'Icertis',
  location: 'Pune',
  jobType: 'Internship',
  eligibleBatch: '2025 & 2026',
  postedDate:'2026-03-05',
  qualification: 'Engineering / Relevant Technical Degree',
  department: 'Software Testing / QA Engineering',
  experience: 'Internship (Students)',
  description: 'Icertis is hiring SDET Interns from the 2025 and 2026 batches to work on software development testing, automation, and quality engineering initiatives.',
  applyLink: 'https://iaaviz.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/Jobs-at-Icertis/job/7337'
},

    {
  id: 'Tech-Mahindra-Recruitment-Drive-2026 For all roles',
  title: 'Tech & Non-Tech Roles',
  company: 'Tech Mahindra',
  location: 'PAN India',
  jobType: 'Full-Time',
  salaryRange: '₹5.8 – ₹22 LPA',
  postedDate:'2026-03-05',
  qualification: 'Graduate / Post Graduate',
  experience: 'Freshers & Experienced',
  department: 'Multiple Departments (Tech & Non-Tech)',
  description: 'Tech Mahindra is conducting a recruitment drive across India for multiple Tech and Non-Tech roles. Open to graduates and postgraduates with competitive salary packages.',
  applyLink: 'https://pdlink.in/4omWEqn'
},

    
    {
  id: 'Senior-Software-Engineer-I-Flutter-GeekyAnts-2026',
  title: 'Senior Software Engineer – I (Flutter Developer)',
  company: 'GeekyAnts India Pvt Ltd',
  location: 'Bengaluru (On-site)',
  jobType: 'Full-Time',
  postedDate: '2026-03-04',
  experience: '4+ Years',
  qualification: 'B.E / B.Tech in Computer Science & Information Technology',
  department: 'Mobile Engineering',
  keySkills: [
    'Flutter',
    'Dart',
    'Clean Architecture',
    'Bloc',
    'Riverpod',
    'REST APIs',
    'GraphQL',
    'WebSockets',
    'CI/CD',
    'Performance Optimization',
    'SQLite',
    'Hive',
    'Swift',
    'Kotlin'
  ],
  responsibilities: [
    'Architect and develop scalable Flutter applications',
    'Lead technical decisions and mentor junior engineers',
    'Drive end-to-end project lifecycle',
    'Optimize performance and app stability',
    'Integrate APIs, offline-first storage, and native modules'
  ],
  description: 'GeekyAnts is hiring a Senior Software Engineer – I (Flutter Developer) with 4+ years of production experience to lead architecture, mentor engineers, and deliver high-quality mobile applications.',
  applyLink: 'https://topgeek.io/company/geekyants-india-pvt-ltd/openings/senior-software-engineer--i-flutter-developer-dc53?uid=316348'
},
    {
  id: 'Intern-Full-Stack-Agentic-AI-Tecnod8AI-2026',
  title: 'Intern – Full Stack (Agentic AI Applications) Development',
  company: 'Tecnod8.AI',
  location: 'Kolkata',
  jobType: 'Internship',
  stipend: '₹20,000 per month',
  postedDate: '2026-03-04',
  experience: 'Internship / Student Level',
  qualification: 'Engineering / Relevant Technical Background Preferred',
  department: 'Full Stack & Agentic AI Development',
  keySkills: [
    'React.js',
    'Next.js',
    'Python',
    'FastAPI',
    'Node.js',
    'REST APIs',
    'PostgreSQL',
    'MongoDB',
    'LLMs',
    'LangChain',
    'RAG',
    'Prompt Engineering'
  ],
  description: 'Tecnod8.AI is hiring Full Stack Interns to build AI-native, agentic co-pilots for industrial and manufacturing engineering. Interns will work on AI-powered full stack applications, LLM integrations, and autonomous agent workflows.',
  benefits: [
    '₹20,000/month stipend',
    'Full-time opportunity after internship',
    'Hands-on experience in Agentic AI',
    'Startup mentorship environment',
    'Flexible work culture'
  ],
  applyLink: 'https://grow.almabetter.com/job-board/0255403d-11bb-4724-ab42-8e21f5d05567'
},
    {
  id: 'Decision-Science-Analyst-American-Express-2026',
  title: 'Decision Science Analyst (Entry-Level)',
  company: 'American Express',
  location: 'India',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  jobId: '26000608',
  postedDate: '2026-03-04',
  experience: '0 – 3 Years',
  qualification: 'Bachelor’s / Master’s Degree (Relevant Field)',
  department: 'Decision Science / Analytics',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Python',
    'Statistics',
    'Business Analytics',
    'Problem Solving',
    'Data Visualization'
  ],
  description: 'American Express is hiring freshers and early-career professionals for the Decision Science Analyst role. Candidates with strong analytical skills and interest in data-driven decision making are encouraged to apply.',
  applyLink: 'https://www.takeofftalent.com/search/label/India'
},
    {
  id: 'AR-Developer-Intern-Arishna-IoT-Solutions-2026',
  title: 'AR Developer Intern',
  company: 'Arishna IoT Solutions',
  location: 'Remote',
  jobType: 'Internship',
  stipend: 'Not Disclosed',
  postedDate: '2026-03-04',
  experience: 'Internship / Student Level',
  eligibility: 'Undergraduate, Postgraduate, Engineering, Management, Arts, Commerce, Science, Law, Medical & Others',
  department: 'Augmented Reality / XR Development',
  keySkills: [
    'Unity Engine',
    'ARCore',
    'ARKit',
    'AR Foundation',
    'C#',
    'Blender',
    '3D Modeling',
    'XR Development'
  ],
  description: 'Arishna IoT Solutions is hiring AR Developer Interns for a remote role. The intern will assist in designing and developing augmented reality applications using Unity and AR tools such as ARCore, ARKit, and AR Foundation.',
  responsibilities: [
    'Develop and prototype AR functionality for mobile/XR platforms',
    'Test AR experiences on multiple devices',
    'Debug and optimize AR performance',
    'Maintain and optimize 3D assets',
    'Research emerging AR technologies'
  ],
  applyLink: 'https://unstop.com/o/jiQJbvq?lb=Bnie7Jo'
},
    {
  id: 'Data-Engineer-Analytics-Amazon-2026',
  title: 'Data Engineer – Analytics',
  company: 'Amazon',
  location: 'Hyderabad, India',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Experienced',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'Data Engineering',
  keySkills: [
    'Data Engineering',
    'SQL',
    'ETL',
    'Big Data',
    'Analytics'
  ],
  description: 'Amazon is hiring Data Engineers for its Analytics team in Hyderabad. Freshers and experienced candidates can apply.',
  applyLink: 'https://www.amazon.jobs/en/jobs/3192579/data-engineer-shiptech-analytics'
},
    {
  id: 'Analyst-Data-Analytics-American-Express-2026',
  title: 'Analyst - Data Analytics',
  company: 'American Express',
  location: 'India (Hybrid)',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Experienced',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'Data Analytics',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Excel',
    'Python',
    'Analytics'
  ],
  description: 'American Express is hiring Data Analytics Analysts for a hybrid role in India. Open to freshers and experienced candidates.',
  applyLink: 'https://aexp.eightfold.ai/careers/job/40410926?hl=en'
},
    {
  id: 'DevOps-QA-Engineer-Quest-Global-2026',
  title: 'DevOps QA Engineer',
  company: 'Quest Global',
  location: 'Bengaluru, India',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Experienced',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'DevOps / QA',
  keySkills: [
    'DevOps',
    'QA Automation',
    'CI/CD',
    'Testing',
    'Cloud Basics'
  ],
  description: 'Quest Global is hiring DevOps QA Engineers in Bengaluru. Both freshers and experienced candidates are eligible.',
  applyLink: 'https://careers.quest-global.com/global/en/job/P-115670/DevOps-QA-Engineer'
},
    {
  id: 'Iqigai-AI-Fellowship-Fractal-2026',
  title: 'Iqigai AI Fellowship Challenge 2026',
  organizer: 'Fractal',
  type: 'AI Hackathon / Fellowship',
  prizePool: '₹20,00,000',
  eligibility: 'Students & Professionals in AI / Data',
  benefits: [
    '₹20L Prize Pool',
    'National-Level Recognition',
    'Hiring Opportunities with Top Companies'
  ],
  description: 'Fractal’s Iqigai AI Fellowship Challenge 2026 is a national-level AI hackathon offering a ₹20L prize pool and hiring opportunities with leading companies.',
  applyLink: 'https://www.analyticsvidhya.com/datahack/contest/iqigai-genai-fellowship-challenge/?utm_source=av_social&utm_medium=whatsapp_post'
},
    {
  id: 'AI-Engineer-I-Sezzle-2026',
  title: 'AI Engineer I',
  company: 'Sezzle',
  location: 'Remote',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Early Career',
  eligibility: '2021–2025 Graduates',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'Artificial Intelligence',
  keySkills: [
    'Machine Learning',
    'Python',
    'AI Development',
    'Data Science',
    'Problem Solving'
  ],
  description: 'Sezzle is hiring AI Engineer I for a remote role. Graduates from 2021 to 2025 batches are eligible to apply.',
  applyLink: 'http://job-boards.greenhouse.io/sezzle/jobs/7645199003?gh_src=6d383ce23us'
},
    {
  id: 'Business-Analyst-Swiggy-2026',
  title: 'Business Analyst',
  company: 'Swiggy',
  location: 'Remote (India)',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Minimum 1 Year',
  qualification: 'Bachelor’s Degree',
  department: 'Business Analytics',
  keySkills: [
    'Business Analysis',
    'Data Analysis',
    'SQL',
    'Stakeholder Management',
    'Problem Solving'
  ],
  description: 'Swiggy is hiring Business Analysts for a remote role in India. Candidates with at least 1 year of experience in analytics or business analysis are encouraged to apply.',
  applyLink: 'https://www.linkedin.com/jobs/view/4378088634/'
},
    {
  id: 'Analyst-Data-Analytics-American-Express-2026',
  title: 'Analyst - Data Analytics',
  company: 'American Express',
  location: 'India (Hybrid)',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Experienced',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'Data Analytics',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Excel',
    'Python',
    'Data Visualization',
    'Analytical Thinking',
    'Problem Solving'
  ],
  description: 'American Express is hiring Analysts for its Data Analytics team in India (Hybrid). Both freshers and experienced candidates with Bachelor’s or Master’s degrees are eligible to apply.',
  applyLink: 'https://aexp.eightfold.ai/careers/job/40410926?hl=en'
},
  {
  id: 'Analyst-Data-Analytics-American-Express-2026',
  title: 'Analyst - Data Analytics',
  company: 'American Express',
  location: 'India (Hybrid)',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Freshers / Experienced',
  qualification: 'Bachelor’s / Master’s Degree',
  department: 'Data Analytics',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Excel',
    'Python',
    'Data Visualization',
    'Analytical Thinking',
    'Problem Solving'
  ],
  description: 'American Express is hiring Analysts for its Data Analytics team in India (Hybrid). Both freshers and experienced candidates with Bachelor’s or Master’s degrees are eligible to apply.',
  applyLink: 'https://aexp.eightfold.ai/careers/job/40410926?hl=en'
},
    {
  id: 'Software-Developer-Codebind-Technologies-2026',
  title: 'Software Developer',
  company: 'Codebind Technologies',
  location: 'Chennai (Onsite)',
  jobType: 'Full-Time',
  salary: '₹4L – ₹6L per year',
  postedDate: '2026-03-03',
  experience: '0 – 1 Years',
  qualification: 'B.Tech / B.E (CS/IT), MCA, M.Tech (Preferred)',
  eligibility: 'Freshers can apply | Must be ready to relocate',
  department: 'Software Development',
  keySkills: [
    'Java',
    'JavaScript',
    'Software Development',
    'Manual Testing',
    'Agile Methodology',
    'Problem Solving',
    'SDLC'
  ],
  description: 'Codebind Technologies is hiring Software Developers for its Chennai onsite location. Freshers and candidates with up to 1 year of experience can apply. The role involves full software development lifecycle participation, coding in Java and JavaScript, manual testing, and collaborating with cross-functional teams.',
  applyLink: 'https://abekus.ai/public-job-search/software-developer-23?referral_hash=IIHT.VIMANNAGAR0138'
},
    {
  id: 'Operational-Buyer-Hitachi-Energy-2026',
  title: 'Operational Buyer',
  company: 'Hitachi Energy',
  location: 'Chennai, Tamil Nadu',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: 'Entry Level',
  qualification: 'Bachelor’s Degree',
  department: 'Supply Chain',
  keySkills: [
    'Procurement',
    'Supply Chain',
    'Vendor Management',
    'Purchase Orders',
    'Negotiation'
  ],
  description: 'Hitachi Energy is hiring Operational Buyers in Chennai for its Supply Chain department. Entry-level candidates with a Bachelor’s degree are eligible.',
  applyLink: 'https://www.hitachienergy.com/careers/open-jobs/details/JID3-178875?source=linkedin'
},
    {
  id: 'R-A-FAC-OE-Analyst-1-Shell-2026',
  title: 'R&A FAC OE Analyst-1',
  company: 'Shell plc',
  location: 'Shell Centre – Chennai',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-03',
  experience: '0 – 2 Years',
  qualification: 'Graduate/Postgraduate in Accounting/Finance (CA/CMA Eligible)',
  department: 'Finance (LNG & Shipping Business)',
  keySkills: [
    'Accounting',
    'Financial Analysis',
    'Finance Operations',
    'Reporting',
    'Cost Management'
  ],
  description: 'Shell plc is hiring R&A FAC OE Analyst-1 in Chennai for its Finance team (LNG & Shipping Business). Early career professionals and CA/CMA candidates are eligible.',
  applyLink: 'https://shell.wd3.myworkdayjobs.com/en-GB/ShellCareers/job/SHELL-CENTRE--CHENNAI/R-A-FAC-OE-Analyst-1_R197492-2/'
},
    {
  id: 'Analyst-Internal-Audit-KPMG-India-2026',
  title: 'Analyst – Internal Audit (Risk Advisory)',
  company: 'KPMG India',
  location: 'Chennai, Tamil Nadu',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-02',
  experience: '0 – 2 Years',
  qualification: 'B.Com / B.E / B.Tech / BMS / BBM',
  department: 'Risk Advisory',
  keySkills: [
    'Internal Audit',
    'Risk Assessment',
    'Financial Analysis',
    'Compliance',
    'Reporting'
  ],
  description: 'KPMG India is hiring Analysts for Internal Audit (Risk Advisory) in Chennai. Freshers and candidates with up to 2 years of experience can apply.',
  applyLink: 'https://ejgk.fa.em2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/job/INTG10041326'
},
    {
  id: 'Software-Engineering-Associate-Goldman-Sachs-2026',
  title: 'Software Engineering – Associate (Compliance Engineering)',
  company: 'Goldman Sachs',
  location: 'Bengaluru, Karnataka',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-02',
  qualification: 'B.E / B.Tech / M.E / M.Tech (CS or related field)',
  department: 'Compliance Engineering',
  keySkills: [
    'Java',
    'Software Development',
    'Compliance Systems',
    'Backend Engineering',
    'Problem Solving'
  ],
  description: 'Goldman Sachs is hiring Software Engineering Associates for its Compliance Engineering team in Bengaluru. Strong Java development skills are required.',
  applyLink: 'https://hdpc.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/LateralHiring/job/161941'
},
    {
  id: 'Software-Engineer-Akamai-2026',
  title: 'Software Engineer',
  company: 'Akamai Technologies',
  location: 'India (Remote – FlexBase Program)',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-02',
  experience: '6 Months – 2 Years',
  qualification: 'B.E / B.Tech (CS or related field)',
  department: 'Software Engineering',
  keySkills: [
    'Java',
    'Backend Development',
    'Problem Solving',
    'Data Structures',
    'Algorithms'
  ],
  description: 'Akamai Technologies is hiring Software Engineers under its FlexBase Remote Program. Candidates with 6 months to 2 years of experience in software development are encouraged to apply.',
  applyLink: 'https://fa-extu-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/job/2477'
},
    {
  id: 'Data-Analyst-Fresher-AU-Small-Finance-Bank-2026',
  title: 'Data Analyst (Fresher / Entry-Level)',
  company: 'AU Small Finance Bank',
  location: 'India',
  jobType: 'Full-Time',
  salary: 'Not Disclosed',
  postedDate: '2026-03-02',
  experience: '0-3 Years',
  department: 'Data Analytics',
  jobId: 'Job33021',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Excel',
    'Python',
    'Data Visualization',
    'Problem Solving',
    'Analytical Thinking'
  ],
  description: 'AU Small Finance Bank is hiring freshers for an entry-level Data Analyst role. Candidates with 0-3 years of experience who have strong analytical skills and knowledge of SQL, Excel, and Python are encouraged to apply.',
  applyLink: 'https://www.takeofftalent.com/search/label/India'
},
    {
  id: 'Mobile-Development-Intern-beBee-2026',
  title: 'Android / iOS Mobile Development Intern',
  company: 'beBee',
  location: 'Bengaluru',
  jobType: 'Internship',
  salary: 'Not Disclosed',
  postedDate: '2026-03-02',
  experience: 'Internship / Student Level',
  department: 'Mobile App Development',
  languagesPreferred: [
    'English'
  ],
  keySkills: [
    'Android Development',
    'iOS Development',
    'Mobile App Development',
    'Cross-Functional Collaboration',
    'UI/UX Understanding',
    'Problem Solving'
  ],
  description: 'beBee is hiring Android or iOS Mobile Development Interns in Bengaluru. This internship provides hands-on experience in designing and developing mobile applications using cutting-edge technologies. Interns will collaborate with cross-functional teams to define and implement new features.',
  applyLink: 'https://grow.almabetter.com/job-board/4c7e007c-1106-4d90-a64f-4d7e2ca2bdd4'
},

  
    {
    id: 'Data-Analyst-I-2026',
    title: 'Data Analyst I',
    department: 'Analytics',
    postedDate:'2026-02-22',
    location:'Not mentioned',
    qualification: [
    'Bachelor’s Degree'
  ],
    experience: 'Entry / Mid Level',
    applyLink: 'https://gfgcdn.com/tu/Z3w'
  },
  {
    id: 'Data-Analyst-II-2026',
    title: 'Data Analyst II',
    department: 'Analytics',
    experience: 'Entry / Mid Level',
    location:'Not mentioned',
    postedDate:'2026-02-22',
    qualification: [
    'Bachelor’s Degree'
  ],
    applyLink: 'https://gfgcdn.com/tu/Z3x/'
  },
  {
    id: 'Implementation-Analyst-2026',
    title: 'Implementation Analyst',
    department: 'Operations / Technology',
    experience: 'Entry / Mid Level',
    postedDate:'2026-02-22',
    location:'Not mentioned',
   qualification: [
    'Bachelor’s Degree'
  ],
    applyLink: 'https://gfgcdn.com/tu/Z3y/'
  },
  {
    id: 'Amazon-Language-Engineer-2026',
    title: 'Language Engineer',
    company: 'Amazon',
    postedDate:'2026-02-22',
    location:'Not mentioned',
    qualification: [
    'Bachelor’s Degree'
  ],
    department: 'AI / NLP / Language Technology',
    experience: 'Entry / Mid Level',
    applyLink: 'https://gfgcdn.com/tu/Z3z/'
  },
  {
  id: 'Data-Analyst-Associate-JPMorgan-2026',
  title: 'Data Analyst - Associate',
  company: 'JPMorgan Chase & Co.',
  location: 'Mumbai, India',
  jobType: 'Full-Time',
  postedDate:'2026-02-21',
  qualification: [
    'Bachelor’s Degree'
  ],
  experience: 'Freshers / Experienced',
  department: 'Data Analytics',
  keySkills: [
    'Data Analysis',
    'SQL',
    'Python',
    'Data Visualization',
    'Reporting',
    'Business Intelligence'
  ],
  description: 'JPMorgan is hiring Data Analyst - Associate in Mumbai. Open to both freshers and experienced professionals with a Bachelor’s Degree. Strong analytical and data handling skills are preferred.',
  applyLink: 'https://jpmc.fa.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1001/job/210654514?keyword=Data+Analyst+-+Associate&mode=location'
},
  {
    id: 'Business-Development-Associate-Nxtwave-2026',
  title: 'Business Development Associate',
  company: 'Nxtwave',
  location: 'Work From Home (India)',
  jobType: 'Full-Time',
  salary: 'Up to ₹5 LPA',
  postedDate:'2026-02-21',
  experience: 'Entry-Level / Graduate',
  department: 'Presales / Business Development',
  languagesPreferred: [
    'Tamil',
    'Telugu',
    'Hindi'
  ],
  keySkills: [
    'Business Development',
    'Presales',
    'Lead Conversion',
    'Communication Skills',
    'Negotiation',
    'CRM Handling'
  ],
  description: 'Nxtwave is hiring Business Development Associates for a Work From Home role. The position focuses on presales, student counseling, and lead conversion. Candidates fluent in Tamil, Telugu, or Hindi are preferred.',
  applyLink: 'https://nxtwave.freshteam.com/jobs/PqqFrapezemf/business-development-associate-work-from-home-presales-tamil-telugu-hindi'
},
    {
    id: 'Customer-Support-Specialist-Cision-2026',
    title: 'Customer Support Specialist',
    company: 'Cision',
    location: ['Bangalore', 'Chennai', 'Mumbai'],
    postedDate:"2026-02-21",
    jobType: 'Full-Time',
    qualification: [
      'Bachelor’s Degree (Preferred)'
    ],
    experience: 'Not Specified',
    keySkills: [
      'Customer Support',
      'Communication Skills',
      'Problem Solving',
      'Client Handling',
      'CRM Tools'
    ],
    description: 'Cision is hiring Customer Support Specialists for multiple locations in India. Ideal candidates should have strong communication skills and a passion for delivering excellent customer service.',
    applyLink: 'https://job-boards.eu.greenhouse.io/cision/jobs/4746702101',
  },
  {
    id: 'Senior-Salesforce-Administrator-Revenue-Cloud-Logitech-2026',
    title: 'Senior Salesforce Administrator – Revenue Cloud',
    company: 'Logitech',
    location: 'Chennai (On-Site)',
    jobType: 'Full-Time',
    experience: '5+ Years',
    postedDate:"2026-02-21",
    qualification: [
      'Bachelor’s Degree in relevant field'
    ],
    keySkills: [
      'Salesforce CPQ',
      'Revenue Cloud',
      'Salesforce Billing',
      'Sales Cloud',
      'Subscription Management',
      'Salesforce Flows',
      'Advanced Approvals',
      'GitHub',
      'Prodly',
      'Oracle ERP Integration',
      'Mulesoft',
      'DevOps',
      'Multi-Currency Environment'
    ],
    certificationsPreferred: [
      'Salesforce Certified CPQ Specialist',
      'Salesforce Certified Administrator',
      'Salesforce Advanced Administrator'
    ],
    description: 'Logitech is hiring a Senior Salesforce Administrator to manage and optimize Salesforce Revenue Cloud (CPQ & Billing). The role involves system configuration, automation, DevOps release management, ERP integrations, and stakeholder collaboration.',
    applyLink: 'https://logitech.wd5.myworkdayjobs.com/en-US/Logitech/details/Senior-Salesforce-Administrator--Revenue-Cloud_145237?source=LinkedIn&locationCountry=c4f78be1a8f14da0ab49ce1162348a5e',
    
  },
    {
    id: 'Frontend-Developer-Fresher-SynapticaTech-2026',
    title: 'Front End Developer – Fresher',
    company: 'SYNAPTICA TECH',
    location: 'Greater Vijayawada District (Hybrid)',
    jobType: 'Full-Time',
    experience: '0–4 Years (Freshers Eligible)',
    qualification: [
      'Bachelor’s Degree in Computer Science, Engineering or related field'
    ],
    keySkills: [
      'HTML',
      'CSS',
      'JavaScript',
      'React.js',
      'Angular',
      'Vue.js',
      'REST APIs',
      'Git',
      'Responsive Design',
      'UI/UX Principles',
      'Tailwind',
      'Bootstrap',
      'Redux',
      'Webpack',
      'Vite',
      'Jest',
      'Cypress'
    ],
    description: 'Hiring creative Frontend Developers (Freshers welcome) to build responsive, high-performance web interfaces. Strong fundamentals in HTML, CSS, JavaScript, and modern frameworks required.',
  applyLink:'https://synapticatech.zohorecruit.in/jobs/Careers/183438000002888349/Front-End-Developer-Fresher?source=LinkedIn-Basic&embedsource=LinkedIn%2BLimited%2BListings',
  postedDate:'2026-02-20'
  },
  {
    id: 'Fullstack-Development-Intern-WebsITSolution-2026',
    title: 'Full-Stack Development Intern',
    company: 'Webs IT Solution',
    location: 'Remote',
    jobType: 'Internship',
    duration: '3 Months',
    stipend: 'Up to ₹7,500 (Performance-Based)',
    qualification: [
      'Pursuing or completed degree in Computer Science / IT or related field'
    ],
    keySkills: [
      'HTML',
      'CSS',
      'JavaScript',
      'React.js',
      'Node.js',
      'MongoDB',
      'MySQL',
      'REST APIs',
      'Git',
      'GitHub'
    ],
    perks: [
      'Certificate of Internship',
      'Mentorship',
      'Live Project Exposure',
      'Potential Full-Time Offer'
    ],
    description: '3-month remote Full-Stack Internship offering hands-on experience in React.js, Node.js, and database integration with mentorship and live project exposure.',
     applyLink:'https://docs.google.com/forms/d/e/1FAIpQLSePKmgH2ctoGq2jchf5RWPwIl4IEhHci9FWrVRPRw--Brp2FA/viewform',
     postedDate:'2026-02-20'
  },
  {
    id: 'Frontend-Developer-Keenai-Global-2026',
    title: 'Frontend Developer (React.js)',
    company: 'Keenai Global',
    location: 'Bengaluru, Karnataka, India (On-site)',
    jobType: 'Full-Time',
    experience: 'Experience Required',
    qualification: [
      'Bachelor’s Degree in Computer Science or related field'
    ],
    keySkills: [
      'React.js',
      'JavaScript',
      'HTML',
      'CSS',
      'State Management Libraries',
      'REST APIs',
      'Git',
      'Sass',
      'Bootstrap',
      'Tailwind',
      'Jest',
      'Next.js',
      'Gatsby'
    ],
    description: 'Keenai Global is hiring a React.js Developer to design and maintain scalable UI components and frontend architecture. Strong React fundamentals and performance optimization skills required.',
    applyLink:'https://www.linkedin.com/jobs/search/?currentJobId=4373670469&originalSubdomain=in',
  postedDate:'2026-02-20'
  },
  {
    id: 'React-JS-Intern-Policybazaar-2026',
    title: 'React JS Intern',
    company: 'Policybazaar.com',
    location: 'Gurugram, Haryana, India (On-site)',
    jobType: 'Internship',
    duration: '3 Months',
    stipend: 'Unpaid',
    qualification: [
      'Pursuing or recently completed degree in Computer Science / IT or related field'
    ],
    keySkills: [
      'JavaScript',
      'HTML',
      'CSS',
      'React Fundamentals',
      'UI Components',
      'Debugging',
      'Testing'
    ],
    perks: [
      'Completion Certificate',
      'Mentorship',
      'Real-world Project Exposure'
    ],
    description: '3-month full-time, work-from-office React JS Internship at Policybazaar. Ideal for students looking for hands-on frontend development experience.',
    applyLink:'https://docs.google.com/forms/d/e/1FAIpQLSfdNSv_jdP1MUXemo2F-rFMqtjTjt03FLnTug0dUR4xYCAIxg/viewform',
  postedDate:'2026-2-20'
  },
    {
     id: 'Software-Developer-Intern-Skillzenloop-2026',
  title: 'Software Developer Intern',
  company: 'Skillzenloop',
  location: 'India (Remote)',
  jobType: 'Full-Time Internship',
  duration: '1–3 Months',
  stipend: '₹15,500 per month',
  experience: 'Internship (Students / Freshers)',
  qualification: [
    'Pursuing or completed Bachelor’s Degree in Computer Science or related field'
  ],
  postedDate: '2026-02-20',
  applicants: '50+ applied',
  keyResponsibilities: [
    'Assist in application development',
    'Support testing and debugging tasks',
    'Help with deployment activities',
    'Collaborate with development team on scalable solutions'
  ],
  description: 'Skillzenloop is hiring a Software Developer Intern for a 1–3 month remote internship. The role involves assisting in software development, testing, and deployment of scalable business applications.',
  applyLink:'https://www.skillzenloop.com/jobs'
},
    {
    id: 'Associate-Analyst-EY-2026',
    title: 'Associate Analyst',
    company: 'EY',
    location: 'Gurgaon, India',
    jobType: 'Full-Time',
    experience: '0–1 Years (Freshers)',
    salary: 'Not Disclosed',
    postedDate: '2026-02-20',
    qualification: [
      'Graduate Degree',
      'Master’s Degree',
      'Postgraduate Degree'
    ],
    keySkills: [
      'Analytical Skills',
      'Communication',
      'MS Excel',
      'Data Analysis',
      'Problem Solving'
    ],
    description: 'EY is hiring Associate Analysts (Freshers) for Gurgaon location. Ideal for graduates looking to start their career in analytics and professional services.',
    applyLink: 'https://careers.ey.com/ey/job/Gurgaon-Associate-Analyst-HR-122010/1293563901/'
  },
  {
    id: 'Full-Stack-Developer-Thrifty-AI-2026',
    title: 'Full Stack Developer',
    company: 'Thrifty AI',
    location: 'Noida (Onsite)',
    jobType: 'Full-Time',
    qualification: [
      'B.Tech / B.E (CS/IT)',
      'MCA',
      'M.Tech (Preferred)'
    ],
    experience: '2–4 Years',
    salary: '₹6 – ₹12 LPA',
    postedDate: '2026-02-20',
    keySkills: [
      'Python (FastAPI/Django/Flask)',
      'Node.js',
      'React.js',
      'Next.js',
      'REST APIs',
      'GraphQL',
      'MongoDB',
      'PostgreSQL',
      'MySQL',
      'AWS',
      'Docker',
      'Kubernetes',
      'CI/CD',
      'WebSockets',
      'OAuth',
      'JWT'
    ],
    applyLink: 'https://abekus.ai/public-job-search/full-stack-developer-15?referral_hash=IIHT.VIMANNAGAR0138',
    description: 'Thrifty AI is hiring Full Stack Developers (2–4 years experience) for their Noida office. Role focuses on backend development with Python, API integrations, cloud deployment, and AI feature integration.'
  },
  {
    id: 'Fullstack-Developer-Node-React-Unified-GlobalTech-2026',
    title: 'Fullstack Developer – Node.js & React.js',
    company: 'Unified GlobalTech (I) Pvt Ltd',
    location: 'Ahmedabad, India',
    jobType: 'Full-Time',
    qualification: [
      'Bachelor’s Degree in Computer Science or related field'
    ],
    experience: '3+ Years',
    salary: 'Not Disclosed',
    postedDate: '2026-02-19',
    keySkills: [
      'Node.js',
      'TypeScript',
      'Next.js',
      'React.js',
      'Tailwind CSS',
      'Bootstrap',
      'Python',
      'Flask',
      'LLM APIs',
      'OpenAI',
      'N8N',
      'MySQL',
      'PostgreSQL',
      'SQLite',
      'Docker',
      'CI/CD',
      'AWS'
    ],
    applyLink: 'https://grow.almabetter.com/job-board/bddf222a-b888-45ca-b830-bc652da01be0',
    description: 'Unified GlobalTech is hiring Fullstack Developers skilled in Node.js, React.js, Next.js, AI integrations, and workflow automation. Experience in API integrations and databases required.'
  },
  {
    id: 'SDE2-GoLang-Developer-Remote-2026',
    title: 'SDE2 – GoLang Developer',
    company: 'Confidential (Hiring via OptimHire)',
    location: 'Bengaluru (Fully Remote)',
    jobType: 'Contract (6 Months – Extendable)',
    qualification: [
      'Bachelor’s Degree in Computer Science or related field'
    ],
    experience: '4–6 Years',
    salary: '₹10 – ₹13 LPA',
    noticePeriod: 'Immediate',
    postedDate: '2026-02-19',
    keySkills: [
      'GoLang',
      'Microservices Architecture',
      'Data Structures & Algorithms',
      'Goroutines',
      'AWS',
      'PostgreSQL',
      'MongoDB',
      'Redis',
      'Docker',
      'Kubernetes',
      'CI/CD',
      'UML',
      'REST / gRPC APIs'
    ],
    applyLink: 'https://optimhire.com/developers/jv/309360?ref_code=mukesh-agrawal',
    description: 'Hiring Senior GoLang Developer (SDE2) with strong DSA expertise for scalable backend system development. Experience in microservices, cloud platforms, concurrency, and CI/CD required. Contract role (6 months, extendable).'
  },

    {
  id: 'Full-Stack-Developer-Thrifty-AI-2026',
  title: 'Full Stack Developer',
  company: 'Thrifty AI',
  location: 'Noida (Onsite)',
  jobType: 'Full-Time',
  qualification: [
    'B.Tech / B.E (CS/IT)',
    'MCA',
    'M.Tech (Preferred)'
  ],
  experience: '2–4 Years',
  salary: '₹6 – ₹12 LPA',
  postedDate: '2026-02-19',
  keySkills: [
    'Python (FastAPI/Django/Flask)',
    'Node.js',
    'React.js',
    'Next.js',
    'REST APIs',
    'GraphQL',
    'MongoDB',
    'PostgreSQL',
    'MySQL',
    'AWS',
    'Docker',
    'Kubernetes',
    'CI/CD',
    'WebSockets',
    'OAuth',
    'JWT'
  ],
  applyLink: 'https://abekus.ai/public-job-search/full-stack-developer-15?referral_hash=IIHT.VIMANNAGAR0138',
  description: 'Thrifty AI is hiring Full Stack Developers (2–4 years experience) for their Noida office. Role focuses on backend development with Python, API integrations, cloud deployment, and AI feature integration.'
},
    {
  id: 'Fullstack-Developer-Node-React-Unified-GlobalTech-2026',
  title: 'Fullstack Developer – Node.js & React.js',
  company: 'Unified GlobalTech (I) Pvt Ltd',
  location: 'Ahmedabad, India',
  jobType: 'Full-Time',
  qualification: ['Bachelor’s Degree in Computer Science or related field'],
  experience: '3+ Years',
  salary: 'Not Disclosed',
  postedDate: '2026-02-19',
  keySkills: [
    'Node.js',
    'TypeScript',
    'Next.js',
    'React.js',
    'Tailwind CSS',
    'Bootstrap',
    'Python',
    'Flask',
    'LLM APIs',
    'OpenAI',
    'N8N',
    'MySQL',
    'PostgreSQL',
    'SQLite',
    'Docker',
    'CI/CD',
    'AWS'
  ],
  applyLink: 'https://grow.almabetter.com/job-board/bddf222a-b888-45ca-b830-bc652da01be0',
  description: 'Unified GlobalTech is hiring Fullstack Developers skilled in Node.js, React.js, Next.js, AI integrations, and workflow automation. Experience in API integrations and databases required.'
},
    {
  id: 'SDE2-GoLang-Developer-Remote-2026',
  title: 'SDE2 – GoLang Developer',
  company: 'Confidential (Hiring via OptimHire)',
  location: 'Bengaluru (Fully Remote)',
  jobType: 'Contract (6 Months – Extendable)',
  qualification: ['Bachelor’s Degree in Computer Science or related field'],
  experience: '4–6 Years',
  salary: '₹10 – ₹13 LPA',
  noticePeriod: 'Immediate',
  postedDate: '2026-02-19',
  keySkills: [
    'GoLang',
    'Microservices Architecture',
    'Data Structures & Algorithms',
    'Goroutines',
    'AWS',
    'PostgreSQL',
    'MongoDB',
    'Redis',
    'Docker',
    'Kubernetes',
    'CI/CD',
    'UML',
    'REST / gRPC APIs'
  ],
  applyLink: 'https://optimhire.com/developers/jv/309360?ref_code=mukesh-agrawal',
  description: 'Hiring Senior GoLang Developer (SDE2) with strong DSA expertise for scalable backend system development. Experience in microservices, cloud platforms, concurrency, and CI/CD required. Contract role (6 months, extendable).'
},
    {
  id: 'Software-Expert-Mercor-Remote-2026',
  title: 'Software Expert (Blender, Godot, GIMP, R, Wings 3D)',
  company: 'Mercor',
  location: 'Remote (Physical Mac Required)',
  jobType: 'Contract (Independent Contractor)',
  qualification: ['Not Mandatory – Domain Expertise Required'],
  experience: 'Experienced Professionals Preferred',
  salary: '$0 – $65 per hour',
  postedDate: '2026-02-18',
  keySkills: [
    'Blender',
    'Godot',
    'GIMP',
    'R Programming',
    'Wings 3D',
    'Screen Recording',
    'UI Annotation',
    'Workflow Documentation',
    'macOS Environment'
  ],
  applyLink: 'https://t.mercor.com/tqWvz',
  description: 'Mercor is hiring Software Experts for a remote AI data collection project. Candidates must have strong expertise in Blender, Godot, GIMP, R, or Wings 3D and access to a physical Mac. The role involves recording expert workflows, annotating UI elements, and supporting AI system improvements. Pay ranges from $0–$65 per hour with weekly payments via Stripe or Wise.'
},
    {
  id: 'Mobile-App-Developer-Intern-Zenix-Automotive-2026',
  title: 'Mobile / App Developer Intern',
  company: 'Zenix Automotive Pvt. Ltd.',
  location: 'Remote',
  jobType: 'Internship',
  qualification: [
    'Undergraduate / Postgraduate Students',
    'Engineering / Management / Arts / Commerce / Sciences / Law / Medical / Others'
  ],
  experience: 'Freshers / Students Eligible',
  stipend: '₹4,000 – ₹7,500 / Month',
  postedDate: '2026-02-19',
  keySkills: [
    'React Native',
    'JavaScript',
    'TypeScript',
    'Redux / MobX / React Context API',
    'Node.js / Express.js',
    'REST APIs / GraphQL',
    'JWT / OAuth / Passport.js',
    'MongoDB / MySQL / PostgreSQL / Firebase / SQLite',
    'UI/UX Implementation',
    'Mobile App Deployment',
    'CI/CD'
  ],
  applyLink: 'https://unstop.com/o/rV2OLSF?lb=Bnie7Jo',
  description: 'Zenix Automotive Pvt. Ltd. is hiring Mobile/App Developer Interns (Remote). Candidates will design, develop, and maintain cross-platform mobile applications using React Native, integrate with backend services, implement state management, and ensure secure authentication. Freshers and students from any discipline are eligible. Stipend ₹4K–7.5K per month.'
},
  {
  id: 'Software Developer (Recent Graduates)-2026',
  title: 'Software Developer',
  company: 'Smarthms Solutions',
  location: 'Thiruvananthapuram,india',
  jobType: 'Full-Time',
  qualification: ['Bachelors degree in Computer Science or related field.'],
  experience: '0-1 Exp',
  postedDate: '2026-02-18',
  salary:'4-6 LPA',
  keySkills: [
    'Communication skills',
    'Logical Approach',
    'Problem Solving',
    'Programming',
    'Php programming',
  ],
  applyLink: 'https://www.naukri.com/job-listings-software-developer-recent-graduates-smarthms-solutions-thiruvananthapuram-0-to-1-years-170226047372?src=cluster&sid=17714005782818741_1&xp=1&px=1&nignbevent_src=jobsearchDeskGNB',
  description: 'JPMorgan Chase & Co. is hiring Data Analyst – Associate for its Mumbai (Goregaon East) location. Candidates should have strong expertise in SQL, Python, R, Tableau, and Power BI with experience in dashboarding, data modeling, and predictive analytics.'
},
    {
  id: 'Data-Analyst-Associate-JPMorgan-Chase-2026',
  title: 'Data Analyst – Associate',
  company: 'JPMorgan Chase & Co.',
  location: 'Mumbai (Goregaon East), Maharashtra, India',
  jobType: 'Full-Time',
  qualification: ['Bachelor’s Degree (Preferred)'],
  experience: 'Not Specified',
  postedDate: '2026-02-18',
  keySkills: [
    'SQL',
    'Python',
    'R',
    'Tableau',
    'Power BI',
    'Dashboarding',
    'Data Modeling',
    'Predictive Analytics'
  ],
  applyLink: 'https://jpmc.fa.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1001/job/210654514/',
  description: 'JPMorgan Chase & Co. is hiring Data Analyst – Associate for its Mumbai (Goregaon East) location. Candidates should have strong expertise in SQL, Python, R, Tableau, and Power BI with experience in dashboarding, data modeling, and predictive analytics.'
},
    {
  id: 'Software-Developer-Finarb-Analytics-Consulting-2026',
  title: 'Software Developer (Full Stack)',
  company: 'Finarb Analytics Consulting',
  location: 'Bengaluru, Hyderabad, Kolkata, India',
  jobType: 'Full-Time, Permanent',
  qualification: ['B.Tech / B.E (Any Specialization)'],
  experience: '2-5 Years',
  salary: 'Not Disclosed',
  openings: '1',
  postedDate: '2026-02-17',
  keySkills: [
    'JavaScript (ES6+)',
    'TypeScript',
    'React.js / Angular / Vue.js',
    'Python',
    'Django / Flask / FastAPI',
    'REST APIs',
    'GraphQL',
    'MongoDB',
    'PostgreSQL',
    'Docker',
    'Kubernetes',
    'AWS / Azure / GCP',
    'CI/CD',
    'Microservices'
  ],
  applyLink: 'https://www.naukri.com/job-listings-software-developer-finarb-analytics-consulting-kolkata-hyderabad-bengaluru-2-to-5-years-160226017620?src=cluster&sid=1771337257549792&xp=14&px=1&nignbevent_src=jobsearchDeskGNB',
  description: 'Finarb Analytics Consulting is hiring Software Developers with 2+ years of experience in full stack development. Candidates should have strong expertise in JavaScript, TypeScript, and Python, along with experience in frontend frameworks, REST APIs, databases, cloud platforms, and DevOps practices. The role involves building scalable web applications, mentoring junior developers, and collaborating in agile environments.'
},
    {
  id: 'Software-Developer-Intern-Fresher-Binary-Republik-2026',
  title: 'Software Developer Intern / Fresher',
  company: 'Binary Republik',
  location: 'Ahmedabad, Gujarat, India',
  jobType: 'Full-Time',
  qualification: [
    'BE/B.Tech (IT/CE/CS)',
    'BCA/MCA',
    'BSc/MSc IT',
    'Any Graduate (Technical Background Preferred)'
  ],
  experience: '0-1 Year (Freshers Eligible)',
  vacancies: '10',
  postedDate: '2026-02-17',
  keySkills: [
    'HTML',
    'CSS',
    'JavaScript',
    'jQuery',
    'TypeScript',
    'Python',
    'REST APIs',
    'OOP Concepts',
    'Full Stack Development',
    'AI/ML Basics'
  ],
  applyLink: 'https://www.binaryrepublik.com/careers/software-developer-intern-fresher',
  description: 'Binary Republik is hiring Software Developer Interns/Freshers in Ahmedabad. Candidates will assist in web application development, API integration, Python scripting, and AI/ML feature implementation. This is a great opportunity for freshers to gain hands-on experience in full stack development and AI-based solutions.'
},
  
  ].sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate)));
  

  const [searchQuery, setSearchQuery] = useState("");

  const filteredJobs = useMemo(() => {
    const today = new Date();

    return jobs.filter((job) => {
      const postedDate = new Date(job.postedDate);

      // Calculate difference in days
      const diffTime = today - postedDate;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      const isWithin15Days = diffDays <= 15;

      const matchesSearch =
        job?.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        job?.company?.toLowerCase().includes(searchQuery.toLowerCase());

      return isWithin15Days && matchesSearch;
    });
  }, [jobs, searchQuery]);

  const value = useMemo(
    () => ({
      jobs: filteredJobs,
      allJobs: jobs,
      setSearchQuery
    }),
    [filteredJobs, jobs]
  );

  return (
    <JobContext.Provider value={value}>
      {children}
    </JobContext.Provider>
  );
};